{
  "accept.action.button": "Setuju",
  "accessDenied.message": "Anda tidak memiliki akses pada modul ini. Silahkan kontak admin sistem.",
  "accessDenied.okButton": "OK",
  "accessDenied.title": "Akses ditolak",
  "accession.entry": "Masukkan Nomor Registrasi",
  "activityReportByPanel": "Laporan aktivitas berdasarkan Panel",
  "activityReportByTest": "Laporan aktivitas berdasarkan Pemeriksaan",
  "activityReportByTestSection": "Laporan aktivitas berdasarkan Bagian Pemeriksaan",
  "add.age.range": "Tambah Rentang Umur lainnya +",
  "add.aliquot": "Tambah Alikuot",
  "add.new.dictionary.menu": "Tambah Menu Kamus Baru",
  "address.search.label": "Cari Alamat",
  "adjustment.button": "Sesuaikan Kuantitas",
  "adjustment.newQuantity": "Kuantitas Baru",
  "adjustment.notes": "Catatan",
  "adjustment.notes.placeholder": "Sedialan rincian penyesuaian ini",
  "adjustment.reason": "Alasan Penyesuaian",
  "adjustment.reason.select": "Pilih Alasan",
  "adjustment.success": "Kuantitas lot berhasil disesuaikan",
  "adjustment.title": "Sesuaikan Kuantitas Lot",
  "admin.dashboard.subtitle": "Pilih area administrasi untuk dikonfigurasi",
  "admin.dashboard.title": "Dasbor admin",
  "admin.formEntryConfig": "Konfigurasi Umum",
  "admin.config.logo.error.fileTooLarge": "Gambar terlalu besar. Ukuran maksimum 2 MB.",
  "admin.config.logo.formats": "Format: JPG, PNG, GIF (maks 2MB)",
  "admin.label": "Admin",
  "admin.labUnit.basicInfo.domain.clinical": "Klinis",
  "admin.labUnit.basicInfo.domain.environmental": "Lingkungan",
  "admin.labUnit.basicInfo.domain.label": "Domain",
  "admin.labUnit.basicInfo.domain.vector": "Vektor",
  "admin.labUnit.domain.confirm.body": "Historical orders/results were evaluated against the prior domain's rules. New orders will use the new domain's rules.",
  "admin.labUnit.domain.confirm.heading": "Change Lab Unit Domain?",
  "admin.labUnit.edit.select": "Select Lab Unit",
  "admin.labUnit.edit.title": "Edit Lab Unit Domain",
  "admin.labUnit.list.filter.domain": "Filter by Domain",
  "admin.legacy": "Legacy Admin ",
  "admin.page.configuration.formEntryConfigMenu.button.add": "Tambah",
  "admin.page.configuration.formEntryConfigMenu.button.deactivate": "Nonaktifkan",
  "admin.page.configuration.formEntryConfigMenu.button.exit": "Keluar",
  "admin.page.configuration.formEntryConfigMenu.button.modify": "Modifikasi",
  "admin.page.configuration.formEntryConfigMenu.button.save": "Simpan",
  "admin.page.configuration.formEntryConfigMenu.description": "Deskripsi",
  "admin.page.configuration.formEntryConfigMenu.editRecord": "Rekaman Edit",
  "admin.page.configuration.formEntryConfigMenu.name": "Nama",
  "admin.page.configuration.formEntryConfigMenu.select": "Pilih",
  "admin.page.configuration.formEntryConfigMenu.value": "Nilai",
  "admin.labelPresets.title": "Pengaturan Label",
  "admin.labelPresets.addButton": "Tambah Pengaturan",
  "admin.labelPresets.search.placeholder": "Cari pengaturan...",
  "admin.labelPresets.col.name": "Nama",
  "admin.labelPresets.col.barcodeType": "Jenis Kode QR",
  "admin.labelPresets.col.dimensions": "Dimensi",
  "admin.labelPresets.col.scope": "Ruang Lingkup",
  "admin.labelPresets.col.status": "Status",
  "admin.labelPresets.col.actions": "Aksi",
  "admin.labelPresets.systemTag": "Sistem",
  "admin.labelPresets.status.active": "Aktif",
  "admin.labelPresets.status.inactive": "Inaktif",
  "admin.labelPresets.scope.order": "Pemesanan",
  "admin.labelPresets.scope.sample": "Sampel",
  "admin.labelPresets.action.edit": "Edit",
  "admin.labelPresets.action.duplicate": "Duplikasi",
  "admin.labelPresets.action.activate": "Aktifkan",
  "admin.labelPresets.action.deactivate": "Nonaktifkan",
  "admin.labelPresets.duplicateName": "Salinan dari {name}",
  "admin.labelPresets.duplicated": "Pengaturan diduplikasi",
  "admin.labelPresets.duplicateFailed": "Duplikasi gagal",
  "admin.labelPresets.activated": "Pengaturan diaktifkan",
  "admin.labelPresets.deactivated": "Pengaturan dinonaktifkan",
  "admin.labelPresets.toggleFailed": "Gagal merubah status",
  "admin.labelPresets.saveFailed": "Penyimpanan gagal",
  "admin.labelPresets.editor.titleAdd": "Tambah Pengaturan Label",
  "admin.labelPresets.editor.titleEdit": "Edit Pengaturan Label",
  "admin.labelPresets.editor.section.basicInfo": "Informasi Dasar",
  "admin.labelPresets.editor.section.dimensions": "Dimensi (mm)",
  "admin.labelPresets.editor.section.barcodeSettings": "Pengaturan Kode QR",
  "admin.labelPresets.editor.section.printScope": "Ruang Lingkup & Kuantitas Pencetakan",
  "admin.labelPresets.field.name": "Nama Pengaturan",
  "admin.labelPresets.field.isActive": "Aktif",
  "admin.labelPresets.field.heightMm": "Tinggi (mm)",
  "admin.labelPresets.field.widthMm": "Lebar (mm)",
  "admin.labelPresets.field.barcodeType": "Jenis Kode QR",
  "admin.labelPresets.field.defaultPerOrder": "Default per Pemesanan",
  "admin.labelPresets.field.maxPerOrder": "Maks per Pemesanan",
  "admin.labelPresets.field.defaultPerSample": "Default per Sampel",
  "admin.labelPresets.field.maxPerSample": "Maks per Sampel",
  "admin.labelPresets.validation.name.required": "Wajb ada nama ",
  "admin.labelPresets.validation.name.toolong": "Nama tidak lebih dari 120 karakter",
  "admin.labelPresets.validation.dimension.range": "Dimensi harus antara 5 sampai 200 mm",
  "admin.labelPresets.validation.barcodeType.required": "Wajib ada jenis kode QR",
  "admin.labelPresets.validation.scope.required": "Setidaknya satu ruang lingkup pencetakan (Pemesanan atau Sample) harus dipilih",
  "admin.labelPresets.validation.max.lte": "Maks harus lebih dari atau sama dengan default",
  "advanced.search": "Pencarian Lanjutan",
  "alert.expired.title": "Barang Kedaluwarsa",
  "alert.expiring.title": "Segera Kedaluwarsa",
  "alert.lowStock.title": "Peringatan Stok Sedikit",
  "alerts.acknowledge.button": "Mengetahui",
  "alerts.acknowledge.comment": "Komentar Pemecahan Masalah",
  "alerts.acknowledge.comment.placeholder": "Jelaskan bagaimana peringatan diatasi...",
  "alerts.acknowledge.comment.required": "Komentar resolusi diperlukan untuk peringatan kritis",
  "alerts.acknowledge.error": "Gagal mengkonfirmasi peringatan",
  "alerts.acknowledge.success": "Berhasil mengkonfirmasi peringatan",
  "alerts.acknowledge.title": "Konfirmasi Peringatan",
  "alerts.autoRefresh": "Auto-refresh setiap 60 detik",
  "alerts.dashboard.title": "Dasbor peringatan",
  "alerts.empty": "Tidak ada peringatan untuk ditampilkan",
  "alerts.eqaDeadlineSummary.critical": "Kritis",
  "alerts.eqaDeadlineSummary.deadlineCount": "{count} deadline berikutnya",
  "alerts.eqaDeadlineSummary.subtitle": "Pengumpulan PME yang deadline dikelompokan berdasarkan penyelenggara",
  "alerts.eqaDeadlineSummary.title": "Ringkasan Deadline PME",
  "alerts.eqaDeadlineSummary.viewAll": "Lihat Semua",
  "alerts.filter.myAlerts": "Peringatan Saya",
  "alerts.filter.search": "Mencari peringatan...",
  "alerts.filter.severity": "Keparahan",
  "alerts.filter.status": "Status",
  "alerts.filter.type": "Jenis Peringatan",
  "alerts.severity.critical": "Kritis",
  "alerts.severity.warning": "Peringatan",
  "alerts.status.acknowledged": "Sudah diketahui",
  "alerts.status.open": "Buka",
  "alerts.status.resolved": "Selesai",
  "alerts.summary.critical": "Peringatan Kritis",
  "alerts.summary.eqaDeadlines": "Deadline PME",
  "alerts.summary.sampleExpiration": "Sampel segera kedaluwarsa",
  "alerts.summary.statOverdue": "Pemesanan STAT yang lewat tenggat",
  "alerts.summary.totalOpen": "Total Terbuka",
  "alerts.table.actions": "Aksi",
  "alerts.table.created": "Dibuat",
  "alerts.table.message": "Pesan",
  "alerts.table.severity": "Keparahan",
  "alerts.table.status": "Status",
  "alerts.table.type": "Jenis",
  "alerts.type.critical_unacknowledged": "Batalkan Konfirmasi Kritis",
  "alerts.type.eqa_deadline": "Deadline PME",
  "alerts.type.required_by_deadline": "Required By Deadline",
  "alerts.type.sample_expiration": "Tanggal Kedaluwarsa Sampel",
  "alerts.type.stat_overdue": "STAT lewat tenggat",
  "alerts.type.stat_upcoming": "STAT segera tenggat",
  "aliquot": "Alikuot",
  "aliquot.analyses.count": "Analisis: {count}",
  "aliquot.id": "ID Alikuot",
  "aliquot.quantity": "Kuantitas Alikuot",
  "aliquot.quantity.not.balanced": "Jumlah tidak seimbang untuk jenis sampel",
  "aliquot.save.error": "Error saat menyimpan data alikuot.",
  "aliquot.save.success": "Data pembuatan alikuot sukses tersimpan.",
  "aliquot.tests.not.assigned": "Tidak menugaskan pemeriksaan pada jenis sampel",
  "aliquot.validation.errors": "Kesalahan Validasi",
  "aliquoting": "Pembuatan alikuot",
  "aliquoting.section": "Bagian pembuatan alikuot",
  "all.label": "Semua",
  "all.tests.assigned": "Semua pemeriksaan ditugaskan",
  "allocated.to.aliquots": "Dialokasikan pada Alikuot",
  "analysis.count": "Penghitungan Analisis",
  "analysis.details": "Rincian Analisis",
  "analyzer.action.add": "Tambah Alat",
  "analyzer.action.copyMappings": "Salin Pemetaan",
  "analyzer.action.delete": "Hapus",
  "analyzer.action.edit": "Edit",
  "analyzer.action.fieldMappings": "Pemetaan Field/Bidang",
  "analyzer.action.qcRules": "Aturan QC",
  "analyzer.action.testConnection": "Uji Koneksi",
  "analyzer.combinationName.notification": "Kombinasi alat dan nama pemeriksaan di alat harus unik",
  "analyzer.copyMappings.confirmation.message": "Apakah Anda ingin menyalin sejumlah {count} pemetaan? Pemetaan sebelumnya akan ditimpa.",
  "analyzer.copyMappings.confirmation.title": "Konfirmasi Salin Pemetaan",
  "analyzer.copyMappings.copy": "Salin Pemetaan",
  "analyzer.copyMappings.error": "Error saat menyalin pemetaan",
  "analyzer.copyMappings.error.noSourceMappings": "Alat sumber tidak memiliki pemetaan untuk disalin",
  "analyzer.copyMappings.loading": "Menyalin pemetaan...",
  "analyzer.copyMappings.source": "Alat Sumber",
  "analyzer.copyMappings.source.name": "Nama",
  "analyzer.copyMappings.source.type": "Jenis",
  "analyzer.copyMappings.subtitle": "Salin pemetaan bidang dari {source} ke {target}",
  "analyzer.copyMappings.success": "Sejumlah {count} pemetaan berhasil disalin",
  "analyzer.copyMappings.success.viewTarget": "Lihat Alat yang Dituju",
  "analyzer.copyMappings.summary": "Ringkasan Pemetaan",
  "analyzer.copyMappings.summary.breakdown": "Pemetaan bidang: {fieldCount}, Konversi satuan: {unitCount}, Pemetaan kualitatif: {qualCount}",
  "analyzer.copyMappings.summary.count": "sejumlah {count} pemetaan akan disalin",
  "analyzer.copyMappings.target": "Alat yang Dituju",
  "analyzer.copyMappings.target.placeholder": "Pilih alat yang dituju",
  "analyzer.copyMappings.target.required": "Alat yang Dituju*",
  "analyzer.copyMappings.title": "Salin Pemetaan Bidang",
  "analyzer.copyMappings.warning": "Hal ini akan menyalin semua pemetaan bidang termasuk konversi satuan dan pemetaan nilai kualitatif. Pemetaan sebelumnya akan ditimpa.",
  "analyzer.delete.cancel": "Batalkan",
  "analyzer.delete.delete": "Hapus",
  "analyzer.delete.error": "Error",
  "analyzer.delete.error.noId": "Wajib ada ID Alat",
  "analyzer.delete.error.unknown": "Error saat menghapus alat",
  "analyzer.delete.message": "Apakah Anda yakin ingin menghapus '{name}'? Aksi ini tidak dapat dibatalkan dan akan menghapus semua pemetaan bidang terkait.",
  "analyzer.delete.success": "Alat dihapus",
  "analyzer.delete.title": "Hapus Alat",
  "analyzer.delete.unknown": "Alat Tidak Dikenal",
  "analyzer.errorDashboard.acknowledgeAll": "Mengetahui Semua",
  "analyzer.errorDashboard.action.acknowledge": "Mengetahui",
  "analyzer.errorDashboard.action.menu": "Aksi error",
  "analyzer.errorDashboard.action.viewDetails": "Lihat Rincian",
  "analyzer.errorDashboard.errorType.connection": "Koneksi",
  "analyzer.errorDashboard.errorType.mapping": "Pemetaan",
  "analyzer.errorDashboard.errorType.protocol": "Protokol",
  "analyzer.errorDashboard.errorType.timeout": "Waktu habis",
  "analyzer.errorDashboard.errorType.validation": "Validasi",
  "analyzer.errorDashboard.filter.analyzer": "Alat",
  "analyzer.errorDashboard.filter.analyzer.all": "Semua",
  "analyzer.errorDashboard.filter.search": "Cari error...",
  "analyzer.errorDashboard.filter.severity": "Keparahan",
  "analyzer.errorDashboard.filter.severity.all": "Semua Keparahan",
  "analyzer.errorDashboard.filter.type": "Jenis Error",
  "analyzer.errorDashboard.filter.type.all": "Semua Jenis",
  "analyzer.errorDashboard.severity.critical": "Kritis",
  "analyzer.errorDashboard.severity.error": "Error",
  "analyzer.errorDashboard.severity.warning": "Peringatan",
  "analyzer.errorDashboard.stats.critical": "Kritis",
  "analyzer.errorDashboard.stats.last24Hours": "24 jam terakhir",
  "analyzer.errorDashboard.stats.total": "Total Error",
  "analyzer.errorDashboard.stats.unacknowledged": "Tidak diketahui",
  "analyzer.errorDashboard.status.acknowledged": "Sudah diketahui",
  "analyzer.errorDashboard.status.unacknowledged": "Tidak diketahui",
  "analyzer.errorDashboard.subtitle": "Lihat dan kelola error dan peringatan alat",
  "analyzer.errorDashboard.table.analyzer": "Alat",
  "analyzer.errorDashboard.table.message": "Pesan",
  "analyzer.errorDashboard.table.severity": "Keparahan",
  "analyzer.errorDashboard.table.status": "Status",
  "analyzer.errorDashboard.table.timestamp": "Stempel Waktu",
  "analyzer.errorDashboard.table.type": "Jenis",
  "analyzer.errorDashboard.title": "Dasbor Error",
  "analyzer.errorDetails.acknowledged": "Sudah diketahui",
  "analyzer.errorDetails.acknowledgedBy": "Oleh {user} pada tanggal {date}",
  "analyzer.errorDetails.analyzer": "Alat",
  "analyzer.errorDetails.analyzerId": "ID Alat",
  "analyzer.errorDetails.close": "Tutup",
  "analyzer.errorDetails.copy": "Salin",
  "analyzer.errorDetails.createMapping": "Buat Pemetaan",
  "analyzer.errorDetails.download": "Unduh",
  "analyzer.errorDetails.errorId": "ID Error",
  "analyzer.errorDetails.errorMessage": "Pesan Error",
  "analyzer.errorDetails.errorType": "Jenis Error",
  "analyzer.errorDetails.logs": "Log Alat ({count} entri)",
  "analyzer.errorDetails.recommendedActions": "Aksi yang disarankan",
  "analyzer.errorDetails.recommendedActions.checkConfiguration": "Periksa alamat IP dan konfigurasi portal di pengaturan alat",
  "analyzer.errorDetails.recommendedActions.createMapping": "Buat pemetaan untuk bidang yang belum dipetakan untuk menyelesaikan error ini",
  "analyzer.errorDetails.recommendedActions.testConnection": "Uji koneksi dengan menggunakan fitur 'Uji Koneksi'",
  "analyzer.errorDetails.recommendedActions.verifyConnection": "Verifikasi apakah alat terkoneksi dengan listrik dan kabel jaringan",
  "analyzer.errorDetails.severity": "Keparahan",
  "analyzer.errorDetails.subtitle": "RIncian informasi error dan log alat {id}",
  "analyzer.errorDetails.timestamp": "Stempel Waktu",
  "analyzer.errorDetails.title": "Rincian Error",
  "analyzer.fhirImport.error.importFailed": "Gagal mengimpor FHIR bundle",
  "analyzer.fhirImport.error.invalidBundleType": "Jenis bundle harus berupa 'transaksi' atau 'batch', yang ditampilkan: {bundleType}",
  "analyzer.fhirImport.error.noObservations": "Bundle tidak memiliki Observation dengan hasil",
  "analyzer.fieldCreation.acceptedUnits.label": "Satuan yang diterima",
  "analyzer.fieldCreation.acceptedUnits.placeholder": "Pilih satuan yang diterima",
  "analyzer.fieldCreation.cancel": "Batalkan",
  "analyzer.fieldCreation.confirmation": "Saya mengerti bidang ini akan tersedia untuk pemetaan segera setelah dibuat",
  "analyzer.fieldCreation.create": "Buat Bidang",
  "analyzer.fieldCreation.createNew": "Buat Bidang Baru",
  "analyzer.fieldCreation.description.label": "Deskripsi (Opsional)",
  "analyzer.fieldCreation.description.placeholder": "Masukkan deskripsi bidang",
  "analyzer.fieldCreation.entityType.label": "Jenis Entitas",
  "analyzer.fieldCreation.entityType.placeholder": "Pilih jenis entitas",
  "analyzer.fieldCreation.error.generic": "Gagal membuat bidang",
  "analyzer.fieldCreation.error.title": "Error saat membuat bidang",
  "analyzer.fieldCreation.fieldName.label": "Nama Bidang",
  "analyzer.fieldCreation.fieldName.placeholder": "Masukkan nama bidang",
  "analyzer.fieldCreation.fieldType.label": "Jenis Bidang",
  "analyzer.fieldCreation.fieldType.placeholder": "Pilih jenis bidang",
  "analyzer.fieldCreation.loincCode.label": "Kode LOINC (Opsional)",
  "analyzer.fieldCreation.loincCode.placeholder": "Masukkan kode LOINC",
  "analyzer.fieldCreation.modal.subtitle": "Buat bidang baru yang siap dipetakan segera",
  "analyzer.fieldCreation.modal.title": "Buat Bidang Baru SILNAS",
  "analyzer.fieldCreation.success.message": "Bidang sudah tersedia untuk pemetaan",
  "analyzer.fieldCreation.success.title": "Bidang berhasil dibuat",
  "analyzer.fieldCreation.validation.entityType.required": "Wajib ada jenis entitas",
  "analyzer.fieldCreation.validation.fieldName.required": "Wajib ada nama bidang",
  "analyzer.fieldCreation.validation.unique": "Bidang dengan nama ini sudah ada",
  "analyzer.fieldCreation.validation.units.required": "Satuan yang diterima wajib diisi untuk kolom numerik.",
  "analyzer.fieldMapping.activationModal.activate": "Aktivasi Perubahan",
  "analyzer.fieldMapping.activationModal.cancel": "Batalkan",
  "analyzer.fieldMapping.activationModal.confirmCheckbox": "Saya mengerti perubahan ini akan diterapkan hanya pada pesan baru",
  "analyzer.fieldMapping.activationModal.errorConcurrentEdit": "Perubahan pemetaan terdeteksi. Pengguna lain telah memodifikasi pemetaan alat ini. Mohon memuat ulang halaman untuk melihat perubahan terakhir.",
  "analyzer.fieldMapping.activationModal.errorMissingRequired": "Tidak dapat mengaktivasi: Pemetaan yang wajib tidak ditemukan",
  "analyzer.fieldMapping.activationModal.errorMissingRequired.detail": "Bidang yang wajib tidak ditemukan: {fields}",
  "analyzer.fieldMapping.activationModal.reloadPage": "Memuat ulang halaman",
  "analyzer.fieldMapping.activationModal.subtitle": "Konfirmasi aktivasi perubahan pemetaan untuk alat '{name}'",
  "analyzer.fieldMapping.activationModal.title": "Aktivasi Perubahan Pemetaan",
  "analyzer.fieldMapping.activationModal.viewPendingMessages": "Lihat Pesan Tertunda",
  "analyzer.fieldMapping.activationModal.warning": "Anda akan mengaktivasi perubahan pemetaan untuk alat '{name}'. Perubahan ini akan diterapkan untuk semua pesan yang diterima setelah aktivasi. Hasil yang sudah ada tidak akan terpengaruh.",
  "analyzer.fieldMapping.activationModal.warningActive": "Alat ini tengah aktif. Aktivasi perubahan akan mempengaruhi hasil yang masuk.",
  "analyzer.fieldMapping.activationModal.warningPendingMessages": "Alat ini memiliki sejumlah {count} pesan tertunda di antrian error. Mengaktivasi perubahan pemetaan akan mempengaruhi pemrosesan pesan-pesan tersebut. Disarankan untuk menyelesaikan error terlebih dahulu.",
  "analyzer.fieldMapping.back": "Kembali",
  "analyzer.fieldMapping.fieldType.controlTest": "Pemeriksaan Kontrol",
  "analyzer.fieldMapping.fieldType.custom": "Kustom",
  "analyzer.fieldMapping.fieldType.dateTime": "Tanggal/Waktu",
  "analyzer.fieldMapping.fieldType.meltingPoint": "Titik Leleh",
  "analyzer.fieldMapping.fieldType.numeric": "Numerik",
  "analyzer.fieldMapping.fieldType.qualitative": "Kualitatif",
  "analyzer.fieldMapping.fieldType.text": "Teks",
  "analyzer.fieldMapping.page.subtitle": "Konfigurasi pemetaan bidang antara alat dan SILNAS",
  "analyzer.fieldMapping.page.title": "Pemetaan Bidang",
  "analyzer.fieldMapping.panel.mapping.active": "Aktif",
  "analyzer.fieldMapping.panel.mapping.retired": "Bebas tugas",
  "analyzer.fieldMapping.panel.retire": "Pemetaan yang bebas tugas",
  "analyzer.fieldMapping.panel.retire.disabled.tooltip": "Tidak dapat dibebastugaskan: {reason}",
  "analyzer.fieldMapping.panel.source.fieldsAvailable": "{count} bidang tersedia",
  "analyzer.fieldMapping.panel.source.search": "Cari bidang...",
  "analyzer.fieldMapping.panel.source.title": "Bidang Alat ({type})",
  "analyzer.fieldMapping.panel.status.mapped": "Dipetakan",
  "analyzer.fieldMapping.panel.status.unmapped": "Tidak dipetakan",
  "analyzer.fieldMapping.panel.statusFilter.active": "Hanya yang Aktif",
  "analyzer.fieldMapping.panel.statusFilter.all": "Semua Bidang",
  "analyzer.fieldMapping.panel.statusFilter.draft": "Hanya Draf",
  "analyzer.fieldMapping.panel.statusFilter.label": "Filter berdasarkan Status",
  "analyzer.fieldMapping.panel.statusFilter.mapped": "Hanya yang Dipetakan",
  "analyzer.fieldMapping.panel.statusFilter.unmapped": "Hanya yang Tidak Dipetakan",
  "analyzer.fieldMapping.panel.target.cancel": "Batalkan",
  "analyzer.fieldMapping.panel.target.edit": "Edit",
  "analyzer.fieldMapping.panel.target.remove": "Hapus",
  "analyzer.fieldMapping.panel.target.saveActivate": "Simpan dan Aktivasi",
  "analyzer.fieldMapping.panel.target.saveDraft": "Simpan sebagai Draf",
  "analyzer.fieldMapping.panel.target.selectField": "Pilih bidang di panel kiri untuk melihat dan membuat pemetaan.",
  "analyzer.fieldMapping.panel.target.summary": "Ringkasan Pemetaan",
  "analyzer.fieldMapping.panel.unmappedField.tooltip": "Bidang Tidak Dipetakan - Bidang ini tidak memiliki konfigurasi pemetaan",
  "analyzer.fieldMapping.pendingCodes.actions": "Aksi",
  "analyzer.fieldMapping.pendingCodes.code": "Kode Alat",
  "analyzer.fieldMapping.pendingCodes.empty": "Tidak ada pemetaan kode alat yang tertunda.",
  "analyzer.fieldMapping.pendingCodes.ignore": "Abaikan",
  "analyzer.fieldMapping.pendingCodes.markMapped": "Tandai yang sudah dipetakan",
  "analyzer.fieldMapping.pendingCodes.seenCount": "Terlihat",
  "analyzer.fieldMapping.pendingCodes.status": "Status",
  "analyzer.fieldMapping.pendingCodes.subtitle": "Tinjau dan selesaikan kode alat yang belum dipetakan.",
  "analyzer.fieldMapping.pendingCodes.title": "Pemetaan Kode yang Tertunda",
  "analyzer.fieldMapping.pluginConfig.title": "Snapshot Konfigurasi Plugin",
  "analyzer.fieldMapping.queryAnalyzer": "Alat Kueri",
  "analyzer.fieldMapping.retirementModal.cancel": "Batalkan",
  "analyzer.fieldMapping.retirementModal.confirmation": "Apakah Anda ingin membebastugaskan pemetaan ini? Riwayat pesan masih akan merujuk ke pemetaan ini untuk kepentingan audit.",
  "analyzer.fieldMapping.retirementModal.errorPendingMessages": "Tidak dapat bebas tugas: sejumlah {count} pesan tertunda masih menggunakan pemetaan ini",
  "analyzer.fieldMapping.retirementModal.reasonLabel": "Alasan Pembebastugasan (Opsional)",
  "analyzer.fieldMapping.retirementModal.reasonPlaceholder": "Opsional: Alasan pembebastugasan pemetaan ini",
  "analyzer.fieldMapping.retirementModal.retire": "Bebastugaskan Pemetaan",
  "analyzer.fieldMapping.retirementModal.subtitle": "Konfirmasi pembebastugasan pemetaan bidang",
  "analyzer.fieldMapping.retirementModal.title": "Bebastugaskan Pemetaan",
  "analyzer.fieldMapping.save": "Simpan Pemetaan",
  "analyzer.fieldMapping.stats.pendingCodes": "Kode Tertunda",
  "analyzer.fieldMapping.stats.required": "Pemetaan Wajib Ada",
  "analyzer.fieldMapping.stats.total": "Total Pemetaan",
  "analyzer.fieldMapping.stats.unmapped": "Bidang tidak dipetakan",
  "analyzer.fieldMapping.status.active": "Aktif",
  "analyzer.fieldMapping.status.draft": "Draf",
  "analyzer.fieldMapping.status.retired": "Bebas tugas",
  "analyzer.fieldMapping.status.unmapped": "Tidak dipetakan",
  "analyzer.fieldMapping.testMapping": "Pemetaan Pemeriksaan",
  "analyzer.fieldMapping.warning.missingRequired": "Pemetaan yang diperlukan tidak ditemukan",
  "analyzer.fieldMapping.warning.missingRequired.detail": "Beberapa bidang yang wajib tidak terpetakan. Mohon memetakan semua bidang wajib sebelum mengaktivasi.",
  "analyzer.filter.lifecycleStage.all": "Semua Tahapan Siklus Hidup",
  "analyzer.filter.lifecycleStage.label": "Tahapan Siklus Hidup",
  "analyzer.filter.status": "Status",
  "analyzer.filter.status.all": "Semua Status",
  "analyzer.filter.status.label": "Status",
  "analyzer.filter.testUnit": "Instalasi Lab",
  "analyzer.filter.type": "Jenis Alat",
  "analyzer.form.activeStatus": "Status Aktif",
  "analyzer.form.activeStatus.description": "Aktifkan alat ini untuk koleksi data",
  "analyzer.form.addTitle": "Tambah Alat Baru",
  "analyzer.form.cancel": "Batalkan",
  "analyzer.form.communicationMode": "Mode Komunikasi",
  "analyzer.form.communicationMode.analyzerInitiated": "Alat → SIL (alat terkoneksi ke OpenELIS)",
  "analyzer.form.communicationMode.both": "Bidireksional (dua arah)",
  "analyzer.form.communicationMode.help": "Yang memulai koneksi. Umumnya menggunakan Alat → SIL.",
  "analyzer.form.communicationMode.lisInitiated": "SIL → Alat (SIL terhubung ke alat)",
  "analyzer.form.createdBy": "Dibuat Oleh",
  "analyzer.form.createdDate": "Tanggal/Waktu Dibuat",
  "analyzer.form.defaults.error": "Gagal memuat konfigurasi default",
  "analyzer.form.defaults.loaded": "Konfigurasi default dimuat",
  "analyzer.form.defaults.loaded.subtitle": "Templat untuk {name} berhasil dimuat. Lakukan kustomisasi sebelum menyimpan.",
  "analyzer.form.editTitle": "Edit Alat",
  "analyzer.form.error.invalidCommunicationMode": "Mode komunikasi invalid: {value}. Nilai valid: {validValues}",
  "analyzer.form.error.invalidProtocolVersion": "Versi protokol invalid: {value}. Nilai valid: {validValues}",
  "analyzer.form.error.save": "Gagal menyimpan alat",
  "analyzer.form.error.unknown": "Terjadi error yang tidak diketahui",
  "analyzer.form.fileProtocol.description": "Alat ini mengimpor hasil dari file. Pengaturan impor akan dikonfigurasi setelah menyimpan.",
  "analyzer.form.fileProtocol.title": "Protokol Impor File",
  "analyzer.form.identifierPattern": "Pola Pengidentifikasi",
  "analyzer.form.identifierPattern.helperText": "Pola Regex untuk mencocokkan pengidentfikasi pesan masuk untuk routing",
  "analyzer.form.identifierPattern.placeholder": "misalnya, ^ABX\\^PENTRA.*",
  "analyzer.form.ipAddress": "Alamat IP",
  "analyzer.form.ipAddress.placeholder": "192.168.1.10",
  "analyzer.form.lastModified": "Tanggal/Waktu Modifikasi Terakhir",
  "analyzer.form.loadDefaultConfig": "Muat Konfigurasi Default",
  "analyzer.form.loadDefaultConfig.helperText": "Pengaturan cepat menggunakan templat alat pre-konfigurasi untuk plugin GenericASTM dan GenericHL7",
  "analyzer.form.loadDefaultConfig.placeholder": "Pilih templat alat pre-konfigurasi",
  "analyzer.form.name": "Nama Alat",
  "analyzer.form.name.placeholder": "misalnya, Hematology Analyzer 1",
  "analyzer.form.pluginType": "Jenis Plugin",
  "analyzer.form.pluginType.helperText": "Plugin alat yang akan menangani pesan masuk",
  "analyzer.form.pluginType.placeholder": "Pilih jenis plugin...",
  "analyzer.form.port": "Nomor Portal",
  "analyzer.form.port.placeholder": "5000",
  "analyzer.form.protocolVersion": "Versi Protokol",
  "analyzer.form.save": "Simpan",
  "analyzer.form.status": "Status",
  "analyzer.form.status.helperText": "Transisi status berdasarkan status alat. Pembatalan manual hanya untuk INAKTIF, PENGATURAN, dan VALIDASI.",
  "analyzer.form.subtitle": "Konfigurasi pengaturan koneksi alat dan instalasi lab",
  "analyzer.form.success.save": "Alat berhasil disimpan",
  "analyzer.form.testConnection": "Tes Koneksi",
  "analyzer.form.testConnection.error": "Koneksi Gagal",
  "analyzer.form.testUnits": "Penugasan Instalasi Lab",
  "analyzer.form.testUnits.helper": "Pilih satu atau lebih instalasi lab untuk alat ini",
  "analyzer.form.testUnits.placeholder": "Pilih instalasi lab...",
  "analyzer.form.type": "Jenis Alat",
  "analyzer.form.type.other": "Lainnya",
  "analyzer.form.type.placeholder": "Pilih jenis alat",
  "analyzer.form.validation.ipAddress.invalid": "Format alamat IP tidak valid",
  "analyzer.form.validation.name.required": "Wajib mengisi nama alat",
  "analyzer.form.validation.type.required": "Wajib mengisi jenis alat",
  "analyzer.hl7.insertError": "Error memasukkan HL7",
  "analyzer.hl7.parseError": "Error saat mengurai HL7",
  "analyzer.hl7.unknownAnalyzer": "Tidak dapat mengidentifikasi dari HL7 MSH (aplikasi/fasilitas yang mengirim)",
  "analyzer.list.subtitle": "Kelola alat laboratorium dan pemetaan bidang",
  "analyzer.list.title": "Alat",
  "analyzer.navigation.analyzerTypes": "Jenis Alat",
  "analyzer.navigation.analyzers": "Alat",
  "analyzer.navigation.analyzersList": "Daftar Alat",
  "analyzer.navigation.errorDashboard": "Dasbor Error",
  "analyzer.navigation.fieldMappings": "Pemetaan Bidang",
  "analyzer.navigation.qc": "Kendali Mutu",
  "analyzer.navigation.qcDashboard": "Dasbor QC",
  "analyzer.navigation.qcAlerts": "Peringatan dan Pelanggaran Kendali Mutu",
  "analyzer.navigation.qcCorrectiveActions": "Tindakan perbaikan",
  "analyzerType.page.title": "Jenis Alat",
  "analyzerType.column.name": "Nama",
  "analyzerType.column.description": "Deskripsi",
  "analyzerType.column.protocol": "Protokol",
  "analyzerType.column.pluginClass": "Kelas Plugin",
  "analyzerType.column.genericPlugin": "Plugin Generik",
  "analyzerType.column.identifierPattern": "Pola Pengidentifikasi",
  "analyzerType.column.pluginLoaded": "Plugin Dimuat",
  "analyzerType.column.instances": "Instance",
  "analyzerType.column.status": "Status",
  "analyzerType.search.placeholder": "Cari jenis alat...",
  "analyzerType.button.create": "Buat Jenis Alat Baru",
  "analyzerType.button.creating": "Membuat...",
  "analyzerType.button.cancel": "Batal",
  "analyzerType.modal.createTitle": "Buat Jenis Alat Baru",
  "analyzerType.field.name": "Nama",
  "analyzerType.field.description": "Deskripsi",
  "analyzerType.field.protocol": "Protokol",
  "analyzerType.field.selectProtocol": "Pilih protokol",
  "analyzerType.field.pluginClassName": "Nama Kelas Plugin",
  "analyzerType.field.identifierPattern": "Pola Pengidentifikasi",
  "analyzerType.field.identifierPatternHelper": "Pola regex untuk mencocokkan pengidentifikasi sampel (misal. ^[A-Z]{2}\\d{6}$)",
  "analyzerType.field.isGenericPlugin": "Plugin Generik",
  "analyzerType.field.isActive": "Aktif",
  "analyzerType.error.nameRequired": "Wajb ada nama ",
  "analyzerType.notification.createSuccess": "Membuat jenis alat berhasil",
  "analyzerType.notification.createError": "Gagal membuat jenis alat",
  "analyzer.navigation.qcControlLots": "Lot Kontrol",
  "analyzer.navigation.qcRuleConfig": "Konfigurasi Aturan",
  "analyzer.page.addButton": "Tambah Alat",
  "analyzer.page.hierarchy.list": "Daftar Alat",
  "analyzer.page.hierarchy.mappings": "Pemetaan Bidang",
  "analyzer.page.hierarchy.root": "Alat",
  "analyzer.page.title": "Alat",
  "analyzer.plugin.missing": "Plugin Tidak Ditemukan",
  "analyzer.qc.alerts.message": "Fitur peringatan dan pelanggaran akan segera tersedia.",
  "analyzer.qc.alerts.title": "Peringatan dan Pelanggaran Kendali Mutu",
  "analyzer.qc.corrective.message": "Fitur tindakan perbaikan akan segera tersedia.",
  "analyzer.qc.corrective.title": "Tindakan Perbaikan",
  "analyzer.qc.placeholder.message": "Fitur Kendali Mutu akan segera tersedia.",
  "analyzer.qc.placeholder.title": "Kendali Mutu",
  "analyzer.qualitativeMapping.isDefault": "Default",
  "analyzer.qualitativeMapping.mappings": "Pemetaan Nilai",
  "analyzer.qualitativeMapping.noValues": "Tidak ada nilai alat tersedia untuk pemetaan",
  "analyzer.qualitativeMapping.openelisCode.placeholder": "Pilih kode SILNAS",
  "analyzer.qualitativeMapping.subtitle": "Pemetaan nilai kualitatif untuk {fieldName}",
  "analyzer.qualitativeMapping.title": "Pemetaan Nilai Kualitatif",
  "analyzer.qualitativeMapping.validation.error": "Kesalahan Validasi",
  "analyzer.qualitativeMapping.validation.error.subtitle": "Perbaiki error di bawah ini",
  "analyzer.qualitativeMapping.validation.noDefault": "Tidak ada nilai default",
  "analyzer.qualitativeMapping.validation.noDefault.subtitle": "Setidaknya satu pemetaan harus ditandai sebagai default",
  "analyzer.qualitativeMapping.validation.openelisCode.required": "Wajib mengisi kode SILNAS",
  "analyzer.query.button": "Kueri Alat",
  "analyzer.query.cancel": "Batal",
  "analyzer.query.modal.logs": "Log Koneksi",
  "analyzer.query.modal.noLogs": "Belum ada log",
  "analyzer.query.modal.progress": "Progress",
  "analyzer.query.modal.state": "Status",
  "analyzer.query.modal.subtitle": "Ambil bidang yang tersedia dari alat",
  "analyzer.query.modal.title": "Kueri Alat",
  "analyzer.query.progress": "{percent}% selesai",
  "analyzer.search.label": "Cari",
  "analyzer.search.placeholder": "Cari Alat...",
  "analyzer.stat.active": "Aktif",
  "analyzer.stat.inactive": "Inaktif",
  "analyzer.stat.pluginWarnings": "Peringatan Plugin",
  "analyzer.stat.total": "Total Alat",
  "analyzer.stats.active": "Alat Aktif",
  "analyzer.stats.inactive": "Alat Inaktif",
  "analyzer.stats.total": "Total Alat",
  "analyzer.status.active": "Aktif",
  "analyzer.status.deleted": "Hapus",
  "analyzer.status.error_pending": "Error Tertunda",
  "analyzer.status.inactive": "Inaktif",
  "analyzer.status.offline": "Offline",
  "analyzer.status.pending_registration": "Registrasi Tertunda",
  "analyzer.status.setup": "Pengaturan",
  "analyzer.status.validation": "Validasi",
  "analyzer.success.save": "Alat berhasil disimpan",
  "analyzer.table.actions": "Aksi",
  "analyzer.table.connection": "Koneksi",
  "analyzer.table.header.connection": "Koneksi",
  "analyzer.table.header.lastModified": "Dimodifikasi Terakhir",
  "analyzer.table.header.name": "Nama",
  "analyzer.table.header.status": "Status",
  "analyzer.table.header.testUnits": "Instalasi Lab",
  "analyzer.table.header.type": "Jenis",
  "analyzer.table.lastModified": "Dimodifikasi Terakhir",
  "analyzer.table.name": "Nama",
  "analyzer.table.status": "Status",
  "analyzer.table.testUnits": "Instalasi Lab",
  "analyzer.table.type": "Jenis",
  "analyzer.testConnection.bridge.healthCheckFailed": "Tidak dapat mencapai bridge health endpoint di {url}: {detail}",
  "analyzer.testConnection.bridge.httpStatus": "Bridge returned HTTP {status}",
  "analyzer.testConnection.bridge.notConfigured": "Bridge tidak dikonfigurasi",
  "analyzer.testConnection.bridge.unparseableResponse": "Bridge respon unparsable (tidak dapat di parse)",
  "analyzer.testConnection.bridge.unreachable": "Tidak dapat mencapai bridge: {detail}",
  "analyzer.testConnection.close": "Tutup",
  "analyzer.testConnection.logs": "Log Koneksi",
  "analyzer.testConnection.requestBuildFailed": "Gagal membuat request: {detail}",
  "analyzer.testConnection.success": "Koneksi Berhasil",
  "analyzer.testConnection.tcp.bridgeNotConfigured": "Bridge tidak dikonfigurasi, koneksi dengan alat tidak dapat diuji coba",
  "analyzer.testConnection.testAgain": "Uji Kembali",
  "analyzer.testConnection.testing": "Menguji koneksi...",
  "analyzer.testConnection.title": "Uji Koneksi",
  "analyzer.testMapping.activeMappings": "{count} pemetaan aktif",
  "analyzer.testMapping.analyzerInfo": "Informasi Alat",
  "analyzer.testMapping.analyzerName": "Nama Alat",
  "analyzer.testMapping.analyzerType": "Jenis Alat",
  "analyzer.testMapping.appliedMappings": "Pemetaan yang Diterapkan",
  "analyzer.testMapping.entityPreview": "Pratinjau Entitas SILNAS",
  "analyzer.testMapping.errors": "Error",
  "analyzer.testMapping.loading": "Memproses pratinjau...",
  "analyzer.testMapping.messageInput": "Sampel Pesan ASTM",
  "analyzer.testMapping.messageInput.counter": "{current} / {max} karakter",
  "analyzer.testMapping.messageInput.helper": "Masukkan pesan sampel ASTM untuk pratinjau bagaimana interpretasinya",
  "analyzer.testMapping.messageInput.placeholder": "H|\\^&|||PSM^Micro^2.0|...",
  "analyzer.testMapping.messageInput.required": "Sampel Pesan ASTM *",
  "analyzer.testMapping.noResults": "Belum ada hasil pratinjau. Masukkan sampel pesan ASTM dan klik Pratinjau Pemetaan.",
  "analyzer.testMapping.parsedFields": "Bidang yang diurai",
  "analyzer.testMapping.parsedFields.astmRef": "ASTM Ref",
  "analyzer.testMapping.parsedFields.fieldName": "Nama Bidang",
  "analyzer.testMapping.parsedFields.interpretation": "Interpretasi",
  "analyzer.testMapping.parsedFields.mappedTo": "Dipetakan ke",
  "analyzer.testMapping.parsedFields.rawValue": "Nilai Mentah",
  "analyzer.testMapping.pluginConfigSnapshot": "Snapshot Konfigurasi Plugin",
  "analyzer.testMapping.previewOptions": "Opsi Pratinjau",
  "analyzer.testMapping.previewOptions.detailedParsing": "Tunjukkan rincian tahapan penguraian",
  "analyzer.testMapping.previewOptions.validateAll": "Validasi semua pemetaan",
  "analyzer.testMapping.results": "Pratinjau Hasil",
  "analyzer.testMapping.saveTestCase": "Simpan sebagai Kasus Pengujian",
  "analyzer.testMapping.submit": "Pratinjau Pemetaan",
  "analyzer.testMapping.subtitle": "Pratinjau bagaimana sampel pesan ASTM akan diinterpretasi",
  "analyzer.testMapping.testAnother": "Uji Pesan Lainnya",
  "analyzer.testMapping.title": "Pemetaan Bidang Pemeriksaan",
  "analyzer.testMapping.validation.invalidFormat": "Format pesan ASTM invalid",
  "analyzer.testMapping.validation.messageRequired": "Pesan ASTM wajib ada",
  "analyzer.testMapping.validation.messageTooLarge": "Pesan ASTM melebihi maksimum 10KB",
  "analyzer.testMapping.warnings": "Peringatan",
  "analyzer.unitMapping.analyzerUnit": "Satuan Sumber (Alat)",
  "analyzer.unitMapping.analyzerUnit.helper": "Satuan yang dilaporkan oleh alat",
  "analyzer.unitMapping.conversionFactor": "Faktor Konversi",
  "analyzer.unitMapping.conversionFactor.helper": "Faktor untuk mengkonversi dari {from} ke {to} (misalnya, 0.0555 mg/dL ke mmol/L)",
  "analyzer.unitMapping.openelisUnit": "Satuan Target (SILNAS)",
  "analyzer.unitMapping.openelisUnit.helper": "Satuan resmi digunakan di SILNAS",
  "analyzer.unitMapping.openelisUnit.placeholder": "Pilih satuan target",
  "analyzer.unitMapping.rejectIfMismatch": "Tolak bila Satuan Tidak Cocok",
  "analyzer.unitMapping.rejectIfMismatch.helper": "Tolak pesan bila satuan tidak cocok dan tidak ada faktor konversi yang tersedia",
  "analyzer.unitMapping.subtitle": "Konfigurasi pemetaan satuan untuk {fieldName}",
  "analyzer.unitMapping.title": "Pemetaan Satuan",
  "analyzer.unitMapping.validation.analyzerUnit.required": "Satuan sumber wajib ada",
  "analyzer.unitMapping.validation.conversionFactor.invalid": "Faktor konversi harus angka positif",
  "analyzer.unitMapping.validation.conversionFactor.required": "Faktor konversi wajib ada jika satuan berbeda",
  "analyzer.unitMapping.validation.error": "Kesalahan Validasi",
  "analyzer.unitMapping.validation.error.subtitle": "Mohon perbaiki error di bawah",
  "analyzer.unitMapping.validation.openelisUnit.required": "Satuan target wajib ada",
  "analyzer.qcRules.modal.title": "Aturan Identifikasi Sample QC — {analyzerName}",
  "analyzer.qcRules.breadcrumb": "QC Sample Identification Rules",
  "analyzer.qcRules.orSemantics": "Aturan yang digunakan ATAU semantik:  sampel akan di tandai sebagai QC jika ADA kecocokan aturan yang aktif.",
  "analyzer.qcRules.addRule": "Tambah Aturan",
  "analyzer.qcRules.deleteRule": "Hapus Aturan",
  "analyzer.qcRules.noRules": "Tidak ada konfigurasi aturan QC. Tambah setidaknya satu aturan sebelum mengaktivasi alat.",
  "analyzer.qcRules.ruleType": "Jenis Aturan",
  "analyzer.qcRules.targetField": "Referensi Lapangan",
  "analyzer.qcRules.targetField.placeholder": "Misalnya, O.12, QC_TASK",
  "analyzer.qcRules.operand": "Cocokkan Nilai",
  "analyzer.qcRules.operand.placeholder": "Misalnya, Q, CNEG, ^(CNEG|CPOS).*",
  "analyzer.qcRules.error.loadFailed": "Gagal memuat aturan QC",
  "analyzer.qcRules.error.saveFailed": "Gagal menyimpan aturan QC",
  "analyzer.qcRules.error.deleteFailed": "Gagal menghapus aturan QC",
  "analyzerTestName.header.analyzerName": "Alat - Nama Alat Uji",
  "analyzerTestName.modal.add.heading": "Tambah Nama Alat Uji",
  "analyzerTestName.modal.update.heading": "Perbarui Nama Alat Uji",
  "assigned.cytopathologist.label": "Ahli Sitopatologi ditugaskan",
  "assigned.pathologist.label": "Ahli Patologi ditugaskan",
  "assigned.technician.label": "Teknisi ditugaskan",
  "audittrail.table.heading.action": "Tindakan",
  "audittrail.table.heading.identifier": "Pengidentifikasi",
  "audittrail.table.heading.item": "Barang",
  "audittrail.table.heading.newvalue": "Nilai Baru",
  "audittrail.table.heading.oldvalue": "Nilai Lama",
  "audittrail.table.heading.time": "Waktu",
  "audittrail.table.heading.user": "Pengguna",
  "audittrail.table.title.patientResults": "Hasil Pasien",
  "availabletests.title": "Pemeriksaan Tersedia",
  "back.action.button": "Kembali",
  "banner.menu.administration": "Admin",
  "banner.menu.alerts": "Peringatan",
  "banner.menu.alerts.tooltip": "Dasbor peringatan dan penjaminan mutu",
  "banner.menu.aliquot": "Alikuot",
  "banner.menu.aliquot.tooltip": "Alikuot sampel",
  "banner.menu.billing": "Pembayaran",
  "banner.menu.billing.tooltip": "Pembayaran",
  "banner.menu.createDouble": "Entri Ganda",
  "banner.menu.createInitial": "Entri Awal",
  "banner.menu.eorders": "Pemesanan yang masuk",
  "banner.menu.eqa": "PME",
  "banner.menu.eqa.distribution": "Distribusi PME",
  "banner.menu.eqa.distribution.tooltip": "Buat dan kelola distribusi PME",
  "banner.menu.eqa.management": "Program PME",
  "banner.menu.eqa.management.tooltip": "Buat dan kelola program PME",
  "banner.menu.eqa.mgmt": "Pengelolaan PME",
  "banner.menu.eqa.mgmt.distributions": "Distribusi",
  "banner.menu.eqa.mgmt.distributions.tooltip": "Buat dan kelola distribusi PME",
  "banner.menu.eqa.mgmt.participants": "Peserta",
  "banner.menu.eqa.mgmt.participants.tooltip": "Kelola pendaftaran organisasi di program PME",
  "banner.menu.eqa.mgmt.programs": "Program",
  "banner.menu.eqa.mgmt.programs.tooltip": "Buat dan kelola program PME",
  "banner.menu.eqa.mgmt.results": "Hasil & Analisis",
  "banner.menu.eqa.mgmt.results.tooltip": "Pengumpulan hasil PME dan analisis statistik",
  "banner.menu.eqa.mgmt.tooltip": "Kelola program, peserta, dan distribusi PME",
  "banner.menu.eqa.tests": "Pemeriksaan PME",
  "banner.menu.eqa.tests.myPrograms": "Program Saya",
  "banner.menu.eqa.tests.myPrograms.tooltip": "Kelola pendaftaran pribadi untuk program PME eksternal",
  "banner.menu.eqa.tests.orders": "Pemesanan",
  "banner.menu.eqa.tests.orders.tooltip": "Lihat dan kelola pemesanan pemeriksaan PME",
  "banner.menu.eqa.tests.tooltip": "Pemesanan pemeriksaan PME dan pendaftaran program",
  "banner.menu.eqa.tooltip": "Pemantapan Mutu Eksternal",
  "banner.menu.generic.sample": "Sampel Generik",
  "banner.menu.generic.sample.edit": "Edit Sampel",
  "banner.menu.generic.sample.import": "Impor Sampel",
  "banner.menu.generic.sample.order": "Penerimaan Sampel",
  "banner.menu.generic.sample.results": "Masukkan Hasil",
  "banner.menu.help": "Bantuan",
  "banner.menu.help.about": "Tutorial Video",
  "banner.menu.help.contact": "Catatan rilis",
  "banner.menu.help.documents": "Dokumentasi Proses",
  "banner.menu.help.formDBS": "Formulir Dried Blood Spot",
  "banner.menu.help.formVL": "Formulir Viral Load",
  "banner.menu.help.usermanual": "Panduan Pengguna",
  "banner.menu.home": "Beranda",
  "banner.menu.inventory": "Inventaris",
  "banner.menu.inventory.catalog": "Kelola Katalog",
  "banner.menu.inventory.dashboard": "Dasbor",
  "banner.menu.inventory.list": "Barang Inventaris",
  "banner.menu.inventory.reports": "Laporan",
  "banner.menu.nonconformity": "Ketidaksesuaian",
  "banner.menu.nonconformity.correctiveActions": "Tindakan perbaikan",
  "banner.menu.nonconformity.dashboard": "Semua Kejadian Ketidaksesuaian",
  "banner.menu.nonconformity.report": "Laporan Kejadian Ketidaksesuaian",
  "banner.menu.nonconformity.view": "Lihat Kejadian Ketidaksesuaian Baru",
  "banner.menu.patient": "Pasien",
  "banner.menu.patient.Create": "Kajian",
  "banner.menu.patient.addOrEdit": "Tambah/Edit Pasien",
  "banner.menu.patient.merge": "Gabung Pasien",
  "banner.menu.patient.merge.tooltip": "Gabung duplikasi rekaman pasien",
  "banner.menu.patientConsult": "Lihat",
  "banner.menu.patientEdit": "Edit",
  "banner.menu.patienthistory": "Riwayat Pasien",
  "banner.menu.printBarcode": "Kode QR",
  "banner.menu.referredOut": "Dirujuk keluar",
  "banner.menu.report.validation.backlog": "Validasi Tertunda",
  "banner.menu.reports": "Laporan",
  "banner.menu.reports.routine": "Rutin",
  "banner.menu.reports.study": "Kajian",
  "banner.menu.results": "Hasil",
  "banner.menu.results.CobasIntegra400": "Biokimia: Cobas Integra 400+",
  "banner.menu.results.FacsCalibur": "Imunologi: FacsCalibur",
  "banner.menu.results.FacsCantoII": "Imunologi: FacsCantoII",
  "banner.menu.results.FacsPrestoanalyzer": "Imunologi: FacsPresto",
  "banner.menu.results.Fullyanalyzer": "Biokimia: Pengimpor seluruh alat",
  "banner.menu.results.GeneXpertAnalyzer": "GeneXpertAnalyzer",
  "banner.menu.results.GeneXpertanalyzer": "GeneXpertFileAnalyzer",
  "banner.menu.results.PocH100iAnalyzer": "PocH100iAnalyze",
  "banner.menu.results.SysmeXT": "Hematologi: SysmeXT 2000i",
  "banner.menu.results.SysmexXNLAnalyzer": "SysmexXNLAnalyzer",
  "banner.menu.results.SysmexXNLanalyzer": "SysmexXNL Analyzer",
  "banner.menu.results.SysmexXPAnalyzer": "SysmexXPAnalyzer",
  "banner.menu.results.SysmexXPanalyzer": "SysmexXP Analyzer",
  "banner.menu.results.accession": "Berdasarkan Pemesanan",
  "banner.menu.results.analyzer": "Alat",
  "banner.menu.results.cobasc111analyzer": "Biokimia: Cobas C111",
  "banner.menu.results.genexpertanalyzer": "GeneXpert",
  "banner.menu.results.logbook": "Berdasarkan Unit",
  "banner.menu.results.mindrayanalyzer": "Mindray",
  "banner.menu.results.order.programmes": "Pemesanan Program",
  "banner.menu.results.patient": "Berdasarkan Pasien",
  "banner.menu.results.quantstudio3analyzer": "QuantStudio 3",
  "banner.menu.results.status": "Berdasarkan Pemeriksaan, Tanggal atau Status",
  "banner.menu.results.sysmexanalyzer": "Hematologi: Sysmex XT 2000 i",
  "banner.menu.results.sysmexxtanalyzer": "Hematologi: Pengimport Sysmex XT analyzer",
  "banner.menu.results.taqman48dbsanalyzer": "Virologi: Cobas TaqMan48 DNA PCR",
  "banner.menu.results.testdate": "Berdasarkan Tanggal Pemeriksaan",
  "banner.menu.results.unified": "Results Entry",
  "banner.menu.results.unified.tooltip": "Unified results entry worklist",
  "banner.menu.results.weber": "Weber 4000",
  "banner.menu.resultvalidation": "Validasi",
  "banner.menu.resultvalidation.bacteria": "Bakteri",
  "banner.menu.resultvalidation.bench": "Berdasarkan Meja Kerja",
  "banner.menu.resultvalidation.biochemistry": "Biokimia",
  "banner.menu.resultvalidation.cytobacteriology": "Sitobakteriologi",
  "banner.menu.resultvalidation.dnapcr": "DNA PCR",
  "banner.menu.resultvalidation.ecbu": "ECBU",
  "banner.menu.resultvalidation.endocrinologie": "Endokrinologi",
  "banner.menu.resultvalidation.genotyping": "Genotiping",
  "banner.menu.resultvalidation.hemato-immunology": "Hemato-imunologi",
  "banner.menu.resultvalidation.hematology": "Hematologi",
  "banner.menu.resultvalidation.immunology": "Imunologi",
  "banner.menu.resultvalidation.immunology.Haiti": "Imuno-virologi",
  "banner.menu.resultvalidation.immunologyHematology": "Imuno - hematologi",
  "banner.menu.resultvalidation.liquidBio": "Cairan biologis",
  "banner.menu.resultvalidation.malaria": "Malaria",
  "banner.menu.resultvalidation.molecularBio": "Biologi Molekuler",
  "banner.menu.resultvalidation.mycobacteriology": "Mikobakteriologi",
  "banner.menu.resultvalidation.mycology": "Mikologi",
  "banner.menu.resultvalidation.parasitology": "Parasitologi",
  "banner.menu.resultvalidation.serology": "Serologi",
  "banner.menu.resultvalidation.serology-immunology": "Serologi-Imunologi",
  "banner.menu.resultvalidation.viralload": "Viral Load",
  "banner.menu.resultvalidation.virology": "Virologi",
  "banner.menu.resultvalidation_routine": "Rutin",
  "banner.menu.resultvalidation_study": "Kajian",
  "banner.menu.sample": "Pemesanan",
  "banner.menu.sample.shipment": "Pengiriman Sampel",
  "banner.menu.sampleAdd": "Tambah Pemesanan",
  "banner.menu.sampleBatchEntry": "Masukkan Pemesanan Batch",
  "banner.menu.sampleConsult": "Lihat",
  "banner.menu.sampleCreate": "Kajian",
  "banner.menu.sampleEdit": "Edit Pemesanan",
  "banner.menu.sampleManagement": "Pengelolaan Sampel",
  "banner.menu.sampleManagement.tooltip": "Menu Pengelolaan Sampel",
  "banner.menu.storage": "Penyimpanan",
  "banner.menu.storage.tooltip": "Pengelolaan Penyimpanan Sampel",
  "banner.menu.study.eorders": "Pemesanan Elektronik",
  "banner.menu.workplan": "Rencana Kerja",
  "banner.menu.workplan.bench": "Berdasarkan Unit",
  "banner.menu.workplan.panel": "Berdasarkan Panel",
  "banner.menu.workplan.priority": "Berdasarkan Prioritas",
  "banner.menu.workplan.test": "Berdasarkan Jenis Pemeriksaan",
  "banner.menu.workplan.unit": "Berdasarkan Bagian Pemeriksaan",
  "barcode.additionalInvalidLevels.message": "Kode QR memiliki tingkatan di luar bagian yang valid. Hanya tingkatan valid yang diisi.",
  "barcode.additionalInvalidLevels.warning": "Tingkatan tidak valid lainnya terdeteksi",
  "barcode.autoOpenForm": "Membuka formulir lokasi dengan hirarki yang valid",
  "barcode.debounce.warning": "Silahkan tunggu sebelum memindai kode QR lain",
  "barcode.error": "Kode QR tidak valid",
  "barcode.firstMissingLevel": "Tingkatan pertama yang hilang: {level}",
  "barcode.format": "Format Kode QR",
  "barcode.header": "kode QR",
  "barcode.invalidFormat": "Format kode QR tidak valid. Aturan: RUANGAN-PERANGKAT atau RUANGAN-PERANGKAT-RAK-LACI-POSISI",
  "barcode.label.block": "Label blok",
  "barcode.label.freezer": "Label freezer",
  "barcode.label.helper.text": "Masukkan nilai dalam: mm",
  "barcode.label.order": "Label Pemesanan",
  "barcode.label.slide": "Label slide",
  "barcode.label.specimen": "Label spesimen",
  "barcode.label.info.blockCaseNumber": "Nomor Kasus Blok",
  "barcode.label.info.blockId": "ID Blok",
  "barcode.label.info.blockNumber": "Nomor Blok",
  "barcode.label.info.boxid": "ID Boks",
  "barcode.label.info.caseNumber": "Nomor Kasus",
  "barcode.label.info.collectedBy": "Dikumpulkan oleh",
  "barcode.label.info.collectionDate": "Tanggal Pengambilan",
  "barcode.label.info.collectionDateTime": "Tanggal dan Waktu Pengumpulan",
  "barcode.label.info.created": "Dibuat",
  "barcode.label.info.destination": "Tujuan",
  "barcode.label.info.expiryDate": "Tanggal Kedaluwarsa",
  "barcode.label.info.labNumber": "Nomor Registrasi",
  "barcode.label.info.patientDobFull": "Tanggal Lahir Pasien",
  "barcode.label.info.patientId": "NIK Pasien",
  "barcode.label.info.patientName": "Nama Pasien",
  "barcode.label.info.patientSexFull": "Jenis Kelamin Pasien",
  "barcode.label.info.samplecount": "Sampel",
  "barcode.label.info.siteId": "Site Id",
  "barcode.label.info.slideId": "ID slide",
  "barcode.label.info.slideNumber": "Nomor Slide",
  "barcode.label.info.specimenType": "Jenis Spesimen",
  "barcode.label.info.stainType": "Jenis Pewarnaan",
  "barcode.label.info.storageLocation": "Lokasi Penyimpanan",
  "barcode.label.info.temperature": "Suhu",
  "barcode.label.info.tests": "Pemeriksaan",
  "barcode.labels.order.row": "Label pemesanan",
  "barcode.labels.running.total": "Total pengerjaan",
  "barcode.labels.sample.row": "Contoh label spesimen {sampleNumber}",
  "barcode.labels.section.title": "Kuantitas label",
  "barcode.locationNotFound": "Lokasi tidak ditemukan",
  "barcode.notification.save": "Konfigurasi kode QR telah disimpan",
  "barcode.partialMatch": "Kecocokan parsial - beberapa komponen valid",
  "barcode.print.button": "Cetak",
  "barcode.print.dialog.quantityFor": "Kuantitas yang akan dicetak {label}",
  "barcode.print.dialog.title": "Cetak label",
  "barcode.print.done": "Selesai",
  "barcode.print.individual.button": "Cetak Label",
  "barcode.print.later": "Loncat — Cetak Nanti",
  "barcode.print.preprint": "Kode QR pra-cetak",
  "barcode.print.preprint.button": "Label pra-cetak",
  "barcode.print.preprint.note": "Catatan: Bila ada penambahan institusi dan/atau sampel dan pemeriksaan, data tersebut akan dicetak di SEMUA label",
  "barcode.print.reprint.dialog": "Cetak ulang label",
  "barcode.print.section.set": "Pengaturan cetak",
  "barcode.print.set.button": "Pengaturan Cetak",
  "barcode.print.set.instruction": "Pengaturan cetak untuk label (2 label pemesanan pemeriksaan+ 1 label per spesimen)",
  "barcode.print.skip": "Skip",
  "barcode.print.title": "Cetak Label Kode QR",
  "barcode.ready": "Siap untuk memindai",
  "barcode.scan": "Pindai kode QR",
  "barcode.scan.error": "Pemesanan tidak ditemukan",
  "barcode.scan.placeholder": "Pindai Kode QR atau masukkan nomor lab...",
  "barcode.scan.success": "Pemesanan berhasil dimuat",
  "barcode.scanning": "Memindai...",
  "barcode.scanOrType": "Pindai kode QR atau ketik lokasi",
  "barcode.success": "Lokasi ditemukan",
  "barcode.validHierarchyPrefilled": "Tingkatan hirarki yang valid telah terisi",
  "barcode.validation.altPrefix": "Input harus alphanumeric dan mengandung maksimum 4 karakter.",
  "barcode.validationFailed": "Validasi kode QR gagal",
  "barcodeconfiguration.browse.title": "Konfigurasi Kode QR",
  "breadcrumb.home": "Beranda",
  "breadcrumb.caseView": "Case View",
  "breadcrums.admin.managment": "Pengelolaan Admin",
  "calendar.management.title": "Pengelolaan Kalender",
  "calendar.management.description": "Kelola libur nasional dan konfigurasi akhir pekan untuk penghitungan TAT di jam kerja",
  "calendar.management.addHoliday": "Tambah hari libur",
  "calendar.management.editHoliday": "Edit hari libur",
  "calendar.management.deleteConfirm": "Apakah Anda mau menghapus hari libur ini?",
  "calendar.management.holidayName": "Nama Hari Libur",
  "calendar.management.date": "Tanggal",
  "calendar.management.recurring": "Pengulangan",
  "calendar.management.annual": "Tahunan",
  "calendar.management.oneTime": "Sekali",
  "calendar.management.active": "Aktif",
  "calendar.management.inactive": "Inaktif",
  "calendar.management.weekend": "Akhir pekan",
  "calendar.management.weekendDays": "Hari Akhir Pekan (dikeluarkan dari Jam Kerja)",
  "calendar.management.weekendSaved": "Konfigurasi akhir pekan disimpan",
  "calendar.management.importCsv": "Impor CSV",
  "calendar.management.exportCsv": "Ekspor CSV",
  "calendar.management.importPreview": "Pratinjau Impor",
  "calendar.management.year": "Tahun",
  "calendar.management.noHolidays": "Tidak ada Hari Libur dikonfigurasi untuk {year}. Klik \"Tambah Hari Libur\" untuk mulai.",
  "calendar.management.duplicateDate": "Hari Libur sudah ada di tanggal ini",
  "calendar.management.imported": "{count} hari libur diimpor",
  "calendar.management.skipped": "{count} hari libur diloncat",
  "calendar.management.holidayCount": "{count} hari libur dikonfigurasi untuk {year}",
  "calendar.management.saveError": "Error menyimpan hari libur",
  "calendar.management.loadError": "Error menyimpan hari libur",
  "calendar.management.save": "Simpan",
  "calendar.management.cancel": "Batal",
  "calendar.management.actions": "Aksi",
  "calendar.management.status": "Status",
  "calendar.management.column.date": "Tanggal",
  "calendar.management.column.holidayName": "Nama Hari Libur",
  "calendar.management.column.recurring": "Pengulangan",
  "calendar.management.column.status": "Status",
  "calendar.management.column.actions": "Aksi",
  "calendar.management.day.sun": "Min",
  "calendar.management.day.mon": "Sen",
  "calendar.management.day.tue": "Sel",
  "calendar.management.day.wed": "Rab",
  "calendar.management.day.thu": "Kam",
  "calendar.management.day.fri": "Jum",
  "calendar.management.day.sat": "Sab",
  "calendar.management.chooseFile": "Pilih file CSV",
  "calendar.management.csvColumns": "Kolom: tanggal, nama, pengulangan (true/false)",
  "calendar.management.rowsFound": "{count} baris ditemukan",
  "calendar.management.column.csvDate": "Tanggal",
  "calendar.management.column.csvName": "Nama",
  "calendar.management.column.csvRecurring": "Pengulangan",
  "calendar.management.importing": "Mengimpor...",
  "column.qc.accession": "QC Sample",
  "column.qc.detail": "Detail",
  "column.qc.result": "Hasil",
  "column.qc.test": "Pemeriksaan",
  "column.qc.type": "Tipe",
  "compliance.dashboard.chart.comparison.title": "Site Comparison — Current Period Compliance %",
  "compliance.dashboard.chart.drilldown.title": "Site Drill-Down — Per-Parameter Trend",
  "compliance.dashboard.chart.trend.title": "Compliance Rate Trend — All Sites",
  "compliance.dashboard.descriptive.excluded": "Descriptive parameters excluded from trend chart",
  "compliance.dashboard.drilldown.placeholder": "Select a site…",
  "compliance.dashboard.empty": "No data matches the selected filters",
  "compliance.dashboard.export.pdf": "Ekspor PDF",
  "compliance.dashboard.filter.allStandards": "All Standards",
  "compliance.dashboard.filter.dateRange": "Rentang Tanggal",
  "compliance.dashboard.filter.dateRangeEnd": "End date",
  "compliance.dashboard.filter.drilldownSite": "Drill down by site",
  "compliance.dashboard.filter.sites": "Tempat Pengambilan Sampel",
  "compliance.dashboard.filter.standard": "Compliance Standard",
  "compliance.dashboard.kpi.complianceRate": "Compliance Rate",
  "compliance.dashboard.kpi.exceedances": "Total Exceedances",
  "compliance.dashboard.kpi.sitesMonitored": "Sites Monitored",
  "compliance.dashboard.kpi.totalOrders": "Total Orders",
  "compliance.dashboard.loading.comparison": "Loading comparison…",
  "compliance.dashboard.loading.drilldown": "Loading drill-down…",
  "compliance.dashboard.loading.exceedances": "Loading exceedances…",
  "compliance.dashboard.loading.generating": "Generating…",
  "compliance.dashboard.loading.trend": "Loading trend…",
  "compliance.dashboard.lowData": "Low data (< 3 orders)",
  "compliance.dashboard.status.fail": "FAIL",
  "compliance.dashboard.table.col.date": "Tanggal",
  "compliance.dashboard.table.col.labNumber": "Lab #",
  "compliance.dashboard.table.col.parameter": "Parameter",
  "compliance.dashboard.table.col.result": "Hasil",
  "compliance.dashboard.table.col.site": "Site",
  "compliance.dashboard.table.col.status": "Status",
  "compliance.dashboard.table.col.threshold": "Threshold",
  "compliance.dashboard.table.exceedances.title": "Exceedance Summary",
  "compliance.dashboard.title": "Environmental Compliance Dashboard",
  "error.referOut.emailFormat": "Enter a valid email address (e.g. lab@example.org).",
  "error.referOut.handoffRequiredForDispatch": "Handoff Date/Time is required to dispatch.",
  "error.referOut.maxLength": "Maximum {max} characters.",
  "error.referOut.phoneFormat": "Enter a valid phone number with country code prefix (e.g. +62 812 3456 7890).",
  "error.referOut.referringLabRequired": "Select a referring lab.",
  "error.validation.qc.ackFailed": "Failed to record QC acknowledgment. Please try again.",
  "holding.time.exceeded.message": "The SOP max holding time has been exceeded for: {tests}",
  "holding.time.exceeded.note": "WARNING: Result entered after SOP max holding time was exceeded.",
  "holding.time.exceeded.title": "Holding Time Exceeded",
  "instructions.results.entry.unified.route": "When enabled, the unified Results Entry worklist replaces the legacy result entry pages: the Results menu shows a single Results Entry item and the old result entry links redirect to it. Disable to restore the legacy pages.",
  "label.button.edit.details": "Edit details",
  "label.expand.poolDetails": "Expand pool details",
  "label.pool.collapse": "Hide individual specimens",
  "label.pool.expand": "Show individual specimens",
  "label.pool.expansion.next": "Berikutnya",
  "label.pool.expansion.page": "Page {page} of {total}",
  "label.pool.expansion.prev": "Sebelumnya",
  "label.pool.expansion.title": "{animal} specimens ({count})",
  "label.qc.fail": "Fail",
  "label.qc.pass": "Pass",
  "label.referOut.action.dispatch": "Dispatch",
  "label.referOut.action.edit": "Edit",
  "label.referOut.action.referOut": "Refer Out",
  "label.referOut.action.save": "Save Referral",
  "label.referOut.action.view": "Lihat",
  "label.referOut.column.actions": "Aksi",
  "label.referOut.column.referringLab": "Referring Lab",
  "label.referOut.column.sampleId": "Nomor Identitas Sampel",
  "label.referOut.column.sampleType": "Jenis Sampel",
  "label.referOut.column.status": "Subcontract Status",
  "label.referOut.column.tests": "Pemeriksaan",
  "label.referOut.dispatch.error": "Failed to dispatch referral.",
  "label.referOut.dispatch.notSaved": "Save the referral before dispatching.",
  "label.referOut.dispatch.success": "Referral dispatched.",
  "label.referOut.empty.subtitle": "Samples appear here once they are saved. Save the order first to refer specimens out.",
  "label.referOut.empty.title": "No samples available for referral",
  "label.referOut.field.agreementReference": "Agreement Reference",
  "label.referOut.field.cocContactEmail": "Chain-of-Custody Contact Email",
  "label.referOut.field.cocContactEmail.placeholder": "lab@example.org",
  "label.referOut.field.cocContactName": "Chain-of-Custody Contact Name",
  "label.referOut.field.cocContactPhone": "Chain-of-Custody Contact Phone",
  "label.referOut.field.cocContactPhone.placeholder": "+62 812 3456 7890",
  "label.referOut.field.expectedReturnDate": "Expected Return Date",
  "label.referOut.field.handoffDate": "Handoff Date",
  "label.referOut.field.handoffDatetime": "Handoff Date/Time",
  "label.referOut.field.handoffTime": "Handoff Time",
  "label.referOut.field.handoffTime.placeholder": "HH:mm",
  "label.referOut.field.notes": "Catatan",
  "label.referOut.field.referringLab": "Referring Lab",
  "label.referOut.field.referringLab.placeholder": "Select a referring lab",
  "label.referOut.save.error": "Failed to save referral.",
  "label.referOut.save.success": "Referral saved.",
  "label.referOut.section.description": "Refer specimens to an external lab. Each sample carries its full chain-of-custody metadata.",
  "label.referOut.section.title": "Refer Out / Subcontract",
  "label.referOut.status.cancelled": "Dibatalkan",
  "label.referOut.status.closed": "Ditutup",
  "label.referOut.status.completed": "Selesai",
  "label.referOut.status.dispatched": "Dispatched",
  "label.referOut.status.draft": "Draf",
  "label.referOut.status.inProgress": "In progress",
  "label.referOut.status.notReferred": "In-house",
  "label.referOut.status.received": "Diterima",
  "label.referOut.status.rejected": "Ditolak",
  "label.referOut.status.requested": "Requested",
  "label.referOut.status.resultsReturned": "Results Returned",
  "label.sampleKind.blank": "BLANK",
  "label.sampleKind.client": "Client sample",
  "label.sampleKind.control": "CONTROL",
  "label.sampleKind.duplicate": "DUPLICATE",
  "label.sampleKind.qc": "QC",
  "label.validation.qc.ack.checkbox": "I have reviewed the QC failures and assessed their impact on the result release",
  "label.validation.qc.ack.heading": "Required Acknowledgment",
  "label.validation.qc.banner.subtitle": "Review and acknowledge below before releasing results.",
  "label.validation.qc.banner.title": "QC failures detected — {count} QC sample(s) failed acceptance criteria",
  "label.validation.qc.failedSamples": "Failed QC Samples",
  "label.validation.qc.justification": "Justification",
  "laporanHasil.action.generatePdf": "Generate PDF",
  "laporanHasil.action.regeneratePdf": "Re-generate PDF",
  "laporanHasil.col.actions": "Aksi",
  "laporanHasil.col.collectionDate": "Tanggal Pengambilan",
  "laporanHasil.col.compliance": "Kepatuhan",
  "laporanHasil.col.labNumber": "Nomor Registrasi",
  "laporanHasil.col.lastGenerated": "Last Generated",
  "laporanHasil.col.site": "Site",
  "laporanHasil.col.standard": "Standar",
  "laporanHasil.col.tests": "Pemeriksaan",
  "laporanHasil.detail.ambientTemp": "Ambient Temp",
  "laporanHasil.detail.collectionDateTime": "Collection Date/Time",
  "laporanHasil.detail.collectionMethod": "Metode Pengambilan",
  "laporanHasil.detail.complianceSummary": "Compliance Summary",
  "laporanHasil.detail.conditions": "Kondisi Pengambilan",
  "laporanHasil.detail.gps": "GPS",
  "laporanHasil.detail.labAnalyst": "Lab Analyst",
  "laporanHasil.detail.labManager": "Lab Manager",
  "laporanHasil.detail.parameter": "Parameter",
  "laporanHasil.detail.ppNo": "PP No.",
  "laporanHasil.detail.preservation": "Preservation",
  "laporanHasil.detail.result": "Hasil",
  "laporanHasil.detail.signatures": "Signatures",
  "laporanHasil.detail.site": "Site",
  "laporanHasil.detail.siteInfo": "Pengaturan Informasi Aplikasi",
  "laporanHasil.detail.standard": "Standar",
  "laporanHasil.detail.status": "Status",
  "laporanHasil.detail.threshold": "Threshold",
  "laporanHasil.detail.waterTemp": "Water Temp",
  "laporanHasil.detail.weather": "Cuaca",
  "laporanHasil.empty": "No orders found for the selected filters.",
  "laporanHasil.error": "Failed to load report. Please try again.",
  "laporanHasil.filter.all": "Semua",
  "laporanHasil.filter.allSites": "Semua Tempat",
  "laporanHasil.filter.allStandards": "All Standards",
  "laporanHasil.filter.complianceStatus": "Status Kepatuhan",
  "laporanHasil.filter.dateFrom": "Date From",
  "laporanHasil.filter.dateTo": "Date To",
  "laporanHasil.filter.generated": "Generated",
  "laporanHasil.filter.generationStatus": "Generation Status",
  "laporanHasil.filter.notGenerated": "Not Yet Generated",
  "laporanHasil.filter.samplingSite": "Tempat Pengambilan Sampel",
  "laporanHasil.filter.standard": "Compliance Standard",
  "laporanHasil.loading": "Loading compliance report...",
  "laporanHasil.status.borderline": "Garis ambang",
  "laporanHasil.status.compliant": "Sesuai Kepatuhan",
  "laporanHasil.status.ineligible": "No standard linked",
  "laporanHasil.status.nonCompliant": "Tidak Sesuai Kepatuhan",
  "laporanHasil.status.none": "–",
  "laporanHasil.subtitle": "Generate compliance certificates for validated environmental orders",
  "laporanHasil.tile.generated": "Generated",
  "laporanHasil.tile.ineligible": "Ineligible",
  "laporanHasil.tile.ineligible.desc": "Not validated or no standard linked",
  "laporanHasil.tile.notGenerated": "Not Yet Generated",
  "laporanHasil.title": "Compliance Report",
  "lhu.amendment.error.generic": "Failed to reissue the report. Please try again.",
  "lhu.amendment.modal.description": "You are reissuing LHU for lab number {labNumber}. The reissued report will be identified as an amendment to the previously released certificate.",
  "lhu.amendment.modal.heading": "Reissue LHU with Amendment",
  "lhu.amendment.modal.submit": "Reissue & Download PDF",
  "lhu.amendment.reason.helper": "State why the original report is being amended (required for ISO 17025 §7.8.8 compliance).",
  "lhu.amendment.reason.label": "Amendment reason",
  "lhu.amendment.reason.placeholder": "e.g. Incorrect pH result — instrument was not calibrated",
  "lhu.amendment.reason.required": "Amendment reason is required",
  "lhu.amendment.reissue": "Reissue with Amendment",
  "lhu.amendment.submitting": "Reissuing…",
  "nce.close.error": "Failed to close NCE",
  "nce.close.success": "NCE closed successfully",
  "nce.correctiveAction.error": "Failed to advance NCE status",
  "nce.correctiveAction.success": "NCE moved to Corrective Action",
  "notificationtrigger.activetriggers.heading": "Active Triggers",
  "notificationtrigger.activetriggers.subtitle": "Each row controls one notification event type. Toggle On to activate. Channel and recipient settings only apply when the trigger is enabled.",
  "notificationtrigger.channel.email": "Email",
  "notificationtrigger.channel.whatsapp": "WhatsApp",
  "notificationtrigger.column.channels": "Channel",
  "notificationtrigger.column.enabled": "Diaktifkan",
  "notificationtrigger.column.eventcode": "Event Code",
  "notificationtrigger.column.override": "Per-Lab-Unit Override",
  "notificationtrigger.column.recipients": "Penerima",
  "notificationtrigger.column.trigger": "Trigger",
  "notificationtrigger.config.subtitle": "Enable or disable notification triggers, select delivery channels, and configure recipient types per event.",
  "notificationtrigger.config.title": "Notification Trigger Configuration",
  "notificationtrigger.disabled.hint": "Enable this trigger to configure its channels and recipients.",
  "notificationtrigger.override.comingsoon": "Per-lab-unit override is not available yet.",
  "notificationtrigger.override.configure": "Konfigurasi",
  "notificationtrigger.recipient.coccontact": "CoC Contact",
  "notificationtrigger.recipient.orderingprovider": "Ordering Provider",
  "notificationtrigger.recipient.submittinguser": "Submitting User",
  "notificationtrigger.referralout.defaultoff": "Defaults OFF — must be enabled explicitly.",
  "notificationtrigger.referralout.description": "Sent when a sample is referred to an external laboratory.",
  "notificationtrigger.referralout.firesoncenote": "Fires once per saved referral. If one order has referrals to two different labs, two notifications are sent.",
  "notificationtrigger.referralout.name": "Referral Out",
  "notificationtrigger.sentmessages.action.resend": "Resend",
  "notificationtrigger.sentmessages.action.viewlog": "View Log",
  "notificationtrigger.sentmessages.channel.failed": "failed",
  "notificationtrigger.sentmessages.channel.sent": "sent",
  "notificationtrigger.sentmessages.column.actions": "Aksi",
  "notificationtrigger.sentmessages.column.channels": "Channel",
  "notificationtrigger.sentmessages.column.datetime": "Date / Time",
  "notificationtrigger.sentmessages.column.recipient": "Recipient",
  "notificationtrigger.sentmessages.column.reference": "Reference",
  "notificationtrigger.sentmessages.column.status": "Status",
  "notificationtrigger.sentmessages.column.type": "Tipe",
  "notificationtrigger.sentmessages.count": "{count} of {total} messages",
  "notificationtrigger.sentmessages.empty.heading": "No notifications have been sent yet.",
  "notificationtrigger.sentmessages.filter.status.all": "Semua Status",
  "notificationtrigger.sentmessages.filter.status.failed": "Gagal",
  "notificationtrigger.sentmessages.filter.status.label": "Status",
  "notificationtrigger.sentmessages.filter.status.sent": "Terkirim",
  "notificationtrigger.sentmessages.filter.type.all": "Semua Jenis",
  "notificationtrigger.sentmessages.filter.type.label": "Tipe",
  "notificationtrigger.sentmessages.heading": "Sent Messages",
  "notificationtrigger.sentmessages.resend.disclaimer": "Resending replays the original message bytes and recipient address. To send to a different address, edit the patient record and trigger a new event.",
  "notificationtrigger.sentmessages.resend.failure": "Resend failed. See server logs for details.",
  "notificationtrigger.sentmessages.resend.success": "Notification resent.",
  "notificationtrigger.sentmessages.status.failed": "Gagal",
  "notificationtrigger.sentmessages.status.sent": "Terkirim",
  "notificationtrigger.sentmessages.subtitle": "All outbound notifications dispatched by OpenELIS, across all trigger types and channels.",
  "notificationtrigger.sentmessages.viewlog.channels": "Channel Outcomes",
  "notificationtrigger.sentmessages.viewlog.column.attempts": "Attempts",
  "notificationtrigger.sentmessages.viewlog.column.channel": "Channel",
  "notificationtrigger.sentmessages.viewlog.column.error": "Error",
  "notificationtrigger.sentmessages.viewlog.column.status": "Status",
  "notificationtrigger.sentmessages.viewlog.heading": "Notification Log",
  "notificationtrigger.sentmessages.viewlog.message": "Message Body",
  "notificationtrigger.sentmessages.viewlog.subject": "Subjek",
  "notificationtrigger.status.new": "NEW",
  "notificationtrigger.subcontractdispatched.description": "Sent when a sample has been physically dispatched to the receiving laboratory.",
  "notificationtrigger.subcontractdispatched.name": "Subcontract Dispatched",
  "notificationtrigger.tabs.sentmessages": "Sent Messages",
  "notificationtrigger.tabs.sentmessages.placeholder": "Sent messages — coming in a future milestone.",
  "notificationtrigger.tabs.templates": "Templates",
  "notificationtrigger.tabs.templates.placeholder": "Template editor — coming in a future milestone.",
  "notificationtrigger.tabs.triggers": "Triggers",
  "notificationtrigger.templates.body.help": "Free text with merge fields. This template is not managed by i18n — edit it directly.",
  "notificationtrigger.templates.body.label": "Message Body",
  "notificationtrigger.templates.button.reset": "Reset to Default",
  "notificationtrigger.templates.button.save": "Save Template",
  "notificationtrigger.templates.channel.help": "Each channel has its own template fields. Switch channels to edit separately.",
  "notificationtrigger.templates.channel.label": "Channel",
  "notificationtrigger.templates.heading": "Notification Template Configuration",
  "notificationtrigger.templates.mergefields.heading": "Available Merge Fields",
  "notificationtrigger.templates.mergefields.help": "Fields below are specific to the {eventCode} event. Click a field to insert it at the cursor position.",
  "notificationtrigger.templates.mergefields.optionalnote": "If [expectedReturn] is not set on the referral, it renders blank — no error.",
  "notificationtrigger.templates.preview.label": "Rendered Preview",
  "notificationtrigger.templates.referralout.description": "Sent to the customer contact (Ordering Provider) and/or internal staff (Submitting User) when a referral is saved.",
  "notificationtrigger.templates.subcontractdispatched.description": "Sent to the receiving lab's CoC contact and the customer when a sample is physically dispatched to the receiving laboratory.",
  "notificationtrigger.templates.subject.label": "Subjek",
  "notificationtrigger.templates.subtitle": "Compose message templates for each notification event type. Templates are free text with merge fields.",
  "order.clinicalInfo.helper": "Optional context to guide test selection and reporting — not recorded as a confirmed diagnosis.",
  "order.complete.processing.description": "{labNumber} is now in {status} status and will appear in the V-03 Vector Identification worklist.",
  "order.complete.processing.description.plain": "{labNumber} is now in Processing status and will appear in the V-03 Vector Identification worklist.",
  "order.complete.processing.title": "Order Complete — Processing",
  "order.context.poolOf": "Pool of {count} {animal}",
  "order.paymentStatus.helper": "How payment will be handled for this order.",
  "order.priority.helper": "ROUTINE: standard turnaround. STAT: process immediately.",
  "order.referral.sampleType.ambiguous": "This referred order requested {items}, but the sample type could not be determined automatically. Please select a sample type below and choose the requested test(s).",
  "order.requester.section.helper": "Select the facility that ordered the tests and the responsible provider.",
  "panel.domain.clinical": "Klinis",
  "panel.domain.environmental": "Lingkungan",
  "panel.domain.eqa": "PME",
  "panel.domain.vector": "Vektor",
  "panel.filter.domain": "Domain",
  "panel.organism.flea": "Flea",
  "panel.organism.fly": "Fly",
  "panel.organism.mosquito": "Mosquito",
  "panel.organism.rodent": "Rodent",
  "panel.organism.selectPlaceholder": "Select Organism Group",
  "panel.organism.tick": "Tick",
  "patient.search.section.helper": "Search by any combination of fields — partial matches accepted. 'External Search' queries the Client Registry and requires at minimum a name and date of birth.",
  "placeholder.validation.qc.justification": "Required (max 500 chars)",
  "provider.add.new": "+ Add new provider \"{name}\"",
  "provider.email.field": "Email Penyelenggara",
  "provider.fax.field": "Provider Fax",
  "provider.firstName.field": "Nama Depan",
  "provider.lastName.field": "Nama Belakang",
  "provider.new.helper": "Will be created as a new provider when this order is saved.",
  "provider.new.tag": "New",
  "provider.no.match": "No matching provider found.",
  "provider.phone.field": "Telepon",
  "qc.add.blank": "+ Blank QC",
  "qc.add.control": "+ Control QC",
  "qc.add.duplicate": "+ Duplicate QC",
  "qc.collect.inheritsFromParent": "Collection details inherited from parent sample",
  "qc.expectedValue.placeholder": "e.g. 50.0",
  "qc.samples.label": "QC samples:",
  "qc.samples.numericOnly": "QC is currently supported only for tests with numeric results. The selected tests are coded — pick a numeric test to attach QC.",
  "qc.samples.thresholdsMissing": "Configure QC thresholds for {tests} in Administration → Test Configuration before adding QC samples.",
  "qc.type.blank": "QC: Blank",
  "qc.type.control": "QC: Control",
  "qc.type.duplicate": "QC: Duplicate",
  "referral.accept.error": "Could not accept the result. Please try again.",
  "referral.action.accept": "Terima",
  "referral.action.acceptToAnalysis": "Accept to Analysis",
  "referral.action.clearFilters": "Clear filters",
  "referral.action.enterResult": "Masukkan hasil",
  "referral.action.markLost": "Mark Lost",
  "referral.action.notifyReferenceLab": "Notify reference lab",
  "referral.action.openResultEntry": "Open in Result Entry",
  "referral.action.reject": "Tolak",
  "referral.banner.filterToStuck": "Filter to stuck only",
  "referral.banner.stuckReferralsSubtitle": "{count} referral(s) have been at a reference lab for more than {threshold} day(s).",
  "referral.banner.stuckReferralsTitle": "Stuck referrals detected",
  "referral.box.cannotReconcileMessage": "Cannot reconcile box — {count} samples still awaiting result reconciliation. See Reference Lab Results.",
  "referral.box.viewBlockedReferrals": "View in Reference Lab Results",
  "referral.breadcrumb.referenceLabResults": "Reference Lab Results",
  "referral.chip.ariaLabel": "Reference lab results view",
  "referral.chip.history": "Riwayat",
  "referral.chip.outstanding": "Outstanding",
  "referral.chip.returned": "Returned — needs action",
  "referral.column.actions": "Aksi",
  "referral.column.boxId": "ID Boks",
  "referral.column.closedDate": "Closed date",
  "referral.column.daysOutstanding": "Days outstanding",
  "referral.column.daysTotal": "Days total",
  "referral.column.labNumber": "Nomor Registrasi",
  "referral.column.outcome": "Outcome",
  "referral.column.patient": "Pasien",
  "referral.column.priority": "Prioritas",
  "referral.column.referenceLab": "Lab Rujukan",
  "referral.column.requestor": "Original requestor",
  "referral.column.resultSummary": "Result summary",
  "referral.column.returnedDate": "Returned Date",
  "referral.column.sentDate": "Tanggal Dikirim",
  "referral.column.status": "Status",
  "referral.column.tests": "Pemeriksaan",
  "referral.expand.criticalBadge": "CRITICAL",
  "referral.expand.detail.ageYears": "{years, plural, one {# year} other {# years}}",
  "referral.expand.detail.boxId": "ID Boks",
  "referral.expand.detail.boxReceivedDate": "Received at reference lab",
  "referral.expand.detail.collected": "Diambil",
  "referral.expand.detail.currentStatus": "Current status",
  "referral.expand.detail.daysOutstanding": "Days outstanding",
  "referral.expand.detail.dispatched": "Dispatched",
  "referral.expand.detail.fhirTask": "FHIR Task",
  "referral.expand.detail.labNumber": "Nomor Registrasi",
  "referral.expand.detail.patient": "Pasien",
  "referral.expand.detail.priority": "Prioritas",
  "referral.expand.detail.referenceLab": "Lab Rujukan",
  "referral.expand.detail.requestor": "Original requestor",
  "referral.expand.detail.sampleType": "Jenis sampel",
  "referral.expand.detail.tests": "Pemeriksaan",
  "referral.expand.noResultPayload": "No structured result was returned by the reference lab.",
  "referral.expand.originalOrderContext": "Original order context",
  "referral.expand.outcomeDetail": "Outcome detail",
  "referral.expand.receptionAction": "Reception action",
  "referral.expand.receptionHint": "Review the returned result below, then Accept it to post to the patient record, or Reject it if the result cannot be used.",
  "referral.expand.referenceLabTransit": "Reference lab transit",
  "referral.expand.result": "Hasil",
  "referral.expand.statusDetail": "Status detail",
  "referral.filter.allPriorities": "All priorities",
  "referral.filter.allRefLabs": "All reference labs",
  "referral.filter.dateRange": "Date range",
  "referral.filter.daysOutstandingBucket": "Days outstanding",
  "referral.filter.daysOutstandingBucket.stuck": "Stuck (> {threshold} days)",
  "referral.filter.priority": "Prioritas",
  "referral.filter.referenceLab": "Lab Rujukan",
  "referral.markLost.cancelButton": "Batal",
  "referral.markLost.confirmButton": "Mark as lost",
  "referral.markLost.description": "This marks the referral as lost in transit and removes it from Outstanding. The clinical team will need to re-collect and re-refer the sample.",
  "referral.markLost.modalTitle": "Mark referral as lost",
  "referral.markLost.reasonLabel": "Reason",
  "referral.markLost.reasonPlaceholder": "e.g. Courier confirmed loss. Box never arrived at the reference lab.",
  "referral.markLost.reasonRequired": "Reason is required.",
  "referral.metric.outstanding": "Outstanding",
  "referral.metric.reconciledToday": "Reconciled today",
  "referral.metric.rejectedThisWeek": "Rejected this week",
  "referral.metric.returned": "Returned — needs action",
  "referral.notification.accepted": "Result accepted to the patient record.",
  "referral.notification.rejected": "Result rejected. The clinician has been notified to re-collect.",
  "referral.notify.errorRetry": "Failed to notify reference lab. Try again.",
  "referral.notify.toast": "Reference lab notified.",
  "referral.page.title": "Reference Lab Results",
  "referral.reject.cancelButton": "Batal",
  "referral.reject.confirmButton": "Reject and notify clinician",
  "referral.reject.description": "Rejecting closes the originating test terminally and notifies the clinician to re-collect and re-refer the sample.",
  "referral.reject.error": "Could not reject the result. Please try again.",
  "referral.reject.modalTitle": "Reject returned result",
  "referral.reject.reason.clotted": "Clotted",
  "referral.reject.reason.damagedContainer": "Damaged container",
  "referral.reject.reason.hemolyzed": "Hemolyzed",
  "referral.reject.reason.insufficientVolume": "Insufficient volume",
  "referral.reject.reason.mislabeled": "Mislabeled",
  "referral.reject.reason.other": "Lainnya",
  "referral.reject.reason.temperatureDeviation": "Temperature deviation",
  "referral.reject.reason.wrongSampleType": "Wrong sample type",
  "referral.reject.reasonLabel": "Reason",
  "referral.reject.reasonTextLabel": "Details",
  "referral.reject.reasonTextPlaceholder": "Describe why this returned result cannot be used.",
  "referral.reject.reasonTextRequired": "Details are required.",
  "referral.reject.warningTitle": "This action cannot be undone",
  "referral.result.interp.Abnormal": "Abnormal",
  "referral.result.interp.Critical": "Kritis",
  "referral.result.interp.Normal": "Normal",
  "referral.status.cancelled": "Dibatalkan",
  "referral.status.completed": "Result returned",
  "referral.status.draft": "Draf",
  "referral.status.inProgress": "In progress at reference lab",
  "referral.status.received": "At reference lab",
  "referral.status.reconciled": "Direkonsiliasi",
  "referral.status.rejected": "Rejected by reference lab",
  "referral.status.requested": "Sent — awaiting acceptance",
  "referral.table.count": "{count, plural, =0 {No referrals} one {# referral} other {# referrals}}",
  "referral.table.history.title": "Riwayat",
  "referral.table.outstanding.title": "Outstanding referrals",
  "referral.table.returned.title": "Returned — needs action",
  "referral.tag.manuallyEntered": "Manually entered",
  "reports.tat.title": "Laporan Waktu Penyelesaian",
  "reports.tat.description": "Analisis waktu penyelesaian laboratorium setiap milestone pekerjaan",
  "reports.tat.generateReport": "Membuat Laporan",
  "reports.tat.clearFilters": "Hapus filter",
  "reports.tat.segment.orderToCollection": "Pemesanan sampai Pengambilan",
  "reports.tat.segment.collectionToReceipt": "Pengambilan sampai Diterima",
  "reports.tat.segment.receiptToTesting": "Pengambilan sampai Pengujian Dimulai",
  "reports.tat.segment.receiptToResult": "Diterima sampai Entri Hasil",
  "reports.tat.segment.receiptToValidation": "Diterima sampai Validasi",
  "reports.tat.segment.resultToValidation": "Entri Hasil sampai Validasi",
  "reports.tat.segment.overall": "Waktu Penyelesaian (TAT) keseluruhan",
  "reports.tat.calendarTime": "Waktu Kalender",
  "reports.tat.workingTime": "Jam Kerja",
  "reports.tat.workingTimeInfo": "Mode Jam Kerja: Selain {weekendDays} dan {holidayCount} libur nasional di kisaran tanggal ini",
  "reports.tat.configuredWeekends": "akhir pekan yang dikonfigurasi",
  "reports.tat.noHolidaysWarning": "Tidak ada konfigurasi libur nasional. Konfigurasi libur nasional dapat dilakukan di Admin > Pengelolaan Kalender",
  "reports.tat.manageCalendar": "Kelola Kalender",
  "reports.tat.totalResults": "Hasil Total",
  "reports.tat.meanTat": "Mean TAT",
  "reports.tat.medianTat": "Median TAT",
  "reports.tat.percentile90": "Presentil 90",
  "reports.tat.minTat": "Min TAT",
  "reports.tat.maxTat": "Maks TAT",
  "reports.tat.stdDeviation": "Simpangan Baku",
  "reports.tat.distribution": "Distribusi TAT",
  "reports.tat.breakdownBy": "Breakdown berdasarkan",
  "reports.tat.clickRowHint": "Klik baris untuk melihat hasil individual",
  "reports.tat.summary": "Ringkasan",
  "reports.tat.detailList": "Daftar Rinci",
  "reports.tat.trends": "Tren",
  "reports.tat.noResults": "Hasil tidak ditemukan untuk filter ini. Coba mengatur rentang tanggal atau kriteria filter.",
  "reports.tat.insufficientData": "Data tidak cukup",
  "reports.tat.loadError": "Error memuat data laporan",
  "reports.tat.dateRange": "Rentang Tanggal",
  "reports.tat.labUnit": "Instalasi Lab",
  "reports.tat.testPanel": "Pemeriksaan / Panel",
  "reports.tat.priority.all": "Semua",
  "reports.tat.priority.routine": "Rutin",
  "reports.tat.priority.stat": "STAT",
  "reports.tat.priority.asap": "ASAP",
  "reports.tat.sampleType": "Jenis Sampel",
  "reports.tat.orderingSite": "Institusi Pemesan",
  "reports.tat.priority": "Prioritas",
  "reports.tat.includeCancelled": "Sertakan pembatalan/penolakan",
  "reports.tat.export": "Ekspor",
  "reports.tat.exportCsv": "Ekspor CSV",
  "reports.tat.exportPdf": "Ekspor PDF",
  "reports.tat.labNumber": "Nomor Lab",
  "reports.tat.patient": "Pasien",
  "reports.tat.test": "Pemeriksaan",
  "reports.tat.orderCreated": "Pemesanan Dibuat",
  "reports.tat.collected": "Diambil",
  "reports.tat.received": "Diterima",
  "reports.tat.testingStarted": "Pemeriksaan Dimulai",
  "reports.tat.resultEntered": "Hasil Dimasukkan",
  "reports.tat.validated": "Divalidasi",
  "reports.tat.selectedTat": "TAT yang dipilih",
  "reports.tat.overallTat": "TAT keseluruhan",
  "reports.tat.columns": "Kolom",
  "reports.tat.rowsPerPage": "Baris per halaman",
  "reports.tat.showing": "Menampilkan {from}-{to} dari {total} hasil",
  "reports.tat.trend": "Tren",
  "reports.tat.aggregation": "Agregasi",
  "reports.tat.daily": "Harian",
  "reports.tat.weekly": "Mingguan",
  "reports.tat.monthly": "Bulanan",
  "reports.tat.compareBy": "Bandingkan berdasarkan",
  "reports.tat.showVolume": "Tampilkan volume pemesanan",
  "reports.tat.mean": "Mean",
  "reports.tat.median": "Median",
  "reports.tat.notApplicable": "N/A",
  "reports.tat.dateRangeFrom": "Rentang Tanggal (Dari)",
  "reports.tat.dateRangeTo": "Rentang Tanggal (Sampai)",
  "reports.tat.tatSegment": "Segmen TAT",
  "reports.tat.metrics": "Metrik",
  "reports.tat.compareNone": "Tidak ada",
  "reports.tat.comparePriority": "Prioritas",
  "reports.tat.column.labNumber": "Nomor Lab",
  "reports.tat.column.test": "Pemeriksaan",
  "reports.tat.column.labUnit": "Instalasi Lab",
  "reports.tat.column.priority": "Prioritas",
  "reports.tat.column.ordered": "Dipesan",
  "reports.tat.column.collected": "Diambil",
  "reports.tat.column.received": "Diterima",
  "reports.tat.column.started": "Dimulai",
  "reports.tat.column.resulted": "Dihasilkan",
  "reports.tat.column.validated": "Divalidasi",
  "reports.tat.column.selectedTat": "TAT yang dipilih",
  "reports.tat.column.overallTat": "TAT keseluruhan",
  "reports.tat.column.name": "Nama",
  "reports.tat.column.count": "Jumlah",
  "reports.tat.column.mean": "Mean",
  "reports.tat.column.median": "Median",
  "reports.tat.column.p90": "90th %ile",
  "reports.tat.column.max": "Maks",
  "reports.tat.home": "Beranda",
  "reports.tat.all": "Semua",
  "reports.tat.preset.today": "Hari ini",
  "reports.tat.preset.7days": "7 hari terakhir",
  "reports.tat.preset.30days": "30 hari terakhir",
  "reports.tat.preset.90days": "90 hari terakhir",
  "reports.tat.preset.thisMonth": "Bulan ini",
  "reports.tat.preset.lastMonth": "Bulan lalu",
  "reports.tat.preset.thisQuarter": "Triwulan ini",
  "button.cancel": "Batal",
  "button.activate": "Aktifkan",
  "button.adjust": "Sesuaikan",
  "button.deactivate": "Nonaktifkan",
  "button.dispose": "Musnahkan",
  "button.edit": "Edit",
  "button.generate": "Membuat",
  "button.label.genarateReport": "Membuat Laporan",
  "button.label.loadnext": "Memuat Bundel Berikutnya",
  "button.label.loadprevious": "Memuat Bundel Sebelumnya",
  "button.label.showHidePram": "Tunjukkan/Sembunyikan Parameter Laporan",
  "button.record": "Rekam",
  "button.save": "Simpan",
  "button.save.draft": "Simpan draf",
  "button.save.next": "Simpan & Lanjut",
  "button.save.stay": "Simpan",
  "button.send": "Kirim",
  "button.update": "Perbarui",
  "calculatedTests": "Perhitungan Pemeriksaan",
  "catalog.item.activate.success": "Barang di katalog berhasil diaktifkan",
  "catalog.item.category": "Kategori",
  "catalog.item.compatibleAnalyzers": "Alat yang Kompatibel",
  "catalog.item.deactivate.confirm.button": "Nonaktifkan",
  "catalog.item.deactivate.confirm.message": "Apakah Anda yakin akan menonaktifkan {itemName}?",
  "catalog.item.deactivate.confirm.title": "Konfirmasi Penonaktifan",
  "catalog.item.deactivate.implications.1": "Barang ini tidak akan muncul lagi di daftar barang aktif",
  "catalog.item.deactivate.implications.2": "Lot tersisa untuk barang ini masih dapat diakses",
  "catalog.item.deactivate.implications.3": "Anda dapat mengaktifkan ulang barang ini kembali saat diperlukan",
  "catalog.item.deactivate.implications.title": "Implikasi:",
  "catalog.item.deactivate.label": "Barang Dinonaktifkan",
  "catalog.item.deactivate.success": "Barang berhasil dinonaktifkan",
  "catalog.item.form.title.add": "Tambah Barang Baru di Katalog",
  "catalog.item.form.title.edit": "Edit Barang di Katalog",
  "catalog.item.lowStockThreshold": "Ambang Batas Stok Sedikit",
  "catalog.item.manufacturer": "Produsen",
  "catalog.item.minimumStock": "Level Stok Minimum",
  "catalog.item.name": "Nama Barang",
  "catalog.item.reorderLevel": "Level Pemesanan Ulang",
  "catalog.item.reorderQuantity": "Kuantitas yang dipesan ulang",
  "catalog.item.save.error": "Error menyimpan barang di katalog",
  "catalog.item.save.success": "Barang di katalog berhasil disimpan",
  "catalog.item.stabilityAfterOpening": "Stabilitas Setelah Dibuka (hari)",
  "catalog.item.status": "Status",
  "catalog.item.storageRequirements": "Persyaratan Penyimpanan",
  "catalog.item.testTypes": "Jenis Pemeriksaan",
  "catalog.item.testsPerCartridge": "Pemeriksaan Per Katrid",
  "catalog.item.testsPerKit": "Pemeriksaan Per Kit",
  "catalog.item.type": "Jenis Barang",
  "catalog.item.units": "Unit",
  "catalog.search.placeholder": "Cari berdasarkan nama barang",
  "choose.availablepanel": "Pilih Panel yang Tersedia",
  "coldStorage.action.createSuccess": "Tindakan perbaikan berhasil dibuat",
  "coldStorage.action.retractSuccess": "Tindakan perbaikan berhasil dibatalkan",
  "coldStorage.action.updateSuccess": "Tindakan perbaikan berhasil diperbarui",
  "coldStorage.actions": "Aksi",
  "coldStorage.activated": "sudah aktif",
  "coldStorage.addDevicesMessage": "Tambah perangkat di Pengelolaan Perangkat untuk mengkonfigurasi ambang batas suhu",
  "coldStorage.addNewDevice": "Tambah Perangkat Baru",
  "coldStorage.alert.equipment": "Alat Gagal",
  "coldStorage.alert.equipment.description": "Peringatan malfungsi atau masalah koneksi alat",
  "coldStorage.alert.inventory": "Peringatan Inventaris",
  "coldStorage.alert.inventory.description": "Peringatan inventaris hampir habis atau pengelolaan stok ",
  "coldStorage.alert.saveFailed": "Gagal menyimpan pilihan notifikasi:",
  "coldStorage.alert.saveSuccess": "Pilihan notifikasi berhasil disimpan. Setiap jenis peringatan memiliki metode notifikasi sesuai konfigurasinya.",
  "coldStorage.alert.temperature": "Peringatan Suhu",
  "coldStorage.alert.temperature.description": "Peringatan akan dipicu saat suhu freezer melebihi ambang batas",
  "coldStorage.alert.type": "Jenis Peringatan",
  "coldStorage.alertConfiguration": "Konfigurasi Peringatan",
  "coldStorage.autoEscalate": "Otomatis lakukan eskalasi peringatan yang tidak terselesaikan",
  "coldStorage.bacnetUdpPort": "Portal BACnet UDP",
  "coldStorage.button.delete": "Hapus",
  "coldStorage.config.saveSuccess": "Konfigurasi sistem berhasil disimpan",
  "coldStorage.configMoved": "Konfigurasi Dipindah ke Panel Admin",
  "coldStorage.configMovedDesc": "Pengaturan sistem keseluruhan harus dikelola oleh Admin UI dimana terdapat semua konfigurasi global. Halaman ini read-only dan akan dihapus di perilisan berikutnya.",
  "coldStorage.configuredDevices": "Perangkat yang dikonfigurasi",
  "coldStorage.criticalThreshold": "Ambang Batas Kritis (°C)",
  "coldStorage.databaseVersion": "Versi Database",
  "coldStorage.deactivated": "sudah inaktif",
  "coldStorage.description": "Deskripsi",
  "coldStorage.device.activate": "Aktivasi perangkat",
  "coldStorage.device.activateMessage": "Mengaktivasi perangkat ini akan mengaktivasi pemantauan dan pengumpulan data.",
  "coldStorage.device.changeStatus": "Ubah Status Perangkat",
  "coldStorage.device.changeStatusOf": "Ubah status {name}:",
  "coldStorage.device.created": "Perangkat berhasil dibuat",
  "coldStorage.device.createdSuccess": "Perangkat \"{name}\" berhasil dibuat",
  "coldStorage.device.deactivate": "Inaktivasi perangkat",
  "coldStorage.device.deactivateMessage": "Menginaktivasi perangkat ini akan menghentikan pemantauan dan pengumpulan data. Riwayat data akan tersimpan.",
  "coldStorage.device.delete": "Hapus Perangkat",
  "coldStorage.device.deleteConfirm": "Apakah Anda yakin akan menghapus {name}?",
  "coldStorage.device.deleteWarning": "Aksi ini akan menandai perangkat sebagai inaktif dan menghapusnya dari pemantauan aktif. Riwayat data akan tersimpan.",
  "coldStorage.device.deleted": "Perangkat \"{name}\" berhasil dihapus",
  "coldStorage.device.deviceStatus": "Status Perangkat",
  "coldStorage.device.edit": "Edit perangkat",
  "coldStorage.device.id": "ID perangkat",
  "coldStorage.device.ipAddress": "Alamat IP",
  "coldStorage.device.port": "Portal",
  "coldStorage.device.protocol": "Protokol",
  "coldStorage.device.roomFacility": "Ruangan/Fasilitas",
  "coldStorage.device.statusChanged": "Perangkat \"{name}\" berhasil {status}",
  "coldStorage.device.type": "Jenis",
  "coldStorage.device.updated": "Perangkat berhasil diperbarui",
  "coldStorage.email": "Email",
  "coldStorage.emailSmsNotifications": "Notifikasi Email & SMS",
  "coldStorage.error.createAction": "Gagal membuat tindakan perbaikan. Silahkan coba lagi.",
  "coldStorage.error.createDevice": "Gagal membuat perangkat:",
  "coldStorage.error.createRoom": "Gagal membuat ruangan:",
  "coldStorage.error.deleteDevice": "Gagal menghapus perangkat:",
  "coldStorage.error.loadActions": "Gagal memuat tindakan perbaikan. Silahkan coba lagi.",
  "coldStorage.error.loadConfig": "Gagal memuat konfigurasi sistem:",
  "coldStorage.error.loadDevices": "Gagal memuat perangkat:",
  "coldStorage.error.loadLocations": "Gagal memuat lokasi:",
  "coldStorage.error.loadUsers": "Gagal membuat daftar pengguna. Silahkan coba beberapa saat lagi.",
  "coldStorage.error.retractAction": "Gagal membatalkan tindakan perbaikan. Silahkan coba lagi.",
  "coldStorage.error.saveConfig": "Gagal menyimpan konfigurasi sistem:",
  "coldStorage.error.saveThreshold": "Gagal menyimpan konfigurasi ambang batas:",
  "coldStorage.error.toggleStatus": "Gagal mengganti status perangkat:",
  "coldStorage.error.updateAction": "Gagal memuat tindakan perbaikan. Silahkan coba beberapa saat lagi.",
  "coldStorage.error.updateDevice": "Gagal memperbarui perangkat:",
  "coldStorage.escalationDelay": "Penundaan Eskalasi (menit)",
  "coldStorage.escalationDelayHelper": "Waktu tunggu sebelum eskalasi peringatan yang tidak terselesaikan",
  "coldStorage.escalationRules": "Aturan Eskalasi",
  "coldStorage.filter.activeOnly": "Hanya yang Aktif",
  "coldStorage.filter.all": "Semua Perangkat",
  "coldStorage.filter.inactiveOnly": "Hanya yang Inaktif",
  "coldStorage.granularNotificationControl": "Kendali Notifikasi Granular",
  "coldStorage.granularNotificationControlDesc": "Konfigurasi notifikasi email dan SMS untuk setiap jenis peringatan. Aktifkan metode notifikasi yang diinginkan untuk setiap jenis kategori peringatan.",
  "coldStorage.howNotificationsWork": "Bagaimana notifikasi bekerja",
  "coldStorage.howNotificationsWorkDesc": "Saat peringatan terpicu (pelanggaran ambang batas suhu, kegagalan perangkat, dll.), sistem akan:",
  "coldStorage.lastUpdate": "Pembaruan Terakhir",
  "coldStorage.loadingConfig": "Memuat konfigurasi sistem...",
  "coldStorage.loadingDevices": "Memuat perangkat...",
  "coldStorage.loadingPrefs": "Memuat pilihan notifikasi...",
  "coldStorage.modbusTcpPort": "Portal Modbus TCP",
  "coldStorage.name": "Nama",
  "coldStorage.noConfigFound": "Konfigurasi tidak ditemukan",
  "coldStorage.noDevicesConfigured": "Tidak ada perangkat yang dikonfigurasi",
  "coldStorage.notification.createRecord": "Membuat rekaman peringatan di sistem (tampil di Dasbor)",
  "coldStorage.notification.logAttempt": "Log percobaan notifikasi untuk kepentingan proses jejak audit",
  "coldStorage.notification.sendEmail": "Kirim notifikasi via EMAIL jika diaktifkan (untuk penerima yang di tetapkan)",
  "coldStorage.notification.sendSms": "Kirim notifikasi SMS jika diaktifkan (untuk nomor telepon yang ditetapkan)",
  "coldStorage.pollInterval": "Interval Poll (detik)",
  "coldStorage.protocolConfiguration": "Konfigurasi Protokol",
  "coldStorage.readOnlyMode": "Mode Read-Only",
  "coldStorage.readOnlyModeDesc": "Untuk memodifikasi pengaturan ini, silahkan navigasi ke Admin → Konfigurasi Sistem",
  "coldStorage.room.addNew": "Tambah Ruangan Baru",
  "coldStorage.room.create": "Buat Ruangan",
  "coldStorage.room.created": "Ruangan berhasil dibuat",
  "coldStorage.room.description": "Deskripsi",
  "coldStorage.room.descriptionPlaceholder": "Masukkan deskripsi ruangan (opsional)",
  "coldStorage.room.name": "Nama Ruangan *",
  "coldStorage.room.namePlaceholder": "Masukkan nama ruangan (misalnya, Ruangan Penyimpanan Lab A)",
  "coldStorage.saveNotificationPrefs": "Menyimpan Pilihan Notifikasi",
  "coldStorage.saveThresholdConfig": "Simpan Konfigurasi Ambang Batas",
  "coldStorage.saving": "Menyimpan...",
  "coldStorage.search.placeholder": "Cari berdasarkan ID atau nama perangkat",
  "coldStorage.securitySettings": "Pengaturan Keamanan",
  "coldStorage.sessionTimeout": "Sesi Habis",
  "coldStorage.sms": "SMS",
  "coldStorage.status": "Status",
  "coldStorage.status.active": "AKTIF",
  "coldStorage.status.inactive": "INAKTIF",
  "coldStorage.supervisorEmail": "Email Penyelia",
  "coldStorage.supervisorEmailHelper": "Alamat email untuk mengirim peringatan tereskalasi",
  "coldStorage.supervisorEmailPlaceholder": "supervisor@lab.com",
  "coldStorage.systemConfiguration": "Konfigurasi Peringatan",
  "coldStorage.systemInformation": "Informasi Sistem",
  "coldStorage.systemVersion": "Versi Sistem",
  "coldStorage.targetTemperature": "Target Suhu (°C)",
  "coldStorage.threshold.saveSuccess": "Konfigurasi ambang batas berhasil disimpan",
  "coldStorage.thresholdConfiguration": "Konfigurasi Ambang Batas Suhu",
  "coldStorage.twoFactorAuth": "Two-Factor Authentication",
  "coldStorage.uptime": "Waktu aktif",
  "coldStorage.usingDefaults": "Menggunakan pengaturan notifikasi default. Simpan untuk membuat konfigurasi.",
  "coldStorage.validation.error": "Kesalahan Validasi",
  "coldStorage.validation.retractionReason": "Masukkan alasan pembatalan",
  "coldStorage.validation.selectActionType": "Mohon pilih jenis aksi",
  "coldStorage.validation.selectDevice": "Mohon pilih perangkat",
  "coldStorage.validation.selectRoom": "Mohon pilih ruangan/lokasi untuk perangkat ini",
  "coldStorage.warningThreshold": "Peringatan Ambang Batas (°C)",
  "collect.addSample.button": "Tambah Sampel",
  "collect.assign.addToSample": "Tambah ke sampel yang ada",
  "collect.assign.button": "Tugaskan Pemeriksaan",
  "collect.assign.description": "Tugaskan pemeriksaan ke tube sampel",
  "collect.assign.newSample": "Buat sampel baru",
  "collect.assign.newSampleHelp": "Masukkan jenis sampel ke tube baru",
  "collect.assign.noExisting": "Tidak ada sampel tersebut",
  "collect.assign.title": "Penugasan Pemeriksaan",
  "collect.multiSampleExample.description": "Jika dibutuhkan jenis sample lebih dari satu",
  "collect.multiSampleExample.result": "Buat tube terpisah untuk setiap jenis",
  "collect.multiSampleExample.title": "Contoh Pengambilan Multi-Sampel",
  "collect.noSampleYet": "Sampel belum diambil",
  "collect.noTestsOrdered": "Pemeriksaan belum dipesan",
  "collect.noTestsWarning.subtitle": "Tambah sample dengan pemeriksaan di Step 1 sebelum lanjut",
  "collect.noTestsWarning.title": "Tidak ada pemeriksaan yang diambil",
  "collect.printMoreLabels.button": "Cetak Label Lagi",
  "collect.printMoreLabels.helper": "Cetak label tambahan untuk sampel ini",
  "collect.requestedTests.info": "Pemeriksaan diminta untuk pemesanan ini",
  "collect.requestedTests.title": "Pemeriksaan yang diminta",
  "collect.sample.assignedTests": "Pemeriksaan Ditugaskan",
  "collect.sample.collectionConditions": "Kondisi Pengambilan",
  "collect.sample.collectionConditions.placeholder": "Catat kondisi khusus...",
  "collect.sample.collectionDate": "Tanggal Pengambilan",
  "collect.sample.collectionDate.helper": "Tanggal saat sampel diambil",
  "collect.sample.collectionTime": "Waktu Pengambilan",
  "collect.sample.collector": "Pengambil sampel",
  "collect.sample.header": "Sampel {number}",
  "collect.sample.labPerformedSampling": "Lab performed sampling",
  "collect.sample.nce.link": "Laporan Kejadian Ketidaksesuaian",
  "collect.sample.noTests": "Tidak ada pemeriksaan yang ditugaskan untuk sampel ini",
  "collect.sample.printLabels": "Cetak label",
  "collect.sample.quantity": "Kuantitas",
  "collect.sample.receivedAtLab": "Diterima di Lab",
  "collect.sample.receivedAtLab.helper": "Periksa jika sampel sudah diterima di laboratorium",
  "collect.sample.receivedDate": "Tanggal Diterima",
  "collect.sample.receivedTime": "Waktu Diterima",
  "collect.sample.remove": "Hapus Sampel",
  "collect.samples.title": "Sampel",
  "collect.table.compatibleTypes": "Jenis Sampel Yang Kompatibel",
  "collect.table.sampleAssignments": "Penugasan Sampel",
  "collect.table.testPanel": "Pemeriksaan / Panel",
  "heading.informedConsent.sectionTitle": "Informed Consent",
  "heading.informedConsent.auditRecord": "Rekaman Audit Consent",
  "label.informedConsent.consentGiven": "Pasien sudah memberi tanda tangan consent",
  "label.informedConsent.formReference": "Nomor Referensi Form Consent",
  "label.informedConsent.recordedBy": "Direkam oleh",
  "label.informedConsent.recordedAt": "Direkam pada",
  "label.informedConsent.statusTag": "Consent sudah Direkam",
  "label.informedConsent.notRecorded": "Tidak terekam",
  "placeholder.informedConsent.formReference": "mis. CF-2026-00123",
  "placeholder.informedConsent.recordedBy": "mis. Dr. Smith",
  "error.informedConsent.formReferenceMaxLength": "Referensi form consent tidak lebih dari 100 karakter",
  "error.informedConsent.formReferenceInvalidChars": "Hanya boleh menggunakan abjad, angka, hyphen, dan spasi",
  "coldstorage.label.dashboard": "Dasbor Penyimpanan Beku",
  "collection.date": "Tanggal Pengambilan",
  "collector": "Pengambil sampel",
  "collector.label": "Pengambil sampel",
  "column.actions": "Aksi",
  "column.name.accept": "Terima",
  "column.name.analyzerResult": "Hasil dari Alat",
  "column.name.currentResult": "Hasil Saat Ini",
  "column.name.ignore": "Abaikan",
  "column.name.normalRange": "Rentang Normal",
  "column.name.notes": "Catatan",
  "column.name.pastNotes": "Catatan Sebelumnya",
  "column.name.qcDetail": "Detail",
  "column.name.qcStatus": "Status QC",
  "column.name.reject": "Tolak",
  "column.name.result": "Hasil",
  "column.name.retest": "Pemeriksaan Ulang",
  "column.name.sampleInfo": "Informasi Sampel",
  "column.name.sampleKind": "Sample Kind",
  "column.name.save": "Simpan",
  "column.name.statusPerRegulation": "Status — Per Regulation",
  "column.name.testDate": "Tanggal Pemeriksaan",
  "column.name.testId": "Identitas Pemeriksaan",
  "column.name.testName": "Nama Pemeriksaan",
  "column.name.uncertainty": "U (k=2)",
  "common.properties.title": "Properti Umum",
  "configuration.batch.test.reassignment": "Penugasan kembali dan pembatalan pemeriksaan kelompok",
  "configuration.method": "Pengelolaan Metode",
  "configuration.method.create": "Buat Metode Baru",
  "configuration.method.explain": "Untuk membuat metode baru, mengaktifkan atau menonaktifkan metode",
  "configuration.method.rename": "Ganti nama metode yang ada",
  "configuration.method.rename.explain": "Gunakan untuk mengkoreksi nama metode",
  "configuration.panel.assign": "Penugasan Pemeriksaan",
  "configuration.panel.assign.explain": "Klik untuk memilih nama pemeriksaan yang akan ditugaskan pada panel; nama pemeriksaan yang baru akan muncul di bagian bawah panel",
  "configuration.panel.confirmation.explain": "Panel ini tidak aktif sampai ada satu pemeriksaan yang ditugaskan",
  "configuration.panel.create": "Buat panel baru",
  "configuration.panel.create.duplicate": "Jenis panel dengan nama yang sama ditemukan. Batalkan dan gunakan nama lain.",
  "configuration.panel.manage": "Kelola Panel",
  "configuration.panel.manage.explain": "Untuk membuat, mengatur tampilan pemesanan atau menugaskan pemeriksaan pada panel",
  "configuration.panel.order": "Mengatur Urutan Panel",
  "configuration.panel.order.explain": "Menyortir panel dengan mengklik dan menyeret ke urutan yang tepat",
  "configuration.panel.order.explain.limits": "Hanya panel dengan pemeriksaan yang ditugaskan dapat dipesan. Untuk panel baru, mohon menugaskan pemeriksaan sebelum melakukan pemesanan.",
  "configuration.panel.rename": "Menamai ulang panel yang ada",
  "configuration.panel.rename.explain": "Gunakan nama yang tepat untuk panel yang ada",
  "configuration.sampleType.assign.explain": "Pilih pemeriksaan yang akan ditugaskan pada jenis sampel dengan mengklik nama pemeriksaan; pemeriksaan baru akan tampilan di bawah jenis sampel yang ditugaskan",
  "configuration.sampleType.assign.new.type": "Tugaskan ke jenis sampel",
  "configuration.sampleType.confirmation.explain": "Jenis sampel ini tidak akan aktif sampai setidaknya satu pemeriksaan telah ditugaskan.",
  "configuration.sampleType.create": "Buat Jenis Sampel Baru",
  "configuration.sampleType.create.duplicate": "Jenis sampel dengan nama yang sama ditemukan. Mohon membatalkan atau menggunakan nama lain",
  "configuration.sampleType.manage": "Kelola Jenis Sampel",
  "configuration.sampleType.manage.explain": "Gunakan untuk membuat, mengatur tampilan pemesanan atau menugaskan pemeriksaan pada jenis sampel",
  "configuration.sampleType.order": "Mengatur Urutan Jenis Sampel",
  "configuration.sampleType.order.explain": "Menyortir jenis sampel dengan mengklik dan menyeret ke urutan yang tepat",
  "configuration.sampleType.order.explain.limits": "Hanya jenis sampel dengan penugasan pemeriksaan yang dapat dipesan. Untuk jenis sampel baru, mohon menugaskan pemeriksaan sebelum melakukan pemesanan.",
  "configuration.selectList.add": "Tambah daftar pilihan hasil",
  "configuration.selectList.add.alert": "Untuk mengubah ejaan entri daftar hasil saat ini, gunakan opsi Ganti nama daftar hasil yang ada.",
  "configuration.selectList.add.explain": "Untuk membuat daftar pilihan hasil untuk hasil pemeriksaan",
  "configuration.selectList.assign.description": "Entri baru dapat ditugaskan ke pemeriksaan atau dapat disimpan tanpa penugasan. Pilih satu atau lebih pemeriksaan untuk ditugaskan, lalu sesuaikan urutan tampilan. Jika entri baru berupa nilai rentang normal untuk pemeriksaan yang dipilih, centang kotak berlabel `Normal`. Jika diinginkan, petugas dapat memasukkan teks untuk lebih memperjelas hasil, dan centang kotak berlabel `Dapat Diperjelas`. Misalnya; jika pilihannya adalah daftar organisme dan pilihan terakhir adalah `Lainnya`, maka pengguna dapat memasukkan organisme yang tidak ada dalam daftar.",
  "configuration.selectList.assign.header": "Tugaskan pilihan hasil baru ke pemeriksaan",
  "configuration.selectList.assign.new": "Opsi daftar pilihan baru",
  "configuration.selectList.confirmChange": "Nilai normal akan diubah dari %oldvalue% ke%newvalue%, apakah anda yakin akan lanjut?",
  "configuration.selectList.description": "Masukkan English dan French ke opsi pilihan baru. Bila terjemahan tidak diketahui, maka istilah akan digunakan untuk kedua bahasa tersebut.",
  "configuration.selectList.header": "Buat opsi pilihan hasil baru",
  "configuration.selectList.rename": "Namai ulang opsi daftar hasil yang ada",
  "configuration.selectList.rename.explain": "Namai ulang opsi daftar hasil yang ada",
  "configuration.test.activate": "Aktif/nonaktifkan pemeriksaan",
  "configuration.test.activate.explain": "Untuk mengaktifkan atau menonaktifkan pemeriksaan yang ada",
  "configuration.test.add": "Menambah pemeriksaan baru",
  "configuration.test.add.explain": "Untuk menambah pemeriksaan baru ke sistem. Modifikasi pemeriksaan yang ada harus dilakukan melalui tautan Kelola pemeriksaan lainnya",
  "configuration.test.catalog": "Lihat Katalog Pemeriksaan",
  "configuration.test.catalog.explain": "Melihat Katalog Pemeriksaan saat ini",
  "configuration.test.management.ocl": "Impor OCL Concept",
  "configuration.test.management.organization": "Pengaturan Pemeriksaan",
  "configuration.test.management.spelling": "Koreksi Penamaan",
  "configuration.test.modify": "Modifikasi pemeriksaan",
  "configuration.test.modify.explain": "Untuk memodifikasi pemeriksaan yang ada dalam sistem",
  "configuration.test.modify.tab.configuration": "Konfigurasi",
  "configuration.test.modify.tab.compliance": "Ambang Kepatuhan",
  "configuration.test.modify.filter.instruction": "Pilih Jenis Sampel atau Bagian Sampel untuk menampilkan pemeriksaan",
  "configuration.test.modify.filter.noTestsFound": "Tidak ada pemeriksaan yang cocok untuk kriteria yang dipilih",
  "configuration.test.modify.filter.selectToBegin": "Silahkan pilih Jenis Sampel atau Bagian Sampel untuk mulai menampilkan pemeriksaan",
  "configuration.test.orderable": "Mengaktifkan/menonaktifkan ketersediaan pemeriksaan",
  "configuration.test.orderable.explain": "Pemeriksaan yang tersedia dapat dipesan pada saat penerimaan pasien. Jika tidak tersedia, maka dapat dipesan sebagai pemeriksaan refleks.",
  "configuration.test.rename": "Menamai ulang pemeriksaan yang ada",
  "configuration.test.rename.explain": "Untuk menamai ulang pemeriksaan yang ada. Pemeriksaan tidak berubah, hanya ada perubahan pada tampilan pengguna di sistem dan pada laporan. ",
  "configuration.testSection.rename": "Menamai ulang Bagian Pemeriksaan yang ada",
  "configuration.testSection.rename.explain": "Untuk mengkoreksi nama bagian pemeriksaan yang sudah ada",
  "configuration.testUnit.assign.new.unit": "Menugaskan ke bagian pemeriksaan",
  "configuration.testUnit.confirmation.explain": "Instalasi Lab ini tidak aktif sampai setidaknya satu pemeriksaan ditugaskan",
  "configuration.testUnit.create": "Buat Instalasi Lab baru",
  "configuration.testUnit.create.duplicate": "Instalasi Lab dengan nama yang sama ditemukan. Batalkan atau gunakan nama lain.",
  "configuration.testUnit.manage": "Kelola Instalasi Lab",
  "configuration.testUnit.manage.explain": "Untuk membuat, mengatur urutan tampilan atau menugaskan pemeriksaan ke Instalasi Lab",
  "configuration.testUnit.order": "Mengatur Urutan Unit Pemeriksaan",
  "configuration.testUnit.order.explain": "Menyortir unit laboratorium dengan mengklik dan menyeret unit ke urutan yang tepat",
  "configuration.testUnit.order.explain.limits": "Hanya bagian pemeriksaan dengan pemeriksaan yang ditugaskan yang dapat dipesan. Untuk bagian baru, silahkan menugaskan pemeriksaan sebelum melakukan pemesanan.",
  "configuration.type.rename": "Menamai ulang jenis sampel yang ada",
  "configuration.type.rename.explain": "Untuk mengkoreksi nama panel yang ada",
  "heading.sampleType.management": "Sample Type Management",
  "heading.sampleType.subtitle": "Configure sample types, display order, test associations, and domain classification.",
  "heading.sampleType.editing": "Edit: {name}",
  "label.sampleType.domain": "Sample Domain",
  "label.domain.CLINICAL": "Klinis",
  "label.domain.ENVIRONMENTAL": "Lingkungan",
  "label.domain.VECTOR": "Vektor",
  "label.sampleType.domain.clinical": "Klinis",
  "label.sampleType.domain.environmental": "Lingkungan",
  "label.sampleType.domain.helper": "Determines which workflow mode (Clinical or Environmental) this sample type appears in.",
  "label.sampleType.filterDomain": "Filter by domain",
  "label.sampleType.testCount": "Pemeriksaan",
  "label.sampleType.actions": "Aksi",
  "label.sampleType.status": "Status",
  "placeholder.sampleType.search": "Search sample types...",
  "placeholder.sampleType.filter.domain": "All domains",
  "button.sampleType.add": "Tambah Jenis Sampel",
  "configuration.uom.create": "Buat Satuan Pengukuran Baru",
  "configuration.uom.manage": "Kelola Satuan Pengukuran",
  "configuration.uom.manage.explain": "Untuk membuat Satuan Pengukuran",
  "configuration.uom.rename": "Menamai ulang entri Satuan Pengukuran yang ada",
  "configuration.uom.rename.explain": "Untuk mengkoreksi nama entri satuan pengukuran yang ada.",
  "configure.labNumber.title": "Pengelolaan Nomor Registrasi",
  "confirmation.rename": "Konfirmasi perubahan yang dibuat",
  "currentests.title": "Pemeriksaan saat ini",
  "customFieldType.page.hierarchy.management": "Custom Field Types",
  "customFieldType.page.hierarchy.root": "System Administration",
  "cytology.label.cellabnomality": "Abnormalitas Sel Epitel",
  "cytology.label.confirmSelect": "Bila opsi ini dipilih, semua informasi diagnosis saat ini akan dihapus",
  "cytology.label.dashboard": "Dasbor Sitologi",
  "cytology.label.glandular": "Glandular",
  "cytology.label.negative": "Negatif lesi intraepitelial atau keganasan",
  "cytology.label.neoplastic": "Keragaman sel non-neoplastik",
  "cytology.label.organisms": "Organisme",
  "cytology.label.other": "Neoplasma ganas lainnya",
  "cytology.label.otherResult": "Hasil diagnosis lainnya",
  "cytology.label.reactive": "Perubahan sel reaktif",
  "cytology.label.review": "Menunggu tinjauan dari ahli sitopatologi",
  "cytology.label.specimen": "Kecukupan spesimen",
  "cytology.label.squamous": "Skuamosa",
  "cytology.label.title": "Sitologi",
  "dashboard.avg.turn.around.label": "Rerata waktu penyelesaian",
  "dashboard.avg.turn.around.reception.to.result.label": "Waktu Rerata Penerimaan Sampai Hasil",
  "dashboard.avg.turn.around.reception.to.validation.label": "Waktu Rerata Penerimaan Sampai Validasi",
  "dashboard.avg.turn.around.result.to.validation.label": "Waktu Rerata Hasil Sampai Validasi",
  "dashboard.avg.turn.around.subtitle.label": "Penerimaan sampai validasi",
  "dashboard.complete.orders.label": "Pemesanan selesai hari ini",
  "dashboard.in.progress.label": "Dalam Pengerjaan",
  "dashboard.in.progress.subtitle.label": "Menunggu entri hasil",
  "dashboard.partially.completed.label": "Sebagian selesai hari ini",
  "dashboard.partially.completed.subtitle.label": "Menunggu Pemeriksaan yang Belum Selesai",
  "dashboard.rejected.orders": "Pemesanan ditolak",
  "dashboard.turn.around.label": "Waktu penyelesaian tertunda",
  "dashboard.turn.around.subtitle.label": "Lebih dari 96 jam",
  "dashboard.unprints.results.label": "Hasil belum dicetak",
  "dashboard.user.orders.label": "Pemesanan yang dimasukkan pengguna",
  "dashboard.user.orders.today.label": "Pemesanan dimasukkan oleh pengguna hari ini",
  "dashboard.validation.ready.label": "Siap untuk validasi",
  "dashboard.validation.ready.subtitle.label": "Menunggu tinjauan",
  "dataexport.status.actions": "Aksi",
  "dataexport.status.attempt.duration": "Durasi",
  "dataexport.status.attempt.endTime": "Waktu Selesai",
  "dataexport.status.attempt.startTime": "Waktu Mulai",
  "dataexport.status.attempt.status": "Status",
  "dataexport.status.duration.ms": "{value} ms",
  "dataexport.status.duration.s": "{value} s",
  "dataexport.status.empty": "No FHIR subscribers are configured. Set org.openelisglobal.fhir.subscriber in common.properties and restart the server to register one.",
  "dataexport.status.endpoint": "Endpoint",
  "dataexport.status.failed24h": "Gagal / Total (24 jam)",
  "dataexport.status.failed24hValue": "{failed} / {total}",
  "dataexport.status.intervalMin": "Interval retry",
  "dataexport.status.intervalValue": "{value} min",
  "dataexport.status.lastAttempt": "Coba terakhir",
  "dataexport.status.lastRefreshed": "Refresh terakhir",
  "dataexport.status.lastStatus": "Status Terakhir",
  "dataexport.status.lastSuccess": "Sukses Terakhir",
  "dataexport.status.loadingAttempts": "Memuat riwayat percobaan...",
  "dataexport.status.never": "Tidak pernah",
  "dataexport.status.noAttempts": "Belum ada percobaan",
  "dataexport.status.placeholderDash": "—",
  "dataexport.status.refresh": "Refresh",
  "dataexport.status.retry": "Ulangi sekarang",
  "dataexport.status.retryInFlight": "Men-trigger…",
  "dataexport.status.title": "Status Ekspor Data FHIR",
  "datasubmission.siteid": "Site Id",
  "database.clean": "Pembersihan Database",
  "database.clean.button": "Kosongkan Database",
  "database.clean.confirm.message": "Apakah Anda yakin akan mengosongkan database? Ini akan menghapus semua data pasien dan pemeriksaan",
  "database.clean.confirm.title": "Konfirmasi Pengosongan Database",
  "database.clean.confirm.warning": "Aksi ini tidak dapat dibatalkan!",
  "database.clean.error": "Gagal mengosongkan database.",
  "database.clean.not.training": "Pembersihan database hanya tersedia di instalasi pelatihan.",
  "database.clean.success": "Database berhasil dikosongkan.",
  "database.clean.warning": "Ini akan menghapus permanen semua data pasien, sampel dan hasil dari database.",
  "date.created": "Tanggal Dibuat",
  "datepicker.placeholder.dmy": "dd/mm/yyyy",
  "datepicker.placeholder.mdy": "mm/dd/yyyy",
  "delete.error.msg": "Error saat menghapus",
  "delete.success.msg": "Berhasil dihapus",
  "description.active": "Jika pemeriksaan sedang aktif, maka dapat dipesan melalui formulir pemesanan atau sebagai bagian algoritma pemeriksaan. Jika pemeriksaan tidak aktif, maka tidak dapat dipesan atau dijadikan bagian algoritma pemeriksaan.",
  "description.ageRange": "Jika rentang usia (dalam bulan) penting untuk nilai yang diberikan, maka akan ditentukan di sini.",
  "description.name": "Nama pemeriksaan akan muncul di dalam sistem, baik versi bahasa Inggris maupun Prancis.",
  "description.normalRange": "Rentang numerik yang diharapkan dari orang sehat.",
  "description.note": "n/a berarti tidak tersedia. Nilai tidak dispesifikasi.",
  "description.orderable": "Jika pemeriksaan aktif dan dapat dipesan, maka pemeriksaan dapat dipesan melalui formulir pemesanan. Jika pemeriksaan aktif tetapi tidak dapat dipesan, maka pemeriksaan hanya akan dilakukan jika merupakan rujukan dari pemeriksaan lain.",
  "description.panel": "Jika pemeriksaan adalah bagian dari panel pemeriksaan, maka panel akan disebut di sini.",
  "description.referenceValue": "Nilai pilihan untuk orang sehat. Hanya untuk daftar hasil yang dipilih.",
  "description.reportName": "Nama pemeriksaan yang tampil pada laporan. Tampil dalam Bahasa Inggris maupun Perancis",
  "description.resultLimits": "Batas hasil normal dan valid untuk pemeriksaan numerik. Nilai tergantung umur dan jenis kelamin pasien.",
  "description.resultType": "Jenis hasil untuk pemeriksaan ini:",
  "description.resultType.alphanumeric": "A - Alphanumeric:",
  "description.resultType.alphanumericDesc": "Menerima nilai numerik atau teks dalam kotak teks. Nilai tidak akan dievaluasi apakah normal atau valid.",
  "description.resultType.cascadingMultiSelectList": "C - Daftar pilihan berganda bertingkat:",
  "description.resultType.cascadingMultiSelectListDesc": "Serupa dengan pilihan berganda, tapi pengguna dapat memilih lebih dari satu kelompok dari pilihan dropdown.",
  "description.resultType.kind": "Jenis hasil untuk pemeriksaan ini:",
  "description.resultType.multiSelectList": "M - Daftar pilihan berganda:",
  "description.resultType.multiSelectListDesc": "Pengguna dapat memilih satu atau lebih nilai dari daftar dropdown. Nilai referensi tidak dispesifikasi.",
  "description.resultType.numeric": "N - Numerik:",
  "description.resultType.numericDesc": "Hanya menerima hasil numerik dalam kotak teks. Hasil dapat dievaluasi dalam rentang normal atau valid.",
  "description.resultType.selectList": "D - Daftar pilihan:",
  "description.resultType.selectListDesc": "Pengguna dapat memilih dari daftar dropdown. Nilai normal akan ditentukan sebagai nilai referensi.",
  "description.resultType.textArea": "R-Teks bebas:",
  "description.resultType.textAreaDesc": "Menerima lebih dari 200 karakter dalam area teks. Tidak dievaluasi apakah normal atau valid.",
  "description.sampleType": "Jenis sampel yang dapat diuji. Jika petugas yang menerima dapat memilih jenis sampel setelah pemesanan pemeriksaan, maka akan ditandai sebagai \"pengguna\", untuk menunjukkan bahwa pengguna memilih jenis sampel tersebut.",
  "description.selectValues": "Hanya ditentukan untuk hasil pilihan tunggal, pilihan ganda, atau pilihan ganda bertingkat. Ini adalah pilihan yang tersedia terlihat oleh pengguna. Jika pilihan ditandai sebagai 'dapat memenuhi syarat', maka pengguna dapat memasukkan informasi tambahan di kotak teks.",
  "description.sex": "Jika jenis kelamin pasien berpengaruh pada nilai, maka akan disebutkan disini.",
  "description.significantDigits": "Jumlah digit signifikan untuk hasil numerik. Hasil yang dimasukkan akan dibulatkan atau ditambahkan angka di depan hingga mencapai jumlah digit yang benar. Rentang normal akan ditampilkan dengan jumlah angka signifikan yang benar.",
  "description.testUnit": "Bagian lab yang melakukan pemeriksaan. Disebut juga sebagai bagian pemeriksaan.",
  "description.uom": "Satuan pengukuran pemeriksaan. Biasanya berlaku hanya untuk jenis hasil numerik atau alfanumerik.",
  "description.validRange": "Hasil numerik di luar rentang ini adalah indikasi pemeriksaan tidak dilakukan dengan benar.",
  "dictionary.category.isActive": "Aktif",
  "dictionary.category.label": "Kategori Kamus",
  "dictionary.category.localAbbreviation": "Singkatan lokal",
  "dictionary.category.name": "Kategori",
  "dictionary.dictEntry": "Entri kamus",
  "dictionary.label.modify": "Menu kamus",
  "dictionary.loincCode": "LOINC Code",
  "dictionary.loincCode.help": "Masukkan kode LOINC standar",
  "dictionary.loincCode.helpText": "Pengenal standar observasi laboratorium",
  "dictionary.loincCode.invalid": "Format LOINC tidak valid (contoh yang benar: 12345-6 or LP12345-6)",
  "dictionary.loincCode.placeholder": "misalnya, 12345-6",
  "dictionary.menu.deactivate.fail": "Penonaktifan menu kamus gagal",
  "dictionary.menu.deactivate.success": "Penonaktifan menu kamus sukses",
  "dictionary.modal.add.heading": "Tambah Kamus",
  "dictionary.modal.edit.heading": "Edit Kamus",
  "dictionary.number.label": "Nomor Kamus",
  "disposal.button": "Musnahkan Lot",
  "disposal.notes": "Catatan Pemusnahan",
  "disposal.notes.placeholder": "Sediakan rincian pemusnahan (metode pemusnahan, saksi, dll.)",
  "disposal.reason": "Alasan Pemusnahan",
  "disposal.reason.select": "Pilih alasan",
  "disposal.success": "Lot berhasil dimusnahkan",
  "disposal.title": "Musnahkan Lot",
  "disposal.warning.message": "Aksi ini tidak dapat dibatalkan. Lot akan ditandai dimusnahkan atau dihapus dari inventaris aktif.",
  "disposal.warning.title": "Peringatan",
  "edit.add.program.title": "Tambah/Edit Program",
  "emergencyContactInfo.title": "Informasi Kontak Darurat",
  "english.current": "Bahasa Inggris saat ini",
  "english.label": "Bahasa Inggris",
  "enterText.label": "Masukkan hasil teks",
  "eorder.allInfo": "Semua Informasi",
  "eorder.button.editOrder": "Edit Pemesanan",
  "eorder.button.enterOrder": "Masukkan Pemesanan",
  "eorder.buttons": " ",
  "eorder.date.end": "Tanggal Selesai",
  "eorder.date.start": "Tanggal Mulai",
  "eorder.facility.requesting": "Lembaga Pemohon",
  "eorder.header": "Cari Pemesanan Pemeriksaan Yang Masuk",
  "eorder.id.national": "NIK",
  "eorder.id.subjectNumber": "Nomor Subyek",
  "eorder.instructions.enter1": "Kecocokan Pencarian Permintaan Pemeriksaan - Dalam",
  "eorder.instructions.enter2": "menu, tambah nomor registrasi dan pilih",
  "eorder.instructions.enter3": "menerima permintaan seperti apa adanya, atau pilih",
  "eorder.instructions.enter4": "membuat perubahan",
  "eorder.labNumber": "Nomor Registrasi",
  "eorder.labnumber.referring": "Nomor Lab Perujuk",
  "eorder.name.first": "Nama Depan",
  "eorder.name.last": "Nama Belakang",
  "eorder.passport.number": "Nomor Paspor",
  "eorder.priority": "Prioritas",
  "eorder.requestDate": "Tanggal Permintaan",
  "eorder.search.noresults": "Nomor Permintaan Elektronik",
  "eorder.search1.text": "Cari berdasar Nama Belakang, NIK, Nomor Lab Perujuk, atau Nomor Paspor",
  "eorder.search2.text": "Cari berdasarkan Tanggal, dan Status rentang tanggal permintaan pemeriksaan. Pencarian akan dilakukan berdasarkan tanggal dirujuk, atau tanggal permintaan elektronik.",
  "eorder.searchValue": "Cari Nilai",
  "eorder.status": "Status",
  "eorder.test.name": "Nama Pemeriksaan",
  "eqa.action.deactivate": "Nonaktifkan",
  "eqa.action.edit": "Edit",
  "eqa.action.enterResults": "Masukkan Hasil",
  "eqa.action.enterViewResults": "Masukkan/Lihat Hasil",
  "eqa.action.reactivate": "Aktifkan Ulang",
  "eqa.action.viewOrder": "Lihat Pemesanan",
  "eqa.action.viewResults": "Lihat Hasil",
  "eqa.admin.addProgram": "Tambah Program",
  "eqa.admin.col.actions": "Aksi",
  "eqa.admin.col.category": "Kategori",
  "eqa.admin.col.frequency": "Frekuensi",
  "eqa.admin.col.participants": "Peserta yang terdaftar",
  "eqa.admin.col.programName": "Nama Program",
  "eqa.admin.col.provider": "Penyelenggara",
  "eqa.admin.delete": "Hapus",
  "eqa.admin.form.addHeading": "Tambah Program PME Baru",
  "eqa.admin.form.category.placeholder": "Pilih Kategori",
  "eqa.admin.form.description.placeholder": "Deskripsi dan tujuan program...",
  "eqa.admin.form.editHeading": "Edit Program PME",
  "eqa.admin.form.frequency.placeholder": "Pilih Frekuensi",
  "eqa.admin.form.name.placeholder": "mis., Kultur TB & Sensitivitas",
  "eqa.admin.form.provider.placeholder": "Pilih penyelenggara",
  "eqa.admin.form.subtitle": "Daftar di program PME baru",
  "eqa.admin.programs.subtitle": "Kelola program dan penyelenggara PME yang terdaftar",
  "eqa.admin.programs.title": "Program PME",
  "eqa.admin.provider.placeholder": "mis., WHO",
  "eqa.admin.subtitle": "Kelola program, pengguna dan pengaturan sistem PME",
  "eqa.admin.systemSettings.placeholder": "Pengaturan sistem segera ada.",
  "eqa.admin.tab.participants": "Peserta",
  "eqa.admin.tab.programs": "Program PME",
  "eqa.admin.tab.systemSettings": "Pengaturan Sistem",
  "eqa.admin.tab.userManagement": "Pengelolaan Pengguna",
  "eqa.admin.tile.acrossAllPrograms": "Seluruh program",
  "eqa.admin.tile.activePrograms": "Program Aktif",
  "eqa.admin.tile.canManageEqa": "Dapat mengelola PME",
  "eqa.admin.tile.enrolledParticipants": "Peserta yang terdaftar",
  "eqa.admin.tile.systemUsers": "Pengguna Sistem",
  "eqa.admin.tile.totalParticipants": "Total Peserta",
  "eqa.admin.tile.totalPrograms": "{count} total program",
  "eqa.admin.title": "Administrasi Program",
  "eqa.admin.userManagement.placeholder": "Pengelolaan pengguna segera ada",
  "eqa.column.actions": "Aksi",
  "eqa.deadline.label": "Tenggat Pemeriksaan",
  "eqa.distribution.action.continue": "Lanjut",
  "eqa.distribution.action.ship": "Kirim",
  "eqa.distribution.action.track": "Lacak",
  "eqa.distribution.action.viewReport": "Lihat Laporan",
  "eqa.distribution.advance": "Status Lanjutan",
  "eqa.distribution.backToDashboard": "Kembali ke Distribusi",
  "eqa.distribution.barcodes": "Buat Kode QR",
  "eqa.distribution.col.actions": "Aksi",
  "eqa.distribution.col.deadline": "Tenggat",
  "eqa.distribution.col.participants": "Peserta",
  "eqa.distribution.col.program": "Program",
  "eqa.distribution.col.responses": "Respon",
  "eqa.distribution.col.round": "Round",
  "eqa.distribution.col.samples": "Sampel",
  "eqa.distribution.col.shipmentId": "ID Pengiriman",
  "eqa.distribution.col.status": "Status",
  "eqa.distribution.create": "Buat Distribusi",
  "eqa.distribution.createError": "Gagal membuat distribusi",
  "eqa.distribution.createShipment": "Buat Pengiriman Baru",
  "eqa.distribution.createSuccess": "Distribusi berhasil dibuat.",
  "eqa.distribution.dashboard.subtitle": "Distribusi sampel PME ke laboratorium peserta",
  "eqa.distribution.dashboard.title": "Distribusi PME",
  "eqa.distribution.deadline": "Tenggat Penyerahan",
  "eqa.distribution.detail.title": "Rincian Distribusi",
  "eqa.distribution.empty": "Distribusi tidak ditemukan",
  "eqa.distribution.filter.allShipments": "Semua Pengiriman",
  "eqa.distribution.filter.program": "Filter berdasarkan Program",
  "eqa.distribution.filter.status": "Filter berdasarkan Status",
  "eqa.distribution.list.title": "Distribusi PME",
  "eqa.distribution.manageParticipants": "Kelola Peserta",
  "eqa.distribution.name": "Nama Distribusi",
  "eqa.distribution.name.placeholder": "mis, Round 1 - Kimia 2026",
  "eqa.distribution.network.active": "Peserta Aktif",
  "eqa.distribution.network.active.sub": "Yang terdaftar saat ini",
  "eqa.distribution.network.responseRate": "Rerata Kecepatan Respon",
  "eqa.distribution.network.responseRate.sub": "4 triwulan terakhir",
  "eqa.distribution.network.subtitle": "Ringkasan laboratorium peserta yang terdaftar",
  "eqa.distribution.network.title": "Jejaring Peserta",
  "eqa.distribution.network.total": "Total Peserta",
  "eqa.distribution.network.total.sub": "Seluruh negara",
  "eqa.distribution.participants": "Organisasi Peserta",
  "eqa.distribution.participants.min": "Wajib setidaknya 2 organisasi peserta",
  "eqa.distribution.participants.none": "Tidak ada organisasi yang terdaftar di program tersebut. Daftarkan peserta sebelum membuat distribusi.",
  "eqa.distribution.participants.select": "Pilih organisasi",
  "eqa.distribution.program": "Program PME",
  "eqa.distribution.program.select": "Pilih program",
  "eqa.distribution.responseRate": "kecepatan respon",
  "eqa.distribution.shipments.subtitle": "Lacak distribusi sampel PME dan respon peserta",
  "eqa.distribution.shipments.title": "Pengiriman PME",
  "eqa.distribution.shipped": "Sudah dikirim",
  "eqa.distribution.status.completed": "Selesai",
  "eqa.distribution.status.draft": "Draf",
  "eqa.distribution.status.prepared": "Disiapkan",
  "eqa.distribution.status.shipped": "Sudah dikirim",
  "eqa.distribution.step.confirmation": "Konfirmasi",
  "eqa.distribution.step.details": "Program & Rincian",
  "eqa.distribution.step.participants": "Peserta",
  "eqa.distribution.summary.completed": "Selesai",
  "eqa.distribution.summary.completed.sub": "Semua respon sudah diterima",
  "eqa.distribution.summary.draft": "Draf Pengiriman",
  "eqa.distribution.summary.draft.sub": "Tengah disiapkan",
  "eqa.distribution.summary.participants": "Peserta",
  "eqa.distribution.summary.participants.sub": "Sudah terdaftar",
  "eqa.distribution.summary.shipped": "Sudah dikirim",
  "eqa.distribution.summary.shipped.sub": "Menunggu respon",
  "eqa.enrollment.allStatuses": "Semua Status",
  "eqa.enrollment.alreadyEnrolled": "Yang terdaftar saat ini",
  "eqa.enrollment.alreadyEnrolledCount": "{count} organisasi yang terdaftar",
  "eqa.enrollment.confirmWithdraw": "Konfirmasi Penarikan",
  "eqa.enrollment.created.success": "Pendaftaran program berhasil dibuat",
  "eqa.enrollment.deactivated": "Pendaftaran program berhasil dinonaktifkan",
  "eqa.enrollment.description": "Deskripsi",
  "eqa.enrollment.district": "Kabupaten",
  "eqa.enrollment.editing": "Edit: {name}",
  "eqa.enrollment.empty": "Tidak ada pendaftaran ditemukan untuk program ini",
  "eqa.enrollment.enroll": "Daftar",
  "eqa.enrollment.enrollParticipant": "Daftarkan Peserta",
  "eqa.enrollment.enrollSelected": "Daftarkan yang Dipilih",
  "eqa.enrollment.enrollmentDate": "Tanggal Pendaftaran",
  "eqa.enrollment.labUnits": "Instalasi Lab",
  "eqa.enrollment.new": "Pendaftaran Program PME Baru",
  "eqa.enrollment.organizationCode": "Kode Organisasi",
  "eqa.enrollment.organizationName": "Nama Organisasi",
  "eqa.enrollment.panels": "Panel",
  "eqa.enrollment.programName": "Nama Program",
  "eqa.enrollment.programName.placeholder": "Masukkan nama program",
  "eqa.enrollment.provider": "Penyelenggara",
  "eqa.enrollment.provider.placeholder": "Masukkan nama penyelenggara",
  "eqa.enrollment.reactivate": "Aktifkan Ulang",
  "eqa.enrollment.reactivated": "Pendaftaran program diaktifkan ulang",
  "eqa.enrollment.save": "Simpan Pendaftaran",
  "eqa.enrollment.saveChanges": "Simpan Perubahan",
  "eqa.enrollment.searchOrgs": "Cari organisasi...",
  "eqa.enrollment.searchPlaceholder": "Cari organisasi berdasarkan nama atau kode...",
  "eqa.enrollment.selectLabUnits": "Pilih instalasi lab...",
  "eqa.enrollment.selectOrg": "Pilih organisasi...",
  "eqa.enrollment.selectOrgsPrompt": "Pilih organisasi untuk mendaftar",
  "eqa.enrollment.selectPanels": "Pilih panel...",
  "eqa.enrollment.selectProgram": "Pilih Program",
  "eqa.enrollment.selectProgramPrompt": "Pilih program untuk melihat pendaftaran",
  "eqa.enrollment.selectTests": "Pilih pemeriksaan...",
  "eqa.enrollment.selected": "dipilih",
  "eqa.enrollment.status": "Status",
  "eqa.enrollment.status.active": "Aktif",
  "eqa.enrollment.status.suspended": "Ditangguhkan",
  "eqa.enrollment.status.withdrawn": "Ditarik",
  "eqa.enrollment.success": "Pendaftaran Berhasil",
  "eqa.enrollment.suspend": "Ditangguhkan",
  "eqa.enrollment.tests": "Pemeriksaan",
  "eqa.enrollment.thisLab": "Lab ini",
  "eqa.enrollment.updated.success": "Pendaftaran program berhasil diperbarui",
  "eqa.enrollment.withdraw": "Tarik",
  "eqa.enrollment.withdrawReason": "Alasan Penarikan",
  "eqa.enrollment.withdrawReasonPlaceholder": "Masukkan alasan penarikan peserta ini...",
  "eqa.filter.allPriorities": "Semua Prioritas",
  "eqa.filter.allPrograms": "Semua Program",
  "eqa.filter.allStatuses": "Semua Status",
  "eqa.filter.eqaOnly": "Hanya Sampel PME",
  "eqa.filter.priority": "Prioritas",
  "eqa.filter.program": "Program",
  "eqa.filter.status": "Status",
  "eqa.management.action.enterResults": "Masukkan Hasil",
  "eqa.management.action.submit": "Kirim",
  "eqa.management.bulkUpload": "Unggah Hasil Bulk",
  "eqa.management.col.accession": "Aksesi #",
  "eqa.management.col.actions": "Aksi",
  "eqa.management.col.deadline": "Tenggat",
  "eqa.management.col.progress": "Progress",
  "eqa.management.col.provider": "Penyelenggara/Program",
  "eqa.management.col.sampleId": "Nomor Identitas Sampel",
  "eqa.management.col.status": "Status",
  "eqa.management.daysLeft": "hari tersisa",
  "eqa.management.distributions.title": "Distribusi",
  "eqa.management.filter.allSamples": "Semua Sampel",
  "eqa.management.overdue": "Lewat tenggat",
  "eqa.management.participants.subtitle": "Kelola pendaftaran organisasi di program PME",
  "eqa.management.participants.title": "Peserta",
  "eqa.management.performance.onTime": "Penyerahan Tepat Waktu",
  "eqa.management.performance.participation": "Keikutsertaan",
  "eqa.management.performance.participation.sub": "Semua program terdaftar",
  "eqa.management.performance.subtitle": "Metrik kinerja PME laboratorium Anda",
  "eqa.management.performance.title": "Ringkasan Kinerja",
  "eqa.management.performance.zScore": "Rerata Z-Score",
  "eqa.management.performance.zScore.sub": "Dalam rentang dapat diterima",
  "eqa.management.programs.subtitle": "Kelola program yang didistribusi oleh laboratorium ini",
  "eqa.management.programs.title": "Program PME",
  "eqa.management.results.title": "Hasil & Analisis",
  "eqa.management.samples.empty": "Tidak ada sampel PME ditemukan",
  "eqa.management.samples.subtitle": "Kelola sampel PME yang diterima dan kirim hasil",
  "eqa.management.samples.title": "Sampel PME",
  "eqa.management.status.completed": "Selesai",
  "eqa.management.status.completed.sub": "Siap untuk mengirim",
  "eqa.management.status.inProgress": "Dalam Pengerjaan",
  "eqa.management.status.inProgress.sub": "Pemeriksaan dalam pengerjaan",
  "eqa.management.status.in_progress": "Dalam Pengerjaan",
  "eqa.management.status.overdue": "Lewat tenggat",
  "eqa.management.status.pending": "Tertunda",
  "eqa.management.status.pending.sub": "Belum dimulai",
  "eqa.management.status.submitted": "Dikirim",
  "eqa.management.status.submitted.sub": "Hasil dikirim",
  "eqa.management.subtitle": "Terima dan kelola sampel PME dari penyelenggara eksternal",
  "eqa.management.title": "Pengelolaan PME",
  "eqa.management.viewPerformance": "Lihat Kinerja",
  "eqa.myProgram.helperText": "Memilih pendaftaran akan secara otomatis mengisi pemeriksan dan panel",
  "eqa.myProgram.label": "Pendaftaran Program Saya",
  "eqa.myProgram.prePopulated.subtitle": "{tests} pemeriksaan dan {panels} panel yang telah dipilih sebelumnya dari pendaftaran",
  "eqa.myProgram.prePopulated.title": "Pemeriksaan/panel terisi otomatis",
  "eqa.myProgram.select": "Memilih pendaftaran untuk mengisi pemeriksan dan panel secara otomatis...",
  "eqa.myPrograms.action.deactivate": "Nonaktifkan",
  "eqa.myPrograms.action.edit": "Edit",
  "eqa.myPrograms.action.reactivate": "Aktifkan Ulang",
  "eqa.myPrograms.description": "Deskripsi",
  "eqa.myPrograms.enrollButton": "Daftar Program",
  "eqa.myPrograms.enrollInProgram": "Daftar Program",
  "eqa.myPrograms.labUnits": "Instalasi Lab",
  "eqa.myPrograms.panels": "Panel",
  "eqa.myPrograms.programName": "Nama Program",
  "eqa.myPrograms.provider": "Penyelenggara",
  "eqa.myPrograms.search.placeholder": "Cari program...",
  "eqa.myPrograms.status": "Status",
  "eqa.myPrograms.status.active": "Aktif",
  "eqa.myPrograms.status.inactive": "Inaktif",
  "eqa.myPrograms.subtitle": "Program yang diikuti laboratorium ini",
  "eqa.myPrograms.testMapping": "Pemetaan Pemeriksaan (Opsional)",
  "eqa.myPrograms.testMappingHint": "Pilih pemeriksaan dan panel untuk otomatis mengisi Entri Pemesanan saat program dipilih",
  "eqa.myPrograms.tests": "Pemeriksaan",
  "eqa.myPrograms.title": "Program PME Saya",
  "eqa.order.deadline": "Tenggat Hasil",
  "eqa.order.form.title": "Informasi Sampel PME",
  "eqa.order.participantId": "ID Peserta",
  "eqa.order.priority": "Prioritas PME",
  "eqa.order.programme": "Program",
  "eqa.order.provider": "Penyelenggara",
  "eqa.order.providerSampleId": "ID Sampel Penyelenggara",
  "eqa.orders.completedThisMonth": "Selesai Bulan Ini",
  "eqa.orders.enterNewTest": "Masukkan Pemeriksaan PME Baru",
  "eqa.orders.inProgress": "Dalam Pengerjaan",
  "eqa.orders.overdue": "Lewat tenggat",
  "eqa.orders.pending": "Tertunda",
  "eqa.orders.search.placeholder": "Cari berdasarkan nomor lab atau program...",
  "eqa.participant.id": "ID Peserta",
  "eqa.priority.critical": "Kritis",
  "eqa.priority.label": "Prioritas",
  "eqa.priority.standard": "Standar",
  "eqa.priority.urgent": "Mendesak",
  "eqa.program.activate": "Aktifkan",
  "eqa.program.active": "Aktif",
  "eqa.program.addProgram": "Tambah Program",
  "eqa.program.cancel": "Batal",
  "eqa.program.create": "Buat Program",
  "eqa.program.createTitle": "Buat Program PME",
  "eqa.program.deactivate": "Nonaktifkan",
  "eqa.program.description": "Deskripsi",
  "eqa.program.description.placeholder": "Deskripsi Program PME...",
  "eqa.program.edit": "Edit Program",
  "eqa.program.editTitle": "Edit Program PME",
  "eqa.program.empty": "Program PME tidak ditemukan",
  "eqa.program.inactive": "Inaktif",
  "eqa.program.label": "Program PME",
  "eqa.program.management.title": "Pengelolaan Program PME",
  "eqa.program.name": "Nama Program",
  "eqa.program.name.placeholder": "mis., Uji Profisiensi Kimia",
  "eqa.program.name.required": "Nama program wajib ada",
  "eqa.program.provider.required": "Penyelenggara wajib ada",
  "eqa.program.participantCount": "Peserta yang terdaftar",
  "eqa.program.provider": "Penyelenggara",
  "eqa.program.required": "Program PME wajib ada saat mendaftarkan sampel PME",
  "eqa.program.save": "Simpan Program",
  "eqa.program.select": "Pilih Program PME",
  "eqa.program.status": "Status",
  "eqa.program.tests": "Pemeriksaan Ditugaskan",
  "eqa.program.tests.assign": "Tugaskan Pemeriksaan",
  "eqa.program.tests.select": "Pilih pemeriksaan untuk ditugaskan",
  "eqa.provider.label": "Organisasi Penyelenggara PME",
  "eqa.provider.sampleId": "ID Sampel Penyelenggara",
  "eqa.provider.select": "Pilih Penyelenggara PME",
  "eqa.results.acceptable": "Dapat diterima",
  "eqa.results.batch.import": "Impor Batch",
  "eqa.results.col.deadline": "Tenggat",
  "eqa.results.col.labNumber": "Nomor Lab",
  "eqa.results.col.priority": "Prioritas",
  "eqa.results.col.programme": "Program",
  "eqa.results.col.provider": "Penyelenggara",
  "eqa.results.col.status": "Status",
  "eqa.results.import.confirm": "Konfirmasi Impor",
  "eqa.results.import.errors": "{count} baris ada error",
  "eqa.results.import.success": "{count} hasil berhasil diimpor",
  "eqa.results.import.upload": "Unggah file CSV",
  "eqa.results.manual.entry": "Entri Hasil Manual",
  "eqa.results.mean": "Mean",
  "eqa.results.minimum.participants": "Minimal 5 peserta diperlukan untuk analisis statistik",
  "eqa.results.noResults": "Hasil pemeriksaan PME tidak ditemukan.",
  "eqa.results.organization": "Organisasi",
  "eqa.results.organization.select": "Pilih organisasi",
  "eqa.results.participant.count": "Jumlah Peserta",
  "eqa.results.performance": "Kinerja",
  "eqa.results.questionable": "Dipertanyakan",
  "eqa.results.report.downloading": "Mengunduh laporan...",
  "eqa.results.report.generate": "Buat Laporan",
  "eqa.results.search.placeholder": "Cari berdasarkan nomor lab, program, atau penyelenggara...",
  "eqa.results.standardDeviation": "Simpangan Baku",
  "eqa.results.statistics": "Statistik",
  "eqa.results.submit": "Kirim Hasil",
  "eqa.results.test": "Pemeriksaan",
  "eqa.results.test.select": "Pilih Pemeriksaan",
  "eqa.results.title": "Hasil & Analisis PME",
  "eqa.results.unacceptable": "Tidak dapat diterima",
  "eqa.results.value": "Nilai Hasil",
  "eqa.results.zscore": "Z-Score",
  "eqa.sample.badge": "PME",
  "eqa.sample.checkbox": "Sampel PME",
  "eqa.sample.checkbox.helper": "Periksa jika ini sampel Pemantapan Mutu Eksternal",
  "eqa.sample.demographics.disabled": "Demografi tidak diaktifkan untuk sampel PME",
  "eqa.sample.patient.readonly.body": "Bidang demografi pasien diatur otomatis untuk sampel PME dan tidak dapat diedit.",
  "eqa.sample.patient.readonly.title": "Sampel PME — Info Pasien Dikunci",
  "eqa.section.title": "Rincian Sampel PME",
  "eqa.settings.integration.apiKey": "API Key",
  "eqa.settings.integration.apiUrl": "API Base URL",
  "eqa.settings.integration.fhir": "Integrasi API FHIR",
  "eqa.settings.integration.fhir.desc": "Aktifkan API FHIR R4 untuk pertukaran data PME eksternal",
  "eqa.settings.integration.subtitle": "Konfigurasi integrasi sistem eksternal",
  "eqa.settings.integration.title": "Pengaturan Integrasi",
  "eqa.settings.loading": "Memuat pengaturan...",
  "eqa.settings.notifications.email": "Notifikasi Email",
  "eqa.settings.notifications.email.desc": "Kirim notifikasi email untuk peringatan kritis dan tenggat",
  "eqa.settings.notifications.eqaDeadline": "Peringatan Tenggat PME",
  "eqa.settings.notifications.eqaDeadline.desc": "Terima peringatan saat tenggat penyerahan PME sudah dekat",
  "eqa.settings.notifications.stat": "Peringatan Permintaan STAT",
  "eqa.settings.notifications.stat.desc": "Peringatan saat permintaan STAT lewat tenggat",
  "eqa.settings.notifications.subtitle": "Konfigurasi preferensi peringatan dan notifikasi",
  "eqa.settings.notifications.threshold": "Peringatan Ambang (hari sebelum tenggat)",
  "eqa.settings.notifications.title": "Pengaturan Notifikasi",
  "eqa.settings.performance.autoZScore": "Penghitungan Z-Score Otomatis",
  "eqa.settings.performance.autoZScore.desc": "Z-Score dihitung otomatis saat hasil dikirim",
  "eqa.settings.performance.generateReports": "Buat Laporan Kinerja",
  "eqa.settings.performance.generateReports.desc": "Buat laporan kinerja otomatis setelah setiap round",
  "eqa.settings.performance.subtitle": "Konfigurasi parameter analisis kinerja PME",
  "eqa.settings.performance.title": "Analisis Kinerja",
  "eqa.settings.performance.zScoreMax": "Z-Score Maksimum Dapat Diterima",
  "eqa.settings.performance.zScoreMin": "Z-Score Minimum Dapat Diterima",
  "eqa.settings.saveError": "Gagal menyimpan pengaturan",
  "eqa.settings.saveSuccess": "Pengaturan berhasil disimpan",
  "eqa.settings.saving": "Menyimpan...",
  "eqa.status.active": "Aktif",
  "eqa.status.completed": "Selesai",
  "eqa.status.inProgress": "Dalam Pengerjaan",
  "eqa.status.inactive": "Inaktif",
  "eqa.status.inprogress": "Dalam Pengerjaan",
  "eqa.status.overdue": "Lewat tenggat",
  "eqa.status.pending": "Tertunda",
  "eqa.submission.audit": "Penyerahan Jejak Audit",
  "eqa.submission.date": "Tanggal Penyerahan",
  "eqa.submission.error": "Penyerahan gagal",
  "eqa.submission.fhir": "Kirim lewat FHIR",
  "eqa.submission.fhir.description": "Kirim hasil ke penyelenggara PME eksternal melalui FHIR R4",
  "eqa.submission.late.approve": "Setujui Penyerahan Terlambat",
  "eqa.submission.late.justification": "Justifikasi Penyerahan Terlambat",
  "eqa.submission.late.justification.placeholder": "Masukkan alasan keterlambatan penyerahan...",
  "eqa.submission.late.supervisor": "ID Pengguna Penyelia",
  "eqa.submission.late.warning": "Tenggat penyerahan sudah lewat. Wajib ada persetujuan penyelia.",
  "eqa.submission.method": "Metode Penyerahan",
  "eqa.submission.success": "Hasil berhasil diserahkan",
  "eqa.submission.title": "Penyerahan Hasil",
  "eqa.tests.action.enterResults": "Masukkan Hasil",
  "eqa.tests.action.viewOrder": "Lihat Pemesanan",
  "eqa.tests.action.viewResults": "Lihat Hasil",
  "eqa.tests.dateEntered": "Tanggal Masuk",
  "eqa.tests.deadline": "Tenggat",
  "eqa.tests.enterNew": "Masukkan Pemeriksaan PME Baru",
  "eqa.tests.labNumber": "Nomor Lab",
  "eqa.tests.orders.subtitle": "Pemesanan uji profisiensi untuk laboratorium ini",
  "eqa.tests.orders.title": "Pemesanan PME",
  "eqa.tests.priority": "Prioritas",
  "eqa.tests.program": "Program PME",
  "eqa.tests.provider": "Penyelenggara",
  "eqa.tests.searchPlaceholder": "Cari berdasarkan # registrasi, program, atau penyelenggara...",
  "eqa.tests.status": "Status",
  "eqa.tests.status.completed": "Selesai",
  "eqa.tests.status.inProgress": "Dalam Pengerjaan",
  "eqa.tests.status.overdue": "Lewat tenggat",
  "eqa.tests.status.pending": "Tertunda",
  "eqa.tests.summary.completedThisMonth": "Selesai Bulan Ini",
  "eqa.tests.summary.inProgress": "Dalam Pengerjaan",
  "eqa.tests.summary.overdue": "Lewat tenggat",
  "eqa.tests.summary.pending": "Tertunda",
  "eqa.validation.deadline.required": "Wajib ada Tenggat Pemeriksaan",
  "eqa.validation.program.required": "Wajib ada Program PME",
  "eqa.validation.provider.required": "Wajib ada Organisasi Penyelenggara PME",
  "error.add.edited.msg": "Error saat mengedit/menambah",
  "error.barcode.dimension.positive": "Dimensi label harus bilangan positif",
  "error.barcode.labelcount.default.lte.max": "Jumlah label default tidak boleh melebihi maksimum untuk jenis label ini",
  "error.delete.msg": "Error saat menghapus",
  "error.duplicate.calculationname": "Duplikasi Nama Penghitungan atau Error saat menyimpan",
  "error.fetch.boxDetails": "Gagal menarik rincian boks",
  "error.fetch.boxes": "Gagal menarik boks pengiriman",
  "error.fetch.facilities": "Gagal menarik fasilitas",
  "error.fetch.unassignedSamples": "Gagal menarik sampel yang tidak ditugaskan",
  "error.field.required": "Bidang ini diperlukan",
  "error.import.patient": "Error saat mengimpor Pasien ke sistem",
  "error.invalid.email": "Email tidak valid",
  "error.invalidcredentials": "Nama Pengguna atau Kata Kunci salah",
  "error.locale.format": "Format invalid. Gunakan: en, fr, es, atau en-US, fr-CA, dll.",
  "error.no.patient.data": "Tidak ada Data Pasien yang dapat diimpor",
  "error.nonconform.report": "Silahkan Masukkan Nilai",
  "error.report.csv.date": "Silahkan pilih jenis tanggal.",
  "error.report.csv.study": "Silahkan pilih jenis kajian.",
  "error.report.status": "Error saat membuat laporan",
  "error.required.destination": "Wajib ada lembaga tujuan",
  "error.results.loadFailed": "The results worklist could not be loaded",
  "error.results.loadFailed.detail": "This is not an empty worklist — the request failed, so any pending work here is not shown. Try again, and tell an administrator if it keeps failing.",
  "error.results.precision": "This test reports to {0} decimal place(s). Enter the value at that precision, or the record and the reported value will differ.",
  "error.results.staleSave": "This result was updated by {0} at {1} — refresh to see the latest value",
  "error.save.failed": "Gagal menyimpan",
  "error.save.msg": "Error saat menyimpan",
  "error.save.order": "Error saat menyimpan pemesanan",
  "error.save.patient": "Error saat menyimpan Pasien",
  "error.title": "Error",
  "errorBoundary.reload": "Muat ulang",
  "errorBoundary.route.patientResultsViewer.message": "Ada kesalahan saat menampilkan hasil pasien ini. Coba muat ulang.",
  "errorBoundary.route.patientResultsViewer.title": "Hasil pasien tidak bisa dimuat ulang",
  "errorBoundary.route.resultsSearch.message": "Ada kesalahan pada halaman hasil. Coba muat ulang.",
  "errorBoundary.route.resultsSearch.title": "Hasil tidak bisa dimuat",
  "errorBoundary.route.samplePatientEntry.message": "Ada kesalahan pada halaman entri sampel. Coba muat ulang.",
  "errorBoundary.route.samplePatientEntry.title": "Entri sampel tidak bisa dimuat",
  "errorBoundary.route.storage.message": "Ada kesalahan pada halaman ini. Coba muat ulang, atau gunakan menu untuk pindah halaman.",
  "errorBoundary.route.storage.title": "Penyimpanan tidak bisa dimuat",
  "errorBoundary.route.analyzers.message": "Ada kesalahan pada saat memuat halaman ini. Coba muat ulang.",
  "errorBoundary.route.analyzers.title": "Modul alat tidak dapat dimuat",
  "errorBoundary.route.analyzerResults.message": "Ada kesalahan pada saat memuat hasil. Coba muat ulang.",
  "errorBoundary.route.analyzerResults.title": "Hasil dari alat tidak dapat dimuat",
  "esig.button.certify": "Sertifikasi & Lanjut",
  "esig.button.reject": "Tolak",
  "esig.button.saveAndSign": "Simpan",
  "esig.button.sign": "Tanda tangan",
  "esig.button.validate": "Validasi",
  "esig.certification.acknowledge": "Saya sudah membaca dan mengerti pernyataan di atas",
  "esig.certification.intro": "Sebelum menggunakan tanda tangan elektronik, Anda harus menyatakan bahwa tanda tangan elektronik Anda setara dengan tanda tangan tertulis yang sah secara hukum.",
  "esig.error.disabled": "Tanda tangan elektronik tidak diaktifkan",
  "esig.error.generic": "Terjadi error",
  "esig.error.invalidCredentials": "Kredensial invalid",
  "esig.error.keycloakNotSupported": "Keycloak authentication belum tersedia untuk tanda tangan elektronik",
  "esig.error.loadingStatus": "Gagal memuat status tanda tangan",
  "esig.error.mustAcknowledge": "Anda harus menyetujui pernyataan sertifikasi",
  "esig.error.passwordRequired": "Kata kunci diperlukan",
  "esig.error.rejectionReasonRequired": "Wajib ada alasan penolakan",
  "esig.error.title": "Error",
  "esig.error.usernameRequired": "Nama pengguna diperlukan",
  "esig.info.fullAuth": "Ini adalah tanda tangan pertama Anda untuk sesi ini. Masukkan nama pengguna dan kata kunci Anda untuk mengotentikasi.",
  "esig.info.legalBinding": "Dengan memasukkan kredensial, Anda membuat tanda tangan elektronik yang mengikat secara hukum berdasarkan 21 CFR Part 11.",
  "esig.info.passwordOnly": "Anda memiliki sesi tanda tangan aktif. Masukkan kata kunci untuk melanjutkan.",
  "esig.label.context": "Aksi:",
  "esig.label.meaning": "Signature Meaning:",
  "esig.label.password": "Kata kunci",
  "esig.label.rejectionReason": "Alasan Penolakan",
  "esig.label.signingAs": "Menandatangani sebagai: {userName}",
  "esig.label.username": "Nama pengguna",
  "esig.meaning.authored": "Dibuat oleh",
  "esig.meaning.modified": "Modified",
  "esig.meaning.rejected": "Ditolak",
  "esig.meaning.validatedAndReleased": "Divalidasi dan Diterbitkan",
  "esig.placeholder.password": "Masukkan kata kunci untuk mengkonfirmasi",
  "esig.placeholder.rejectionReason": "Masukkan alasan penolakan",
  "esig.placeholder.username": "Masukkan nama pengguna Anda",
  "esig.title.certification": "Sertifikasi Tanda Tangan Elektronik",
  "esig.title.signature": "Tanda Tangan Elektronik",
  "example": "Contoh",
  "external.id": "Identitas Eksternal",
  "external.referrals.report": "Laporan Rujukan Eksternal",
  "externalReferredOutTests.title": "Laporan Rujukan Eksternal",
  "externalconnections.active": "Aktif",
  "externalconnections.add.title": "Tambah Koneksi Eksternal",
  "externalconnections.authtype": "Tipe Otentikasi",
  "externalconnections.authtype.basic.password": "Kata kunci",
  "externalconnections.authtype.basic.username": "Nama pengguna",
  "externalconnections.browse.title": "Koneksi Eksternal",
  "externalconnections.deactivate.success": "Koneksi eksternal berhasil dinonaktifkan.",
  "externalconnections.description": "Deskripsi",
  "externalconnections.edit.title": "Edit Koneksi Eksternal",
  "externalconnections.name": "Nama",
  "externalconnections.name.placeholder": "Masukkan nama koneksi",
  "externalconnections.programmedconnection": "Tipe Koneksi",
  "externalconnections.save.success": "Koneksi eksternal berhasil disimpan.",
  "externalconnections.search": "Cari koneksi eksternal",
  "externalconnections.search.placeholder": "Cari berdasarkan nama atau tipe",
  "externalconnections.select": "Pilih",
  "externalconnections.uri": "URI",
  "externalconnections.uri.placeholder": "mis. https://server:port",
  "false.label": "False",
  "field.active": "Aktif/Tidak Aktif",
  "field.ageRange": "Rentang Umur",
  "field.dictionaryValues": "Nilai Kamus",
  "field.loinc": "LOINC",
  "field.name": "Nama",
  "field.normalRange": "Rentang normal",
  "field.note": "Catatan",
  "field.orderable": "Permintaan dapat/tidak dapat dilakukan",
  "field.panel": "Panel",
  "field.referenceValue": "Nilai referensi",
  "field.reportName": "Nama Laporan",
  "field.resultLimits": "Batas hasil",
  "field.resultType": "Jenis hasil",
  "field.sampleType": "Jenis sampel",
  "field.select.testSection": "Pilih Bagian Pemeriksaan",
  "field.selectValues": "Pilih nilai",
  "field.sex": "Jenis kelamin",
  "field.significantDigits": "Digit signifikan",
  "field.testSection": "Bagian pemeriksaan",
  "field.testUnit": "Instalasi Lab",
  "field.uom": "Satuan pengukuran",
  "field.validRange": "Rentang valid",
  "file.import.configuration.active": "Aktif",
  "file.import.configuration.analyzer": "Alat",
  "file.import.configuration.analyzer.emptyState": "Tidak ada plugin impor file yang diinstal",
  "file.import.configuration.analyzer.placeholder": "Pilih Alat",
  "file.import.configuration.cancel": "Batal",
  "file.import.configuration.columnMappings": "Pemetaan Kolom",
  "file.import.configuration.columnMappings.helperText": "Pemetaan JSON untuk kolom CSV ke bidang SILNAS (misalnya, {\"Sample_ID\": \"sampleId\", \"Result\": \"result\"})",
  "file.import.configuration.delimiter": "Delimiter",
  "file.import.configuration.delimiter.helperText": "Karakter delimiter CSV (default: koma)",
  "file.import.configuration.error.save": "Gagal menyimpan konfigurasi impor file",
  "file.import.configuration.error.unknown": "Terjadi error yang tidak diketahui",
  "file.import.configuration.fileFormat": "Format File",
  "file.import.configuration.fileFormat.placeholder": "Pilih format file",
  "file.import.configuration.filePattern": "Pola File",
  "file.import.configuration.filePattern.helperText": "Pola glob untuk file yang cocok (misalnya, *.csv, results_*.txt)",
  "file.import.configuration.hasHeader": "Baris yang memiliki Header",
  "file.import.configuration.importDirectory": "Direktori Impor",
  "file.import.configuration.importDirectory.helperText": "Direktori untuk melihat file baru",
  "file.import.configuration.importDirectory.placeholder": "/data/import",
  "file.import.configuration.save": "Simpan",
  "file.import.configuration.success.created": "Konfigurasi impor file berhasil dibuat",
  "file.import.configuration.success.updated": "Konfigurasi impor file berhasil diperbarui",
  "file.import.configuration.title.add": "Tambah Konfigurasi Impor File",
  "file.import.configuration.title.edit": "Edit Konfigurasi Impor File",
  "file.import.configuration.validation.analyzerId.required": "Alat wajib ada",
  "file.import.configuration.validation.columnMappings.invalid": "Format JSON invalid untuk pemetaan kolom",
  "file.import.configuration.validation.importDirectory.required": "Direktori impor wajib ada",
  "fileImport.format.csv": "CSV",
  "fileImport.format.excel": "Excel",
  "fileImport.format.tsv": "TSV",
  "filters.label": "Filter",
  "freezer.nav.corrective": "Tindakan Perbaikan",
  "freezer.nav.corrective.tooltip": "Kelola tindakan perbaikan",
  "freezer.nav.dashboard": "Dasbor",
  "freezer.nav.dashboard.tooltip": "Lihat dasbor pemantauan penyimpanan dingin",
  "freezer.nav.reports": "Laporan",
  "freezer.nav.reports.tooltip": "Membuat laporan penyimpanan dingin",
  "freezer.nav.settings": "Pengaturan",
  "freezer.nav.settings.tooltip": "Konfigurasi pengaturan penyimpanan dingin",
  "freezer.nav.trends": "Tren Historis",
  "freezer.nav.trends.tooltip": "Lihat tren suhu berdasarkan waktu",
  "french.current": "PERANCIS saat ini",
  "french.label": "Perancis",
  "from.title": "Dari",
  "genericSample.edit.success": "Sample berhasil diperbarui",
  "genericSample.edit.title": "Edit Sampel",
  "genericSample.field.by": "Oleh",
  "genericSample.field.count": "#",
  "genericSample.field.date": "Tanggal",
  "genericSample.field.from": "Dari",
  "genericSample.field.id": "Identitas",
  "genericSample.field.labPersonReceived": "Diterima petugas lab",
  "genericSample.field.project": "Proyek",
  "genericSample.field.storageLocation": "# Freezer penyimpanan dan lokasi",
  "genericSample.field.type": "Jenis",
  "genericSample.notebook.selection.title": "Pemilihan Proyek (Opsional)",
  "genericSample.order.error.labNoRequired": "Mohon membuat Nomor Registrasi sebelum menyimpan.",
  "genericSample.order.generateLabNo": "Membuat Nomor Registrasi",
  "genericSample.order.labNo.placeholder": "Klik untuk \"Membuat Nomor Registrasi\"",
  "genericSample.order.success.details": "Rincian Sampel",
  "genericSample.order.success.message": "Pemesanan sampel berhasil dibuat dengan nomor registrasi: {accessionNumber}",
  "genericSample.order.title": "Penerimaan Sampel",
  "gps.accuracy.display": "±{accuracy}m akurasi",
  "gps.accuracy.warning.message": "Akurasi GPS {accuracy}m, melebihi ambang batas wajib {required}m. Mohon mengambil lokasi lagi dengan mengubah posisi.",
  "gps.accuracy.warning.title": "Peringatan Akurasi GPS",
  "gps.button.clear": "Kosongkan",
  "gps.button.getting.location": "Mengambil Lokasi...",
  "gps.button.location.captured": "Lokasi Diambil",
  "gps.button.use.my.location": "Gunakan Lokasi Saya",
  "gps.collapse": "Ciutkan bagian GPS",
  "gps.config.accuracy.helper": "Maksimum akurasi GPS yang dapat diterima dalam meter. Atur ke 0 untuk menginaktifkan pemeriksaan akurasi.",
  "gps.config.accuracy.label": "Akurasi yang diperlukan (meter)",
  "gps.config.enabled.description": "Jika diaktifkan, bidang koordinat GPS akan muncul di alur kerja Entri Pesanan untuk menarik lokasi pengambilan sampel.",
  "gps.config.enabled.label": "Aktifkan Koordinat GPS",
  "gps.config.error.load": "Gagal memuat konfigurasi GPS",
  "gps.config.save.error": "Gagal menyimpan konfigurasi GPS",
  "gps.config.save.success": "Konfigurasi GPS berhasil disimpan",
  "gps.config.saving": "Menyimpan...",
  "gps.config.section.general": "Pengaturan GPS",
  "gps.config.timeout.helper": "Waktu maksimum untuk menunggu lokasi GPS dalam detik.",
  "gps.config.timeout.label": "Waktu habis (detik)",
  "gps.config.title": "Konfigurasi Koordinat GPS",
  "gps.config.unsaved.changes": "Anda memiliki perubahan belum tersimpan. Apakah Anda yakin untuk menutup?",
  "gps.config.unsaved.subtitle": "Ingat untuk menyimpan perubahan sebelum meninggalkan halaman.",
  "gps.config.unsaved.title": "Perubahan Tidak Tersimpan",
  "gps.config.validation.accuracy.negative": "Akurasi wajib tidak boleh negatif",
  "gps.config.validation.accuracy.too.high": "Akurasi wajib tidak boleh lebih dari 10.000 meter",
  "gps.config.validation.timeout.too.high": "Waktu habis tidak boleh lebih dari 120 detik",
  "gps.config.validation.timeout.too.low": "Waktu habis harus setidaknya 1 detik",
  "gps.coordinates.captured.via": "Diambil dengan {method}",
  "gps.coordinates.current": "Koordinat saat ini",
  "gps.error.not.supported": "GPS tidak didukung dengan peramban ini",
  "gps.error.permission.denied": "Akses GPS ditolak. Mohon mengaktifkan izin lokasi dan coba lagi.",
  "gps.error.position.unavailable": "Lokasi GPS tidak tersedia. Mohon periksa pengaturan lokasi perangkat Anda.",
  "gps.error.timeout": "Waktu permintaan GPS habis. Silahkan coba lagi.",
  "gps.error.title": "GPS Error",
  "gps.error.unknown": "Terjadi error GPS yang tidak diketahui. Mohon coba lagi.",
  "gps.info.description": "Koordinat GPS merekam lokasi geografis lokasi sampel, untuk mendukung surveilans epidemiologi dan pemetaan penyakit.",
  "gps.info.title": "Koordinat GPS",
  "gps.latitude.helper": "Derajat Utara (+) atau Selatan (-), antara -90 dan 90",
  "gps.latitude.invalid": "Garis lintang harus di antara -90 dan 90 derajat",
  "gps.latitude.label": "Garis Lintang",
  "gps.latitude.placeholder": "misalnya, -1.286389",
  "gps.longitude.helper": "Derajat Timur (+) atau Barat (-), antara -180 dan 180",
  "gps.longitude.invalid": "Garis bujur harus di antara -180 dan 180 derajat",
  "gps.longitude.label": "Garis bujur",
  "gps.longitude.placeholder": "misalnya, 36.817223",
  "gps.manual.entry.off": "Matikan",
  "gps.manual.entry.on": "Nyalakan",
  "gps.manual.entry.title": "Masukkan koordinat manual",
  "gps.manual.entry.toggle": "Entri koordinat manual",
  "gps.not.captured": "Tidak tertangkap",
  "gps.section.description": "Menangkap lokasi geografis pengambilan sampel untuk pelacakan epidemiologi",
  "gps.section.title": "Lokasi Pengambilan (GPS)",
  "gps.status.captured": "Ditangkap",
  "gps.status.optional": "Opsional",
  "gps.tile.collapse": "Ciutkan bagian GPS",
  "gps.tile.expand": "Kembangkan untuk menambah koordinat GPS",
  "gps.warning.partial.coordinates": "Garis lintang dan garis bujur harus menunjukkan lokasi valid.",
  "header.ID": "Identitas",
  "header.assign": "Menugaskan",
  "header.cancel.test": "Membatalkan Pemeriksaan",
  "header.formname": "Nama Formulir",
  "header.icon.help": "Bantuan",
  "header.icon.lang": "Bahasa",
  "header.icon.menu.close": "Tutup menu",
  "header.icon.menu.open": "Buka menu",
  "header.icon.menu.pin": "Sematkan menu",
  "header.icon.menu.unpin": "Unpin menu",
  "header.icon.notifications": "Notifikasi",
  "header.icon.search": "Cari",
  "header.icon.user": "Pengguna",
  "header.label.ARV": "ARV-awal",
  "header.label.EID": "Diagnosis anak-anak dengan DBS-PCR",
  "header.label.changeLab": "Pilih Lab",
  "header.label.followup": "ARV-Tindak-lanjut",
  "header.label.intialFollowup": "ARV-->Awal-TindakLanjut-VL",
  "header.label.logout": "Keluar",
  "header.label.nonconformityByDate": "Laporan Ketidaksesuaian berdasarkan Tanggal",
  "header.label.selectLab": "Pilih Lab",
  "header.label.selectlocale": "Pilih Lokal",
  "header.label.specialRequest": "Permintaan khusus",
  "header.label.study.ciexport": "Ekspor file CSV berdasarkan Tanggal",
  "header.label.study.vlloadtrends": "Laporan Ekspor Data Viral Load",
  "header.label.version": "Versi:",
  "header.reject": "Tolak",
  "header.rejection.reason": "Alasan penolakan",
  "header.results.recorded": "Hasil terekam",
  "hide.aliquoting": "Sembunyikan pengalikuotan",
  "holder.choose.availabletest": "Pilih Pemeriksaan yang tersedia",
  "home.label": "Beranda",
  "immunohistochemistry.label.addreport": "Tambah Laporan",
  "immunohistochemistry.label.averageChrom": "Rerata Sinyal Kromosom 17 per nukleus",
  "immunohistochemistry.label.averageHer2": "Rerata HER2 per nukleus",
  "immunohistochemistry.label.cellIntensity": "Intensitas. Skor Allred",
  "immunohistochemistry.label.cellPercent": "% sel yang menujukkan pewarnaan nukleus dengan",
  "immunohistochemistry.label.dashboard": "Dasbor Imunohistokimia",
  "immunohistochemistry.label.her2Assesment": "Penilaian protein HER2 adalah",
  "immunohistochemistry.label.her2Pattern": "Pola pewarnaan CerbB2/HER2",
  "immunohistochemistry.label.her2ScoreOf": "dengan skor",
  "immunohistochemistry.label.historicalDiagnosis": "Diagnosis histologis",
  "immunohistochemistry.label.ihcRatio": "Rasio Sinyal HER2/Neu terhadap Kromosom 17",
  "immunohistochemistry.label.ihcScore": "IHK (Skor Cerb2)",
  "immunohistochemistry.label.mibName": " MiB 1(ki-67) (Indeks Proliferatif): ",
  "immunohistochemistry.label.molecularType": "Subtipe Molekuler",
  "immunohistochemistry.label.numberOfCancer": "Jumlah Nukleus Kanker",
  "immunohistochemistry.label.outOf8": "dari 8",
  "immunohistochemistry.label.report": "Laporan",
  "immunohistochemistry.label.reports": "Laporan",
  "immunohistochemistry.label.review": "Menunggu Tinjauan Imunohistokimia",
  "immunohistochemistry.label.title": "Imunohistokimia",
  "immunohistochemistry.label.tumorCells": "dari positif sel tumor (cut off 20%)",
  "import.autoGenerated": "Auto-generated",
  "import.created": "Dibuat",
  "import.error.failed": "Impor gagal",
  "import.error.importFile": "Gagal mengimpor file",
  "import.error.selectFile": "Pilih file terlebih dahulu",
  "import.error.validateFile": "Gagal memvalidasi file",
  "import.error.validateFirst": "Silahkan validasi file terlebih dahulu dan perbaiki kesalahan yang ada",
  "import.error.validationFailed": "Validasi gagal. Silahkan periksa kesalahan di bawah.",
  "import.failed": "Impor Gagal",
  "import.failedCount": "Gagal",
  "import.header.collectionDate": "Tanggal Pengambilan",
  "import.header.errorMessage": "Pesan Kesalahan",
  "import.header.field": "Bidang",
  "import.header.from": "Dari",
  "import.header.labNo": "No Registrasi",
  "import.header.quantity": "Kuantitas",
  "import.header.row": "Baris",
  "import.header.sampleType": "Jenis Sampel",
  "import.header.samplesToCreate": "Sampel yang akan dibuat",
  "import.importing": "Mengimpor...",
  "import.invalidRows": "Baris Invalid",
  "import.selectFile": "Pilih file",
  "import.status.invalid": "Invalid",
  "import.status.valid": "Valid",
  "import.success": "Impor Berhasil",
  "import.totalRows": "Baris total",
  "import.totalSamplesToCreate": "Total Sampel yang akan Dibuat",
  "import.uploadFile": "Unggah file",
  "import.uploadFileDesc": "Unggah file CSV atau Excel ({types})",
  "import.validRows": "Baris Valid",
  "import.validating": "Memvalidasi...",
  "import.validationStatus": "Status Validasi",
  "input.error.same.panel.type": "Jenis panel yang ada dengan nama yang sama ditemukan. Batalkan atau gunakan nama lain.",
  "input.placeholder.labNo": "Masukkan Nomor Registrasi",
  "input.placeholder.patientFirstName": "Masukkan Nama Depan Pasien",
  "input.placeholder.patientId": "Masukkan Identitas Pasien",
  "input.placeholder.patientLastName": "Masukkan Nama Belakang Pasien",
  "input.placeholder.prevLabNumber": "Masukkan Nomor Registrasi Sebelumnya",
  "input.placeholder.providerEmail": "Masukkan Email Pemohon",
  "input.placeholder.providerFax": "Masukkan Nomor Faks Pemohon",
  "input.placeholder.providerWorkPhone": "Masukkan Nomor Telepon Pemohon",
  "input.placeholder.provisionalClinicalDiagnosis": "Masukkan Diagnosis Klinis Sementara",
  "input.placeholder.requesterFirstName": "Masukkan Nama Depan Pemohon",
  "input.placeholder.requesterLastName": "Masukkan Nama Belakang Pemohon",
  "input.placeholder.searchTestName": "Cari Nama Pemeriksaan di sini",
  "input.placeholder.selectPanel": "Pilih Jenis Panel",
  "input.placeholder.selectPriority": "Pilih Prioritas",
  "input.placeholder.selectTest": "Pilih Jenis Pemeriksaan",
  "input.placeholder.selectTestSection": "Pilih Jenis Unit",
  "instructions.copy.labnum": "Salin Nomor Registrasi ",
  "instructions.order.entry.eqa.enabled": "Bila aktif, akan ada kotak centang di layar Entri Pemesanan, dan petugas dapat menandai sampel sebagai sampel PME (Pemantapan Mutu Eksternal). Demografi pasien akan otomatis terisi dengan N/A dan dikunci.",
  "instructions.order.entry.requester": "When enabled, Search Requester and Requester First Name and Requester Last Name become required fields on the Add Order screen. When disabled (default), all three fields are optional.",
  "instructions.test.activation": "Pemeriksaan Aktif: kotak centang menunjukkan pemeriksaan yang sudah aktif. Untuk mengaktifkan pemeriksaan, centang kotak; untuk menonaktifkan, hapus centang. Semua jenis sampel tanpa pemeriksaan aktif akan dinonaktifkan dan muncul di bagian bawah, di bawah 'Jenis Sampel Tidak Aktif'. Jika salah satu pemeriksaan diaktifkan, jenis sampel tersebut akan diaktifkan.",
  "instructions.test.activation.confirm": "Verifikasi perubahan yang akan dibuat. Simpan jika sudah benar. Gunakan tombol kembali untuk memperbaiki perubahan.",
  "instructions.test.activation.sort": "Urutan tampilan: Daftar jenis sampel yang mempunyai pemeriksaan yang baru diaktivasi. Sortir pemeriksaan untuk mengatur tampilan di layar entri permintaan. Sortir dilakukan dengan menyeret ke posisi yang diinginkan",
  "instructions.test.order": "Permintaan dapat dilakukan untuk pemeriksaan yang dicentang. Ubah tanda centang untuk mengubah status. Agar permintaan pemeriksan dapat dilakukan, pemeriksaan tersebut harus aktif dan dapat dipesan. Pemeriskaan yang aktif tetapi tidak dapat dipesan dapat diminta sebagai bagian dari pemeriksaan refleks.",
  "invalid.json": "JSON tidak valid",
  "inventory.add.button": "Tambah Lot Baru",
  "inventory.addItem.button": "Tambah Barang Katalog",
  "inventory.dashboard.title": "Dasbor Inventaris",
  "inventory.export.button": "Ekspor",
  "inventory.filter.all": "Semua",
  "inventory.filter.status": "Filter berdasarkan Status",
  "inventory.filter.type": "Filter berdasarkan Jenis",
  "inventory.list.title": "Barang Inventaris",
  "inventory.metrics.expired": "Kedaluwarsa",
  "inventory.metrics.expiringSoon": "Segera Kedaluwarsa",
  "inventory.metrics.lowStock": "Stok Sedikit",
  "inventory.metrics.totalLots": "Lot Total",
  "inventory.search.placeholder": "Cari berdasarkan nama barang atau nomor lot",
  "inventory.tab.catalog": "Katalog",
  "inventory.tab.dashboard": "Dasbor",
  "inventory.tab.reports": "Laporan",
  "inventory.title": "Pengelolaan Inventaris",
  "label.action": "Aksi",
  "labNumber.format.current": "Format saat ini",
  "labNumber.format.new": "Format baru",
  "labNumber.prefix": "Prefiks",
  "labNumber.type": "Jenis Nomor Registrasi ",
  "labNumber.usePrefix": "Gunakan prefiks",
  "label.actions": "Aksi",
  "label.active": "Aktif",
  "label.actualTestName": "Nama pemeriksaan aktual",
  "label.add": "Tambah",
  "label.add.notification": "Tambah notifikasi pop up ke pengguna",
  "label.all": "Semua",
  "label.analysisNotStarted": "Analisis belum dimulai",
  "label.any": "Apa saja",
  "label.audittrail": "No Registrasi",
  "label.audittrail.Reports": "Laporan Jejak Audit",
  "label.audittrail.labNo.invalidaccessionnumber": "Nomor Registrasi Invalid",
  "label.audittrail.labNo.missing": "Perlu No Registrasi!",
  "label.audittrailreport.nextvisitdate": "Tanggal Kunjungan Berikutnya",
  "label.audittrailreport.priority": "Prioritas",
  "label.audittrailreport.program": "Program",
  "label.audittrailreport.receiveddate": "Tanggal Diterima",
  "label.audittrailreport.requestdate": "Tanggal Permintaan",
  "label.audittrailreport.requester": "Pemohon",
  "label.audittrailreport.requester.firstname": "Nama Depan Pemohon",
  "label.audittrailreport.requester.lastname": "Nama Belakang Pemohon",
  "label.audittrailreport.sitename": "Nama Tempat",
  "label.autoFilledFromServer": "Auto terisi dari server",
  "label.barcode": "Kode QR",
  "label.barcode.labelsets": "Jumlah Set Label",
  "label.barcode.orderlabel": "Jumlah Label yang dipesan per set",
  "label.barcode.specimenlabel": "Jumlah label spesimen per set",
  "label.barcode.totallabel": "Jumlah label untuk dicetak",
  "label.button.action": "Aksi",
  "label.button.add": "Tambah",
  "label.button.add.question": "Tambah pertanyaan baru",
  "label.button.cancel": "Batal",
  "label.button.close": "Tutup",
  "label.button.changepassword": "Ganti Kata Kunci",
  "label.button.clear": "Kosongkan",
  "label.button.confirm": "Konfirmasi",
  "label.button.confirmAction": "Konfirmasi aksi",
  "label.button.confirmDelete": "Konfirmasi hapus",
  "label.button.confirmTitle": "Apakah Anda yakin?",
  "label.button.delete": "Hapus",
  "label.button.descritpion": "Deskripsi",
  "label.button.edit": "Edit",
  "label.button.exit": "Keluar",
  "label.button.externalsearch": "Pencarian Eksternal",
  "label.button.field": "Field",
  "label.button.finish": "Selesai",
  "label.button.finished": "Selesai",
  "label.button.generatePrintableVersion": "Buat versi cetak",
  "label.button.import": "Impor",
  "label.button.login": "Login",
  "label.button.login.sso": "Single Sign On",
  "label.button.newEntry": "Entri baru",
  "label.button.ok": "Ok",
  "label.button.previous": "Sebelumnya",
  "label.button.range": "Rentang",
  "label.button.remove": "Hapus",
  "label.button.remove.block": "Hapus Blok",
  "label.button.remove.report": "Hapus Laporan",
  "label.button.remove.slide": "Hapus slide",
  "label.button.reset": "Atur Ulang",
  "label.button.sample": "Sampel",
  "label.button.save": "Simpan",
  "label.button.saveconfig": "SImpan Konfigurasi",
  "label.button.search": "Cari",
  "label.button.select": "Pilih",
  "label.button.select.pathologist": "Pilih Ahli Patologi",
  "label.button.select.status": "Pilih Status",
  "label.button.select.technician": "Pilih Petugas",
  "label.button.select.test": "Pilih Pemeriksaan",
  "label.button.start": "Mulai",
  "label.button.submit": "Kirim",
  "label.button.update": "Perbarui",
  "label.button.uploadfile": "Unggah file",
  "label.button.validate": "Validasi",
  "label.button.viewReport": "Lihat Laporan",
  "label.cancel": "Batal",
  "label.cancel.test.no.replace": "Batalkan pemeriksaan untuk nomor registrasi terpilih, jangan menugaskan pemeriksaan baru",
  "label.checkedWillBeModified": "No Lab yang dicentang akan dimodifikasi",
  "label.clear": "Hapus filter",
  "label.content": "Konten Label",
  "label.confirm": "Konfirmasi",
  "label.created.samples": "Sampel yang Dibuat",
  "label.critical.range": "Rentang kritis",
  "label.currentTest": "Pemeriksaan saat ini",
  "label.days": "hari",
  "label.default.result": "Hasil default",
  "label.delete": "Hapus",
  "label.description": "Deskripsi",
  "label.edit": "Edit",
  "label.electronic.orders": "Permintaan elektronik",
  "label.equals": "sama dengan",
  "label.error": "Error",
  "label.existing.methods": "Metode yang ada",
  "label.existing.test.sets": "Set pemeriksaan yang ada",
  "label.filters.mycases": "Kasus saya",
  "label.filters.status": "Status",
  "label.field.required": "Bidang ini diperlukan",
  "label.status": "Status",
  "label.form.searchby": "Cari berdasarkan",
  "label.id": "ID",
  "label.import.errors": "Error saat Impor",
  "label.inactive": "Inaktif",
  "label.inactive.methods": "Metode inaktif. Tugaskan pemeriksaan untuk mengaktivasi",
  "label.includeInactiveTests": "Sertakan pemeriksaan inaktif",
  "label.inside.normalrange": "adalah dalam rentang normal",
  "label.lastPrinted": "Pencetakan terakhir: {date} {time} oleh {user}",
  "label.loading": "Memuat...",
  "label.loinc": "LOINC",
  "label.management.title": "Pengelolaan Label",
  "label.no": "Tidak",
  "label.no.options.available": "Tidak ada opsi tersedia",
  "label.none": "Kosong (tidak ada filter)",
  "label.notValidated": "Tidak tervalidasi",
  "label.notequals": "tidak sama dengan",
  "label.order.labNrPrefix": "Lab Nr",
  "label.order.patientPrefix": "Pasien",
  "label.order.scan.text": "Pindai ATAU masukkan manual ATAU",
  "label.orderable": "Dapat dipesan",
  "label.outside.normalrange": "adalah di luar rentang normal",
  "label.page.patientHistory": "Riwayat Pasien",
  "label.preview.data": "Pratinjau Data",
  "label.print": "Cetak Label",
  "label.print.error": "Error saat membuat label. Silahkan coba lagi.",
  "label.print.error.popupBlocked": "Popup diblokir. Izinkan popup untuk situs ini agar dapat mencetak label.",
  "label.print.generating": "Membuat...",
  "label.print.success": "Pencetakan label berhasil",
  "label.print.description": "Cetak label untuk pemesanan dan sampel",
  "label.print.helper": "Pilih jenis dan kuantitas label untuk dicetak",
  "label.print.success.count": "{count} label berhasil dicetak",
  "label.print.title": "Cetak label",
  "label.printAll": "Cetak Semua Label",
  "label.printAll.success": "Semua label berhasil dicetak",
  "label.printConfirmation.message": "Cetak label untuk {name}{code}?",
  "label.printConfirmation.title": "Cetak Label",
  "label.printHistory": "Cetak Riwayat",
  "label.printHistory.byUser": "Oleh {user}",
  "label.printHistory.count": "{count} label",
  "label.printHistory.loading": "Memuat riwayat cetak...",
  "label.printHistory.never": "Belum pernah dicetak",
  "label.printHistory.unknownUser": "Tidak diketahui",
  "label.printHistory.viewAll": "Lihat Riwayat",
  "label.printLabel": "Cetak Label",
  "label.program": "Program",
  "label.qualifiers": "Pengkualifikasi",
  "label.quantity": "Kuantitas",
  "label.readonly": "Read Only",
  "label.reference.value": "Nilai referensi",
  "label.refertest.referencelab": "Rujuk ke lab rujukan",
  "label.rejectedByBiologist": "Ditolak oleh ahli biologi",
  "label.rejectedByTechnician": "Ditolak oleh petugas",
  "label.remove": "Hapus",
  "label.replaceWith": "Ganti dengan",
  "label.report.byNationalId": "Berdasarkan NIK",
  "label.reporting.range": "Rentang pelaporan",
  "label.result.order": "Pemesanan hasil",
  "label.resultSelectList": "Daftar pilihan hasil",
  "label.results.actions": "Aksi",
  "label.results.anotherUser": "another user",
  "label.results.date": "Test date",
  "label.results.domain": "Klinis",
  "label.results.domain.env": "Water Quality",
  "label.results.domain.vector": "Surveilans Vektor",
  "label.results.edit": "Edit",
  "label.results.inReviewBy": "In review by {0}",
  "label.results.labUnit": "Instalasi Lab",
  "label.results.load": "Load results",
  "label.results.range": "Reference Range",
  "label.results.range.env": "Regulatory Limit",
  "label.results.range.vector": "Interpretasi",
  "label.results.reflexTriggered": "Reflex/calculated tests added for:",
  "label.results.refresh": "Refresh",
  "label.results.result": "Hasil",
  "label.results.resultFor": "Result for {0}",
  "label.results.retry": "Try again",
  "label.results.save": "Simpan",
  "label.results.search": "Search by lab number",
  "label.results.status": "Status",
  "label.results.status.all": "Semua",
  "label.results.subject": "Sample / Patient",
  "label.results.subject.env": "Sample / Site",
  "label.results.subject.vector": "Sample / Trap",
  "label.results.table.caption": "Results worklist",
  "label.results.test": "Pemeriksaan",
  "label.results.method": "Method",
  "label.results.analyzer": "Alat",
  "label.results.analyzer.none": "Not from an instrument",
  "label.results.fromAnalyzer": "from analyzer",
  "label.results.methodAnalyzerHint": "Method is the analyzer type; Analyzer is the specific instrument.",
  "label.results.expandRow": "Perluas baris",
  "label.results.collapseRow": "Collapse row",
  "label.results.referredOut": "Referred out",
  "label.results.notes": "Catatan",
  "label.results.note.context": "Context",
  "label.results.note.context.entry": "Entry",
  "label.results.note.context.modification": "Modification",
  "label.results.note.context.auto": "Set automatically from what you are doing.",
  "label.results.note.visibility": "Visibility",
  "label.results.note.internal": "In lab only",
  "label.results.note.external": "Send with result",
  "label.results.note.analysisLevel": "Analysis-level",
  "label.results.note.externalWarning": "This note will appear on the patient report.",
  "label.results.note.placeholder": "Add a note…",
  "label.results.dilution.measured": "Measured value",
  "label.results.dilution.factor": "Dilution factor",
  "label.results.dilution.reported": "Reported value: {0}",
  "label.results.saveHint": "Saving records your e-signature. Critical acknowledgment never blocks Save.",
  "label.results.flag.normal": "Normal",
  "label.results.flag.abnormal": "Abnormal",
  "label.results.flag.critical": "Kritis",
  "label.results.flag.invalid": "Invalid",
  "label.results.sample": "Sampel",
  "label.results.flag": "Flag",
  "label.results.order.clinician": "Ordering clinician",
  "label.results.order.phone": "Telepon",
  "label.results.order.site": "Requesting site",
  "label.results.order.priority": "Prioritas",
  "label.results.order.collection": "Collection",
  "label.results.section.program": "Program info",
  "label.results.program.name": "Program",
  "label.results.program.eqa": "PME",
  "label.results.program.readonly": "Program fields are read-only here — edit on the originating order.",
  "label.results.section.storage": "Storage & sample disposal",
  "label.results.storage.location": "Lokasi",
  "label.results.storage.position": "Posisi",
  "label.results.storage.notes": "Catatan",
  "label.results.storage.unassigned": "No storage assignment",
  "label.results.storage.assignLocation": "Tempatkan di Lokasi",
  "label.results.storage.moveLocation": "Move to Location",
  "label.results.program.capturedData": "Programme data",
  "label.results.sampleStatus.title": "Sample status",
  "label.results.sampleStatus.volume": "Volume: {0} remaining of {1} · status {2}.",
  "label.results.sampleStatus.noVolume": "Status {0}.",
  "label.results.sampleStatus.available": "available",
  "label.results.sampleStatus.usedUp": "used up (exhausted)",
  "label.results.sampleStatus.disposed": "disposed",
  "label.results.sampleStatus.recordUse": "Record amount used",
  "label.results.sampleStatus.markUsedUp": "Mark used up",
  "label.results.sampleStatus.startDisposal": "Start disposal",
  "label.results.sampleStatus.amountUsed": "Amount used this test",
  "label.results.sampleStatus.record": "Rekam",
  "label.results.sampleStatus.recordHint": "Decrements remaining volume — the sample is not disposed until exhausted or explicitly marked used up.",
  "label.results.sampleStatus.usedUpNote": "The sample is exhausted and queued for the disposal workflow. Disposal records who, when, and method.",
  "label.results.sampleStatus.disposalReason": "Disposal reason",
  "label.results.sampleStatus.disposalMethod": "Disposal method",
  "label.results.sampleStatus.disposalNotes": "Catatan",
  "label.results.sampleStatus.confirmDisposal": "Confirm disposal",
  "label.results.sampleStatus.reason.expired": "Kedaluwarsa",
  "label.results.sampleStatus.reason.contaminated": "Contaminated",
  "label.results.sampleStatus.reason.patient_request": "Patient Request",
  "label.results.sampleStatus.reason.testing_complete": "Testing Complete",
  "label.results.sampleStatus.reason.other": "Lainnya",
  "label.results.sampleStatus.method.autoclave": "Biohazard Autoclave",
  "label.results.sampleStatus.method.neutralization": "Chemical Neutralization",
  "label.results.sampleStatus.method.incineration": "Incineration",
  "label.results.sampleStatus.method.other": "Lainnya",
  "label.results.sampleStatus.footnote": "Partial use records the amount consumed against the sample item's remaining volume; full exhaustion (or Mark used up) triggers disposal.",
  "label.results.section.reagents": "Reagents, QC & Controls",
  "label.results.reagents.summary.analyzer": "analyzer-reported lot",
  "label.results.reagents.summary.manual": "manual capture",
  "label.results.reagents.mode.analyzer": "capture mode: analyzer-reported",
  "label.results.reagents.mode.manual": "capture mode: manual (optional)",
  "label.results.reagents.analyzerNote": "Reported by {0} in its result payload — read-only.",
  "label.results.reagents.lotsUsed": "Reagent lots used",
  "label.results.reagents.noneLinked": "No reagents linked to this test — links are configured in the Test Catalog.",
  "label.results.reagents.noLots": "No available lots in inventory for this reagent.",
  "label.results.reagents.perTest": "{0} {1} per test",
  "label.results.reagents.fefo": "FEFO Suggested",
  "label.results.reagents.expires": "Exp {0} ·",
  "label.results.reagents.remaining": "{0} {1} remaining",
  "label.results.reagents.quantityUsed": "Quantity used",
  "label.results.reagents.recordUse": "Record use",
  "label.results.reagents.recorded": "Recorded {0} {1} — consumed FEFO across lots.",
  "label.results.reagents.recordFailed": "Could not record reagent use.",
  "label.results.reagents.amountInvalid": "Quantity used must be a positive number.",
  "label.results.reagents.consumeNote": "Recording use decrements inventory (FEFO) and writes a consumption transaction linked to this analysis.",
  "label.results.control.title": "Control result",
  "label.results.control.noneConfigured": "No control lots configured for this test and analyzer.",
  "label.results.control.viewResults": "View control results",
  "label.results.control.manualBlocked": "Manual control capture is not yet available — QC results are numeric-only and written by the analyzer pipeline. Configure control lots and review runs on the QC dashboard.",
  "label.results.dilution.title": "Dilution",
  "label.results.section.attachments": "Lampiran",
  "label.results.attachments.summary": "{0} file(s)",
  "label.results.attachments.none": "none",
  "label.results.attachments.empty": "No attachments on this order yet.",
  "label.results.attachments.add": "Add attachment",
  "label.results.attachments.tooLarge": "File exceeds the 10 MB limit.",
  "label.results.attachments.uploadFailed": "Upload failed — PDF, JPG, PNG, or TIFF up to 10 MB.",
  "label.results.attachments.resultsScope": "Hasil",
  "label.results.attachments.orderScope": "Order Entry",
  "label.results.attachments.view": "Lihat",
  "label.results.attachments.download": "Unduh",
  "label.results.section.interpretation": "Interpretasi",
  "label.results.interpretation.summary": "enter via rule or free text",
  "label.results.interpretation.ruleFired": "rule fired ({0}) · auto-open",
  "label.results.interpretation.autoOpen": "rule fired · auto-open",
  "label.results.interpretation.ruleBanner": "Rule match (configured on the test): the entered value {0} falls in {1}. Pick a category to apply its interpretation text, then edit as needed.",
  "label.results.interpretation.match": "matches value",
  "label.results.interpretation.freeText": "Interpretation (free text)",
  "label.results.interpretation.footnote": "Interpretation can be set by a rule configured on the test (the categorical buckets, auto-matched to the value) or free text. Rule text is a non-binding suggestion until applied or edited. Saving sends it with the result to the report.",
  "label.results.nce.disposition": "Result disposition",
  "label.results.nce.disposition.hint": "Applied when the NCE is submitted. Refer-out is a separate row action, not a disposition.",
  "label.results.nce.disposition.none": "Tidak ada",
  "label.results.nce.disposition.none.detail": "File the NCE without changing the result.",
  "label.results.nce.disposition.cancel": "Cancel result",
  "label.results.nce.disposition.cancel.detail": "Voided. No value reported. Common for pre-analytical NCEs.",
  "label.results.nce.disposition.reject": "Reject + reason",
  "label.results.nce.disposition.reject.detail": "Clears the value and records the reason. Applied by your e-signature Save.",
  "label.results.nce.disposition.retest": "Pemeriksaan Ulang",
  "label.results.nce.disposition.retest.detail": "Orders the same test again on this sample; the repeat appears as pending.",
  "label.results.nce.disposition.rejectArmed": "Rejection armed on the row — Save (e-signature) to apply it.",
  "label.results.nce.disposition.cancelled": "Result cancelled.",
  "label.results.nce.disposition.retested": "Retest ordered.",
  "label.results.critical.range": "Kritis",
  "label.results.critical.banner.title": "Critical value — physician notification required",
  "label.results.critical.banner.body": "The responsible clinician must be notified. Acknowledgment is recorded on the Alerts dashboard and never blocks Save.",
  "label.results.critical.acknowledge": "I Acknowledge",
  "label.results.critical.acknowledged": "Sudah diketahui",
  "label.results.critical.comment": "Acknowledgment comment",
  "label.results.critical.comment.placeholder": "e.g. Physician notified by phone",
  "label.results.section.history": "History (this analysis)",
  "label.results.history.summary": "{0} events",
  "label.results.history.summary.unloaded": "revisions · status · retests",
  "label.results.history.when": "When",
  "label.results.history.event": "Event",
  "label.results.history.detail": "Detail",
  "label.results.history.by": "Oleh",
  "label.results.history.event.CREATED": "Dibuat",
  "label.results.history.event.STATUS": "Status",
  "label.results.history.event.RESULT": "Hasil",
  "label.results.history.event.NOTE": "Catatan",
  "label.results.history.event.RETEST": "Pemeriksaan Ulang",
  "label.results.history.event.REFLEX": "Reflex",
  "label.results.history.event.OTHER": "Event",
  "label.results.history.empty": "No recorded events yet for this analysis.",
  "label.results.history.footnote": "This analysis only — revisions, status transitions, retests, corrections, notes and audit entries. Patient trends live on the patient record; Westgard rules on the QC dashboard.",
  "label.results.nce.report": "Report Non-Conformity",
  "label.results.reject.result": "Reject result",
  "label.results.reject.reason": "Rejection reason",
  "label.results.reject.hint": "Saving with a rejection clears the value, records the reason, and marks the analysis Technical Rejected.",
  "label.results.referral.refer": "Refer this test",
  "label.results.referral.editing": "Referral pending — edit",
  "label.results.referral.organization": "Reference laboratory",
  "label.results.referral.reason": "Referral reason",
  "label.results.referral.date": "Referral date",
  "label.results.referral.hint": "The referral is recorded when you Save this row and hands off to the Referrals dashboard.",
  "label.results.referral.cancel": "Discard",
  "label.results.section.aliquots": "Alikuot",
  "label.results.aliquots.summary": "{0} aliquots",
  "label.results.aliquots.summary.unloaded": "list · create",
  "label.results.aliquots.labNo": "No Registrasi",
  "label.results.aliquots.quantity": "Kuantitas",
  "label.results.aliquots.createdDate": "Dibuat",
  "label.results.aliquots.empty": "No aliquots yet for this sample item.",
  "label.results.aliquots.count": "Number of aliquots",
  "label.results.aliquots.totalQuantity": "Total quantity to transfer",
  "label.results.aliquots.notes": "Catatan",
  "label.results.aliquots.create": "Create aliquots",
  "label.results.aliquots.created": "Aliquots created.",
  "label.results.aliquots.failed": "Could not create aliquots.",
  "label.results.aliquots.remaining": "Parent remaining quantity",
  "label.results.history.event.REFERRAL": "Referred",
  "label.results.history.event.NCE": "Non-conformity",
  "label.results.referenceZone": "Reference & context",
  "label.results.layoutRemembered": "Layout remembered",
  "label.results.resetLayout": "Reset layout",
  "label.results.section.orderInfo": "Order info",
  "label.results.sampleType": "Jenis sampel",
  "label.results.testDate": "Test date",
  "label.results.receivedDate": "Diterima",
  "label.results.technician": "Petugas",
  "label.routine.Reports": "Laporan Rutin",
  "label.sample.types.activate": "Jenis sampel berikut akan diaktivasi:",
  "label.sample.types.deactivate": "Jenis sampel berikut akan dinonaktifkan karena tidak memiliki pemeriksaan:",
  "label.save": "Simpan",
  "label.saving": "Menyimpan...",
  "label.search.available.targetest": "Cari pemeriksaan tersedia",
  "label.search.availablepanel": "Cari panel tersedia",
  "label.search.labno.family": "Cari berdasarkan LabNo atau Nama Belakang",
  "label.search.patient": "Cari Pasien",
  "label.select": "Pilih",
  "label.select.dateRange": "Pilih Rentang Tanggal untuk laporan yang diinginkan",
  "label.select.list.options": "Pilih opsi daftar",
  "label.selectTestSectionCatalog": "Pilih bagian pemeriksaan untuk melihat katalog bagian tersebut",
  "label.sex.dependent": "Tergantung jenis kelamin",
  "label.shortCode": "Kode Pendek",
  "label.shortCode.error.invalidChars": "Kode pendek hanya dapat mengandung huruf, angka, hyphen atau underscore",
  "label.shortCode.error.maxLength": "Kode pendek harus kurang dari atau sama dengan 10 karakter",
  "label.shortCode.error.network": "Tidak dapat memverifikasi keunikan. Silahkan periksa manual.",
  "label.shortCode.error.save": "Error saat menyimpan kode pendek: {error}",
  "label.shortCode.error.startChar": "Kode pendek harus dimulai dengan huruf atau angka",
  "label.shortCode.helper": "Maksimum 10 karakter, alfanumerik dengan hyphen/underscore",
  "label.shortCode.optional.helper": "Opsional (kode akan digunakan jika ≤10 karakter). Maksimum 10 karakter, alfanumerik dengan hyphen/underscore",
  "label.shortCode.required.helper": "Wajib jika kode > 10 karakter. Maksimum 10 karakter, alfanumerik dengan hyphen/underscore",
  "label.shortCode.update.success": "Pembaruan kode pendek berhasil",
  "label.shortCodeRequired": "Kode pendek diwajibkan untuk pencetakan label. Silahkan buat pengaturan kode pendek di formulir Edit terlebih dahulu.",
  "label.shortCodeWarning": "Mengubah kode pendek akan membatalkan validasi label yang ada",
  "label.showChildren": "Tunjukan Elemen Anak",
  "label.study.Reports": "Laporan kajian",
  "label.test.activate": "Pemeriksaan ini akan diaktivasi",
  "label.test.add": "Tambahkan Pemeriksaan",
  "label.test.batch.cancel.finish": "Tidak dapat dibalik",
  "label.test.batch.cancel.start": "Anda telah memilih untuk membatalkan pemeriksaan",
  "label.test.batch.no.change.finish": "Pemeriksaan tidak dapat diubah",
  "label.test.batch.replace.start": "Berikut ini",
  "label.test.deactivate": "Pemeriksaan berikut akan diinaktivasi",
  "label.test.display.order": "Urutan tampilan pemeriksaan",
  "label.test.order.confirm": "Verifikasi: aktivasi/inaktivasi pemeriksaan yang dapat dipesan",
  "label.test.orderable": "Pemeriksaan berikut ini dapat dipesan dengan formulir permintaan",
  "label.test.results": "Hasil Pemeriksaan",
  "label.test.resultsData": "Data Hasil Pemeriksaan",
  "label.test.unorderable": "Pemeriksaan berikut ini tidak dapat dipesan dengan formulir permintaan. Hanya bisa dipesan sebagai pemeriksaan refleks",
  "label.testActivate": "Aktivasi Pemeriksaan",
  "label.testName": "Nama pemeriksaan",
  "label.text.generate": "Hasilkan",
  "label.total.tests": "Pemeriksaan total",
  "label.type": "Jenis Label",
  "label.type.order": "Label Pemesanan",
  "label.type.pool": "Pool of {count} {animal}",
  "label.type.sample": "Label Sampel",
  "label.unit": "Unit",
  "label.user.notestsection": "Pengguna tidak memiliki Instalasi Lab yang ditugaskan. Hubungi Admin",
  "label.validation.errors": "Kesalahan Validasi",
  "label.validation.results": "Hasil Validasi",
  "label.view": "Lihat",
  "label.viewtestCatalog": "Katalog Pemeriksaan",
  "label.warning": "Peringatan",
  "label.yes": "Ya",
  "labno.alt.prefix.instruction": "Prefiks untuk label kode QR pra-cetak (4 karakter):",
  "labno.alt.prefix.note": "CATATAN: Jika prefiks ini telah digunakan, penomoran akan berlanjut dari nomor terakhir yang dihasilkan.",
  "labno.alt.prefix.use": "Gunakan format yang sama untuk nomor registrasi dan kumpulan nomor yang ada seperti pada Pembuatan Entri Permintaan.",
  "language.select.label": "Indonesia",
  "legend.search.availabletests": "Mencari dari pemeriksaan yang ada",
  "loading": "Memuat...",
  "loading.boxes": "Memuat boks...",
  "loading.description": "Memuat...",
  "location.collection.title": "Lokasi Pengambilan",
  "location.environmentalConditions": "Kondisi Lingkungan",
  "location.environmentalConditions.placeholder": "mis. 25°C, cuaca cerah",
  "location.gps.error": "Gagal mengambil lokasi",
  "location.gps.getCurrent": "Ambil Lokasi Saat",
  "location.gps.getting": "Mengambil Lokasi...",
  "location.gps.latitude": "Garis Lintang GPS",
  "location.gps.longitude": "Garis bujur GPS",
  "location.gps.notSupported": "Geolokasi tidak didukung dengan peramban ini",
  "location.gps.permissionDenied": "Izin lokasi ditolak",
  "location.gps.timeout": "Permintaan lokasi time out",
  "location.gps.unavailable": "Informasi lokasi tidak tersedia",
  "location.helper": "Hirarki Lokasi (Kabupaten Kota / Kecamatan / Kelurahan-Desa) menggunakan sistem struktur Lokasi yang ada. Jika perlu pengaturan baris yang lebih sederhana/pendek, profil alur kerja Lingkungan memungkinkan beberapa baris tidak dilabel.",
  "location.requesterReference": "Referensi Pemohon",
  "location.requesterReference.placeholder": "mis. Metode EPA 524.2",
  "location.select.placeholder": "Pilih {levelName}...",
  "location.siteDescription": "Deskripsi Tempat Pengambilan",
  "location.siteDescription.placeholder": "mis. titik masuk pasokan air kabupaten",
  "locale.active": "Aktif",
  "locale.add": "Tambah Bahasa",
  "locale.add.title": "Tambah Bahasa",
  "locale.code": "Kode Lokal",
  "locale.code.helper": "mis., en, fr, es, pt",
  "locale.create.success": "Bahasa berhasil dibuat",
  "locale.delete.confirm.message": "Apakah Anda yakin akan menghapus bahasa ini? Aksi ini tidak dapat dibatalkan.",
  "locale.delete.confirm.title": "Hapus Bahasa",
  "locale.delete.error": "Gagal menghapus bahasa",
  "locale.delete.fallback.error": "Tidak dapat menghapus bahasa alternatif. Atur bahasa lain sebagai alternatif terlebih dahulu.",
  "locale.delete.success": "Bahasa berhasil dihapus",
  "locale.displayName": "Nama di Tampilan",
  "locale.displayName.helper": "mis., English, Français, Español",
  "locale.edit.title": "Edit Bahasa",
  "locale.fallback": "Bahasa Alternatif",
  "locale.fallback.error": "Gagal mengatur bahasa alternatif",
  "locale.fallback.success": "Bahasa alternatif diperbarui",
  "locale.management.description": "Kelola bahasa yang ada untuk terjemahan metadata.",
  "locale.management.title": "Pengelolaan Bahasa",
  "locale.setFallback": "Atur sebagai Bahasa Alternatif",
  "locale.sortOrder": "Sortir Pemesanan",
  "locale.status": "Status",
  "locale.update.success": "Bahasa berhasil diperbarui",
  "log.submitting.aliquot.data": "Submit data alikuot:",
  "log.submitting.aliquot.data2": "Submit data alikuot (JSON):",
  "logging.management.apply": "Terapkan Level Log",
  "logging.management.description": "Ubah level logging backend saat runtime. Ini berguna untuk mendebug masalah tanpa perlu me-restart server. Perubahan akan berlaku segera tetapi tidak akan bertahan setelah server di-restart.",
  "logging.management.label": "Konfigurasi Logging",
  "logging.management.level": "Level Log",
  "logging.management.logger": "Nama Logger",
  "logging.management.logger.helper": "mis., org.openelisglobal, root",
  "logging.management.success": "Level log diatur ke {level} untuk {logger}",
  "login.account.disabled": "Akun dinon-aktifkan",
  "login.account.locked": "Akun terkunci",
  "login.complexity.message": "Kata kunci harus:",
  "login.complexity.message.1": "Setidaknya 7 karakter",
  "login.complexity.message.2": "Memiliki huruf besar dan kecil, atau angka",
  "login.complexity.message.3": "Memiliki setidaknya 1 karakter berikut ini: *, $, #, !",
  "login.complexity.message.4": "Tidak mengandung karakter lainnya",
  "login.complexity.new.message": "Kata kunci baru harus:",
  "login.complexity.new.message.1": "Tidak boleh sama dengan kata kunci saat ini",
  "login.error.account.disable": "Your account has been disabled. Please contact system administrator.",
  "login.error.password.current.incorrect": "The current password you entered is incorrect. Please try again.",
  "login.error.password.expired": "Your password has expired. Please contact system administrator.",
  "login.error.update.message": "Update password failed. Please try again.",
  "login.login.": "Ulang kata kunci",
  "login.login.current.password": "Kata kunci saat ini",
  "login.login.first": "Nama depan",
  "login.login.last": "Nama belakang",
  "login.login.name": "Nama login",
  "login.login.new.password": "Kata kunci baru",
  "login.login.password": "Kata kunci",
  "login.login.repeat.password": "Ulang kata kunci",
  "login.msg.password": "Kata kunci",
  "login.msg.password.missing": "Kata kunci diperlukan",
  "login.msg.username": "Nama pengguna",
  "login.msg.username.missing": "Nama pengguna diperlukan",
  "login.notice.message": "Pemberitahuan: Akses ke layanan ini hanya untuk personel yang berwenang. Jika Anda tidak memiliki wewenang dari administrator, Anda harus keluar sekarang. Organisasi ini melarang akses tanpa wewenang, pengungkapan, penggandaan, modifikasi, pengalihan, pemusnahan, penghilangan, penyalahgunaan, atau pencurian informasi tanpa izin.",
  "login.password.expired.date": "Tanggal kadaluarsa kata kunci",
  "login.password.expired.date.placeholder": "(dd/mm/yyyy)",
  "login.redirecting.sso": "Mengarahkan ke Single Sign-On...",
  "login.subtitle": "Login",
  "login.timeout": "Pengguna Time Out (menit)",
  "login.timeout.placeholder": "Masukkan dalam ms",
  "login.title": "Login",
  "lot.barcode": "Kode QR",
  "lot.calculatedExpiry": "Perhitungan Kedaluwarsa",
  "lot.currentQuantity": "Kuantitas Saat Ini",
  "lot.dateOpened": "Tanggal Dibuka",
  "lot.details.no.transactions": "Tidak ada transaksi terekam untuk lot ini",
  "lot.details.no.usage": "Tidak riwayat penggunaan untuk lot ini",
  "lot.details.section.basic": "Informasi Dasar",
  "lot.details.section.dates": "Tanggal Penting",
  "lot.details.section.quantities": "Kuantitas",
  "lot.details.section.storage": "Lokasi Penyimpanan",
  "lot.details.section.transactions": "Riwayat Transaksi",
  "lot.details.section.usage": "Riwayat Penggunaan",
  "lot.details.tab.info": "Informasi",
  "lot.details.tab.transactions": "Transaksi",
  "lot.details.tab.usage": "Riwayat Penggunaan",
  "lot.details.title": "Rincian Lot",
  "lot.details.view": "Tampilkan Rincian",
  "lot.expirationDate": "Tanggal Kedaluwarsa",
  "lot.form.title.add": "Menerima Lot Inventaris Baru",
  "lot.form.title.edit": "Edit Lot Inventaris",
  "lot.initialQuantity": "Kuantitas Awal",
  "lot.number": "Nomor Lot",
  "lot.qcStatus": "Status QC",
  "lot.receiptDate": "Tanggal Penerimaan",
  "lot.save.error": "Error saat menyimpan lot",
  "lot.save.success": "Lot berhasil disimpan",
  "lot.selectItem": "Pilih Barang di Katalog",
  "lot.selectLocation": "Tambah Lokasi Penyimpanan",
  "lot.status": "Status",
  "lot.storageLocation": "Lokasi Penyimpanan",
  "manage.testing.algorithms.add.reflex.tests": "Kelola Algoritma Pemeriksaan dan Pemeriksaan Refleks",
  "master.lists.page": "Halaman daftar master",
  "master.lists.page.analyzer": "Menu Nama Pemeriksaan di Alat",
  "master.lists.page.barcode": "Konfigurasi kode QR",
  "master.lists.page.batchtest": "Penugasan ulang dan pembatalan pemeriksaan batch",
  "master.lists.page.external.connections": "Menu Koneksi Eksternal",
  "master.lists.page.field": "Konfigurasi Validasi Field",
  "master.lists.page.list": "Daftar Plugin",
  "master.lists.page.menu": "Konfigurasi menu",
  "master.lists.page.notification": "Konfigurasi Notifikasi Pemeriksaan",
  "master.lists.page.order.entry": "Konfigurasi Entri Permintaan",
  "master.lists.page.org": "Menu Organisasi",
  "master.lists.page.patient": "Konfigurasi Entri Pasien",
  "master.lists.page.printed": "Konfigurasi Laporan Cetak",
  "master.lists.page.provider": "Penyelenggara",
  "master.lists.page.report.result": "Konfigurasi Pelaporan Hasil",
  "master.lists.page.result": "Konfigurasi Entri Hasil",
  "master.lists.page.site": "Pengaturan Informasi Aplikasi",
  "master.lists.page.test.management": "Pengelolaan Pemeriksaan",
  "master.lists.page.user": "Pengelolaan Pengguna",
  "master.lists.page.work.plan": "Konfigurasi Rencana Kerja",
  "menu.accession.validation": "Berdasarkan Permintaan",
  "menu.accession.validation.range": "Berdasarkan Rentang Nomor Permintaan",
  "menu.billing.active": "Menu Pembayaran Aktif",
  "menu.billing.address": "URL Pembayaran",
  "menu.billing.title": "Pengelolaan Menu Pembayaran",
  "menu.genericSample": "Sampel Generik",
  "menu.genericSample.edit": "Edit Sampel",
  "menu.genericSample.import": "Impor",
  "menu.genericSample.order": "Penerimaan Sampel",
  "menu.global.title": "Pengelolaan Menu Global",
  "menu.label.filter": "Filters : ",
  "menu.label.filter.active": "Hanya Aktif",
  "menu.label.filter.admin": "Hanya Administrator",
  "menu.label.filter.role": "Berdasarkan Peran Unit Lab",
  "menu.nonconform.active": "Menu Ketidaksesuaian Aktif",
  "menu.nonconform.title": "Pengelolaan Menu Ketidaksesuaian",
  "menu.patient.active": "Menu Pasien Aktif",
  "menu.patient.title": "Pengelolaan Menu Pasien",
  "menu.results.range": "Berdasarkan Rentang Nomor Permintaan",
  "menu.sidenav.active": "Navigasi Sisi Aktif",
  "menu.study.active": "Menu Kajian Aktif",
  "menu.study.title": "Konfigurasi Menu Kajian",
  "menu.validation.date": "Berdasarkan Tanggal",
  "message.method.activation": "Unit metode ini tidak aktif kecuali setidaknya satu pemeriksaan ditugaskan",
  "message.noPluginFound": "Tidak ada plugin ditemukan",
  "message.propertiesupdate.success": "Properti berhasil diperbarui",
  "method.browse.title": "Bagian Metode",
  "method.methodName": "Nama Metode",
  "method.modal.add.heading": "Tambah Metode Baru",
  "modal.add.method": "Tambah Metode Baru",
  "move.back": "Kembalikan",
  "move.to.aliquot": "Pindahkan ke Alikuot",
  "new.patient.label": "Pasien Baru",
  "new.program.label": "Program Baru",
  "next.action.button": "Berikutnya",
  "nextLabel.action.button": "Label Berikutnya",
  "no.aliquots": "Tidak ada alikuot tersedia",
  "no.analysis.found": "Tidak ada analisis ditemukan",
  "no.data.found": "Tidak ada data ditemukan",
  "no.option": "Tidak",
  "noTestsFound.matching": "Tidak ada pemeriksaan ditemukan",
  "nonconform.add.new.date": "Tambah tanggal baru",
  "nonconform.corrective.action": "Rencana atau rekomendasi tindakan perbaikan",
  "nonconform.corrective.actionType": "Jenis tindakan",
  "nonconform.corrective.comment": "Komentar",
  "nonconform.corrective.control": "Rencana atau rekomendasi tindakan pencegahan, perbaikan atau pengendalian simultan:",
  "nonconform.corrective.title": "Tindakan perbaikan kejadian ketidaksesuaian",
  "nonconform.date.completed": "Tanggal selesai",
  "nonconform.date.discussion.nce": "Tanggal diskusi dengan Petugas Kejadian Ketidaksesuaian",
  "nonconform.date.event": "Tanggal Kejadian",
  "nonconform.description.nce": "Deskripsi Kejadian Ketidaksesuaian",
  "nonconform.field.date": "Tanggal Kejadian Ketidaksesuaian",
  "nonconform.field.reporting.data": "Tanggal Pelaporan",
  "nonconform.goToNceForm": "Pergi ke formulir Kejadian Ketidaksesuaian",
  "nonconform.lab.componenet.nce": "Komponen Lab dimana Kejadian Ketidaksesuaian terjadi",
  "nonconform.label.highseverity": "9 = Keparahan sangat tinggi -- perlu tindakan segera",
  "nonconform.label.lowseverity": "1 = Keparahan sangat rendah -- tidak perlu tindakan segera",
  "nonconform.label.prescibernamesite": "Nama dan Lokasi Dokter yang mengeluarkan resep",
  "nonconform.label.proposed.action": "Tindakan yang diusulkan",
  "nonconform.label.reportingunit": "Unit yang melapor",
  "nonconform.label.suspected.cause.nce": "Penyebab dugaan Kejadian Ketidaksesuaian",
  "nonconform.nce.concurrent.control.action": "Tindakan pengendalian simultan",
  "nonconform.nce.number": "Nomor Kejadian Ketidaksesuaian",
  "nonconform.nce.preventive.action": "Tindakan pencegahan",
  "nonconform.nce.resolution": "Penyelesaian Kejadian Ketidaksesuaian",
  "nonconform.nce.resolution.description": "Apakah tindakan korektif dan pengendalian pencegahan/simultan efektif dalam menyelesaikan Kejadian Ketidaksesuaian dan mencegahnya terulang kembali?",
  "nonconform.nce.turnaround.time": "Waktu Penyelesaian",
  "nonconform.order.save.fail": "Penyimpanan gagal",
  "nonconform.order.save.success": "Penyimpanan berhasil",
  "nonconform.person.reporting.different": "Nama petugas yang melaporkan Kejadian Ketidaksesuaian (bila berbeda)",
  "nonconform.person.responsible": "Petugas yang bertanggungjawab",
  "nonconform.report": "Lapor Kejadian Ketidaksesuaian",
  "nonconform.report.field.date": "Tanggal Laporan",
  "nonconform.severity.score": "Skor Keparahan",
  "nonconform.view.comments": "Komentar",
  "nonconform.view.corrective.action.description": "Deskripsi tindakan perbaikan yang akan diambil",
  "nonconform.view.event.date": "Tanggal Kejadian",
  "nonconform.view.event.description": "Deskripsi Kejadian",
  "nonconform.view.lab.component": "Komponen Laboratorium",
  "nonconform.view.nce.category": "Kategori Kejadian Ketidaksesuaian",
  "nonconform.view.nce.likely.occur": "Seberapa besar kemungkinan Kejadian Ketidaksesuaian akan terulang?",
  "nonconform.view.nce.severity": "Keparahan",
  "nonconform.view.nce.type": "Jenis Kejadian Ketidaksesuaian",
  "nonconform.view.preventive.description": "Jika ada, jelaskan tindakan pencegahan atau pengendalian simultan",
  "nonconform.view.report": "Lihat Kejadian Ketidaksesuaian Baru",
  "nonconform.view.reporting.person": "Petugas yang melapor",
  "nonconform.view.severe.consequences": "Bagaimana tingkat keparahan konsekuensi atau pengaruh dari Kejadian Ketidaksesuaian?",
  "nonconform.view.specimen": "Spesimen",
  "nce.attachment.dropzone": "Tarik dan lepaskan file disini atau klik untuk mengunggah",
  "nce.attachment.error.maxFiles": "Maksimum {maxFiles} file dibolehkan",
  "nce.attachment.error.size": "Ukuran file melebihi maksimum {maxSize}",
  "nce.attachment.error.type": "Tipe file tidak didukung. Tipe yang diterima: {types}",
  "nce.attachment.error.upload": "Error saat mengunggah file",
  "nce.attachment.files": "file",
  "nce.attachment.hint": "(Opsional - maks {maxFiles} file, masing-masing 10MB)",
  "nce.attachment.uploading": "Mengunggah...",
  "nce.category.administrative": "Administratif",
  "nce.category.analytical": "Analisis",
  "nce.category.postanalytical": "Pasca-analisis",
  "nce.category.preanalytical": "Pra- analisis",
  "nce.field.attachments": "Lampiran",
  "nce.field.notes": "Catatan",
  "nce.field.description.placeholder": "Jelaskan apa yang terjadi, kapan terdeteksi, dan hal relevan lainnya...",
  "nce.field.immediateAction": "Tindakan Segera Diambil",
  "nce.field.immediateAction.placeholder": "Tindakan perbaikan apa yang akan segera diambil...",
  "nce.field.linkedItems": "Sampel/Hasil Terkait",
  "nce.field.severity": "Keparahan",
  "nce.field.title": "Judul",
  "nce.field.title.placeholder": "Deskripsi singkat kejadian...",
  "nce.severity.critical": "Kritis",
  "nce.severity.critical.description": "Resiko keselamatan pasien, pelanggaran peraturan",
  "nce.severity.major": "Major",
  "nce.severity.major.description": "Dampat signifikan pada mutu atau operasional",
  "nce.severity.minor": "Minor",
  "nce.severity.minor.description": "Dampak terbatas, mudah diperbaiki",
  "nce.severity.low": "Rendah",
  "nce.severity.low.description": "Dampak minimal, tidak ada tindakan perbaikan diperlukan",
  "nce.status.open": "Buka",
  "nce.status.underInvestigation": "Dalam Investigasi",
  "nce.status.correctiveAction": "Tindakan Perbaikan",
  "nce.status.closed": "Ditutup",
  "nce.tree.empty": "Tidak ada pemesanan ditemukan. Cari nomor lab untuk mulai.",
  "nce.tree.loading": "Memuat pemesanan...",
  "nce.tree.order": "Pemesanan",
  "nce.tree.search": "Filter berdasarkan pemeriksaan atau sampel...",
  "nce.tree.selected": "{sampleCount} sampel, {resultCount} hasil dipilih",
  "nce.trigger.order_cancellation": "Pembatalan pesanan dapat memerlukan dokumen KTS",
  "nce.trigger.partial_sample_rejection": "Penolakan sampel parsial memerlukan dokumentasi KTS",
  "nce.trigger.pathology_rejection": "Penolakan kasus patologi dapat memerlukan dokumentasi KTS",
  "nce.trigger.premature_disposal": "Pemusnahan sebelum waktunya dapat memerlukan dokumen KTS",
  "nce.trigger.qc_invalidation": "Invalidasi QC memerlukan dokumentasi KTS",
  "nce.trigger.referral_rejection": "Penolakan rujukan memerlukan dokumentasi KTS",
  "nce.trigger.result_rejection_no_retest": "Penolakan hasil tanpa pengujian ulang memerlukan dokumentasi KTS",
  "nce.trigger.result_rejection_retest": "Penolakan hasil tanpa pengujian ulang dapat memerlukan dokumentasi KTS",
  "nce.trigger.sample_rejection": "Penolakan sampel memerlukan dokumentasi KTS",
  "nce.trigger.test_cancel_no_results": "Pembatalan pengujian memerlukan dokumen KTS",
  "nce.trigger.test_cancel_with_results": "Pembatalan pengujian dengan hasil memerlukan dokumen KTS",
  "nce.type.calibration_failure": "Kegagalan kalibrasi",
  "nce.type.communication_failure": "Kegagalan komunikasi",
  "nce.type.contamination": "Kontaminasi",
  "nce.type.documentation_error": "Kesalahan dokumentasi",
  "nce.type.equipment_malfunction": "Malfungsi alat",
  "nce.type.labeling_error": "Kesalahan pelabelan",
  "nce.type.patient_id_mismatch": "Salah mencocokkan identitas pasien",
  "nce.type.policy_violation": "Pelanggaran kebijakan",
  "nce.type.procedure_deviation": "Penyimpangan prosedur",
  "nce.type.qc_failure": "Kegagalan QC",
  "nce.type.reagent_issue": "Masalah reagen",
  "nce.type.report_delay": "Laporan terlambat",
  "nce.type.report_distribution_error": "Kesalahan distribusi laporan",
  "nce.type.requisition_incomplete": "Permintaan pemeriksaan tidak lengkap",
  "nce.type.resource_shortage": "Kurang sumber daya",
  "nce.type.result_interpretation_error": "Kesalahan interpretasi hasil",
  "nce.type.sample_collection_error": "Kesalahan pengambilan sampel",
  "nce.type.staff_competency_issue": "Masalah kompetensi pegawai",
  "nce.type.storage_error": "Kesalahan penyimpanan",
  "nce.type.system_error": "Kesalahan sistem",
  "nce.type.training_gap": "Kesenjangan pelatihan",
  "nce.type.transcription_error": "Kesalanan transkripsi",
  "nce.type.transport_issue": "Masalah transportasi",
  "nce.type.request_form_error": "Kesalahan formulir permintaan",
  "nce.type.equipment_failure": "Kegagalan alat",
  "nce.type.procedure_error": "Kesalahan prosedur",
  "nce.type.calibration_error": "Kesalahan kalibrasi",
  "nce.type.cross_contamination": "Kontaminasi silang",
  "nce.type.result_transcription_error": "Kesalahan transkripsi hasil",
  "nce.type.report_delivery_error": "Kesalahan pengiriman hasil",
  "nce.type.critical_value_not_reported": "Nilai kritis tidak dilaporkan",
  "nce.type.delayed_result": "Hasil terlambat",
  "nce.type.result_amendment": "Amendemen hasil",
  "nce.type.training_issue": "Masalah pelatihan",
  "nce.button.createNce": "Buat KTS",
  "nce.button.skip": "Skip",
  "nce.creating": "Membuat KTS...",
  "nce.description.placeholder": "Deskripsikan kejadian ketidaksesuaian...",
  "nce.error.create.failed": "Gagal membuat KTS",
  "nce.error.severity.required": "Keparahan wajib ada",
  "nce.trigger.mandatory.message": "Anda harus membuat KTS sebelum dapat lanjut dengan aksi ini.",
  "nce.trigger.mandatory.title": "KTS wajib ada",
  "nce.trigger.order_cancellation.message": "Pembatalan pesanan dapat memerlukan dokumentasi kejadian ketidaksesuaian.",
  "nce.trigger.order_cancellation.title": "Pembatalan Pemesanan - KTS",
  "nce.trigger.partial_sample_rejection.message": "Penolakan sampel parsial memerlukan dokumentasi kejadian ketidaksesuaian.",
  "nce.trigger.partial_sample_rejection.title": "Penolakan Sampel Parsial - Wajib Ada KTS",
  "nce.trigger.pathology_rejection.message": "Penolakan kasus patologi dapat memerlukan dokumentasi kejadian ketidaksesuaian.",
  "nce.trigger.pathology_rejection.title": "Penolakan Patologi - KTS",
  "nce.trigger.premature_disposal.message": "Pemusnahan sebelum waktunya dapat memerlukan dokumen kejadian ketidaksesuaian.",
  "nce.trigger.premature_disposal.title": "Pemusnahan Sebelum Waktunya - KTS",
  "nce.trigger.qc_invalidation.message": "Invalidasi QC memerlukan dokumentasi kejadian ketidaksesuaian.",
  "nce.trigger.qc_invalidation.title": "Invalidasi QC - Wajib Ada KTS",
  "nce.trigger.referral_rejection.message": "Penolakan rujukan memerlukan dokumentasi kejadian ketidaksesuaian.",
  "nce.trigger.referral_rejection.title": "Penolakan Rujukan - Wajib Ada KTS",
  "nce.trigger.result_rejection_no_retest.message": "Penolakan hasil tanpa pengujian ulang memerlukan dokumentasi kejadian ketidaksesuaian.",
  "nce.trigger.result_rejection_no_retest.title": "Penolakan Hasil - Wajib Ada KTS",
  "nce.trigger.result_rejection_retest.message": "Penolakan hasil dengan pengujian ulang dapat memerlukan dokumentasi kejadian ketidaksesuaian.",
  "nce.trigger.result_rejection_retest.title": "Penolakan Hasil - KTS",
  "nce.trigger.sample_rejection.message": "Penolakan sampel memerlukan dokumentasi kejadian ketidaksesuaian.",
  "nce.trigger.sample_rejection.title": "Penolakan Sampel - Wajib Ada KTS",
  "nce.trigger.test_cancel_no_results.message": "Pembatalan pemeriksaan dapat memerlukan dokumentasi kejadian ketidaksesuaian.",
  "nce.trigger.test_cancel_no_results.title": "Pembatalan Pemeriksaan - KTS",
  "nce.trigger.test_cancel_with_results.message": "Pembatalan pemeriksaan dengan hasil memerlukan dokumentasi kejadian ketidaksesuaian.",
  "nce.trigger.test_cancel_with_results.title": "Pembatalan Pemeriksaan - KTS wajib ada",
  "nce.admin.trigger.config.title": "Konfigurasi Trigger Ketidaksesuaian",
  "nce.admin.trigger.config.description": "Konfigurasi pembuatan Kejadian Ketidaksesuaian secara otomatis",
  "nce.admin.trigger.behaviors.title": "Perilaku Trigger",
  "nce.admin.rejection.mappings.title": "Pemetaan Alasan Penolakan",
  "nce.admin.rejection.mappings.description": "Pemetaan alasan penolakan terhadap kategori KTS untuk mengisi otomatis.",
  "nce.trigger.behavior.mandatory": "Mandatory",
  "nce.trigger.behavior.prompted": "Prompted",
  "nce.trigger.behavior.disabled": "Dinonaktifkan",
  "nce.trigger.column.type": "Tipe Trigger",
  "nce.trigger.column.description": "Deskripsi",
  "nce.trigger.column.behavior": "Perilaku",
  "nce.trigger.column.active": "Aktif",
  "nce.trigger.type.sampleRejection": "Penolakan Sampel",
  "nce.trigger.type.resultRejection": "Penolakan Hasil",
  "nce.trigger.type.qaEvent": "QA Event",
  "nce.trigger.type.manual": "Manual",
  "nce.trigger.update.success": "Konfigurasi trigger diperbarui",
  "nce.trigger.update.error": "Gagal memperbarui konfigurasi trigger",
  "nce.mapping.add": "Tambah Pemetaan",
  "nce.mapping.edit": "Edit Pemetaan",
  "nce.mapping.column.rejectionReason": "Alasan Penolakan",
  "nce.mapping.column.category": "Kategori KTS",
  "nce.mapping.column.type": "Jenis KTS",
  "nce.mapping.column.severity": "Keparahan Default",
  "nce.mapping.column.active": "Aktif",
  "nce.mapping.noData": "Tidak ada konfigurasi pemetaan penolakan",
  "nce.mapping.validation.error": "Wajib ada alasan dan kategori penolakan",
  "nce.mapping.save.success": "Pemetaan berhasil disimpan",
  "nce.mapping.active": "Aktif",
  "nce.field.category": "Kategori",
  "nce.field.type": "Jenis",
  "nce.select.category": "Pilih Kategori",
  "nce.select.type": "Pilih jenis",
  "nce.error.dateOfEvent.required": "Wajib ada tanggal kejadian",
  "nce.error.reportingUnit.required": "Instalasi yang melaporkan wajib ada",
  "nce.error.description.required": "Deksripsi wajib ada",
  "nce.error.suspectedCauses.required": "Penyebab suspek wajib ada",
  "nce.error.proposedAction.required": "Tindakan yang diusulkan wajib ada",
  "nce.error.category.required": "Kategori wajib ada",
  "nce.attachment.saveFirst": "Simpan kejadian KTS untuk mengaktifkan lampiran file",
  "nce.attachment.error.noEvent": "Mohon simpan kejadian KTS terlebih dahulu sebelum mengunggah lampiran",
  "nce.attachment.download": "Unduh",
  "nce.attachment.delete": "Hapus",
  "requester.add.new.restricted": "Adding a new organization has been disabled by your administrator.",
  "requester.add.new.restricted.organization.contact": "Entering contact info for a new organization has been disabled by your administrator. Search for an existing organization above.",
  "requester.add.new.restricted.provider": "Adding a new provider has been disabled by your administrator.",
  "requester.add.new.restricted.provider.contact": "Entering contact info for a new provider has been disabled by your administrator. Search for an existing provider above.",
  "requester.add.new.restricted.requestor": "Adding a new requestor has been disabled by your administrator. Search for an existing requestor above.",
  "requester.contact.search": "Requestor Search",
  "requester.contact.search.helper": "Search for the contact person requesting these tests, or enter a new one below. At least one of Requesting Organization or Requestor is required.",
  "requester.organization.add.new": "+ Add new organization \"{name}\"",
  "requester.organization.email": "Organization Email",
  "requester.organization.fax": "Organization Fax",
  "requester.organization.new.helper": "Will be created as a new organization when this order is saved.",
  "requester.organization.new.tag": "New",
  "requester.organization.no.match": "No matching organization found.",
  "requester.organization.phone": "Organization Phone",
  "requester.organization.search": "Requesting Organization Search",
  "requestor.add.new": "+ Add new requestor \"{name}\"",
  "requestor.add.new.restricted": "Adding a new requestor has been disabled by your administrator.",
  "requestor.department": "Department",
  "requestor.email": "Email",
  "requestor.fax": "No. Telp",
  "requestor.firstName": "Nama Depan",
  "requestor.lastName": "Nama Belakang",
  "requestor.name": "Requestor Name",
  "requestor.name.placeholder": "Enter requestor name",
  "requestor.new.helper": "Will be created as a new requestor when this order is saved.",
  "requestor.new.tag": "New",
  "requestor.no.match": "No matching requestor found.",
  "requestor.phone": "Telepon",
  "requestor.search.helper": "Type at least 2 characters to auto-search.",
  "result.compliance.fail": "FAIL",
  "result.compliance.pass": "PASS",
  "result.pool.filter.allLots": "All lots",
  "result.pool.filter.allPools": "All pools",
  "result.pool.filter.clear": "Clear filter",
  "result.pool.filter.count": "Showing {shown} of {total} results",
  "result.pool.filter.lot": "Filter by lot",
  "result.pool.filter.pool": "Filter by pool",
  "result.pool.intake": "Intake pool",
  "result.pool.subpool": "Sub-pool {n}",
  "result.vectorPool.label": "Pool of {count} {animal}",
  "results.uncertainty.column.label": "U (k=2)",
  "results.uncertainty.validation.negative": "Uncertainty must be a non-negative number.",
  "results.uncertainty.value.prefix": "±",
  "sample.fallback.name": "Sampel",
  "sample.referToReferenceLab.helper": "Mark if this sample requires testing at an external reference laboratory.",
  "sampleAcceptance.action.moveDown": "Geser ke bawah",
  "sampleAcceptance.action.moveUp": "Geser ke atas",
  "sampleAcceptance.banner.resampledFrom": "This is a replacement created by a resample of sample #{id}.",
  "sampleAcceptance.banner.resampledFrom.title": "Replacement sample",
  "sampleAcceptance.banner.resampledTo": "This sample was rejected and resampled. Replacement order: {accession}.",
  "sampleAcceptance.banner.resampledTo.title": "Resampled",
  "sampleAcceptance.button.addItem": "Add item",
  "sampleAcceptance.col.active": "Aktif",
  "sampleAcceptance.col.label": "Label",
  "sampleAcceptance.col.order": "Pemesanan",
  "sampleAcceptance.col.statusForDomain": "Status for this domain",
  "sampleAcceptance.domain.all": "All domains",
  "sampleAcceptance.domain.clinical": "Klinis",
  "sampleAcceptance.domain.environmental": "Lingkungan",
  "sampleAcceptance.domain.vector": "Vektor",
  "sampleAcceptance.enforcement.help": "Enforcement is set per domain, not per lab unit — a reception clerk spans many lab units.",
  "sampleAcceptance.enforcement.label": "Checklist enforcement — {domain}",
  "sampleAcceptance.enforcement.mandatory": "Mandatory — block Step 3 until complete",
  "sampleAcceptance.enforcement.off": "Off — hide the checklist",
  "sampleAcceptance.enforcement.optional": "Optional — record but don't block",
  "sampleAcceptance.gate.blocked": "Intake acceptance is mandatory for this domain — accept every specimen (or report an NCE / resample) before this order can proceed.",
  "sampleAcceptance.labWide.heading": "Lab-wide items (apply unless a domain overrides)",
  "sampleAcceptance.labWide.inherited": "Lab-wide items — inherited (active fallback)",
  "sampleAcceptance.labWide.superseded": "Lab-wide items — superseded here (edit from “All domains”)",
  "sampleAcceptance.notify.enforcementSaved": "Enforcement updated",
  "sampleAcceptance.notify.itemAdded": "Checklist item added",
  "sampleAcceptance.notify.itemSaved": "Checklist item saved",
  "sampleAcceptance.notify.recordFailed": "Failed to record acceptance",
  "sampleAcceptance.notify.rejectFailed": "Failed to reject",
  "sampleAcceptance.notify.resampleFailed": "Failed to resample",
  "sampleAcceptance.ownItems.empty": "No items yet — this domain falls back to the lab-wide list below.",
  "sampleAcceptance.ownItems.heading": "{domain} items",
  "sampleAcceptance.qa.accepted.success": "Acceptance recorded",
  "sampleAcceptance.qa.answer.fail": "Fail",
  "sampleAcceptance.qa.answer.na": "N/A",
  "sampleAcceptance.qa.answer.pass": "Pass",
  "sampleAcceptance.qa.button.accept": "Accept sample",
  "sampleAcceptance.qa.button.reject": "Tolak",
  "sampleAcceptance.qa.button.resample": "Resample",
  "sampleAcceptance.qa.context.collected": "Diambil",
  "sampleAcceptance.qa.context.longTransit": "long transit — your call",
  "sampleAcceptance.qa.context.note": "Transit is shown for reference only — it does not auto-grade anything. Active list: {domain}.",
  "sampleAcceptance.qa.context.received": "Diterima",
  "sampleAcceptance.qa.context.transit": "Transit time",
  "sampleAcceptance.qa.empty": "No acceptance checklist is configured for this domain.",
  "sampleAcceptance.qa.failHint": "This sample has failed checks — report an NCE or resample instead of accepting.",
  "sampleAcceptance.qa.noSample": "Save collection to run intake acceptance for this specimen.",
  "sampleAcceptance.qa.note.label": "Note (optional)",
  "sampleAcceptance.qa.note.placeholder": "Optional — note any observed condition",
  "sampleAcceptance.qa.status.accepted": "Diterima",
  "sampleAcceptance.qa.status.pending": "Tertunda",
  "sampleAcceptance.qa.status.rejected": "Ditolak",
  "sampleAcceptance.qa.status.review": "Review",
  "sampleAcceptance.qa.subtitle": "Complete the acceptance checklist for this sample",
  "sampleAcceptance.qa.subtitle.rejected": "This specimen was rejected and resampled — read-only.",
  "sampleAcceptance.qa.subtitle.rejectedVector": "This catch was rejected — read-only.",
  "sampleAcceptance.qa.title": "Intake acceptance",
  "sampleAcceptance.reject.commit": "Commit reject",
  "sampleAcceptance.reject.info": "Reject this catch as unusable. This cannot be re-collected, so no replacement order is created.",
  "sampleAcceptance.reject.reason.label": "Reason (pre-filled from failed items — editable)",
  "sampleAcceptance.reject.reason.required": "A reason is required",
  "sampleAcceptance.reject.success": "Sample rejected.",
  "sampleAcceptance.reject.title": "Reject — {labNumber}",
  "sampleAcceptance.resample.commit": "Commit resample",
  "sampleAcceptance.resample.info": "Reject this sample and create a new collection order for re-collection. The requester will be notified.",
  "sampleAcceptance.resample.reason.label": "Reason (pre-filled from failed items — editable)",
  "sampleAcceptance.resample.reason.required": "A reason is required",
  "sampleAcceptance.resample.success": "Resample created — new order {accession}. Requester notified.",
  "sampleAcceptance.resample.title": "Resample — {labNumber}",
  "sampleAcceptance.review.col.eligibility": "Eligibility",
  "sampleAcceptance.review.col.labNo": "Lab #",
  "sampleAcceptance.review.col.sampleType": "Jenis sampel",
  "sampleAcceptance.review.col.transit": "Transit",
  "sampleAcceptance.review.noSamples": "No collected specimens to review yet.",
  "sampleAcceptance.review.subtitle": "Select a sample to complete its acceptance checklist",
  "sampleAcceptance.review.title": "Intake Acceptance",
  "sampleAcceptance.status.active": "Aktif",
  "sampleAcceptance.status.inactive": "Inaktif",
  "sampleAcceptance.status.inheritedActive": "Active (inherited)",
  "sampleAcceptance.status.superseded": "Digantikan",
  "sampleAcceptance.title": "Sample Acceptance Checklist",
  "sidenav.label.admin.nceTriggerConfig": "Konfigurasi Trigger",
  "sidenav.label.admin.nceCategoryType": "Kategori & Jenis",
  "sidenav.label.admin.nceConfig": "Konfigurasi Ketidaksesuaian",
  "nce.admin.categorytype.title": "Konfigurasi Kategori dan Jenis Ketidaksesuaian",
  "nce.admin.categorytype.description": "Kelola kategori dan jenis yang ada untuk Kejadian Ketidaksesuaian.",
  "nce.admin.tab.categories": "Kategori",
  "nce.admin.tab.types": "Jenis",
  "nce.admin.category.add": "Tambah Kategori",
  "nce.admin.category.edit": "Edit Kategori",
  "nce.admin.category.name.required": "Nama kategori wajib ada",
  "nce.admin.category.save.success": "Kategori berhasil disimpan",
  "nce.admin.category.save.error": "Gagal menyimpan kategori",
  "nce.admin.type.add": "Tambah Jenis",
  "nce.admin.type.edit": "Edit Jenis",
  "nce.admin.type.validation.error": "Nama dan jenis kategori wajib ada",
  "nce.admin.type.save.success": "Jenis berhasil disimpan",
  "nce.admin.type.save.error": "Gagal menyimpan jenis",
  "nce.admin.column.name": "Nama",
  "nce.admin.column.displayKey": "Display Key",
  "nce.admin.column.typesCount": "Jumlah Jenis",
  "nce.admin.column.category": "Kategori",
  "nce.admin.column.actions": "Tindakan",
  "nce.admin.field.name": "Nama",
  "nce.admin.field.displayKey": "Display Key (untuk i18n)",
  "nce.admin.field.displayKey.helper": "Opsional. Digunakan untuk terjemahan.",
  "nce.admin.field.category": "Kategori",
  "nce.admin.delete.confirm.title": "Konfirmasi Penghapusan",
  "nce.admin.delete.confirm.message": "Apakah Anda yakin mau menghapus '{name}'? Aksi ini tidak dapat dibatalkan.",
  "nce.admin.delete.success": "Berhasil dihapus",
  "nce.inline.title": "Lapor Kejadian Ketidaksesuaian",
  "nce.inline.context": "KONTEKS (Auto-populated)",
  "nce.dashboard.title": "Semua KTS",
  "nce.dashboard.subtitle": "Semua KTS yang terbuka di semua instalasi",
  "nce.button.reportNce": "Lapor KTS",
  "nce.search.placeholder": "Cari KTS...",
  "nce.filter.allStatus": "Semua Status",
  "nce.filter.allCategories": "Semua Kategori",
  "nce.filter.allSeverities": "Semua Keparahan",
  "nce.filter.clearAll": "Hapus Semua",
  "nce.summary.critical": "Kritis",
  "nce.summary.major": "Major",
  "nce.summary.minor": "Minor",
  "nce.summary.overdue": "Lewat tenggat",
  "nce.tag.overdue": "Lewat tenggat",
  "nce.tab.eventDetails": "Rincian Kejadian",
  "nce.tab.investigation": "Investigasi",
  "nce.tab.capa": "CAPA",
  "nce.tab.history": "Riwayat",
  "nce.field.suspectedCauses": "Penyebab Diduga",
  "nce.field.proposedAction": "Tindakan Yang Diusulkan",
  "nce.field.trigger": "Trigger",
  "nce.capa.noItems": "Belum ada tindakan perbaikan/pencegahan yang terekam.",
  "nce.history.noItems": "Tidak ada riwayat tersedia.",
  "nce.history.system": "Sistem",
  "nce.action.acknowledge": "Mengetahui",
  "nce.action.assignTo": "Ditugaskan Ke",
  "nce.action.addNote": "Tambah Catatan",
  "nce.action.close": "Close NCE",
  "nce.action.startCorrectiveAction": "Start Corrective Action",
  "nce.link.duplicate.warning": "Spesimen ini sudah terkait ke KTS ini",
  "nce.list.empty": "Tidak ada KTS yang cocok dengan kriteria Anda.",
  "nce.modal.addNote": "Tambah Catatan",
  "nce.modal.addNoteDescription": "Tambah catatan ke KTS {nceNumber}",
  "nce.modal.notePlaceholder": "Masukkan catatatn Anda...",
  "nce.modal.assign": "Tugaskan KTS",
  "nce.modal.assignDescription": "Tugaskan KTS {nceNumber} ke pengguna",
  "nce.modal.selectUser": "Pilih Pengguna",
  "nce.modal.searchUser": "Cari pengguna...",
  "nce.assign.selectUser": "Pilih pengguna untuk menugaskan",
  "nce.assign.success": "KTS berhasil ditugaskan",
  "nce.assign.error": "Gagal menugaskan KTS",
  "nce.acknowledge.success": "KTS berhasil diketahui",
  "nce.acknowledge.error": "Gagal mengetahui KTS",
  "nce.note.empty": "SIlahkan masukan catatan",
  "nce.note.success": "Catatan berhasil ditambah",
  "nce.note.error": "Gagal menambah catatan",
  "nce.attachment.downloadError": "Gagal mengunduh lampiran",
  "nce.attachment.viewError": "Gagal melihat lampiran",
  "not.available": "Tidak tersedia",
  "not.specified": "Tidak dispesifikasi",
  "notAuthenticated": "Tidak diotentikasi",
  "notebook.attachments.title": "Lampiran",
  "notebook.attachments.uploadPrompt": "Klik untuk mengunggah file",
  "notebook.auditTrail.action.archived": "Diarsipkan",
  "notebook.auditTrail.action.created": "Dibuat",
  "notebook.auditTrail.action.finalized": "Difinalisasi",
  "notebook.auditTrail.action.locked": "Terkunci",
  "notebook.auditTrail.action.submitted": "Dikirim",
  "notebook.auditTrail.action.updated": "Terbarui",
  "notebook.auditTrail.comingSoon": "Fungsionalitas Jejak Audit akan segera tersedia.",
  "notebook.auditTrail.none.subtitle": "Entri Jejak Audit untuk Notebook ini tidak tersedia.",
  "notebook.auditTrail.none.title": "Jejak Audit tidak tersedia",
  "notebook.auditTrail.title": "Jejak Audit",
  "notebook.button.edit": "Edit",
  "notebook.button.editResults": "Edit Hasil",
  "notebook.button.enterResults": "Masukkan Hasil",
  "notebook.button.newLabNotebook": "Proyek",
  "notebook.button.view": "Lihat",
  "notebook.comments.add.button": "Tambah Komentar",
  "notebook.comments.add.label": "Tambah Komentar",
  "notebook.comments.none.subtitle": "Komentar belum ditambah.",
  "notebook.comments.none.title": "Belum ada komentar",
  "notebook.comments.title": "Komentar",
  "notebook.error.notAssigned": "Anda tidak ditugaskan pada proyek ini",
  "notebook.heading.allEntries": "Semua Entri",
  "notebook.heading.notebooks": "Proyek",
  "notebook.icon.edit": "Edit",
  "notebook.instruments.title": "Alat",
  "notebook.label.addpage": "Tambah Laman",
  "notebook.label.author": "Pengarang",
  "notebook.label.basicinfo": "Informasi Dasar",
  "notebook.label.content": "Isi Utama",
  "notebook.label.dashboard": "Dasbor Notebook",
  "notebook.label.drafts": "Draf",
  "notebook.label.entry": "Notebook Entry",
  "notebook.label.entryFiles": "File Entri",
  "notebook.label.instanceEntry": "Notebook Instance Entry",
  "notebook.label.entryTags": "Tag Entri",
  "notebook.label.experimentDoc": "Dokumen Eksperimen",
  "notebook.label.experimentType": "Jenis Eksperimen",
  "notebook.label.filter.types": "Jenis Eksperimen",
  "notebook.label.finalized": "Difinalkan minggu ini",
  "notebook.label.formEntry": "Entri Formulir Notebook",
  "notebook.label.objective": "Tujuan",
  "notebook.label.pages": "Halaman Alur Kerja",
  "notebook.label.pending": "Tinjauan Tertunda",
  "notebook.label.project": "Proyek",
  "notebook.label.project.title": "Judul Proyek",
  "notebook.label.projectFiles": "File Proyek",
  "notebook.label.projectTags": "Tag Proyek",
  "notebook.label.protocol": "Nomor Protokol",
  "notebook.label.questionnaire": "Kuesioner",
  "notebook.label.sampleManagement": "Pengelolaan Sampel",
  "notebook.label.status": "Status",
  "notebook.label.technician": "Petugas",
  "notebook.label.title": "Judul Entri",
  "notebook.label.total": "Entri Total",
  "notebook.page.completed": "Selesai",
  "notebook.page.content": "Isi:",
  "notebook.page.instructions": "Petunjuk:",
  "notebook.page.markComplete": "Tandai sebagai Selesai",
  "notebook.page.modal.add.errorRequired": "Judul dan isi diperlukan.",
  "notebook.page.modal.add.title": "Tambah Halaman Baru",
  "notebook.page.modal.content.label": "Isi",
  "notebook.page.modal.edit.title": "Edit Halaman",
  "notebook.page.modal.instructions.label": "Petunjuk",
  "notebook.page.modal.title.label": "Judul",
  "notebook.page.title": "Notebook",
  "notebook.pages.none.subtitle": "Klik untuk menambah Halaman",
  "notebook.pages.none.title": "Tidak ada Halaman yang ditambah",
  "notebook.project.definition.form.title": "Formulir Definisi Proyek",
  "notebook.project.entry.form.title": "Formulir Entri Proyek",
  "notebook.results.modal.title": "Hasil untuk {accession}",
  "notebook.results.noAccession": "Sampel ini tidak memiliki nomor registrasi",
  "notebook.results.none.subtitle": "Hasil tidak ditemukan untuk nomor registrasi yang diberikan.",
  "notebook.results.none.title": "Hasil tidak ditemukan",
  "notebook.results.title": "Hasil",
  "notebook.sample.result.dateCreated": "Tanggal dibuat",
  "notebook.samples.available": "Sampel yang tersedia",
  "notebook.samples.none.subtitle": "Pencarian Sampel berdasarkan Pasien atau Nomor Registrasi",
  "notebook.samples.none.subtitle.selected": "Klik untuk menambah sampel",
  "notebook.samples.none.title": "Tidak ada sampel yang tersedia",
  "notebook.samples.none.title.selected": "Tidak ada sampel yang dipilih",
  "notebook.samples.resultsRecorded": "Hasil yang terekam:",
  "notebook.samples.selected": "Sampel yang dipilih",
  "notebook.search.byAccession": "Cari berdasarkan Aksesi",
  "notebook.search.byPatient": "Cari berdasarkan Pasien",
  "notebook.select.label": "Pilih Notebook",
  "notebook.status.archived": "Entri arsip",
  "notebook.status.assignment.title": "Status dan Penugasan",
  "notebook.status.draft": "Simpan draf",
  "notebook.status.finalized": "Finalisasi Entri",
  "notebook.status.locked": "Kunci Entri",
  "notebook.status.metadata.title": "Status & Metadata",
  "notebook.status.submitted": "Kirim untuk Peninjauan",
  "notebook.tab.attachments": "Lampiran",
  "notebook.tab.auditTrail": "Jejak Audit",
  "notebook.tab.comments": "Komentar",
  "notebook.tab.content": "Isi",
  "notebook.tab.entryDetails": "Rincian Entri",
  "notebook.tab.metadata": "MetaData",
  "notebook.tab.results": "Hasil",
  "notebook.tab.samples": "Sampel",
  "notebook.tab.workflow": "Alur Kerja",
  "notebook.table.header.entries": "Entri",
  "notebook.tag.placeholder": "Masukkan Tag",
  "notebook.tags.add": "Tambah Tag",
  "notebook.tags.modal.add.errorRequired": "Tag diperlukan",
  "notebook.tags.modal.add.label": "Tag",
  "notebook.tags.modal.add.title": "Tambah Tag Baru",
  "notebook.tags.title": "Tag",
  "notebook.validation.content.required": "Isi Utama diperlukan.",
  "notebook.validation.objective.required": "Tujuan diperlukan.",
  "notebook.validation.project.required": "Proyek diperlukan.",
  "notebook.validation.protocol.required": "Nomor protokol diperlukan.",
  "notebook.validation.title.required": "Judul diperlukan.",
  "notebook.validation.type.required": "Jenis eksperimen diperlukan.",
  "notification.error": "Error",
  "notification.info": "Informasi",
  "notification.invalid.confirm.password": "Kata Kunci tidak sama dengan di atas.",
  "notification.invalid.loginName": "Masukkan nilai alfanumerik tanpa spasi.",
  "notification.invalid.name": "Hanya masukkan nilai alfanumerik.",
  "notification.invalid.password": "Masukkan Kata Kunci sesuai petunjuk.",
  "notification.login.generic.error": "Error saat login",
  "notification.login.syntax.error": "Terjadi error saat mencoba masuk - Tidak dapat mengurai respons ke JSON",
  "notification.organization.post.delete.success": "Organisasi berhasil dinonaktifkan.",
  "notification.organization.post.internetAddress": "Masukkan URL organisasi yang valid.",
  "notification.organization.post.save.success": "Penambahan Informasi Organisasi Berhasil.",
  "notification.organization.post.success": "Pembaruan Informasi Organisasi Berhasil.",
  "notification.password.change.fail": "Perubahan Kata Kunci gagal",
  "notification.password.change.success": "Kata Kunci berhasil diubah",
  "notification.response.syntax.error": "Error -  Tidak dapat mengurai respon ke JSON",
  "notification.slideover.button.hideread": "Sembunyikan dibaca",
  "notification.slideover.button.markallasread": "Tandai semua sebagai dibaca",
  "notification.slideover.button.markasread": "Tandai sebagai dibaca",
  "notification.slideover.button.reload": "Muat ulang",
  "notification.slideover.button.showread": "Tampilkan dibaca",
  "notification.slideover.button.subscribe": "Berlangganan di Perangkat ini",
  "notification.slideover.button.subscribe.fail": "Berlangganan gagal",
  "notification.slideover.button.subscribe.success": "Berlangganan berhasil",
  "notification.slideover.button.unsubscribe": "Berhenti berlangganan",
  "notification.slideover.button.unsubscribe.fail": "Berhenti berlangganan gagal",
  "notification.slideover.button.unsubscribe.success": "Berhenti berlangganan berhasil",
  "notification.slideover.empty.header": "Semua sudah dibaca",
  "notification.sliderover.empty.message": "Tidak ada notifikasi saat ini",
  "notification.title": "Pesan notifikasi",
  "notification.user.post.delete.success": "Penguna berhasil dinonaktifkan.",
  "notification.user.post.save.success": "Informasi Pengguna berhasil ditambah.",
  "notify.error": "Pengguna dan Pesan diperlukan",
  "notify.main.title": "Beri tahu Pengguna",
  "notify.message": "Pesan",
  "notify.user.by": "Pengguna yang akan dinotifikasi",
  "notify.user.success.notification": "Notifikasi berhasil terkirim",
  "of": "dari",
  "openreports.activity.title": "Laporan Kegiatan",
  "openreports.aggregate.title": "Laporan Agregat",
  "openreports.all.test.summary.title": "Ringkasan Laporan Pemeriksaan",
  "openreports.all.tests.aggregate": "Ringkasan Semua Pemeriksaan",
  "openreports.hiv.aggregate": "Ringkasan Pemeriksaan HIV",
  "openreports.management.title": "Laporan Manajemen",
  "openreports.mgt.nonconformity.date": "Laporan Ketidaksesuaian berdasarkan Tanggal",
  "openreports.mgt.nonconformity.section": "Laporan Ketidaksesuaian berdasarkan Unit dan Alasan",
  "openreports.mgt.rejection": "Laporan Penolakan",
  "openreports.patient.EID.version1": "EID Versi 1",
  "openreports.patient.EID.version2": "EID Versi 2",
  "openreports.patient.VL.version1": "VL Versi Nasional",
  "openreports.patientTestStatus": "Laporan Status Pasien",
  "openreports.patientreports.title": "Laporan Status Pasien",
  "openreports.stat.aggregate": "Laporan Statistik",
  "order.accept": "Terima",
  "order.accept.error": "Gagal menerima pemesanan",
  "order.additionalInfo": "Informasi Tambahan",
  "order.additionalInfo.helper": "Catatan opsional tentang pemesanan ini",
  "order.clinicalInfo": "Informasi Klinis",
  "order.continue": "Lanjut",
  "order.current.time": "Waktu sekarang (hh:mm)",
  "order.dashboard.empty": "Pemesanan tidak ditemukan",
  "order.dashboard.title": "Dasbor Pemesanan",
  "order.department.label": "ruang/departemen/unit:",
  "order.diagnosis.helper": "Working diagnosis — guides test selection. Not recorded as a confirmed diagnosis.",
  "order.diagnosis.placeholder": "Masukkan diagnosis atau catatan klinis",
  "order.entry.setup": "Pengaturan Entri Permintaan Batch",
  "order.external": "Eksternal",
  "order.facility": "Lembaga",
  "order.filter.priority": "Filter berdasarkan Prioritas",
  "order.filter.status": "Filter berdasarkan Status",
  "order.fixIssue": "Perbaiki Masalah",
  "order.form.label": "Formulir:",
  "order.form.select": "Pilih Formulir",
  "order.generate.barcode": "Buat Kode QR dan Simpan",
  "order.generate.barcode.history": "Nomor Registrasi yang digunakan sebelumnya",
  "order.if.other.label": "Lainnya, jelaskan:",
  "order.invalid.requester.name.label": "nama pemohon tidak valid",
  "order.invalid.site.name": "Nama tempat tidak valid",
  "order.labNumber": "Nomor Registrasi",
  "order.labNumber.generate": "Membuat Nomor Registrasi",
  "order.labNumber.helper": "Pengidentifikasi unik untuk pemesanan ini",
  "order.attachment.action.delete": "Hapus lampiran",
  "order.attachment.action.download": "Unduh lampiran",
  "order.attachment.action.view": "Lihat lampiran",
  "order.attachment.column.actions": "Aksi",
  "order.attachment.column.fileName": "Nama File",
  "order.attachment.column.fileSize": "Ukuran",
  "order.attachment.column.fileType": "Jenis",
  "order.attachment.column.uploadedAt": "Waktu diunggah",
  "order.attachment.delete.confirm.body": "Apakah Anda yakin mau menghapus \"{fileName}\"? Ini tidak dapat dibatalkan.",
  "order.attachment.delete.confirm.title": "Hapus lampiran",
  "order.attachment.delete.failed": "Tidak dapat menghapus lampiran. Silahkan coba lagi.",
  "order.attachment.dropzone": "Tarik dan lepaskan file disini atau klik untuk mencari",
  "order.attachment.empty": "Belum ada lampiran",
  "order.attachment.error.maxFiles": "Anda dapat melampirkan maks {maxFiles} file.",
  "order.attachment.error.size": "Setiap file tidak lebih dari {maxSize}.",
  "order.attachment.error.type": "Jenis file yang didukung: {types}",
  "order.attachment.heading": "Lampiran",
  "order.attachment.hint": "Opsional. Sampai dengan {maxFiles} file, masing-masing 10MB. Mendukung: PDF, JPG, PNG, TIFF.",
  "order.attachment.upload.failed": "Satu atau lebih lampiran tidak dapat diunggah.",
  "order.labNumber.placeholder": "Masukkan atau buat nomor registrasi",
  "order.label.add": "Tambah Permintaan",
  "order.label.modify": "Modifikasi Permintaan",
  "order.legend.EDTATube": "Tabung EDTA",
  "order.legend.commonFields": "Field Umum",
  "order.legend.configureBarcode": "Konfigurasi Entri Kode QR",
  "order.legend.dryBloodSpot": "Dry Blood Spot",
  "order.legend.dryTube": "Tabung kering",
  "order.legend.facility": "Lembaga",
  "order.legend.onDemand": "Sesuai permintaan",
  "order.legend.optionalFields": "Field opsional",
  "order.legend.patient": "Informasi Pasien",
  "order.legend.preDemand": "Pra-cetak",
  "order.legend.sample": "Sampel",
  "order.legend.selectMethod": "Pilih Metode",
  "order.legend.siteName": "Nama Tempat",
  "order.legend.specimen.collected": "Spesimen diambil",
  "order.legend.tests": "Pemeriksaan",
  "order.legend.viralLoadTest": "Pemeriksaan Viral Load",
  "order.lastUpdated": "Pembaruan Terakhir",
  "order.load.error": "Gagal memuat pemesanan",
  "order.location": "Lokasi",
  "order.new": "Pemesanan Baru",
  "order.payment.status.label": "Status pembayaran pasien:",
  "order.paymentStatus": "Status Pembayaran",
  "order.previousLabNumber": "Nomor Registrasi sebelumnya",
  "order.previousLabNumber.placeholder": "Masukkan nomor registrasi sebelumnya jika ada",
  "order.printLabels": "Cetak Label",
  "order.printLabels.info": "Cetak Kode QR untuk pemesanan ini",
  "order.priority": "Prioritas",
  "order.progress": "Progress",
  "order.provisionalDiagnosis": "Diagnosis Sementara",
  "order.received.time": "Waktu datang (hh:mm)",
  "order.reception.time": "Waktu diterima (hh:mm)",
  "order.remember.site.and.requester.label": "Ingat tempat dan pemohon",
  "order.readonly.message": "Pemesanan ini dalam mode read-only",
  "order.requester": "Pemohon",
  "order.requester.email.label": "Email Pemohon:",
  "order.requester.fax.label": "Nomor Faks Pemohon:",
  "order.requester.firstName.label": "NamaDepan Pemohon:",
  "order.requester.lastName.label": "NamaBelakang Pemohon:",
  "order.requester.phone.label": "Nomor telepon Pemohon:",
  "order.requester.provisionalDiagnosis.label": "Diagnosis Klinis Sementara:",
  "order.result.reporting.heading": "PELAPORAN HASIL",
  "order.sampleCategory": "Kategori Sampel",
  "order.sampleCategory.helper": "Pilih kategori sampel untuk pengambilan",
  "order.sampling.performed.label": "Pengambilan sampel yang dilakukan untuk analisis:",
  "order.search.requester.label": "Cari Pemohon",
  "order.saveStatus.error": "Penyimpanan gagal",
  "order.saveStatus.saved": "Disimpan",
  "order.saveStatus.saving": "Menyimpan...",
  "order.saveStatus.unsaved": "Perubahan tidak tersimpan",
  "order.save.incomplete": "Mohon tambah pasien (atau tempat pengambilan sampel) dan setidaknya satu jenis sampel sebelum menyimpan.",
  "order.saved.draft": "Draf disimpan",
  "order.search.placeholder": "Cari pemesanan...",
  "order.search.site.name": "Cari Nama Tempat",
  "order.send.toAnalyzer": "Kirim ke alat",
  "order.send.modal.title": "Kirim pemesanan ke alat",
  "order.send.modal.confirm": "Kirim",
  "order.send.modal.cancel": "Batal",
  "order.send.modal.analyzerLabel": "Alat yang Dituju",
  "order.send.modal.accession": "Nomor registrasi pemesanan: {accession}",
  "order.send.modal.noAnalyzers": "Tidak ada alat yang dikonfigurasi untuk pengiriman dari SIL.",
  "order.send.success": "Pemesanan dikirim",
  "order.send.error": "Gagal mengirim pemesanan",
  "order.send.unknownError": "Kesalahan bridge tidak diketahui",
  "order.send.missingAccession": "Pemesanan tidak memiliki nomor registrasi yang terkait hasil",
  "order.site.name": "Nama tempat:",
  "order.step.collect": "Pengambilan",
  "order.step.complete": "Selesai",
  "order.step.enter": "Masukkan Pemesanan",
  "order.step.label": "Label & Simpan",
  "order.step.patient.info": "Informasi Pasien",
  "order.step.program.selection": "Pilihan Program",
  "order.step.qa": "Tinjauan QA",
  "order.start.new": "Mulai Pemesanan Baru",
  "order.submit.labNumber": "Kirim dengan Nomor Registrasi",
  "order.submit.success": "Pemesanan berhasil dikirim",
  "order.submitted.success.msg": "Pemesanan berhasil dikirim",
  "order.summary.accessionNumber": "Nomor Registrasi",
  "order.summary.collectionDate": "Tanggal Pengambilan",
  "order.summary.patientName": "Nama Pasien",
  "order.summary.sampleType": "Jenis Sampel",
  "order.summary.title": "Ringkasan Pemesanan",
  "order.test.request.heading": "Permintaan Pemeriksaan",
  "order.title": "PERMINTAAN",
  "ordertests.title": "Permintaan Pemeriksaan",
  "organization.add.placeholder": "Nilai alfanumerik",
  "organization.add.placeholder.active": "Ya atau Tidak",
  "organization.add.placeholder.internetAddress": "https://orgname.com",
  "organization.add.placeholder.parent": "Organisasi Induk",
  "organization.add.title": "Tambah Organisasi",
  "organization.city": "Kota",
  "organization.clia.number": "Nomor CLIA",
  "organization.edit.title": "Edit Organisasi",
  "organization.internetaddress": "Website",
  "organization.isActive": "Status Aktif",
  "organization.main.title": "Pengelolaan Organisasi",
  "organization.next": "Halaman Berikutnya",
  "organization.organizationName": "Nama Organisasi",
  "organization.parent": "Induk Organisasi",
  "organization.previous": "Halaman sebelumnya",
  "organization.search.byorgname": "Cari berdasarkan Nama Organisasi",
  "organization.search.parent.name": "Nama Organisasi Induk",
  "organization.search.placeHolder": "Cari berdasarkan Nama Organisasi...",
  "organization.select": "Pilih",
  "organization.short.CI": "Prefiks Organisasi",
  "organization.streetAddress": "Nama Jalan",
  "organization.type.CI": "Jenis Kegiatan",
  "organization.type.CI.description": "Jenis Kegiatan: Deskripsi",
  "organization.type.CI.name": "Jenis Kegiatan: Nama",
  "organization.type.CI.select": "Jenis Kegiatan: Pilih",
  "otherMalignant.placeholder": "Keganasan lainnya",
  "page.breadcrumb.separator": " > ",
  "page.title.back": "Kembali",
  "pagination.backward": "Halaman Sebelumnya",
  "pagination.forward": "Halaman Berikutnya",
  "pagination.item": "{min}-{max}",
  "pagination.item-range": "{min}-{max} dari {total} barang",
  "pagination.items-per-page": "Item per halaman",
  "pagination.itemsPerPage": "Item per halaman:",
  "pagination.nextPage": "Halaman berikutnya",
  "pagination.page": "Halaman {page}",
  "pagination.page-number": "Nomor Halaman",
  "pagination.page-range": "dari {total} {total, plural, one {page} other {pages}}",
  "pagination.previousPage": "Halaman sebelumnya",
  "panel.existing": "Panel yang ada",
  "panel.existing.inactive": "Panel Inaktif (tugaskan pemeriksaan untuk mengaktifkan)",
  "panel.new": "Panel Baru",
  "panel.panelName": "Nama Panel",
  "pathology.label.addblock": "Tambah Blok",
  "pathology.label.addslide": "Tambah Slide",
  "pathology.label.block": "Blok",
  "pathology.label.block.add.number": "Jumlah Blok untuk ditambah",
  "pathology.label.block.number": "Nomor Blok",
  "pathology.label.blocks": "Blok",
  "pathology.label.casesInProgress": "Kasus dalam Pengerjaan",
  "pathology.label.complete": "Selesai",
  "pathology.label.conclusion": "Kesimpulan",
  "pathology.label.dashboard": "Dasbor Patologi",
  "pathology.label.grossexam": "Pemeriksaan Umum",
  "pathology.label.location": "Lokasi",
  "pathology.label.microexam": "Pemeriksaan Mikroskopis",
  "pathology.label.printlabel": "Cetak Label",
  "pathology.label.refer": "Rujuk ke Imunohistokimia",
  "pathology.label.release": "Siap untuk dirilis",
  "pathology.label.report": "Laporan Patologi",
  "pathology.label.request": "Permintaan",
  "pathology.label.requests": "Permintaan Patologi Tambahan",
  "pathology.label.review": "Menunggu Tinjauan Patologi",
  "pathology.label.slide": "Slide",
  "pathology.label.slide.add.number": "Jumlah Slide untuk ditambah",
  "pathology.label.slide.number": "Nomor Slide",
  "pathology.label.slides": "Slide",
  "pathology.label.stage": "Tahapan",
  "pathology.label.techniques": "Teknik yang digunakan",
  "pathology.label.textconclusion": "Teks kesimpulan",
  "pathology.label.title": "Patologi",
  "pathology.label.view": "Lihat File",
  "patient.address.camp": "Kelompok/Komunitas",
  "patient.address.fokontany": "Fokontany",
  "patient.address.hamletOrLot": "Hamlet / Lot",
  "patient.address.healthdistrict": "Kabupaten",
  "patient.address.healthregion": "Kecamatan",
  "patient.address.province": "Propinsi",
  "patient.address.street": "Jalan",
  "patient.address.town": "Kota",
  "patient.age.days": "Hari",
  "patient.age.months": "Bulan",
  "patient.age.years": "Umur/Tahun",
  "patient.alias": "Alias",
  "patient.dataSourceName": "Nama Sumber Data",
  "patient.dob": "Tanggal Lahir",
  "patient.eduction": "Pendidikan",
  "patient.emergency.additional.camp": "Masukkan Kelompok/Komunitas",
  "patient.emergency.additional.district": "Masukkan Kabupaten",
  "patient.emergency.additional.education": "Masukkan Pendidikan",
  "patient.emergency.additional.maritalstatus": "Masukkan Status Pernikahan",
  "patient.emergency.additional.nationnality": "Masukkan Kewarganegaraan",
  "patient.emergency.additional.othernationality": "Masukkan Kewarganegaraan Lain",
  "patient.emergency.additional.region": "Masukkan Daerah",
  "patient.emergency.additional.street": "Masukkan Nama Jalan",
  "patient.emergency.additional.town": "Masukkan Kota",
  "patient.emergency.email": "Masukkan Email Kontak Darurat",
  "patient.emergency.firstname": "Masukkan Nama Depan Kontak Darurat",
  "patient.emergency.lastname": "Masukkan Nama Belakang Kontak Darurat",
  "patient.emergency.phone": "Masukkan Nomor Telepon Kontak Darurat",
  "patient.externalId": "Identitas eksternal",
  "patient.female": "Perempuan",
  "patient.first.name": "Nama Depan",
  "patient.gender": "Jenis Kelamin",
  "patient.gps.latitude": "Garis Lintang GPS",
  "patient.gps.latitude.placeholder": "mis., -18.879190 (rentang -90 sampai 90)",
  "patient.gps.longitude": "Garis bujur GPS",
  "patient.gps.longitude.placeholder": "mis., 47.507905 (rentang -180 sampai 180)",
  "patient.id": "Identitas Pasien",
  "patient.information.age": "Masukkan Umur",
  "patient.information.days": "Masukkan Hari",
  "patient.information.email": "Masukkan Email Pasien",
  "patient.information.firstname": "Masukkan Nama Depan Pasien",
  "patient.information.healthid": "Masukkan Pengidentifikasi Kesehatan Unik",
  "patient.information.lastname": "Masukkan Nama Belakang Pasien",
  "patient.information.months": "Masukkan Bulan",
  "patient.information.nationalid": "Masukkan NIK",
  "patient.information.primaryphone": "Masukkan Nomor Utama Pasien",
  "patient.label": "Pasien",
  "patient.label.additionalInfo": "Informasi Tambahan",
  "patient.label.age": "Umur",
  "patient.label.customNotes": "Catatan Kostum",
  "patient.label.diseaseProgramme": "Program Penyakit Target",
  "patient.label.occupation": "Pekerjaan",
  "patient.label.contactphone": "Nomor Telepon Kontak:{PHONE_FORMAT}",
  "patient.label.email": "Email",
  "patient.label.info": "Informasi Pasien",
  "patient.label.modify": "Tambah atau Modifikasi Pasien",
  "patient.label.name": "Nama",
  "patient.label.nopatientid": "Informasi Pasien Tidak Tersedia",
  "patient.label.primaryphone": "Nomor Telepon Utama:{PHONE_FORMAT}",
  "patient.label.sex": "Jenis Kelamin",
  "patient.last.name": "Nama Belakang",
  "phone.format.international.label": "Internasional",
  "phone.format.local.label": "Lokal",
  "patient.male": "Laki-Laki",
  "patient.maritalstatus": "Status Pernikahan",
  "patient.merge.activeOrders": "Permintaan Aktif",
  "patient.merge.address": "Alamat",
  "patient.merge.addressesDiffer": "Alamat berbeda: {primary} vs {secondary}",
  "patient.merge.auditEntries": "Audit Entri (menyimpan data pasien asli)",
  "patient.merge.back": "Kembali",
  "patient.merge.cancelButton": "Batal",
  "patient.merge.clinicalSummary": "Ringkasan Klinis",
  "patient.merge.confirmButton": "Konfrimasi Penggabungan",
  "patient.merge.confirmCheckbox": "Saya memahami bahwa aksi ini tidak dapat dibatalkan dan telah memverifikasi bahwa pasien yang benar sedang digabungkan.",
  "patient.merge.confirmMerge": "Konfirmasi Penggabungan Pasien",
  "patient.merge.conflictNote": "(Demografi pasien primer akan digunakan)",
  "patient.merge.conflictingInfo": "Konflik Informasi terdeteksi",
  "patient.merge.contactInfo": "Informasi Kontak",
  "patient.merge.county": "Provinsi",
  "patient.merge.dataToConsolidate": "Data yang akan Dikonsolidasi",
  "patient.merge.demographics": "Demografi",
  "patient.merge.dob": "Tanggal lahir",
  "patient.merge.email": "Email",
  "patient.merge.emailsDiffer": "Email berbeda: {primary} vs {secondary}",
  "patient.merge.error.alreadyMerged": "Pasien sudah tergabung",
  "patient.merge.error.executionFailed": "Eksekusi penggabungan gagal",
  "patient.merge.error.noPermission": "Hanya Administrator Global yang dapat melakukan penggabungan pasien",
  "patient.merge.error.patientNotFound": "Pasien tidak ditemukan",
  "patient.merge.error.samePatient": "Tidak dapat menggabung pasien yang sama",
  "patient.merge.error.selectBoth": "Pilih kedua pasien untuk melanjutkan",
  "patient.merge.error.selectPrimary": "Pilih pasien yang akan menjadi rekaman primer",
  "patient.merge.error.validationFailed": "Validasi penggabungan gagal",
  "patient.merge.externalIds": "Identitas Eksternal",
  "patient.merge.gender": "Jenis Kelamin",
  "patient.merge.identifiers": "Pengidentifikasi",
  "patient.merge.identifiersToPreserve": "Pengidentifikasi yang Perlu Disimpan (semua pasien)",
  "patient.merge.mergeSummary": "Ringkasan Penggabungan",
  "patient.merge.mergingFrom": "Penggabungan Dari",
  "patient.merge.mergingLabel": "Menggabungkan",
  "patient.merge.name": "Nama",
  "patient.merge.nationalId": "NIK",
  "patient.merge.nationalIds": "NIK",
  "patient.merge.nextStep": "Langkah Berikutnya",
  "patient.merge.noIdentifiers": "Pengidentifikasi tidak ditemukan",
  "patient.merge.noPatientSelected": "Tidak ada Pasien yang dipilih",
  "patient.merge.notRecorded": "Tidak terekam",
  "patient.merge.orders": "Permintaan",
  "patient.merge.ordersCount": "{count} ({active} aktif)",
  "patient.merge.patientId": "Nomor Identitas Pasien",
  "patient.merge.patientIds": "Nomor Identitas Pasien",
  "patient.merge.patientResults": "Hasil Pasien",
  "patient.merge.phone": "Telepon",
  "patient.merge.phonesDiffer": "Nomor Telepon berbeda: {primary} vs {secondary}",
  "patient.merge.postalCode": "Kode Pos",
  "patient.merge.primaryLabel": "Primer",
  "patient.merge.primaryPatient": "Pasien Primer",
  "patient.merge.reason": "Alasan penggabungan (wajib)",
  "patient.merge.reasonPlaceholder": "Masukan alasan penggabungan rekaman pasien",
  "patient.merge.recordsReassigned": "{count} rekaman yang ditugaskan",
  "patient.merge.samples": "Sampel",
  "patient.merge.searchDifferent": "Cari pasien yang berbeda",
  "patient.merge.selectFirstPatient": "Pilih Pasien Pertama",
  "patient.merge.selectPrimaryDescription": "Pasien yang mana akan menjadi rekaman primer?",
  "patient.merge.selectPrimaryRecord": "Pilih Rekaman Pasien Primer",
  "patient.merge.selectSecondPatient": "Pilih Pasien Kedua",
  "patient.merge.step.compare": "Pilih Primer",
  "patient.merge.step.confirm": "Konfirmasi Penggabungan",
  "patient.merge.step.select": "Pilih Pasien",
  "patient.merge.streetAddress": "Nama Jalan",
  "patient.merge.success": "Penggabungan pasien sukses",
  "patient.merge.successMessage": "Pasien {mergedId} telah digabungkan dengan pasien {primaryId}. Audit ID: {auditId}",
  "patient.merge.testResults": "Hasil Pemeriksaan",
  "patient.merge.title": "Gabung Rekaman Pasien",
  "patient.merge.totalContacts": "Kontak",
  "patient.merge.totalRelations": "Hubungan",
  "patient.merge.totalResults": "Hasil Total",
  "patient.merge.totalSamples": "Sampel",
  "patient.merge.town": "Kabupaten/Kota",
  "patient.merge.tryDifferentSearch": "Atur kriteria pencarian atau gunakan pengidentifikasi pasien yang lain.",
  "patient.merge.warning.dataLink": "Semua data berikutnya akan terkait dengan pasien primer. Pasien yang tidak dipilih akan ditandai sebagai penggabungan dan inaktif.",
  "patient.merge.warning.irreversible": "Aksi ini TIDAK BISA dibatalkan. Semua data akan dikonsolidasi permanen.",
  "patient.merge.warning.samePatient": "Pasien yang sama telah dipilih",
  "patient.merge.warning.samePatientDescription": "Anda telah memilih pasien yang sama. Silahkan pilih dua pasien yang berbeda untuk digabunngkan.",
  "patient.natioanalid": "NIK",
  "patient.nationalid": "NIK",
  "patient.nationality": "Kewarganegaraan",
  "patient.nationality.other": "Tuliskan Kewarganegaraan lainnya",
  "patient.photo.active.camera": "Klik untuk mengaktifkan kamera",
  "patient.photo.add": "Tambah Foto",
  "patient.photo.browse": "Klik untuk mencari file",
  "patient.photo.camera.permission.denied": "Izin akses kamera ditolak. Silakan periksa pengaturan browser Anda.",
  "patient.photo.cancel": "Batal",
  "patient.photo.capture": "Ambil Foto",
  "patient.photo.captured": "Foto yang diambil:",
  "patient.photo.change": "Ganti Gambar",
  "patient.photo.confirm": "Konfirmasi",
  "patient.photo.dragndrop": "Seret dan lepas gambar di sini",
  "patient.photo.error.fileTooLarge": "Gambar terlalu besar. Ukuran maksimum 2 MB.",
  "patient.photo.formats": "Format: JPG, PNG (maks 1MB)",
  "patient.photo.import": "Impor",
  "patient.photo.label": "Foto Pasien",
  "patient.photo.modal.heading": "Pilih Foto Pasien",
  "patient.photo.modal.options": "Opsi Pilihan Gambar",
  "patient.photo.preview": "Pratinjau:",
  "patient.photo.preview.alt": "Pratinjau Foto Pasien",
  "patient.photo.preview.captured.alt": "Foto pasien yang diambil",
  "patient.photo.retake": "Pengambilan ulang",
  "patient.photo.start.camera": "Buka Kamera",
  "patient.photo.take": "Ambil Foto",
  "patient.photo.view": "Lihat Foto",
  "patient.idDoc.title": "Dokumen Identitas",
  "patient.idDoc.addDocument": "Tambah Dokumen",
  "patient.idDoc.selectImage": "Pilih Gambar",
  "patient.idDoc.documentType": "Jenis Dokumen",
  "patient.idDoc.description": "Deskripsi",
  "patient.idDoc.description.placeholder": "Masukkan deskripsi dokumen",
  "patient.idDoc.category.nationalId": "NIK",
  "patient.idDoc.category.insuranceCard": "Kartu Asuransi",
  "patient.idDoc.category.other": "Lainnya",
  "patient.idDoc.view": "Lihat",
  "patient.idDoc.edit": "Edit",
  "patient.idDoc.delete": "Hapus",
  "patient.idDoc.remove": "Hapus",
  "patient.idDoc.pending": "Tidak tersimpan",
  "patient.idDoc.empty": "Tidak ada dokumen identitas diunggah",
  "patient.idDoc.viewDocument": "Lihat Dokumen",
  "patient.idDoc.editDocument": "Edit Dokumen",
  "patient.idDoc.confirmDelete": "Hapus Dokumen",
  "patient.idDoc.deleteWarning": "Apakah Anda yakin akan menghapus dokumen ini? Aksi ini tidak dapat dibatalkan.",
  "patient.idDoc.upload": "Unggah",
  "patient.idDoc.dragndrop": "Seret dan lepas gambar di sini",
  "patient.idDoc.browse": "atau klik untuk mencari file",
  "patient.idDoc.formats": "Format: JPEG, PNG, PDF (maks 10MB)",
  "patient.idDoc.useCamera": "Buka Kamera",
  "patient.idDoc.pdfSelected": "Dokumen PDF dipilih",
  "patient.idDoc.error.invalidFormat": "Format file invalid. Format yang didukung: JPEG, PNG, PDF.",
  "patient.idDoc.error.fileTooLarge": "File terlalu besar. Ukuran maksimum 10MB.",
  "patient.prev.lab.no": "Nomor Registrasi sebelumnya",
  "patient.report.associated.name": "Laporan Pasien Lainnya",
  "patient.report.collection.name": "Kumpulan Laporan Pasien ARV",
  "patient.search.nopatient": "Pasien yang dicari tidak ditemukan",
  "patient.st.number": "Nomor ST",
  "patient.subject.number": "Nomor Pengidentifikasi Kesehatan Unik",
  "patient.yrs": "yrs",
  "patientcontact.person.email": "Email Kontak",
  "patientcontact.person.firstname": "Nama Depan Kontak",
  "patientcontact.person.lastname": "Nama Belakang Kontak",
  "placeholder.accession.number": "Masukkan Nomor Registrasi",
  "plugin.files": "File Plugin",
  "plugin.name": "Nama Plugin",
  "print.barcode": "Cetak Kode QR",
  "process.testAdd.pressNext.ageRangeSelectiong": "Tekan tombol Berikutnya. Pemilihan Rentang Usia tidak diperlukan!",
  "process.testAdd.pressNext.selectGroupDictionary": "Tekan tombol Berikutnya. Langkah Memilih Grup Daftar Kamus tidak diperlukan!",
  "program.name.label": "Nama Program",
  "program.name.code": "Kode Program",
  "project.ARVFollowupStudy.name": "Tindak lanjut ARV",
  "project.ARVStudies.name": "ARV",
  "project.ARVStudy.name": "ARV Awal",
  "project.EIDStudy.name": "EID",
  "project.IndeterminateStudy.name": "Indeterminate",
  "project.RTNStudy.name": "RTN",
  "project.Recency.name": "Pemeriksaan Terkini",
  "project.SequencingStudy.name": "Sekuensing",
  "project.SpecialRequestStudy.name": "Permintaan Khusus",
  "project.VLStudy.name": "VL",
  "project.add.subtitle": "Tambah Proyek",
  "project.add.title": "Tambah Proyek",
  "project.browse.title": "Proyek",
  "project.completedDate": "Tanggal Selesai",
  "project.desc.short": "Deksripsi Proyek",
  "project.description": "Deskripsi Proyek",
  "project.edit.subtitle": "Edit Proyek",
  "project.edit.title": "Edit Proyek",
  "project.external.reference": "Rujukan Eksternal",
  "provider.browse.title": "Pengelolaan Penyelenggara",
  "provider.email": "Email",
  "provider.fax": "No. Telp",
  "provider.isActive": "Adalah Aktif",
  "provider.modal.add.heading": "Tambah Penyelenggara",
  "provider.modal.update.heading": "Perbarui Penyelenggara",
  "provider.providerFirstName": "Nama Depan Penyelenggara",
  "provider.providerLastName": "Nama Belakang Penyelenggara",
  "provider.search": "Cari Penyelenggara",
  "provider.search.placeholder": "Cari Nama Penyelenggara...",
  "provider.select": "Pilih Penyelenggara",
  "provider.telephone": "Nomor Telepon",
  "qa.checklist.incomplete": "Daftar centang QA tidak lengkap",
  "qa.checklist.instructions": "Selesaikan semua centang yang diperlukan sebelum mengirim",
  "qa.checklist.samplingSiteCorrect": "Informasi tempat pengambilan sampel sudah benar",
  "qa.checklist.title": "Daftar centang QA",
  "qa.summary.noSamples": "Tidak ada sampel untuk ditinjau",
  "qa.summary.noTests": "Tidak ada pengujian yang dipilih",
  "qa.summary.order": "Rincian Pemesanan",
  "qa.summary.panel": "Panel",
  "qa.summary.patient": "Informasi Pasien",
  "qa.summary.poolOf": "Pool of {count} {animal}",
  "qa.summary.samples": "Ringkasan Sampel",
  "qa.summary.samplingSite": "Tempat Pengambilan Sampel",
  "qa.summary.siteCode": "Kode Tempat",
  "qa.summary.siteName": "Nama Tempat",
  "qc.comments.add": "Tambah Komentar",
  "qc.comments.empty": "Belum ada komentar",
  "qc.comments.placeholder": "Masukkan komentar QC...",
  "qc.comments.title": "Komentar QC",
  "qc.expectedValue": "Expected Value",
  "qc.frequency.compliance": "Metrik Kepatuhan",
  "qc.frequency.config": "Konfigurasi Frekuensi QC",
  "qc.frequency.daily": "Startup Harian",
  "qc.frequency.everyHours": "Setiap N Jam",
  "qc.frequency.everySamples": "Setiap N Sampel",
  "qc.frequency.manual": "Hanya Trigger Manual",
  "qc.frequency.notConfigured": "Tidak dikonfigurasi",
  "qc.frequency.perShift": "Per Shift",
  "qc.frequency.save": "SImpan Konfigurasi",
  "qc.frequency.type": "Jenis Frekuensi",
  "qc.frequency.value": "Nilai Frekuensi",
  "qc.leveyJennings.mean": "Mean",
  "qc.leveyJennings.minus2SD": "-2 SD",
  "qc.leveyJennings.minus3SD": "-3 SD",
  "qc.leveyJennings.noData": "Tidak ada QC data tersedia",
  "qc.leveyJennings.plus2SD": "+2 SD",
  "qc.leveyJennings.plus3SD": "+3 SD",
  "qc.leveyJennings.title": "Levey-Jennings Control Chart",
  "qc.notes": "Catatan QC",
  "qc.notes.placeholder": "Masukkan catatan dan pengamatan QC",
  "qc.parentSample": "Sampel Induk",
  "qc.signature.comment": "Komentar (opsional)",
  "qc.signature.comment.placeholder": "Tambah komentar...",
  "qc.signature.ipAddress": "Alamat IP",
  "qc.signature.noSignatures": "Belum ada tanda tangan",
  "qc.signature.sign": "Tanda tangan Laporan",
  "qc.signature.signedAt": "Waktu Tanda Tangan",
  "qc.signature.success": "Laporan berhasil ditandatangani",
  "qc.signature.title": "Tanda Tangan Elektronik",
  "qc.signature.userId": "ID Pengguna",
  "qc.status": "Status QC",
  "qc.status.failed": "Gagal",
  "qc.status.notRequired": "Tidak Wajib",
  "qc.status.passed": "Lolos",
  "qc.status.pending": "QC tertunda",
  "qc.status.select": "Pilih Status QC",
  "qc.status.update.button": "Perbarui Status QC",
  "qc.status.update.success": "Status QC berhasil diperbarui",
  "qc.status.update.title": "Perbarui Status QC",
  "qc.status.warning.message": "Lot ini tidak dapat digunakan bila ditandai \"Gagal\", sampai status QC diperbarui.",
  "qc.status.warning.title": "Peringatan Kegagalan QC",
  "qc.westgard.noViolations": "Tidak ada pelanggaran terdeteksi",
  "qc.westgard.rule.disabled": "Dinonaktifkan",
  "qc.westgard.rule.enabled": "Diaktifkan",
  "qc.westgard.rules": "Westgard Rule",
  "qc.westgard.rules.description": "Konfigurasi evaluasi QC Westgard multi-rule",
  "qc.westgard.violations": "Pelanggaran",
  "quantity": "Kuantitas",
  "quantity.balanced": "Kuantitas Seimbang",
  "quantity.not.balanced": "Kuantitas tidak seimbang",
  "quick.entry.accession.number": "Nomor Registrasi",
  "referTest.referralLabel": "Rujuk Pemeriksaan ke lab rujukan",
  "referral.button.labSearch": "Cari Rujukan dengan Nomor Registrasi",
  "referral.button.patientSearch": "Cari Pasien",
  "referral.button.unitTestSearch": "Cari Rujukan Berdasarkan Instalasi Lab & Pemeriksaan",
  "referral.date.end": "Tanggal Selesai (dd/mm/yyyy)",
  "referral.date.start": "Tanggal Dimulai (dd/mm/yyyy)",
  "referral.emptyState": "No referrals found for the selected filters.",
  "referral.error": "Tidak ada Rujukan yang cocok dengan kriteria",
  "referral.input": "Pindai atau Masukkan Manual",
  "referral.label.institute": "Lembaga",
  "referral.label.reason": "Alasan Merujuk",
  "referral.label.referredOutTests": "Pemeriksaan yang dirujuk ke luar",
  "referral.label.sentdate": "Tanggal Dikirim",
  "referral.label.testmethod": "Metode",
  "referral.label.testtoperform": "Pemeriksaan yang Dilakukan",
  "referral.main.button": "Cari Rujukan berdasarkan Pasien",
  "referral.matching.search": "Pencarian Kecocokan Pemeriksaan Rujukan",
  "referral.out.head": "Rujukan",
  "referral.out.note": "Catatan: Jika pencarian dilakukan berdasarkan tanggal hasil, maka hanya pemeriksaan yang ada hasilnya yang akan muncul.",
  "referral.out.request": "Hasil berdasarkan Tanggal / Pemeriksaan / Jenis Tanggal Instalasi Lab:",
  "referral.print.selected.patient.reports": "Cetak Laporan Pasien yang Dipilih",
  "referral.print.selected.patient.reports.selectall.button": "Pilih Semua",
  "referral.print.selected.patient.reports.selectnone.button": "Kosongkan Pilihan",
  "referral.result.labNumber": "Hasil berdasarkan Nomor Registrasi",
  "referral.result.referenceRange": "Reference range",
  "referral.search": "Cari",
  "referral.search.column.analysisId": "AnalysisId",
  "referral.search.column.referenceLab": "Lab Rujukan",
  "referral.search.column.resultDate": "Tanggal Hasil",
  "referral.search.column.sentDate": "Tanggal Dikirim",
  "referral.test": "Pemeriksaan",
  "referral.testresult.pastnote": "Catatan Sebelumnya",
  "referral.units": "Unit",
  "referrer.label": "Perujuk",
  "reflexTests": "Pemeriksaan Refleks",
  "reject.action.button": "Penolakan",
  "reject.order.sample.notification": "Anda menolak sampel. Sampel ini akan ditolak dan tidak akan muncul dalam rencana kerja setelah disimpan, tidak ada hasil yang dapat dimasukkan untuk pemesanan ini.",
  "remaining.quantity": "Kuantitas sisa:",
  "remove.aliquot": "Hapus Alikuot",
  "report.enter.labNumber.headline": "Buat laporan atau semua laporan dalam rentang tertentu berdasarkan Nomor Permintaan / Nomor Registrasi",
  "report.enter.patient.headline": "Buat Semua Laporan untuk Klien tertentu",
  "report.enter.patient.headline.description": "Cari pasien melalui nomor registrasi sebelumnya, ID Pasien (yang dapat berupa nomor ID Kesehatan Unik atau NIK) atau bidang lainnya.",
  "report.enter.site.headline": "Buat Laporan berdasarkan Tempat",
  "report.labe.byLabNumber": "Laporan berdasarkan Nomor Registrasi",
  "report.labe.byPatient": "Laporan berdasarkan Pasien",
  "report.labe.date": "Laporan berdasarkan Tanggal",
  "report.labe.site": "Laporan berdasarkan Tempat",
  "report.label.site.dateType": "Jenis Tanggal",
  "report.label.site.onlyResults": "Hanya Laporan yang ada hasil",
  "report.patient.site.description": "Buat laporan berdasarkan tanggal hasil atau tanggal permintaan. Tanggal hasil hanya akan menampilkan laporan dengan hasil. Jika Anda hanya memilih laporan dengan hasil, maka semua laporan untuk pemeriksaan yang dalam pengerjaan tidak akan dibuat.",
  "report.select.site": "Pilih Tempat",
  "report.select.studttype": "Pilih Jenis Kajian",
  "reporting.label.testName": "Nama Pemeriksaan yang dilaporkan",
  "reports.auditTrail": "Jejak Audit",
  "reports.systemAuditTrail": "Jejak Audit Sistem",
  "reports.button": "Membuat Laporan",
  "reports.dateRange": "Rentang Tanggal",
  "reports.endDate": "Tanggal Selesai",
  "reports.error.dateRangeRequired": "Rentang tanggal wajib untuk jenis laporan ini",
  "reports.error.generationFailed": "Gagal membuat laporan. Silahkan coba lagi.",
  "reports.error.invalidDateRange": "Tanggal selesai harus setelah tanggal mulai",
  "reports.export": "Ekspor",
  "reports.export.byDate": "Ekspor berdasarkan Tanggal",
  "reports.export.byDate_routine": "Laporan CSV Rutin",
  "reports.export.general": "Ekspor umum",
  "reports.export.specific": "Ekspor Data Viral Load",
  "reports.export.valid": "Valid",
  "reports.export.whonet": "Laporan WHONET",
  "reports.followupRequired.byLocation": "Diperlukan Tindak Lanjut",
  "reports.format": "Format Ekspor",
  "reports.format.select": "Pilih format",
  "reports.generate.title": "Membuat Laporan Inventaris",
  "reports.generating": "Membuat...",
  "reports.generation.success": "Laporan berhasil dibuat dan diunduh",
  "reports.groupByLocation": "Kelompokkan berdasarkan lokasi penyimpanan",
  "reports.groupByType": "Kelompokkan berdasarkan jenis barang",
  "reports.grouping": "Opsi Pengelompokan",
  "reports.help.description": "Laporan ini untuk menganalisis data inventaris Anda:",
  "reports.help.tip1": "Rentang tanggal untuk analisis kecenderungan",
  "reports.help.tip2": "Kelompokkan berdasarkan jenis atau lokasi agar lebih mudah dipahami",
  "reports.help.tip3": "Ekspor ke Excel untuk analisis lebih lanjut",
  "reports.help.title": "Tips Pelaporan",
  "reports.includeExpired": "Sertakan lot kedaluwarsa",
  "reports.includeInactive": "Sertakan barang inaktif",
  "reports.info.message": "Pilih jenis dan pilihan laporan di bawah. Pembuatan laporan memerlukan waktu.",
  "reports.info.title": "Pembuatan Laporan",
  "reports.label.cistudyexport": "Laporan Umum",
  "reports.label.indicator": "Indikator",
  "reports.label.indicator.performance": "Kinerja Bagian",
  "reports.label.referred.out": "Laporan Pemeriksaan yang dirujuk ke luar",
  "reports.label.trends": "Tren",
  "reports.menu.covid": "Laporan Covid",
  "reports.nonConformity.byDate.report": "Berdasarkan Tanggal",
  "reports.nonConformity.byLabno.report": "Berdasarkan No Lab",
  "reports.nonConformity.bySectionReason.report": "Berdasarkan Unit dan Alasan",
  "reports.nonConformity.bySectionReason.title": "Laporan Ketidaksesuaian berdasarkan Unit dan Alasan",
  "reports.nonConformity.menu": "Laporan Ketidaksesuaian",
  "reports.nonConformity.notification.report": "Notifikasi Ketidaksesuaian",
  "reports.nonConformity.notification.report.instructions": "Jika layanan dipilih, maka semua notifikasi ketidaksesuaian yang belum dicetak akan dicetak. Jika tidak ada layanan yang tercantum, maka semua pemberitahuan telah dicetak. Dengan memasukkan nomor registrasi, maka Anda akan mencetak notifikasi meskipun sebelumnya telah dicetak. Layanan ini tidak harus dipilih.",
  "reports.options": "Opsi Filter",
  "reports.patient.ARV.version1": "ARV-Versi",
  "reports.patient.ARV.version1 ": "ARV-Versi 1",
  "reports.patient.ARVFollowup.version1": "ARV Tindak Lanjut Versi 1",
  "reports.patient.ARVFollowup.version2": "ARV Tindak Lanjut Versi 2",
  "reports.patient.ARVInitial.version1": "ARV Awal Versi 1",
  "reports.patient.ARVInitial.version2": "ARV Awal Versi 2",
  "reports.patient.Indeterminate.location": "Indeterminate berdasarkan Layanan",
  "reports.patient.Indeterminate.version1": "Indeterminate Versi 1",
  "reports.patient.Indeterminate.version2": "Indeterminate Versi 2",
  "reports.startDate": "Tanggal Mulai",
  "reports.type": "Jenis Laporan",
  "reports.type.expirationForecast": "Prakiraan Kedaluwarsa",
  "reports.type.expirationForecast.description": "Barang yang akan kedaluwarsa dalam rentang waktu tersebut",
  "reports.type.lotTraceability": "Ketertelusuran Lot",
  "reports.type.lotTraceability.description": "Ketertelusuran lengkap pergerakan dan penggunaan lot.",
  "reports.type.lowStock": "Peringatan Stok Sedikit",
  "reports.type.lowStock.description": "Barang yang di bawah level stok minimum",
  "reports.type.select": "Pilih jenis laporan",
  "reports.type.stockLevels": "Laporan Level Stok",
  "reports.type.stockLevels.description": "Level stok saat ini untuk semua barang inventaris",
  "reports.type.transactionHistory": "Riwayat Transaksi",
  "reports.type.transactionHistory.description": "Semua transaksi dalam kurun tanggal",
  "reports.type.usageTrends": "Kecenderungan Penggunaan",
  "reports.type.usageTrends.description": "Pola penggunaan dan kecenderungan konsumsi seiring waktu",
  "request.samesite.order": "Masukan permintaan dari tempat yang sama",
  "requester.label": "Pemohon",
  "required.invalidtext": "FIeld ini wajib",
  "result.acceptasis.warning": "Dengan mencentang kotak ini berarti Anda menerima hasilnya tanpa syarat. \nHal ini dapat berarti:\n1. Pemeriksaan sudah diulang dan hasilnya sama.\n2. Tidak ada hasil, tapi tidak ingin membatalkan pemeriksaan.\n3. Ada perubahan hasil, dan ingin memberi opsi agar petugas dapat mencantumkan catatan perubahan untuk petugas di tahap validasi.\nAlasan mengapa aksi ini dilakukan harus dicantumkan.\n",
  "result.acceptasis.trigger": "Terima",
  "result.acceptasis.reason.label": "Alasan untuk penerimaan tanpa syarat",
  "result.acceptasis.reason.placeholder": "Wajib — mis. diuji ulang dua kali dengan hasil yang sama, atau tidak ada hasil tersedia",
  "result.acceptasis.confirm": "Konfirmasi penerimaan",
  "result.acceptasis.cancel": "Batal",
  "result.acceptasis.committed": "Diterima",
  "result.acceptasis.undo": "Batal",
  "result.entry.error.accessionRequired": "Silahkan masukkan nomor registrasi",
  "result.entry.error.title": "Error",
  "result.entry.info.title": "Informasi",
  "result.entry.label": "Entri Hasil",
  "result.entry.noResults": "Tidak ada sampel ditemukan untuk nomor registrasi {accessionNumber}",
  "result.entry.noTestsFound": "Tidak ada pemeriksaan dengan hasil tertunda ditemukan untuk nomor registrasi {accessionNumber}",
  "result.entry.results.accessionNumber": "Nomor Registrasi",
  "result.entry.results.sampleCount": "Sampel",
  "result.entry.results.testCount": "Pemeriksaan",
  "result.entry.results.title": "Hasil Pemeriksaan Tertunda",
  "result.entry.saveSuccess": "Hasil disimpan untuk {testName}",
  "result.entry.search.accessionLabel": "Nomor Registrasi",
  "result.entry.search.accessionPlaceholder": "Masukkan nomor registrasi...",
  "result.entry.search.button": "Cari",
  "result.entry.search.searching": "Mencari...",
  "result.entry.search.title": "Cari berdasarkan Nomor Registrasi",
  "result.entry.success.title": "Berhasil",
  "result.entry.table.action": "Aksi",
  "result.entry.table.header.sampleId": "Nomor Identitas Sampel",
  "result.entry.table.header.sampleType": "Jenis Sampel",
  "result.entry.table.header.testCount": "Pemeriksaan",
  "result.entry.table.noSamples": "Tidak ditemukan sampel dengan pemeriksaan",
  "result.entry.table.noTests": "Tidak ada pemeriksaan untuk sampel ini",
  "result.entry.table.result": "Hasil",
  "result.entry.table.resultPlaceholder": "Masukkan hasil",
  "result.entry.table.save": "Simpan",
  "result.entry.table.saving": "Menyimpan...",
  "result.entry.table.status": "Status",
  "result.entry.table.testName": "Nama Pemeriksaan",
  "result.entry.table.testsTitle": "Pemeriksaan ({count})",
  "result.entry.title": "Entri Hasil",
  "result.noTestsFound": "Tidak ditemukan pemeriksaan yang tepat.",
  "result.nonconforming.item": "Sampel atau permintaan tidak sesuai ATAU telah ditolak",
  "result.outOfValidRange.msg": "Nilai yang Anda masukkan (kolom merah) berada di luar rentang nilai yang diizinkan. Silakan periksa nilainya.",
  "result.reject.warning": "Penolakan hasil bersifat permanen. \nHasil tidak akan tersedia lagi.",
  "result.report.queue.size": "Jumlah Antrian :",
  "result.search.noresult": "Hasil tidak ditemukan",
  "resultreporting.browse.title": "Konfigurasi Pelaporan Hasil",
  "resultreporting.config.url": "URL situs untuk mengirim hasil. Contohnya http://192.168.56.101/someSite",
  "resultreporting.config.url.placeholder": "https://orgname.com/someSite",
  "results.label.refer": "Rujuk pemeriksaan ke lab rujukan",
  "routine.reports": "Laporan Rutin",
  "rulebuilder.error.invalidNumeric": "Nomor Numerik Tidak Valid",
  "rulebuilder.error.invalidTest": "Pemeriksaan Tidak Valid",
  "rulebuilder.label.add.externaltrigger": "Masukkan pesan eksternal `dipicu oleh`",
  "rulebuilder.label.add.internaltrigger": "Masukkan pesan internal `dipicu oleh` message",
  "rulebuilder.label.addAction": "Tambah Aksi",
  "rulebuilder.label.addCondition": "Tambah Kondisi",
  "rulebuilder.label.addExternalNote": "Tambah Catatan Eksternal",
  "rulebuilder.label.addInternalNote": "Tambah Catatan Internal",
  "rulebuilder.label.addPopup": "Tambah Pop Up",
  "rulebuilder.label.addRule": "Tambah Aturan",
  "rulebuilder.label.addRuleConditions": "Tambah Kondisi Aturan Refleks",
  "rulebuilder.label.confirmDelete": "Apakah Anda ingin menonaktifkan Aturan ini?",
  "rulebuilder.label.dictValue": "Nilai Kamus",
  "rulebuilder.label.noSuggestions": "Tidak ada saran tersedia",
  "rulebuilder.label.numericValue": "Nilai Numerik",
  "rulebuilder.label.numericValue2": "Nilai Numerik 2",
  "rulebuilder.label.overallOptions": "Semua Opsi",
  "rulebuilder.label.perfomActions": "Lakukan aksi berikut",
  "rulebuilder.label.relation": "Hubungan",
  "rulebuilder.label.removeAction": "Hapus Aksi",
  "rulebuilder.label.removeCondition": "Hapus Kondisi",
  "rulebuilder.label.removeRule": "Nonaktifkan Aturan",
  "rulebuilder.label.rule": "Aturan",
  "rulebuilder.label.ruleDetails": "Lihat Aturan",
  "rulebuilder.label.ruleName": "Nama Aturan",
  "rulebuilder.label.searchTest": "Cari Pemeriksaan",
  "rulebuilder.label.selectSample": "Pilih Sampel",
  "rulebuilder.label.textValue": "Nilai teks",
  "rulebuilder.label.toggleRule": "Alihkan Aturan",
  "sample.accession.number": "Aksesi Sampel",
  "sample.add.action": "Tambah Sampel",
  "sample.collection.date": "Tanggal Pengambilan",
  "sample.collection.method": "Metode Pengambilan",
  "sample.collection.method.placeholder": "mis., venipuncture, capillary, tubing",
  "sample.collection.time": "Waktu Pengambilan",
  "sample.currentDate": "Tanggal Saat Ini",
  "sample.requiredBy": "Required By",
  "sample.specimen.origin": "Asal Spesimen (lab perujuk)",
  "sample.specimen.origin.placeholder": "Nama laboratorium perujuk",
  "sample.temperature": "Suhu Sampel",
  "sample.temperature.placeholder": "mis., suhu ruang, dibekukan, didinginkan",
  "sample.entry.available.tests": "Pemeriksaan Tersedia",
  "sample.entry.nextVisit.date": "Tanggal kunjungan berikutnya",
  "sample.entry.panels": "Panel",
  "sample.entry.project.patient.and.testName": "Nama/Kode pasien {br} Nama Pemeriksaan",
  "sample.entry.project.testName": "Nama Pemeriksaan",
  "sample.entry.search.barcode": "Cetak Kode QR untuk Permintaan yang Ada",
  "sample.id": "Nomor Identitas Sampel",
  "sample.item.info": "Informasi Sampel",
  "sample.items.for.accession": "Item Sampel untuk nomor registrasi:",
  "sample.label.accessionNumber": "Nomor Registrasi",
  "sample.label.collectionDate": "Tanggal Pengambilan",
  "sample.label.dept": "Ruang/Departmen/Unit",
  "sample.label.facility": "Lembaga Perujuk",
  "sample.label.labnumber": "Nomor Registrasi",
  "sample.label.labnumber.generate": "Buat",
  "sample.label.labnumber.new": "Nomor Registrasi Baru",
  "sample.label.noorder": "Permintaan Tidak Ada",
  "sample.label.orderdate": "Tanggal Permintaan",
  "sample.label.orderpanel": "Panel Permintaan",
  "sample.label.requester": "Pemohon",
  "sample.label.search.Order": "Cari Permintaan",
  "sample.label.search.labnumber": "Cari berdasarkan Nomor Registrasi",
  "sample.label.search.patient": "Cari berdasarkan Pasien",
  "sample.label.typeOfSample": "Jenis Sampel",
  "sample.label.types": "Jenis Sampel",
  "sample.management.action.clearSelection": "Hapus Pilihan",
  "sample.management.action.createAliquot": "Buat Alikuot",
  "sample.management.action.selectAllAliquots": "Pilih Semua Alikuot",
  "sample.management.action.selectAllParents": "Pilih Semua Induk",
  "sample.management.addTests.button": "Tambah Pemeriksaan",
  "sample.management.addTests.error.addFailed": "Gagal menambah pemeriksaan. Silahkan coba lagi.",
  "sample.management.addTests.error.loadSampleTypes": "Error memuat jenis sampel",
  "sample.management.addTests.error.loadTests": "Error memuat pemeriksaan yang tersedia",
  "sample.management.addTests.error.noEligibleSamples": "Tidak dapat menambah pemeriksaan; semua sampel yang dipilih akan dipindahkan seluruhnya",
  "sample.management.addTests.error.noTests": "Silahkan pilih setidaknya satu pemeriksaan",
  "sample.management.addTests.modal.add": "Tambah Pemeriksaan",
  "sample.management.addTests.modal.addCount": "Menambah {count} Pemeriksaan",
  "sample.management.addTests.modal.adding": "Menambahkan...",
  "sample.management.addTests.modal.aliquotsIncluded": "alikuot dimasukkan",
  "sample.management.addTests.modal.bulkAliquotNote": "Pemeriksaan akan ditambahkan pada sampel yang dipilih termasuk alikuot.",
  "sample.management.addTests.modal.cancel": "Batal",
  "sample.management.addTests.modal.noEligibleSamples": "Tidak Ada Sampel yang Memenuhi Syarat",
  "sample.management.addTests.modal.noTestsAvailable": "Tidak ada pemeriksaan tersedia untuk jenis sampel ini.",
  "sample.management.addTests.modal.noTestsSelected": "Tidak ada pemeriksaan yang dipilih",
  "sample.management.addTests.modal.panels": "Panel",
  "sample.management.addTests.modal.searchTestsPlaceholder": "Cari pemeriksaan...",
  "sample.management.addTests.modal.selectSampleType": "Jenis Sampel",
  "sample.management.addTests.modal.selectSampleTypeFirst": "Silahkan pilih jenis sampel untuk mulai menampilkan panel dan pemeriksaan yang tersedia.",
  "sample.management.addTests.modal.selectSampleTypePlaceholder": "Pilih jenis sampel...",
  "sample.management.addTests.modal.selectTests": "Pilih Pemeriksaan",
  "sample.management.addTests.modal.selectTestsPlaceholder": "Cari dan pilih pemeriksaan...",
  "sample.management.addTests.modal.selectedTests": "Pemeriksaan yang Dipilih",
  "sample.management.addTests.modal.subtitle": "Tambah pemeriksaan ke {count} sampel terpilih",
  "sample.management.addTests.modal.tests": "Pemeriksaan",
  "sample.management.addTests.modal.title": "Tambahkan Pemeriksaan ke Sampel",
  "sample.management.addTests.resultItem": "{sampleId}: {added} ditambahkan",
  "sample.management.addTests.resultItem.withSkipped": "{sampleId}: {added} ditambah, {skipped} dilewatkan",
  "sample.management.addTests.success": "{count} pemeriksaan telah berhasil ditambah",
  "sample.management.addTests.successDetailed": "{count} pemeriksaan ditambah ke sampel {samples}: {details}",
  "sample.management.addTests.successDetailedWithSkipped": "{added} pemeriksaan ditambah ke sampel {samples}, {skipped} dilewatkan: {details}",
  "sample.management.addTests.successWithSkipped": "{added} pemeriksaan ditambah, {skipped} pemeriksaan dilewatkan (sudah dipesan)",
  "sample.management.addTests.title": "Tambah Pemeriksaan",
  "sample.management.addTests.warning.dispensedSamples": "{count} sampel yang tidak ada volume tersisa akan dilewatkan. Pemeriksaan akan ditambahkan pada {eligible} sampel yang memenuhi syarat.",
  "sample.management.addTests.warning.dispensedSamples.title": "Tidak termasuk sampel yang dipindahkan",
  "sample.management.aliquot.error.createFailed": "Gagal membuat alikuot. Silahkan coba lagi.",
  "sample.management.aliquot.error.numberOfAliquotsInvalid": "Jumlah alikuot harus antara 1 dan 100",
  "sample.management.aliquot.error.quantityExceedsRemaining": "Kuantitas yang diminta ({requested}) melebihi yang tersisa ({remaining})",
  "sample.management.aliquot.error.quantityPerAliquotTooSmall": "Kuantitas per alikuot ({quantityPerAliquot}) akan kurang dari minimum (0.001)",
  "sample.management.aliquot.error.quantityPositive": "Kuantitas harus lebih dari 0",
  "sample.management.aliquot.error.quantityRequired": "Kuantitas harus ada",
  "sample.management.aliquot.error.title": "Error",
  "sample.management.aliquot.modal.cancel": "Batal",
  "sample.management.aliquot.modal.create": "Buat Alikuot",
  "sample.management.aliquot.modal.createMultiple": "Buat {count} Alikuot",
  "sample.management.aliquot.modal.creating": "Membuat...",
  "sample.management.aliquot.modal.notesLabel": "Catatan (Opsional)",
  "sample.management.aliquot.modal.notesPlaceholder": "Tambah catatan mengenai alikuot ini...",
  "sample.management.aliquot.modal.numberOfAliquotsHelper": "Masukkan jumlah alikuot bervolume sama yang akan dibuat (1-100)",
  "sample.management.aliquot.modal.numberOfAliquotsLabel": "Jumlah Alikuot",
  "sample.management.aliquot.modal.parentInfo": "Informasi Sampel Induk",
  "sample.management.aliquot.modal.preview": "Pratinjau",
  "sample.management.aliquot.modal.previewText": "Membuat {count} alikuot dengan kuantitas masing-masing {quantityEach} {unit}",
  "sample.management.aliquot.modal.quantityHelper": "Masukkan kuantitas untuk dipindahkan dalam {unit}",
  "sample.management.aliquot.modal.quantityLabel": "Kuantitas yang akan Dipindahkan",
  "sample.management.aliquot.modal.quantityPlaceholder": "Masukkan kuantitas",
  "sample.management.aliquot.modal.subtitle": "Membuat alikuot dari sampel {externalId}",
  "sample.management.aliquot.modal.title": "Buat Alikuot",
  "sample.management.aliquot.modal.totalQuantityHelper": "Masukkan kuantitas total untuk dibagi ke alikuot dalam {unit}",
  "sample.management.aliquot.modal.totalQuantityLabel": "Total Kuantitas yang akan Dipindahkan",
  "sample.management.aliquot.success": "Alikuot {externalId} berhasil dibuat. Silahkan lakukan pencarian kembali untuk melihat pembaruan hasil.",
  "sample.management.aliquot.successMultiple": "{count} alikuot berhasil dibuat ({externalIds}). Silahkan lakukan pencarian kembali untuk melihat pembaruan hasil.",
  "sample.management.breadcrumb.title": "Pengelolaan Sampel",
  "sample.management.cancelTest.error": "Gagal membatalkan pemeriksaan. Silahkan coba lagi.",
  "sample.management.cancelTest.success": "Pemeriksaan \"{testName}\" berhasil dibatalkan",
  "sample.management.description": "Pencarian dan pengelolaan item sampel, membuat alikuot, dan menambah pemeriksaan",
  "sample.management.error.title": "Error",
  "sample.management.hierarchy.aliquotOf": "Alikuot dari {parent}",
  "sample.management.hierarchy.aliquots": "alikuot",
  "sample.management.noResults.subtitle": "Tidak ada sampel ditemukan untuk nomor registrasi ini: {accessionNumber}",
  "sample.management.noResults.title": "Hasil tidak ditemukan",
  "sample.management.results.accessionNumber": "Nomor Registrasi",
  "sample.management.results.aliquots": "alikuot",
  "sample.management.results.aliquotsSelected": "alikuot",
  "sample.management.results.item": "item",
  "sample.management.results.items": "item",
  "sample.management.results.selected": "Dipilih",
  "sample.management.results.title": "Item Sampel",
  "sample.management.results.totalCount": "Total Sampel",
  "sample.management.search.error.general": "Error memuat hasil sampel. Silahkan coba lagi.",
  "sample.management.search.label": "Cari Sampel",
  "sample.management.search.loading": "Mencari...",
  "sample.management.search.placeholder": "Masukkan nomor registrasi untuk mencari...",
  "sample.management.search.title": "Cari Sampel",
  "sample.management.status.allVolumeDispensed": "Semua volume dipindahkan",
  "sample.management.status.available": "Tersedia",
  "sample.management.status.consumed": "Habis",
  "sample.management.status.inUse": "Sedang Digunakan",
  "sample.management.status.unknown": "Tidak diketahui",
  "sample.management.success.title": "Berhasil",
  "sample.management.table.cancelTest": "Batalkan Pemeriksaan",
  "sample.management.table.cancelling": "Membatalkan...",
  "sample.management.table.header.externalId": "Nomor Identitas Sampel",
  "sample.management.table.header.hierarchy": "Hirarki",
  "sample.management.table.header.originalQuantity": "Kuantitas Awal",
  "sample.management.table.header.quantity": "Kuantitas Awal",
  "sample.management.table.header.remainingQuantity": "Kuantitas Sisa",
  "sample.management.table.header.sampleType": "Jenis Sampel",
  "sample.management.table.header.status": "Status",
  "sample.management.table.header.tests": "Pemeriksaan",
  "sample.management.table.noResults": "Tidak ada item sampel untuk ditampilkan. Gunakan pencarian di atas untuk menemukan sampel.",
  "sample.management.table.noTests": "Tidak ada pemeriksaan yang dipesan untuk sampel ini",
  "sample.management.table.orderedDate": "Dipesan",
  "sample.management.table.orderedTests": "Pemeriksaan yang Dipesan ({count})",
  "sample.management.title": "Pengelolaan Sampel",
  "sample.panel.label.text": "Cari Panel yang Tersedia",
  "sample.panel.placeholder": "Pilih Panel yang Tersedia",
  "sample.panel.search.error.msg": "Tidak ada panel yang cocok",
  "sample.quantity.label": "Kuantitas",
  "sample.receivedDate": "Tanggal Diterima",
  "sample.reject.label": "Tolak Sampel",
  "sample.remove.action": "Hapus Sampel",
  "sample.requestDate": "Tanggal Permintaan",
  "sample.search.nosample": "Tidak ada sampel ditemukan untuk nomor registrasi ini",
  "sample.search.panel.legend.text": "Cari dari panel yang tersedia",
  "sample.search.scanner.instructions": "Pindai atau Masukkan Manual. Untuk laporan tunggal, kosongkan kotak di kanan",
  "sample.search.scanner.instructions.highaccession": "Untuk laporan tunggal, kosongkan kotak di kanan",
  "sample.search.scanner.instructions2": "Pindai atau Masukkan Manual",
  "sample.search.title": "Cari Sampel",
  "sample.select.type": "Pilih jenis sampel",
  "sample.type": "Jenis Sampel",
  "sample.type.and.test.sort.order": "Jenis sampel dan urutan penyortiran pemeriksaan",
  "sample.type.helper": "Select a specimen type — available panels and tests update after selection.",
  "sample.uom.label": "Satuan Pengukuran Sampel",
  "sample.voided.title": "Sampel dibatalkan",
  "sampleManagement.actions": "Aksi",
  "sampleManagement.addTests.button": "Tambah Pemeriksaan",
  "sampleManagement.addTests.cancel": "Batal",
  "sampleManagement.addTests.duplicate": "Pemeriksaan sudah dipesan untuk {sampleId}",
  "sampleManagement.addTests.error": "Error menambah pemeriksaan",
  "sampleManagement.addTests.incompatible": "Pemeriksaan tidak kompatibel dengan jenis sampel ({sampleType})",
  "sampleManagement.addTests.selectSamples": "Pilih Sampel untuk menambah Pemeriksaan",
  "sampleManagement.addTests.selectTests": "Pilih Sampel untuk ditambah",
  "sampleManagement.addTests.skipped": "{count} duplikat dilewati",
  "sampleManagement.addTests.submit": "Tambah Pemeriksaan",
  "sampleManagement.addTests.success": "{count} pemeriksaan berhasil ditambah",
  "sampleManagement.addTests.title": "Tambahkan Pemeriksaan ke Sampel",
  "sampleManagement.aliquot.button": "Buat Alikuot",
  "sampleManagement.aliquot.cancel": "Batal",
  "sampleManagement.aliquot.error": "Error saat membuat alikuot",
  "sampleManagement.aliquot.error.concurrentModification": "Pengguna lain memodifikasi sampel ini. Refresh dan coba lagi.",
  "sampleManagement.aliquot.error.insufficientQuantity": "Tidak dapat membuat alikuot: yang diminta {requested} melebihi yang sisa {remaining}",
  "sampleManagement.aliquot.error.noRemainingQuantity": "Semua volume dipindahkan: tidak ada kuantitas sisa yang tersedia untuk pengalikuotan",
  "sampleManagement.aliquot.notes": "Catatan (opsional)",
  "sampleManagement.aliquot.notesPlaceholder": "Tambahkan catatan untuk alikuot ini...",
  "sampleManagement.aliquot.parentExternalId": "Identitas Eksternal Induk",
  "sampleManagement.aliquot.parentLabel": "Sampel Induk",
  "sampleManagement.aliquot.quantityPlaceholder": "Masukkan kuantitas...",
  "sampleManagement.aliquot.quantityToTransfer": "Kuantitas yang akan Dipindahkan",
  "sampleManagement.aliquot.remainingQuantity": "Kuantitas Sisa",
  "sampleManagement.aliquot.submit": "Buat Alikuot",
  "sampleManagement.aliquot.success": "Alikuot {externalId} berhasil dibuat",
  "sampleManagement.aliquot.title": "Buat Alikuot",
  "sampleManagement.aliquot.unit": "Unit",
  "sampleManagement.aliquot.validation.exceeds": "Kuantitas melebihi kuantitas sisa",
  "sampleManagement.aliquot.validation.min": "Kuantitas harus setidaknya 0.001",
  "sampleManagement.aliquot.validation.required": "Kuantitas untuk dipindahkan harus ada",
  "sampleManagement.clearSelection": "Hapus pilihan",
  "sampleManagement.hierarchy.children": "Alikuot:",
  "sampleManagement.hierarchy.collapse": "Susutkan hirarki",
  "sampleManagement.hierarchy.expand": "Kembangkan hirarki",
  "sampleManagement.hierarchy.level": "Tingkatan {level}",
  "sampleManagement.hierarchy.parent": "Induk:",
  "sampleManagement.notification.refreshResults": "Hasil sudah direfresh",
  "sampleManagement.results.children": "Alikuot",
  "sampleManagement.results.collectionDate": "Tanggal Pengambilan",
  "sampleManagement.results.count": "{count} sampel ditemukan",
  "sampleManagement.results.externalId": "Identitas Eksternal",
  "sampleManagement.results.originalQuantity": "Kuantitas Awal",
  "sampleManagement.results.parent": "Induk",
  "sampleManagement.results.remainingQuantity": "Kuantitas Sisa",
  "sampleManagement.results.sampleType": "Jenis Sampel",
  "sampleManagement.results.status": "Status",
  "sampleManagement.results.tests": "Pemeriksaan",
  "sampleManagement.results.title": "Hasil Pencarian",
  "sampleManagement.search.button": "Cari",
  "sampleManagement.search.error": "Error saat mencari sampel",
  "sampleManagement.search.label": "Cari berdasarkan Nomor Registrasi",
  "sampleManagement.search.loading": "Mencari...",
  "sampleManagement.search.noResults": "Tidak ada sampel ditemukan untuk nomor registrasi ini",
  "sampleManagement.search.placeholder": "Masukkan Nomor Registrasi...",
  "sampleManagement.selectSamples": "Pilih Sampel",
  "sampleManagement.selectedCount": "{count} terpilih",
  "sampleManagement.test.name": "Nama Pemeriksaan",
  "sampleManagement.test.orderedDate": "Tanggal Permintaan",
  "sampleManagement.test.status": "Status",
  "sampleManagement.test.status.CANCELLED": "Dibatalkan",
  "sampleManagement.test.status.COMPLETED": "Selesai",
  "sampleManagement.test.status.IN_PROGRESS": "Dalam Pengerjaan",
  "sampleManagement.test.status.ORDERED": "Pemesanan",
  "sampleManagement.title": "Pengelolaan Sampel",
  "sampleManagement.validation.accessionNumberRequired": "Nomor Registrasi wajib ada",
  "sampleManagement.validation.parentSampleRequired": "Item sampel induk harus ada",
  "sampleManagement.validation.samplesRequired": "Setidaknya satu sampel harus dipilih",
  "sampleManagement.validation.testsRequired": "Setidaknya satu pemeriksaan harus dipilih",
  "sampleType.existing": "Jenis sampel yang ada",
  "sampleType.existing.inactive": "Jenis Sampel Inaktif. Tugaskan pemeriksaan untuk mengaktivasi.",
  "sampleType.new": "Jenis Sampel Baru",
  "sampleType.typeName": "Nama Jenis Sampel",
  "save.aliquot.changes": "Simpan Perubahan Alikuot",
  "save.config.success.msg": "Konfigurasi Berhasil Diperbarui",
  "save.order.success.msg": "Entri Permintaan Sampel berhasil disimpan",
  "save.success": "Penyimpanan berhasil",
  "saving": "Menyimpan...",
  "search.by.dictionary.entry": "Cari berdasarkan Entri Kamus",
  "search.label": "Cari",
  "search.label.accession": "Masukkan Nomor Registrasi",
  "search.label.analysis": "Pilih Status Analisis",
  "search.label.collectiondate": "Masukkan Tanggal Pengambilan",
  "search.label.fromaccession": "Dari Nomor Registrasi",
  "search.label.loadnext": "Masukkan 99 Rekaman Berikutnya, dimulai dari Nomor Registrasi",
  "search.label.receiveddate": "Masukkan Tanggal Diterima",
  "search.label.sample": "Pilih Status Sampel",
  "search.label.test": "Pilih Nama Pemeriksaan",
  "search.label.testdate": "Masukkan Tanggal Pemeriksaan",
  "search.label.testunit": "Pilih Instalasi Lab",
  "search.label.toaccession": "Ke Nomor Registrasi",
  "search.patient.label": "Cari Pasien",
  "search.placeholder": "Mencari...",
  "searchTests.label": "Cari Pemeriksaan yang Tersedia",
  "searchTests.legend": "Cari seluruh pemeriksaan yang tersedia",
  "searchindexmanagement.description": "Indeks pencarian diperbarui secara otomatis saat data ditambahkan atau dimodifikasi. Jika Anda ingin memperbarui indeks pencarian secara manual, klik tombol Mulai Pengindeksan Ulang. Proses ini akan membutuhkan waktu.",
  "searchindexmanagement.label": "Cari Pengelolaan Indeks",
  "searchindexmanagement.reindex": "Mulai Pengindeksan",
  "searchindexmanagement.reindex.error": "Pengindeksan Ulang gagal",
  "searchindexmanagement.reindex.success": "Pengindeksan Ulang berhasil",
  "select.aliquot": "Cari Alikuot",
  "select.datarange.label": "Rentang tanggal adalah saat perujukan dilakukan",
  "select.dateRange": "Pilih Rentang Tanggal untuk Ringkasan Laporan Pemeriksaan",
  "select.default.option.label": "Pilih satu opsi",
  "select.end.date.referredTests": "Tanggal Selesai (dd/mm/yyyy)",
  "select.labUnits": "Pilih unit laboratorium yang ingin Anda buat pemeriksaannya, Anda dapat memilih sebanyak yang dinginkan.",
  "select.label.analyser": "Pilih Alat",
  "select.priority.tests": "Pilih prioritas pemeriksaan yang ingin ditampilkan",
  "select.program": "Program",
  "select.referral.centre": "Pusat Rujukan atau Laboratorium",
  "select.referral.centre.is.required": "Pusat rujukan atau laboratorium adalah wajib",
  "select.start.date.referredTests": "Tanggal Dimulai (dd/mm/yyy)",
  "select.timeFrame": "Pilih waktu yang diinginkan untuk membuat laporan",
  "select.timeFrame.Note": "CATATAN: semua tanggal dan waktu didasarkan pada waktu penerimaan. Contoh: pemeriksaan yang diterima pada 31 Januari pukul 23:59 dan hasilnya keluar pada 1 Februari pukul 09:30 akan tercatat di luar jam kerja normal pada bulan Januari.",
  "select.year.report": "Pilih tahun yang diinginkan untuk membuat laporan",
  "selectListRenameEntry.selectList": "Pilih Daftar Ganti Nama Entri",
  "selectListRenameEntry.selectListEdit": "Pilih Edit Daftar Ganti Nama Entri",
  "selectReportValues.title": "Pilih Nilai Laporan",
  "selectResult.title": "Pilih Hasil",
  "serial.config.active.label": "Aktif",
  "serial.config.baudRate.label": "Baud Rate",
  "serial.config.connect.button": "Hubungkan",
  "serial.config.connect.error": "Error saat menghubungkan serial port",
  "serial.config.connect.success": "Serial port berhasil terhubung",
  "serial.config.create.title": "Buat Konfigurasi Serial Port",
  "serial.config.dataBits.label": "Bit Data",
  "serial.config.disconnect.button": "Koneksi Putus",
  "serial.config.disconnect.error": "Error saat diskoneksi serial port",
  "serial.config.disconnect.success": "Diskoneksi serial port berhasil",
  "serial.config.edit.title": "Edit Konfigurasi Serial Port",
  "serial.config.flowControl.label": "Kendali Alur",
  "serial.config.flowControl.none": "Tidak ada",
  "serial.config.form.legend": "Pengaturan Serial Port",
  "serial.config.parity.even": "Genap",
  "serial.config.parity.label": "Paritas",
  "serial.config.parity.mark": "Tanda",
  "serial.config.parity.none": "Tidak ada",
  "serial.config.parity.odd": "Ganjil",
  "serial.config.parity.space": "Ruang",
  "serial.config.portName.label": "Nama Portal",
  "serial.config.save.error": "Gagal menyimpan konfigurasi serial port",
  "serial.config.save.success": "Konfigurasi serial port berhasil disimpan",
  "serial.config.status.label": "Status Koneksi",
  "serial.config.stopBits.label": "Stop Bits",
  "serial.config.validation.analyzerId.required": "Identitas alat wajib ada",
  "serial.config.validation.baudRate.invalid": "Baud rate harus di antara 9600 dan 115200",
  "serial.config.validation.dataBits.invalid": "Bit data harus 7 atau 8",
  "serial.config.validation.portName.required": "Nama portal wajib ada",
  "server.error.msg": "Error pada server, silahkan kontak administrator",
  "show.aliquoting": "Tampilkan Pengalikuotan",
  "showing": "Menampilkan",
  "breadcrumb.label.addOrder": "Tambah Pemesanan",
  "sidenav.label.admin": "Admin",
  "sidenav.label.admin.analyzerTest": "Nama Alat",
  "sidenav.label.admin.backToMainMenu": "Kembali ke menu utama",
  "sidenav.label.admin.barcodeconfiguration": "Konfigurasi Kode QR",
  "sidenav.label.admin.labelPresets": "Pengaturan Label",
  "sidenav.label.admin.commonproperties": "Properti Aplikasi",
  "sidenav.label.admin.eqaProgram": "Pengelolaan Program PME",
  "sidenav.label.admin.formEntry.menustatementconfig": "Konfigurasi MenuStatement",
  "sidenav.label.admin.formEntry.nonconformityconfig": "Konfigurasi Ketidaksesuaian",
  "sidenav.label.admin.formEntry.patientconfig": "Konfigurasi Entri Pasien",
  "sidenav.label.admin.formEntry.PrintedReportsconfig": "Konfigurasi Laporan Cetak",
  "sidenav.label.admin.formEntry.resultConfig": "Konfigurasi Entri Hasil",
  "sidenav.label.admin.formEntry.sampleEntryconfig": "Konfigurasi Entri Permintaan",
  "sidenav.label.admin.formEntry.siteBranding": "Branding Situs",
  "sidenav.label.admin.formEntry.siteInfoconfig": "Pengaturan Informasi Aplikasi",
  "sidenav.label.admin.formEntry.validationconfig": "Konfigurasi Validasi",
  "sidenav.label.admin.formEntry.Workplanconfig": "Konfigurasi Rencana Kerja",
  "sidenav.label.admin.labNumber": "Pengelolaan Nomor Registrasi",
  "sidenav.label.admin.Listplugin": "Daftar Plugin",
  "sidenav.label.admin.localization": "Lokalisasi",
  "sidenav.label.admin.menu": "Konfigurasi Menu",
  "sidenav.label.admin.menu.billing": "Konfigurasi Menu Pembayaran",
  "sidenav.label.admin.menu.global": "Konfigurasi Menu Global",
  "sidenav.label.admin.menu.nonconform": "Konfigurasi Menu Ketidaksesuaian",
  "sidenav.label.admin.menu.patient": "Konfigurasi Menu Pasien",
  "sidenav.label.admin.menu.study": "Konfigurasi Menu Kajian",
  "sidenav.label.admin.organizationmgt": "Pengelolaan Organisasi",
  "sidenav.label.admin.pluginFile": "File Plugin",
  "sidenav.label.admin.program": "Entri Program",
  "sidenav.label.admin.testmgt": "Konfigurasi Pemeriksaan Refleks",
  "sidenav.label.admin.testmgt.calculated": "Pengelolaan Pemeriksaan dengan Nilai Terkalkulasi",
  "sidenav.label.admin.testmgt.testCatalogEditor": "Editor Katalog Pemeriksaan",
  "sidenav.label.admin.testCatalog": "Pengelolaan Katalog Pemeriksaan",
  "sidenav.label.admin.testCatalog.backToList": "← Semua Pemeriksaan",
  "sidenav.label.admin.testCatalog.sectionsHelper": "Pilih pemeriksaan untuk pengeditan bagian",
  "sidenav.label.admin.testCatalog.editing": "Edit: {name}",
  "sidenav.label.admin.testCatalog.editingGeneric": "Mengedit pemeriksaan",
  "label.testCatalog.editor": "Editor Katalog Pemeriksaan",
  "label.testCatalog.editor.empty": "Tidak ada pengujian yang dipilih",
  "label.testCatalog.editor.empty.helper": "Buka pemeriksaan dari Katalog Pemeriksaan untuk mengedit",
  "label.testCatalog.editor.loadError": "Gagal memuat pemeriksaan ini. Silahkan coba lagi.",
  "label.testCatalog.editor.saveAsNew": "Simpan sebagai pemeriksaan baru...",
  "label.testCatalog.editor.save.pending": "Penyimpanan tersedia setelah editor bagian tersebut dibuat",
  "label.testCatalog.editor.clone.pending": "Simpan sebagai pemeriksaan baru tersedia setelah editor bagian tersebut dibuat",
  "label.testCatalog.section.pending": "This section's editor ships in a later milestone.",
  "label.testCatalog.section.basic-info": "Informasi Dasar",
  "label.testCatalog.section.sample-results": "Sampel & Hasil",
  "label.testCatalog.section.methods": "Metode",
  "label.testCatalog.section.ranges": "Rentang",
  "label.testCatalog.section.storage": "Penyimpanan Sampel",
  "label.testCatalog.section.panels": "Panel",
  "label.testCatalog.entity.panels": "Panel",
  "note.panel.domainUpgrade": "Panels now have a Domain; existing panels were set to Clinical.",
  "note.panel.domainLaterPhase": "Environmental and Vector domains are enabled in a later phase.",
  "label.panel.list.description": "Ordered bundles of tests; sample types derive from the member tests",
  "label.panel.list.empty": "No panels match the current filters.",
  "label.panel.search": "Search by name or LOINC",
  "button.panel.add": "Add Panel",
  "label.panel.col.name": "Nama Panel",
  "label.panel.col.tests": "Pemeriksaan",
  "label.panel.col.domain": "Domain",
  "label.panel.col.sampleTypes": "Sample Types (derived)",
  "label.panel.col.status": "Status",
  "label.panel.backToList": "Back to list",
  "title.panel.new": "New panel",
  "label.panel.name": "Panel name",
  "placeholder.panel.name": "e.g. Anemia Workup",
  "label.panel.domain": "Domain",
  "helper.panel.domainGuard": "Only {domain}-domain tests can be added to this panel.",
  "helper.panel.loincIsIdentifier": "The panel's LOINC serves as its identifier.",
  "note.panel.sampleTypesDerived": "Sample types are derived from the tests in this panel.",
  "label.panel.description": "Deskripsi",
  "label.panel.active": "Aktif",
  "helper.panel.needsTest": "Add at least one test before this panel can be activated.",
  "error.panel.save": "The panel could not be saved. Check the fields and try again.",
  "error.panel.nameRequired": "A panel name is required.",
  "label.panel.section.basic-info": "Informasi Dasar",
  "label.panel.section.tests": "Pemeriksaan",
  "label.panel.section.terminology": "Terminologi",
  "sidenav.label.admin.panel.editing": "Editing panel: {name}",
  "sidenav.label.admin.panel.addingNew": "Adding a new panel",
  "label.panel.testsCount": "pengujian",
  "label.panel.addTest": "Add a test",
  "label.panel.tests.filterBySampleType": "Filter by sample type",
  "label.panel.tests.filterBySampleType.all": "All sample types",
  "placeholder.panel.addTest": "Search by name or code…",
  "helper.panel.membershipSync": "Membership writes keep order entry's panel list in sync.",
  "label.panel.col.order": "Pemesanan",
  "label.panel.col.testName": "Nama Pemeriksaan",
  "label.panel.col.code": "Kode",
  "label.panel.moveUp": "Geser ke atas",
  "label.panel.moveDown": "Geser ke bawah",
  "empty.panel.tests": "No tests yet — search above to add the first one.",
  "helper.panel.loincRouting": "It is also a live routing key — FHIR e-orders match panels by this code at intake. The primary LOINC stays on the panel for list display and order entry.",
  "label.panel.terminology.primary": "Primer",
  "label.panel.terminology.empty": "No terminology mappings yet. The LOINC mapping is the panel's identifier.",
  "label.panel.terminology.saved": "Terminology mappings saved.",
  "label.panel.terminology.saveInvalid": "Some mappings are invalid. Check source, code, and duplicates.",
  "label.panel.terminology.saveError": "Could not save terminology mappings.",
  "note.panel.positionShared": "Position writes panel_item.sort_order — the same field the test-side Panels section edits.",
  "label.testCatalog.section.labels": "Label",
  "label.testCatalog.section.terminology": "Terminologi",
  "label.testCatalog.labels.col.preset": "Pengaturan",
  "label.testCatalog.labels.col.defaultQty": "Kuantitas Default",
  "label.testCatalog.labels.col.maxQty": "Kuantitas Maks",
  "label.testCatalog.labels.col.allowOverride": "Izinkan Override",
  "label.testCatalog.labels.col.actions": "Aksi",
  "label.testCatalog.labels.addLabelType": "Tambah Jenis Label",
  "label.testCatalog.labels.addLabelType.placeholder": "Pilih Pengaturan Label",
  "label.testCatalog.labels.empty": "Tidak ada jenis label yang dikonfigurasi. Tambah pengaturan label untuk secara otomatis diterapkan saat pemeriksaan ini dipesan.",
  "label.testCatalog.labels.loadError": "Gagal memuat konfigurasi label untuk pemeriksaan ini.",
  "label.testCatalog.labels.saved": "Konfigurasi label disimpan",
  "label.testCatalog.labels.saveError": "Gagal menyimpan konfigurasi label.",
  "label.testCatalog.labels.unsaved": "You have unsaved label changes. Click Save to apply them.",
  "label.testCatalog.labels.maxLtDefault": "Kuantitas Maks harus lebih dari atau sama dengan Kuantitas Default.",
  "label.testCatalog.labels.allowOverride.label": "Izinkan override saat entri pemesanan",
  "label.testCatalog.labels.generationSettings": "Label Generation Settings",
  "label.testCatalog.labels.remove.action": "Hapus",
  "label.testCatalog.labels.remove.title": "Hapus Jenis Label",
  "label.testCatalog.labels.remove.confirm": "Hapus",
  "label.testCatalog.labels.remove.body": "Hapus {name} dari konigurasi label pemeriksaan ini?",
  "label.testCatalog.section.reagents": "Reagen",
  "label.testCatalog.section.analyzers": "Alat",
  "label.testCatalog.section.alerts": "Peringatan",
  "label.testCatalog.section.reflex-calc": "Reflex & Calc",
  "label.testCatalog.section.localization": "Lokalisasi",
  "label.testCatalog.section.display-order": "Urutan tampilan",
  "label.sampleType.section.basic-info": "Informasi Dasar",
  "label.sampleType.section.associated-tests": "Associated Tests",
  "label.sampleType.section.terminology": "Terminologi",
  "label.sampleType.terminology.intro": "Map this sample type to standard terminology codes for interoperability.",
  "label.sampleType.terminology.empty": "No terminology mappings yet.",
  "label.sampleType.terminology.saved": "Terminology mappings saved.",
  "label.sampleType.terminology.saveError": "Could not save terminology mappings.",
  "label.sampleType.terminology.saveInvalid": "Some mappings are invalid. Check source, code, and duplicates.",
  "label.sampleType.terminology.addHint": "Save this sample type first, then add terminology mappings.",
  "label.sampleType.name": "Nama",
  "label.sampleType.section.display-order": "Urutan tampilan",
  "label.sampleType.section.disposal": "Disposal",
  "label.sampleType.displayOrder": "Position in the Sample Type menu",
  "label.sampleType.displayOrder.intro": "Positions this sample type in the order-entry Sample Type menu. Type a position or use the arrows, then save — every sample type is renumbered.",
  "label.sampleType.displayOrder.current": "This sample type",
  "label.sampleType.displayOrder.loading": "Loading sample types...",
  "label.sampleType.displayOrder.saved": "Display order updated.",
  "label.sampleType.displayOrder.saveError": "Could not update display order.",
  "label.sampleType.displayOrder.addHint": "Save this sample type first, then set its menu position.",
  "label.sampleType.disposalInstructions": "Disposal instructions",
  "label.sampleType.disposal.intro": "Free-text reference guidance for disposing of this specimen type. The authoritative, structured handling stays on each test's Storage section and the specimen disposal workflow.",
  "label.sampleType.disposal.placeholder": "e.g. Autoclave before disposal via biohazard waste",
  "label.sampleType.disposal.loading": "Loading disposal instructions...",
  "label.sampleType.disposal.saved": "Disposal instructions saved.",
  "label.sampleType.disposal.saveError": "Could not save disposal instructions.",
  "label.sampleType.disposal.addHint": "Save this sample type first, then add disposal instructions.",
  "label.sampleType.tests.manageIntro": "Tests linked to this sample type. Search the catalog to add more, or remove existing links. The same link can also be managed from a test's Basic Info in the Test Catalog.",
  "label.sampleType.tests.search": "Search tests",
  "label.sampleType.tests.searchPlaceholder": "Search by test name...",
  "label.sampleType.tests.filterBySampleType": "Filter by sample type",
  "label.sampleType.tests.filterBySampleType.all": "Any sample type",
  "label.sampleType.tests.pick": "Test to add",
  "label.sampleType.tests.pickPlaceholder": "Select a test...",
  "label.sampleType.tests.add": "Add test",
  "label.sampleType.tests.addError": "Could not link the test to this sample type.",
  "label.sampleType.tests.remove": "Remove test",
  "label.sampleType.tests.removeError": "Could not unlink the test.",
  "label.sampleType.tests.loading": "Loading associated tests...",
  "label.sampleType.tests.none": "No tests are associated with this sample type.",
  "message.sampleType.edit.success": "Sample type updated successfully.",
  "label.sampleType.loading": "Loading sample type...",
  "warning.sampleType.deactivateInUse": "{count} active tests use this type; they won't be orderable while it's inactive.",
  "note.sampleType.associatedTests.viewOnly": "View only — a test's specimen is part of its identity. To run a test on this sample type, create a specimen variant in the Test Catalog.",
  "sidenav.label.admin.sampleType.backToList": "← All Sample Types",
  "sidenav.label.admin.sampleType.editing": "Edit: {name}",
  "sidenav.label.admin.sampleType.editingGeneric": "Editing sample type",
  "sidenav.label.admin.sampleType.addingNew": "Adding new sample type",
  "label.testCatalog.localization.locale": "Lokal",
  "label.testCatalog.localization.intro": "Edit terjemahan untuk nama pemeriksaan dan pelaporan. Bidang yang tidak diterjemahkan akan dikembalikan ke Bahasa Inggris. Kelola terjemahan dari laman admin Pengelolaan Terjemahan.",
  "label.testCatalog.localization.unsaved": "You have unsaved translation changes. Click Save to apply them.",
  "label.testCatalog.localization.loadError": "Gagal memuat terjemahan untuk pemeriksaan ini.",
  "label.testCatalog.localization.empty": "Pemeriksaan ini tidak memiliki bidang nama lokal.",
  "label.testCatalog.localization.saved": "Terjemahan disimpan",
  "label.testCatalog.localization.saveError": "Tidak dapat menyimpan terjemahan.",
  "label.testCatalog.localization.field.name": "Nama Pemeriksaan",
  "label.testCatalog.localization.field.reportingName": "Nama Pelaporan",
  "label.testCatalog.localization.fallback.en": "Fallback (en)",
  "label.testCatalog.localization.fallback.tooltip": "Menampilkan nilai dalam Bahasa Inggris karena tidak ada terjemahan yang dikonfigurasi untuk {locale}.",
  "label.testCatalog.reflexCalc.loadError": "Gagal memuat refleks dan kalkukasi terkait pemeriksaan ini.",
  "label.testCatalog.reflexCalc.reflex.heading": "Pemeriksaan Refleks",
  "label.testCatalog.reflexCalc.reflex.helper": "Aturan yang mengurutkan pemeriksaan secara otomatis berdasarkan hasil. Kelola ini di Daftar Master → Aturan Refleks.",
  "label.testCatalog.reflexCalc.reflex.col.rule": "Nama Aturan",
  "label.testCatalog.reflexCalc.reflex.col.trigger": "Kondisi Trigger",
  "label.testCatalog.reflexCalc.reflex.col.reflexTests": "Pemeriksaan Refleks Dipesan",
  "label.testCatalog.reflexCalc.reflex.empty": "Tidak ada aturan refleks yang dikonfigurasi. Aturan refleks dikelola di Daftar Master → Aturan Refleks.",
  "label.testCatalog.reflexCalc.reflex.manage": "Kelola Aturan Refleks",
  "label.testCatalog.reflexCalc.calc.heading": "Hasil Terkalkulasi",
  "label.testCatalog.reflexCalc.calc.helper": "Formula yang menggunakan hasil pemeriksaan ini atau yang menghasilkan pemeriksaan ini sebagai output. Kelola di Daftar Master → Hasil Terkalkukasi.",
  "label.testCatalog.reflexCalc.calc.feedsInto": "Pemeriksaan ini mengumpan ke",
  "label.testCatalog.reflexCalc.calc.calculatedBy": "Pemeriksaan ini dikalkulasi oleh",
  "label.testCatalog.reflexCalc.calc.col.name": "Nama Formula",
  "label.testCatalog.reflexCalc.calc.col.formula": "Formula",
  "label.testCatalog.reflexCalc.calc.col.output": "Output Pemeriksaan",
  "label.testCatalog.reflexCalc.calc.empty": "Tidak ada",
  "label.testCatalog.reflexCalc.calc.feedsInto.empty": "This test does not feed into any calculated result. Calculations are managed in Master Lists → Calculated Values.",
  "label.testCatalog.reflexCalc.calc.calculatedBy.empty": "This test is not calculated from other tests. Calculations are managed in Master Lists → Calculated Values.",
  "label.testCatalog.reflexCalc.calc.manage": "Kelola Hasil Terkalkulasi",
  "label.testCatalog.alerts.addRule": "Tambah Aturan",
  "label.testCatalog.alerts.empty": "Tidak ada konfigurasi aturan peringatan. Tambah aturan untuk menotifikasi penerima jika hasil cocok dengan kondisi.",
  "label.testCatalog.alerts.loadError": "Gagal memuat aturan peringatan untuk pemeriksaan ini.",
  "label.testCatalog.alerts.saved": "Aturan peringatan berhasil disimpan",
  "label.testCatalog.alerts.saveError": "Gagal menyimpan aturan peringatan.",
  "label.testCatalog.alerts.deleted": "Aturan peringatan dihapus",
  "label.testCatalog.alerts.deleteError": "Gagal menghapus aturan peringatan.",
  "label.testCatalog.alerts.nameRequired": "Wajib ada nama aturan.",
  "label.testCatalog.alerts.valueRequired": "Nilai spesifik diperlukan untuk trigger Nilai Spesifik.",
  "label.testCatalog.alerts.col.name": "Nama",
  "label.testCatalog.alerts.col.trigger": "Trigger",
  "label.testCatalog.alerts.col.channels": "Channel",
  "label.testCatalog.alerts.col.ack": "Ack Required",
  "label.testCatalog.alerts.col.enabled": "Diaktifkan",
  "label.testCatalog.alerts.col.actions": "Aksi",
  "label.testCatalog.alerts.trigger.ALL": "Semua Hasil",
  "label.testCatalog.alerts.trigger.ABNORMAL": "Abnormal",
  "label.testCatalog.alerts.trigger.CRITICAL": "Kritis",
  "label.testCatalog.alerts.trigger.SPECIFIC_VALUE": "Nilai Spesifik",
  "label.testCatalog.alerts.trigger.COMPLIANCE_BREACH": "Pelanggaran Kepatuhan",
  "label.testCatalog.alerts.edit.action": "Edit",
  "label.testCatalog.alerts.delete.action": "Hapus",
  "label.testCatalog.alerts.delete.title": "Hapus Aturan Peringatan",
  "label.testCatalog.alerts.delete.confirm": "Hapus",
  "label.testCatalog.alerts.delete.body": "Hapus aturan peringatan {name}?",
  "label.testCatalog.alerts.modal.addTitle": "Tambah Aturan Peringatan",
  "label.testCatalog.alerts.modal.editTitle": "Edit Aturan Peringatan",
  "label.testCatalog.alerts.field.name": "Nama Aturan",
  "label.testCatalog.alerts.field.trigger": "Peringatan jika hasil adalah:",
  "label.testCatalog.alerts.field.specificValue": "Nilai spesifik",
  "label.testCatalog.alerts.field.channels": "Channel notifikasi",
  "label.testCatalog.alerts.field.recipients": "Penerima",
  "label.testCatalog.alerts.field.ackRequired": "Require acknowledgment",
  "label.testCatalog.alerts.channel.sms": "SMS",
  "label.testCatalog.alerts.channel.email": "Email",
  "label.testCatalog.alerts.recipient.physician": "Dokter Pemesan",
  "label.testCatalog.alerts.recipient.patient": "Pasien",
  "label.testCatalog.alerts.recipient.facility": "Lembaga Perujuk",
  "label.testCatalog.alerts.recipient.customPhone": "Telepon kostum",
  "label.testCatalog.alerts.recipient.customEmail": "Email kostum",
  "label.testCatalog.alerts.recipient.roleId": "Notifikasi pengguna dengan peran",
  "label.testCatalog.alerts.recipient.rolePlaceholder": "Pilih peran",
  "label.testCatalog.reagents.col.name": "Nama Reagen",
  "label.testCatalog.reagents.col.usage": "Jenis Penggunaan",
  "label.testCatalog.reagents.col.qty": "Kuantitas per Pemeriksaan",
  "label.testCatalog.reagents.col.stock": "Level Stok",
  "label.testCatalog.reagents.col.actions": "Aksi",
  "label.testCatalog.reagents.empty": "Tidak ada reagen terkait. Tautkan reagen dari inventaris untuk melacak konsumsi per pemeriksaan.",
  "label.testCatalog.reagents.loadError": "Gagal memuat reagen untuk pemeriksaan ini.",
  "label.testCatalog.reagents.linkButton": "Tautkan Reagen",
  "label.testCatalog.reagents.linkError": "Gagal menautkan satu atau lebih reagen. Silahkan coba lagi.",
  "label.testCatalog.reagents.modal.title": "Tautkan Reagen",
  "label.testCatalog.reagents.modal.linkSelected": "Tautkan Yang Dipilih",
  "label.testCatalog.reagents.modal.select.label": "Reagen",
  "label.testCatalog.reagents.modal.select.placeholder": "Pilih reagen untuk ditautkan",
  "label.testCatalog.reagents.modal.allLinked": "Semua reagen yang tersedia sudah ditautkan ke pemeriksaan ini.",
  "label.testCatalog.reagents.unitPlaceholder": "Unit",
  "label.testCatalog.reagents.updated": "Reagen diperbarui",
  "label.testCatalog.reagents.saveError": "Gagal menyimpan perubahan.",
  "label.testCatalog.reagents.unsaved": "You have unsaved reagent changes. Click Save to apply them.",
  "label.testCatalog.reagents.retry": "Ulang",
  "label.testCatalog.reagents.unlink.action": "Putuskan Tautan",
  "label.testCatalog.reagents.unlink.title": "Putuskan Tautan Reagen",
  "label.testCatalog.reagents.unlink.confirm": "Putuskan Tautan",
  "label.testCatalog.reagents.unlink.body": "Putuskan tautan {name} untuk pemeriksaan ini? Hasil yang sudah tertaut dengan reagen ini tidak terpengaruh.",
  "label.testCatalog.reagents.unlinked": "Reagen tidak tertaut",
  "label.testCatalog.reagents.unlinkError": "Gagal memutuskan tautan reagen. Silahkan coba lagi.",
  "label.testCatalog.basicInfo.name": "Nama",
  "label.testCatalog.basicInfo.name.helper": "Nama tampilan adalah terjemahan — edit di bagian Lokalisasi.",
  "label.testCatalog.basicInfo.reportingName": "Nama pelaporan",
  "label.testCatalog.basicInfo.labUnit": "Instalasi Lab",
  "label.testCatalog.basicInfo.createInactiveHint": "Pemeriksaan yang dibuat Inaktif. Lakukan konfigurasi, kemudian aktifkan agar dapat dipesan.",
  "sidenav.label.environmental.compliance.tooltip": "Environmental Compliance Dashboard",
  "site.search.helper": "Type at least 2 characters to auto-search. Required for routing results back to the requesting site.",
  "storage.skipped.title": "Storage skipped for {count} sample(s)",
  "test.qc.blankThreshold": "Blank Threshold",
  "test.qc.recoveryWindowPct": "Recovery Window (%)",
  "test.qc.rpdThreshold": "RPD Threshold (%)",
  "test.qc.thresholds.description": "Optional thresholds for environmental/vector QC evaluation. Leave blank if not applicable.",
  "test.qc.thresholds.heading": "QC Acceptance Thresholds",
  "title.testCatalog.createTest": "Buat pemeriksaan baru",
  "label.testCatalog.testName": "Nama pemeriksaan",
  "label.testCatalog.testCode": "Kode pemeriksaan",
  "label.testCatalog.domain": "Domain",
  "label.testCatalog.specimenType": "Jenis sampel",
  "label.testCatalog.basicInfo.sampleTypes": "Jenis sampel",
  "helper.testCatalog.basicInfo.sampleTypesMulti": "Select every specimen this test runs on. Configuration is shared across them.",
  "error.testCatalog.basicInfo.sampleTypeRequired": "Select at least one sample type.",
  "error.testCatalog.basicInfo.sampleTypeDomain": "This sample type's domain doesn't match the test's domain.",
  "label.testCatalog.list.sampleTypesSummary": "{first} +{n}",
  "label.testCatalog.override.col.sampleType": "Spesimen",
  "label.testCatalog.override.shared": "All specimens (shared)",
  "notice.testCatalog.intake.awaitingSpecimen": "Awaiting specimen — this test runs on several specimens; resolve at collection.",
  "tag.testCatalog.finding.noSampleTypeLink": "No sample-type link",
  "error.testCatalog.codeExists": "Pemeriksaan dengan kode ini sudah ada.",
  "notification.testCatalog.testCreated": "Pemeriksaan '{name}' dibuat. Lengkapi konfigurasi pada bagian sebelah kiri.",
  "label.testCatalog.basicInfo.code": "Kode",
  "label.testCatalog.basicInfo.description": "Deskripsi",
  "label.testCatalog.basicInfo.domain": "Domain",
  "label.testCatalog.basicInfo.domain.CLINICAL": "Klinis",
  "label.testCatalog.basicInfo.domain.ENVIRONMENTAL": "Lingkungan",
  "label.testCatalog.basicInfo.domain.VECTOR": "Vektor",
  "label.testCatalog.basicInfo.domainModal.title": "Ganti domain pemeriksaan?",
  "label.testCatalog.basicInfo.domainModal.body": "Ganti domain pemeriksaan ini menjadi {domain}? Ini akan mempengaruhi pengkategorian pemeriksaan di katalog.",
  "label.testCatalog.basicInfo.amr": "Pemeriksaan surveilans AMR",
  "label.testCatalog.basicInfo.active": "Aktif",
  "label.testCatalog.basicInfo.orderable": "Dapat dipesan",
  "label.testCatalog.basicInfo.saved": "Informasi dasar disimpan.",
  "label.testCatalog.sampleResults.saved": "Sampel & hasil disimpan.",
  "label.testCatalog.sampleResults.empty": "Tidak ada komponen hasi. Tambahkan komponen hasil untuk mendefinisikan bagaimana hasil pemeriksaan diambil.",
  "label.testCatalog.sampleResults.newComponent": "(komponen baru)",
  "label.testCatalog.sampleResults.code": "Kode komponen",
  "label.testCatalog.sampleResults.isPrimary": "Komponen primer",
  "label.testCatalog.sampleResults.showOnReport": "Tampilkan di laporan pasien",
  "label.testCatalog.sampleResults.label": "Label komponen",
  "label.testCatalog.sampleResults.resultType": "Jenis hasil",
  "label.testCatalog.sampleResults.resultType.N": "Numerik",
  "label.testCatalog.sampleResults.resultType.none": "No result type selected",
  "label.testCatalog.sampleResults.preview.noType": "Select a result type above to see how technicians will enter this result.",
  "label.testCatalog.sampleResults.resultType.D": "Single-select list (dictionary)",
  "label.testCatalog.sampleResults.resultType.R": "Free text",
  "label.testCatalog.sampleResults.resultType.M": "Multi-select list",
  "label.testCatalog.sampleResults.resultType.C": "Cascading multi-select",
  "label.testCatalog.sampleResults.resultType.T": "Titer",
  "label.testCatalog.sampleResults.resultType.A": "Alpha (validated text)",
  "label.testCatalog.sampleResults.resultType.group.primary": "Common",
  "label.testCatalog.sampleResults.resultType.group.advanced": "Advanced / legacy types",
  "label.testCatalog.sampleResults.resultType.showAdvanced": "Advanced / legacy types",
  "label.testCatalog.sampleResults.resultType.hideAdvanced": "Sembunyikan advanced / legacy types",
  "label.testCatalog.sampleResults.resultTypeDesc.N": "Angka terukur dengan satuan (mis. 12.3 g/dL).",
  "label.testCatalog.sampleResults.resultTypeDesc.D": "Satu nilai di pilih dari fixed set (mis. Terdeteksi / Tidak terdeteksi).",
  "label.testCatalog.sampleResults.resultTypeDesc.R": "Komentar atau deksripsi yang diketik.",
  "label.testCatalog.sampleResults.resultTypeDesc.M": "Satu atau lebih nilai dari daftar; tidak ada nilai rujukan tunggal.<br>",
  "label.testCatalog.sampleResults.resultTypeDesc.C": "Opsi grup; pilih multiple grup.",
  "label.testCatalog.sampleResults.resultTypeDesc.T": "Rasio dilusi, misalnya, 1:10 atau 1:20 (umum di serologi).",
  "label.testCatalog.sampleResults.resultTypeDesc.A": "Teks alfanumerik yang valid (kode atau nilai dengan kode singkat).",
  "label.testCatalog.sampleResults.preview": "Pratinjau entri hasil",
  "label.testCatalog.sampleResults.previewHelper": "Yang terlihat saat petugas lab mengisi hasil.",
  "label.testCatalog.sampleResults.purpose": "Menjelaskan apa yang direkam oleh petugas lab untuk pemeriksaan ini dan bagaimana hasil diinterpretasikan.",
  "label.testCatalog.sampleResults.labelRequired": "Setiap komponen hasil memerlukan label sebelum dapat disimpan.",
  "label.testCatalog.sampleResults.resultTypeRequired": "Select a result type for \"{component}\" before saving.",
  "label.testCatalog.sampleResults.mostTestsOneResult": "Umumnya pemeriksaan merekam satu hasil. Tambah komponen jika pemeriksaan menghasilkan beberapa nilai (mis. diferensial).",
  "label.testCatalog.sampleResults.displayOrder": "Urutan tampilan",
  "label.testCatalog.sampleResults.uom": "Satuan pengukuran",
  "label.testCatalog.sampleResults.uom.none": "(none)",
  "label.testCatalog.sampleResults.uom.addNew": "＋ Tambah satuan baru…",
  "label.testCatalog.sampleResults.uom.newName": "Nama di Tampilan",
  "label.testCatalog.sampleResults.uom.newCode": "Kode",
  "label.testCatalog.sampleResults.uom.newUcum": "Kode UCUM",
  "label.testCatalog.sampleResults.uom.newDescription": "Deskripsi",
  "label.testCatalog.sampleResults.uom.saveNew": "Buat satuan",
  "label.testCatalog.sampleResults.significantDigits": "Digit signifikan",
  "label.testCatalog.sampleResults.significantDigits.helper": "Number of digits to keep after the decimal point when a numeric result is entered. Leave blank for no rounding.",
  "label.testCatalog.sampleResults.defaultResult": "Hasil default",
  "label.testCatalog.sampleResults.allowMultiple": "Izinkan pembacaan multiple",
  "label.testCatalog.sampleResults.options": "Opsi select-list",
  "label.testCatalog.sampleResults.options.empty": "No options defined yet. Add at least one option so this result can be entered.",
  "label.testCatalog.sampleResults.option.value": "Nilai",
  "label.testCatalog.sampleResults.option.sortOrder": "Sortir Pemesanan",
  "label.testCatalog.sampleResults.option.sortOrder.helper": "Options are shown to technicians in ascending sort order — lower numbers appear first.",
  "label.testCatalog.sampleResults.option.normal": "Normal",
  "label.testCatalog.sampleResults.addOption": "Tambah opsi",
  "label.testCatalog.sampleResults.addCustomOption": "Add custom option",
  "label.testCatalog.sampleResults.searchDictionary": "Cari nilai kamus...",
  "label.testCatalog.sampleResults.removeOption": "Hapus opsi",
  "label.testCatalog.sampleResults.interpretations": "Interpretasi",
  "label.testCatalog.sampleResults.interpretations.empty": "No interpretations defined. Add one to attach guidance or a severity flag to a result.",
  "label.testCatalog.sampleResults.interp.valueMatch": "Nilai cocok",
  "label.testCatalog.sampleResults.interp.selectValue": "Pilih nilai...",
  "label.testCatalog.sampleResults.interp.numericHint": "mis. >140, 90-140, =0",
  "label.testCatalog.sampleResults.interp.text": "Interpretasi",
  "label.testCatalog.sampleResults.interp.severity": "Keparahan",
  "label.testCatalog.sampleResults.addInterpretation": "Tambah interpretasi",
  "label.testCatalog.sampleResults.removeInterpretation": "Hapus interpretasi",
  "label.testCatalog.sampleResults.severity.NORMAL": "Normal",
  "label.testCatalog.sampleResults.severity.ABNORMAL": "Abnormal",
  "label.testCatalog.sampleResults.severity.CRITICAL": "Kritis",
  "label.testCatalog.sampleResults.actions": "Aksi",
  "label.testCatalog.sampleResults.addComponent": "Tambah komponen",
  "label.testCatalog.sampleResults.removeComponent": "Hapus komponen",
  "label.testCatalog.sampleResults.moveUp": "Pindahkan komponen ke atas",
  "label.testCatalog.sampleResults.moveDown": "Pindahkan komponen ke bawah",
  "label.testCatalog.sampleResults.copyFrom": "Salin konfigurasi dari pemeriksaan",
  "label.testCatalog.sampleResults.copyFrom.placeholder": "Pilih pemeriksaan",
  "label.testCatalog.sampleResults.copyFromButton": "Salin dari pemeriksaan",
  "label.testCatalog.sampleResults.copied": "Konfigurasi disalin.",
  "label.testCatalog.ranges.activated": "Pemeriksaan diaktifkan.",
  "label.testCatalog.ranges.ackModal.title": "Aktifkan dengan coverage gap?",
  "label.testCatalog.ranges.ackModal.confirm": "Ketahui dan aktifkan",
  "label.testCatalog.ranges.ackModal.warning": "Pemeriksaan ini memiliki rentang referensi dengan coverage gap.",
  "label.testCatalog.ranges.ackModal.body": "The following age windows have no reference range — results there cannot be flagged against a range. Acknowledge to activate anyway.",
  "label.testCatalog.ranges.male": "Laki-Laki",
  "label.testCatalog.ranges.female": "Perempuan",
  "label.testCatalog.ranges.gapRange": "{from} – {to}",
  "label.testCatalog.ranges.days": "hari",
  "label.testCatalog.ranges.months": "months",
  "label.testCatalog.ranges.years": "years",
  "label.testCatalog.ranges.noUpperLimit": "no upper limit",
  "label.testCatalog.ranges.noLowerLimit": "no lower limit",
  "label.testCatalog.ranges.both": "Both",
  "label.testCatalog.ranges.add": "Add range",
  "label.testCatalog.ranges.empty": "No reference ranges defined yet.",
  "label.testCatalog.ranges.saved": "Reference ranges saved.",
  "label.testCatalog.ranges.loadError": "Could not load reference ranges.",
  "label.testCatalog.ranges.col.component": "Component",
  "label.testCatalog.ranges.allComponents": "All components",
  "label.testCatalog.ranges.col.sex": "Jenis Kelamin",
  "label.testCatalog.ranges.col.age": "Rentang Umur",
  "label.testCatalog.ranges.col.normal": "Normal",
  "label.testCatalog.ranges.col.critical": "Kritis",
  "label.testCatalog.ranges.col.valid": "Valid",
  "label.testCatalog.ranges.col.actions": "Aksi",
  "label.testCatalog.ranges.anyAge": "Any age",
  "label.testCatalog.ranges.coverage.title": "Coverage validation",
  "label.testCatalog.ranges.coverage.gapsHeading": "Uncovered age windows:",
  "label.testCatalog.ranges.coverage.gapWithComponent": "{range} — {component}",
  "label.testCatalog.ranges.coverage.status.COMPLETE": "Fully covered",
  "label.testCatalog.ranges.coverage.status.GAP": "Has gaps",
  "label.testCatalog.ranges.coverage.status.OVERLAP": "Has overlaps",
  "label.testCatalog.ranges.coverage.status.EMPTY": "No ranges",
  "label.testCatalog.ranges.modal.titleAdd": "Add reference range",
  "label.testCatalog.ranges.modal.titleEdit": "Edit reference range",
  "label.testCatalog.ranges.modal.sex": "Applies to",
  "label.testCatalog.ranges.modal.component": "Result component",
  "label.testCatalog.ranges.modal.component.all": "All components",
  "label.testCatalog.ranges.modal.ageUnit": "Age unit",
  "label.testCatalog.ranges.modal.minAge": "From age",
  "label.testCatalog.ranges.modal.maxAge": "To age (blank = no upper bound)",
  "label.testCatalog.ranges.modal.lowNormal": "Normal low",
  "label.testCatalog.ranges.modal.highNormal": "Normal high",
  "label.testCatalog.ranges.modal.lowCritical": "Critical low",
  "label.testCatalog.ranges.modal.highCritical": "Critical high",
  "label.testCatalog.ranges.modal.lowValid": "Valid low",
  "label.testCatalog.ranges.modal.highValid": "Valid high",
  "label.testCatalog.ranges.modal.ageError": "“To age” must be greater than “From age”.",
  "label.testCatalog.ranges.modal.boundsError": "Bounds must nest outward: valid low ≤ critical low ≤ normal low ≤ normal high ≤ critical high ≤ valid high.",
  "label.testCatalog.storage.saved": "Sample storage saved.",
  "label.testCatalog.storage.loadError": "Could not load sample storage settings.",
  "label.testCatalog.storage.history.view": "View change history",
  "label.testCatalog.storage.history.title": "Sample Storage — Change History",
  "label.testCatalog.storage.history.loadError": "Unable to load change history.",
  "label.testCatalog.storage.history.empty": "No changes recorded.",
  "label.testCatalog.storage.history.filter": "Filter by field",
  "label.testCatalog.storage.history.col.changedAt": "Changed At",
  "label.testCatalog.storage.history.col.changedBy": "Changed By",
  "label.testCatalog.storage.history.col.field": "Bidang",
  "label.testCatalog.storage.history.col.old": "Nilai Lama",
  "label.testCatalog.storage.history.col.new": "Nilai Baru",
  "label.testCatalog.storage.storageHeading": "Penyimpanan",
  "label.testCatalog.storage.disposalHeading": "Disposal",
  "label.testCatalog.storage.handlingHeading": "Special handling",
  "label.testCatalog.storage.condition": "Storage condition",
  "label.testCatalog.storage.conditionCustom": "Custom condition",
  "label.testCatalog.storage.duration": "Maximum storage duration",
  "label.testCatalog.storage.durationUnit": "Duration unit",
  "label.testCatalog.storage.stabilityNotes": "Stability notes",
  "label.testCatalog.storage.protectFromLight": "Protect from light",
  "label.testCatalog.storage.doNotFreeze": "Do not freeze",
  "label.testCatalog.storage.doNotRefrigerate": "Do not refrigerate",
  "label.testCatalog.storage.disposalMethod": "Disposal method",
  "label.testCatalog.storage.disposalTimeframe": "Disposal timeframe",
  "label.testCatalog.storage.disposalUnit": "Timeframe unit",
  "label.testCatalog.storage.specialInstructions": "Special instructions",
  "label.testCatalog.storage.overrideRestricted": "Restrict storage-duration override",
  "label.testCatalog.storage.none": "— none —",
  "label.testCatalog.storage.condition.AMBIENT": "Ambient / room temperature",
  "label.testCatalog.storage.condition.CONTROLLED_ROOM_TEMPERATURE": "Controlled room temperature (20–25°C)",
  "label.testCatalog.storage.condition.COOL_ROOM": "Cool room (8–15°C)",
  "label.testCatalog.storage.condition.COLD_ROOM": "Cold room (2–8°C)",
  "label.testCatalog.storage.condition.REFRIGERATED": "Refrigerated (2–8°C)",
  "label.testCatalog.storage.condition.FROZEN": "Frozen (−20°C)",
  "label.testCatalog.storage.condition.DEEP_FROZEN": "Deep frozen (−70°C)",
  "label.testCatalog.storage.condition.ULTRA_LOW_FREEZER": "Ultra-low freezer (−80°C)",
  "label.testCatalog.storage.condition.WARM_INCUBATOR": "Warm incubator (35–37°C)",
  "label.testCatalog.storage.disposal.INCINERATION": "Incineration",
  "label.testCatalog.storage.disposal.AUTOCLAVE": "Autoclave",
  "label.testCatalog.storage.disposal.CHEMICAL_DISINFECTION": "Chemical disinfection",
  "label.testCatalog.storage.disposal.BIOHAZARD": "Biohazard waste",
  "label.testCatalog.storage.disposal.SHARPS_CONTAINER": "Sharps container",
  "label.testCatalog.storage.disposal.SEWER": "Sewer / drain disposal",
  "label.testCatalog.storage.disposal.RETURN_TO_SENDER": "Return to sender",
  "label.testCatalog.storage.disposal.ARCHIVE": "Long-term archive",
  "label.testCatalog.storage.disposal.STANDARD": "Standard waste",
  "label.testCatalog.storage.unit.hours": "hours",
  "label.testCatalog.storage.unit.days": "hari",
  "label.testCatalog.storage.unit.weeks": "weeks",
  "label.testCatalog.storage.unit.months": "months",
  "label.testCatalog.analyzers.infoCard": "Analyzers are linked to this test on the analyzer configuration screen. This list is read-only.",
  "label.testCatalog.analyzers.empty": "No analyzers are mapped to this test yet.",
  "label.testCatalog.analyzers.loadError": "Could not load analyzers for this test.",
  "label.testCatalog.analyzers.col.analyzer": "Alat",
  "label.testCatalog.analyzers.col.testName": "Analyzer test name",
  "label.testCatalog.displayOrder.pickSampleType": "Jenis sampel",
  "label.testCatalog.displayOrder.intro": "Reorder how tests appear within a sample type. Order is saved automatically.",
  "label.testCatalog.displayOrder.empty": "No tests are assigned to this sample type.",
  "label.testCatalog.displayOrder.loadError": "Tidak dapat memuat urutan tampilan.",
  "label.testCatalog.displayOrder.saved": "Urutan tampilan disimpan.",
  "label.testCatalog.displayOrder.moveUp": "Geser ke atas",
  "label.testCatalog.displayOrder.moveDown": "Geser ke bawah",
  "label.testCatalog.displayOrder.col.position": "Posisi",
  "label.testCatalog.displayOrder.col.test": "Pemeriksaan",
  "label.testCatalog.displayOrder.dragHandle": "Drag to reorder",
  "label.testCatalog.terminology.intro": "Map this test to standard terminology codes for interoperability.",
  "vector.collectedVolume.helper": "Number of organisms in this pool, e.g., number of mosquitoes.",
  "vector.complete.animal": "Animal",
  "vector.complete.cancel": "Batal",
  "vector.complete.details.collectionDate": "Tanggal Pengambilan",
  "vector.complete.details.collectionSite": "Tempat Pengambilan",
  "vector.complete.details.collector": "Pengambil sampel",
  "vector.complete.details.lifecycleStage": "Tahapan Siklus Hidup",
  "vector.complete.details.tests": "Pemeriksaan",
  "vector.complete.details.title": "Rincian Pemesanan",
  "vector.complete.details.trapType": "Jenis Perangkap",
  "vector.complete.labNumber": "Nomor Registrasi",
  "vector.complete.newOrder": "Pemesanan Vektor Baru",
  "vector.complete.quantity": "Kuantitas",
  "vector.complete.quantity.value": "{count} organisms",
  "vector.complete.status": "Status",
  "vector.complete.status.processing": "Processing",
  "vector.lifecycleStage.helper": "Developmental stage of the collected organism.",
  "vector.order.collectionContext.helper": "Optional — records ecological conditions at time of collection (bionomics).",
  "vector.order.collectionDate.heading": "Tanggal Pengambilan",
  "vector.order.collectionDate.helper": "Date the lot was physically collected from the field. Applies to every sample on this order.",
  "vector.order.site.add.new": "+ Add new site \"{name}\"",
  "vector.order.site.add.new.restricted": "Adding a new sampling site has been disabled by your administrator.",
  "vector.order.site.new.helper": "Will be created as a new sampling site when this order is saved.",
  "vector.order.site.new.tag": "New",
  "vector.order.site.no.match": "No matching site found.",
  "vector.pool.noTests": "No tests recorded",
  "vector.pool.summary": "Pool of {count} {animal}",
  "vector.trapCount.helper": "Number of traps deployed — used with nights to compute density per trap-night.",
  "vector.trapNights.helper": "Number of nights the traps were active. Leave blank if effort was not recorded.",
  "vector.trapType.helper": "Capture method or device used — select a sample type first.",
  "vectorDec.actionBar.assigned": "{assigned}/{total} assigned · {pools} pools",
  "vectorDec.button.back": "Kembali",
  "vectorDec.button.discard": "Discard",
  "vectorDec.button.previewGrouping": "Preview Grouping",
  "vectorDec.button.savePools": "Save Pools",
  "vectorDec.button.splitIndividuals": "Split to individuals →",
  "vectorDec.button.splitIndividuals.tooltip": "Quick set: one specimen per pool",
  "vectorDec.button.view": "Lihat",
  "vectorDec.col.children": "Child Specimens",
  "vectorDec.col.positiveTest": "Positive Test",
  "vectorDec.col.results": "Hasil",
  "vectorDec.col.status": "Status",
  "vectorDec.empty": "No deconvolution tasks.",
  "vectorDec.error.initiateFailed": "Could not initiate deconvolution.",
  "vectorDec.error.loadWorklist": "Could not load deconvolution worklist.",
  "vectorDec.error.minPoolCount": "Number of pools must be at least 2.",
  "vectorDec.error.noAssignedSpecimens": "Drag at least one specimen into a pool before saving.",
  "vectorDec.error.noParent": "No parent SampleItem available to split.",
  "vectorDec.error.poolFloorByType": "Lot has {types} sample types ({names}) — minimum {types} pools required for Random distribution.",
  "vectorDec.error.unassignedSpecimens": "{count} specimens are still unassigned. Assign all specimens before saving.",
  "vectorDec.field.howManyPools": "How many pools?",
  "vectorDec.field.notes": "Catatan",
  "vectorDec.field.organismsPerPool": "Organisms per pool",
  "vectorDec.field.poolCount": "Number of pools",
  "vectorDec.field.strategy": "Assignment method",
  "vectorDec.filter.all": "Semua",
  "vectorDec.filter.status": "Filter by status",
  "vectorDec.heading.preview": "Proposed Pool Grouping",
  "vectorDec.heading.split": "Split into Sub-pools",
  "vectorDec.heading.worklist": "Pool Deconvolution",
  "vectorDec.individualMode.badge": "Individual mode",
  "vectorDec.locationOverride.help": "Override the inherited intake collection site for individual sub-pools. Use this when a single lot was collected from multiple sites.",
  "vectorDec.locationOverride.inherit": "Inherit from lot (default)",
  "vectorDec.locationOverride.notes": "Aliquot notes",
  "vectorDec.locationOverride.site": "Collection site",
  "vectorDec.locationOverride.title": "Per sub-pool collection location (optional)",
  "vectorDec.message.success": "{count} sub-pools created ({labRange}), {orders} test orders queued. Status → Deconvolution In Progress.",
  "vectorDec.message.successIndividual": "{count} individual aliquots created ({labRange}), {orders} test orders queued. Status → Deconvolution In Progress. VR-07 Sporozoite Confirmation will fire on confirmed positives.",
  "vectorDec.parent.label": "Induk",
  "vectorDec.parent.quantity": "Quantity: {qty}",
  "vectorDec.preview.body": "{count} pools using {strategy}. Drag specimens between pools to adjust before saving.",
  "vectorDec.preview.empty": "No specimens",
  "vectorDec.preview.organisms": "organisms",
  "vectorDec.preview.poolN": "Pool {n}",
  "vectorDec.preview.poolWithSpecies": "Pool {n} — {species}",
  "vectorDec.preview.specimenCount": "{count, plural, one {# specimen} other {# specimens}}",
  "vectorDec.preview.title": "Proposed grouping",
  "vectorDec.preview.unassigned": "{count, plural, =0 {All specimens assigned} one {# unassigned} other {# unassigned}}",
  "vectorDec.preview.unassignedHint": "{count} unassigned — these stay in the original pool.",
  "vectorDec.reflexPreview.copiedTag": "COPIED",
  "vectorDec.reflexPreview.eagerTag": "EAGER",
  "vectorDec.reflexPreview.heading": "↪ Reflex rules will fire on save",
  "vectorDec.reflexPreview.parentTests": "Parent test orders ({test}) — re-run on each child",
  "vectorDec.reflexPreview.screeningPanel": "screening panel",
  "vectorDec.reflexPreview.tipSplitIndividuals": "Tip: Split to individual specimens to also fire {rules} — these rules only apply to pools with a single organism.",
  "vectorDec.results.positive": "({count} +)",
  "vectorDec.setup.distribution": "{specimens} specimens → ~{perPool} per pool{remainder, plural, =0 {} other {, remainder +1 to first {remainder}}}",
  "vectorDec.status.complete": "Decon Complete",
  "vectorDec.status.confirmed": "Confirmed",
  "vectorDec.status.inProgress": "Dalam Pengerjaan",
  "vectorDec.status.pending": "Review Needed",
  "vectorDec.strategy.manual": "Assign manually — drag and drop specimens into pools",
  "vectorDec.strategy.manual.hint": "Drag and drop specimens into pools yourself",
  "vectorDec.strategy.manual.title": "Assign manually",
  "vectorDec.strategy.random": "Assign randomly — distribute specimens evenly across pools",
  "vectorDec.strategy.random.hint": "Evenly distribute specimens across pools",
  "vectorDec.strategy.random.title": "Assign randomly",
  "vectorDec.strategy.species": "Auto sub-pool by species — group matching specimens together",
  "vectorDec.strategy.species.hint": "Group specimens by species — requires species ID on specimens",
  "vectorDec.strategy.species.title": "Auto sub-pool by species",
  "vectorDec.totalOrganisms": "Total organisms",
  "vectorDec.warning.exceedsParent.body": "{total} organisms requested across child pools, but parent has {parent}. The system will still create {total} children.",
  "vectorDec.warning.exceedsParent.title": "Total exceeds parent quantity",
  "vectorId.batch.selectedCount": "{count, plural, one {# specimen selected} other {# specimens selected}}",
  "vectorId.bloodMeal.add": "Add Panel to Order",
  "vectorId.bloodMeal.added": "Blood-Meal Identification Panel added to specimen test orders.",
  "vectorId.bloodMeal.addedSub": "Provenance: manual (lab tech accepted suggestion). Per BR-V03-014.",
  "vectorId.bloodMeal.alreadyAttached": "Blood-meal panel already attached ({skipped} tests).",
  "vectorId.bloodMeal.body": "Order the Mosquito Blood-Meal Identification Panel to identify the host species this specimen fed on.",
  "vectorId.bloodMeal.bulkAdd": "Add Panel to All ({count})",
  "vectorId.bloodMeal.bulkAddedSub": "Blood-meal panel processed for {count} specimens.",
  "vectorId.bloodMeal.bulkBody": "Add the Mosquito Blood-Meal Identification Panel to every selected specimen so the lab can identify which vertebrate host the mosquitoes fed on.",
  "vectorId.bloodMeal.bulkSummary": "Blood-meal panel: {added} added, {skipped} already attached, {rejected} rejected.",
  "vectorId.bloodMeal.bulkTitle": "Blood-fed females detected ({count} specimens)",
  "vectorId.bloodMeal.dismiss": "Dismiss",
  "vectorId.bloodMeal.error.add": "Could not add the Mosquito Blood-Meal Identification Panel.",
  "vectorId.bloodMeal.error.dismiss": "Could not record the dismissal.",
  "vectorId.bloodMeal.title": "Blood-fed female detected",
  "vectorId.bulk.applyToCount": "Apply to {count} specimens",
  "vectorId.bulk.heading": "Bulk Apply Species ID",
  "vectorId.bulk.notice.body": "Molecular detail fields (target gene, assay, accession) are not bulk-copied — record those per specimen.",
  "vectorId.bulk.notice.title": "Specimen-specific fields not copied",
  "vectorId.button.bulkApply": "🔖 Bulk Apply ({count})",
  "vectorId.button.cancel": "Batal",
  "vectorId.button.close": "▲ Close",
  "vectorId.button.confirm": "Konfirmasi",
  "vectorId.button.confirmAll": "✓ Confirm for all vectors",
  "vectorId.button.confirmResult": "✓ Confirm: {test}",
  "vectorId.button.hideResults": "Hide results",
  "vectorId.button.identify": "▼ Identify",
  "vectorId.button.reviewResults": "Review results ({n})",
  "vectorId.button.save": "Save Identification",
  "vectorId.button.splitPool": "↗ Split",
  "vectorId.col.collectionDate": "Tanggal Pengambilan",
  "vectorId.col.decon": "Decon",
  "vectorId.col.decon.help": "Deconvolution status — whether pool results have been entered and sub-pools are awaiting review.",
  "vectorId.col.idStatus": "ID Status",
  "vectorId.col.lotId": "Lot ID",
  "vectorId.col.organismGroup": "Group",
  "vectorId.col.progress": "Progress",
  "vectorId.col.site": "Tempat Pengambilan Sampel",
  "vectorId.completion.body": "{positive} of {total} sub-pools confirmed ({pct}%)",
  "vectorId.completion.body.confirmed": "{total} vectors confirmed",
  "vectorId.completion.body.partial": "Confirmed for all vectors in this pool:",
  "vectorId.completion.heading": "Deconvolution Complete",
  "vectorId.completion.heading.confirmed": "Result Confirmed",
  "vectorId.completion.heading.partial": "Results Partially Confirmed",
  "vectorId.completion.tag": "Decon Complete",
  "vectorId.completion.tag.confirmed": "Confirmed",
  "vectorId.completion.tag.partial": "Partially Confirmed",
  "vectorId.confidence.confirmed": "Confirmed",
  "vectorId.confidence.presumptive": "Presumptive",
  "vectorId.distribution.confirmed": "{count} Confirmed",
  "vectorId.distribution.heading": "Species Distribution",
  "vectorId.distribution.notIdentified": "{count} Not Identified",
  "vectorId.distribution.notYet": "Not yet identified",
  "vectorId.distribution.presumptive": "{count} Presumptive",
  "vectorId.empty": "No lots in this queue.",
  "vectorId.error.accessionFormat": "GenBank accession format: 1–2 letters followed by 5–8 digits (e.g. MW123456).",
  "vectorId.error.confidenceRequired": "Confidence is required.",
  "vectorId.error.loadSpecimens": "Could not load specimens for this lot.",
  "vectorId.error.loadWorklist": "Could not load worklist.",
  "vectorId.error.methodRequired": "Identification method is required.",
  "vectorId.error.notesTooLong": "Notes must be 500 characters or less.",
  "vectorId.error.requiredFields": "Species, method, and confidence are required.",
  "vectorId.error.saveFailed": "Could not save identification.",
  "vectorId.error.speciesRequired": "Species is required.",
  "vectorId.filter.complete": "Selesai",
  "vectorId.filter.complete.sub": "All specimens identified.",
  "vectorId.filter.decon": "Deconvolution",
  "vectorId.filter.decon.sub": "Pool results entered, awaiting technician decision to split or confirm.",
  "vectorId.filter.label": "Status",
  "vectorId.filter.notstarted": "Not Started",
  "vectorId.filter.notstarted.sub": "Received, 0 specimens identified.",
  "vectorId.filter.partialid": "Partial ID",
  "vectorId.filter.partialid.sub": "Identification in progress.",
  "vectorId.filter.pending": "Tertunda",
  "vectorId.filter.pending.sub": "All not-complete lots, including pools with results awaiting technician review.",
  "vectorId.form.assayName": "Assay Name",
  "vectorId.form.assayName.placeholder": "Multiplex RT-PCR",
  "vectorId.form.confidence": "Confidence",
  "vectorId.form.genbankAccession": "GenBank Accession",
  "vectorId.form.genbankAccession.placeholder": "MW123456",
  "vectorId.form.lifecycleStage": "Tahapan Siklus Hidup",
  "vectorId.form.linkedResult": "Link to Pathogen Result",
  "vectorId.form.linkedResultPlaceholder": "Select a result on this lot…",
  "vectorId.form.method": "Method",
  "vectorId.form.molecularDetails": "🔬 Molecular Details",
  "vectorId.form.notes": "Catatan",
  "vectorId.form.physState": "Physiological State",
  "vectorId.form.select": "Select…",
  "vectorId.form.species": "Spesies",
  "vectorId.form.speciesPlaceholder": "Search genus or species…",
  "vectorId.form.targetGene": "Target Gene",
  "vectorId.form.targetGene.placeholder": "COI, ITS2, 28S rDNA",
  "vectorId.heading.worklist": "Vector Identification Worklist",
  "vectorId.loading": "Loading…",
  "vectorId.message.bulkSuccess": "Identification applied to {count} specimens.",
  "vectorId.message.saveSuccess": "Identification saved.",
  "vectorId.method.both": "Morphological + Molecular",
  "vectorId.method.molecular": "Molecular",
  "vectorId.method.morphological": "Morphological",
  "vectorId.notif.confirmAll.error": "Could not confirm result. Please try again.",
  "vectorId.notif.confirmAll.success": "Result confirmed for all vectors in this pool.",
  "vectorId.notif.deconNeeded.body": "A result has been entered for this pool. Split into sub-pools for further testing, or confirm the result applies to all vectors.",
  "vectorId.notif.deconNeeded.bodyWithTest": "One of the tests has a result. Split into sub-pools for further testing, or confirm the result applies to all vectors.",
  "vectorId.notif.deconNeeded.title": "Pool Result Awaiting Review",
  "vectorId.physState.blood_fed": "Blood-fed",
  "vectorId.physState.gravid": "Gravid",
  "vectorId.physState.half_gravid": "Half-gravid",
  "vectorId.physState.unfed": "Unfed",
  "vectorId.physState.unknown": "Unknown / not assessed",
  "vectorId.resplit.heading": "Split: {label}",
  "vectorId.search.placeholder": "Search lots…",
  "vectorId.specimen.col.confidence": "Confidence",
  "vectorId.specimen.col.idStatus": "ID Status",
  "vectorId.specimen.col.label": "Spesimen",
  "vectorId.specimen.col.labNo": "Nomor Registrasi",
  "vectorId.specimen.col.poolOrSpecimen": "Pool / Specimen",
  "vectorId.specimen.col.species": "Spesies",
  "vectorId.specimen.confirmed": "Confirmed",
  "vectorId.specimen.count": "specimens",
  "vectorId.specimen.empty": "No specimens for this lot.",
  "vectorId.specimen.label": "Specimen #{n}",
  "vectorId.specimen.notIdentified": "Not Identified",
  "vectorId.specimen.presumptive": "Presumptive",
  "vectorId.status.complete": "Selesai",
  "vectorId.status.inProgress": "Dalam Pengerjaan",
  "vectorId.status.notStarted": "Not Started",
  "vectorId.tag.deconComplete": "Selesai",
  "vectorId.tag.deconInProgress": "Decon in progress",
  "vectorId.tag.deconNeeded": "⚠ Review Result",
  "vectorId.tag.subPoolPending": "{count} sub-pool with results",
  "vectorId.tree.organisms": "{count, plural, one {# organism} other {# organisms}}",
  "vectorReport.density.bySite": "Density by site and period",
  "vectorReport.density.effortNotRecorded": "Effort not recorded",
  "vectorReport.density.period": "Period",
  "vectorReport.density.perTrapNight": "Density (per trap-night)",
  "vectorReport.density.pools": "Pools",
  "vectorReport.density.site": "Site",
  "vectorReport.density.specimens": "Specimens",
  "vectorReport.density.title": "Specimen counts by site",
  "vectorReport.density.trapNights": "Trap-nights",
  "vectorReport.description": "Surveillance indices computed from recorded vector collections, species identifications, and pathogen results",
  "vectorReport.empty": "No data for the selected scope.",
  "vectorReport.exportPdf": "Ekspor PDF",
  "vectorReport.fieldMap.description": "Reorder, hide, relabel, or portal-tag the metrics shown in the Manual Entry Helper.",
  "vectorReport.fieldMap.hidden": "Hidden",
  "vectorReport.fieldMap.label": "Label",
  "vectorReport.fieldMap.metric": "Metric",
  "vectorReport.fieldMap.order": "Pemesanan",
  "vectorReport.fieldMap.portalTag": "Portal tag",
  "vectorReport.fieldMap.title": "Manual Entry Field Map",
  "vectorReport.fieldMap.visibility": "Visibility",
  "vectorReport.fieldMap.visible": "Visible",
  "vectorReport.fieldMap.visibleLabel": "Visible in the Manual Entry Helper",
  "vectorReport.filter.allSites": "All sites",
  "vectorReport.filter.apply": "Terapkan",
  "vectorReport.filter.dateRange": "Date range",
  "vectorReport.filter.from": "Dari",
  "vectorReport.filter.site": "Sampling site",
  "vectorReport.filter.to": "Kepada",
  "vectorReport.freshness": "Data freshness",
  "vectorReport.freshness.as": "Figures as of {time}",
  "vectorReport.freshness.unknown": "unknown",
  "vectorReport.generated": "Dibuat:",
  "vectorReport.home": "Beranda",
  "vectorReport.loadError": "Failed to load surveillance indices. Please try again.",
  "vectorReport.manualEntry.confirmBody": "Record an audit snapshot of this week's figures ({periodStart} – {periodEnd})? Re-submitting a week is recorded as a separate entry.",
  "vectorReport.manualEntry.confirmSubmit": "Konfirmasi",
  "vectorReport.manualEntry.copied": "Copied to clipboard",
  "vectorReport.manualEntry.copy": "Copy value",
  "vectorReport.manualEntry.empty": "No metrics configured for this period",
  "vectorReport.manualEntry.loading": "Loading week's numbers...",
  "vectorReport.manualEntry.lowConfidence": "Confidence reduced (pool deconvolution below 95%)",
  "vectorReport.manualEntry.markSubmitted": "Mark week submitted",
  "vectorReport.manualEntry.submitError": "Could not record submission",
  "vectorReport.manualEntry.submitted": "Week marked submitted",
  "vectorReport.manualEntry.title": "Manual Entry Helper",
  "vectorReport.manualEntry.week": "Reporting week",
  "vectorReport.mir.classic": "MIR (classical)",
  "vectorReport.mir.observed": "Infection rate (observed)",
  "vectorReport.mir.pathogen": "Pathogen",
  "vectorReport.mir.positivePools": "Positive pools",
  "vectorReport.mir.resolution": "Positive resolution",
  "vectorReport.mir.species": "Spesies",
  "vectorReport.mir.sporozoite": "Sporozoite rate",
  "vectorReport.mir.sporozoiteNote": "Confidence is reduced when pool deconvolution resolution is below 95%.",
  "vectorReport.mir.title": "Minimum Infection Rate by species",
  "vectorReport.mir.totalSpecimens": "Total specimens",
  "vectorReport.mir.withheld": "Withheld",
  "vectorReport.positivity.notConfigured": "Positivity classification is not configured for this deployment, so infection-rate, positivity, and sporozoite figures are unavailable. Configure result significance in the test catalog to enable them.",
  "vectorReport.positivity.pathogen": "Pathogen",
  "vectorReport.positivity.pct": "Positivity",
  "vectorReport.positivity.poolsPositive": "Pools positive",
  "vectorReport.positivity.poolsTested": "Pools tested",
  "vectorReport.positivity.title": "Pathogen positivity",
  "vectorReport.positivity.unrecognized": "Some results carry a significance value that is not a recognized classification (POSITIVE, NEGATIVE, or INDETERMINATE) and are excluded from positivity counts. Review the test catalog so these results can be counted.",
  "vectorReport.prompt": "Select a date range and site, then choose Apply to view surveillance indices.",
  "vectorReport.qc.detail": "{passed} of {total} analyses passed",
  "vectorReport.qc.passed": "Analyses passed",
  "vectorReport.qc.passRate": "Pass rate",
  "vectorReport.qc.title": "QC pass-rate",
  "vectorReport.qc.total": "Analyses total",
  "vectorReport.species.genus": "Genus",
  "vectorReport.species.pct": "Share",
  "vectorReport.species.species": "Spesies",
  "vectorReport.species.specimens": "Specimens",
  "vectorReport.species.title": "Species distribution",
  "vectorReport.sporozoite.title": "Sporozoite rate (Anopheles)",
  "vectorReport.title": "Surveilans Vektor",
  "vfs.abj": "ABJ (Larva-Free Rate)",
  "vfs.abj.target.below": "✗ ABJ below the 95% Kemenkes target",
  "vfs.abj.target.met": "✓ ABJ meets the 95% Kemenkes target",
  "vfs.bi": "Breteau Index (per 100 houses)",
  "vfs.ci": "Container Index (CI)",
  "vfs.containersExamined": "Containers examined",
  "vfs.containersPositive": "Containers positive",
  "vfs.err.containersExceeded": "Cannot exceed containers examined.",
  "vfs.err.examinedMin": "Must be ≥ 1 when larval data is entered.",
  "vfs.err.housesExceeded": "Cannot exceed houses examined.",
  "vfs.err.negative": "Cannot be negative.",
  "vfs.err.populationMin": "Must be ≥ 1 when pupal data is entered.",
  "vfs.hi": "House Index (HI)",
  "vfs.housesExamined": "Houses examined",
  "vfs.housesPositive": "Houses positive",
  "vfs.indices.title": "Computed indices (preview)",
  "vfs.larval.title": "Larval Survey — Mode C",
  "vfs.populationAtRisk": "Population at risk",
  "vfs.ppi": "Pupae Per Person (PPI)",
  "vfs.pupaeCount": "Pupae count",
  "vfs.pupal.title": "Pupal Survey — Mode D",
  "vfs.surveyMethod": "Survey method",
  "vfs.surveyMethod.placeholder": "Pilih satu opsi",
  "warning.testCatalog.noLoinc": "This test has no LOINC. Analyzer and electronic-order results cannot be imported to it.",
  "warning.testCatalog.duplicateLoinc": "LOINC {code} is also used by {testName}. Incoming results for this code route to only one test (first match) — results may be sent to the wrong test.",
  "label.testCatalog.terminology.col.source": "Sumber",
  "label.testCatalog.terminology.col.code": "Kode",
  "label.testCatalog.terminology.col.displayName": "Nama di Tampilan",
  "label.testCatalog.terminology.displayName.placeholder": "e.g. Glucose [Mass/volume] in Serum or Plasma",
  "label.testCatalog.terminology.col.relationship": "Relationship",
  "label.testCatalog.terminology.col.appliesTo": "Applies to",
  "label.testCatalog.terminology.appliesTo.test": "Whole test",
  "label.testCatalog.terminology.col.actions": "Aksi",
  "label.testCatalog.terminology.source": "Terminology source",
  "label.testCatalog.terminology.code": "Kode",
  "label.testCatalog.terminology.relationship": "Relationship",
  "label.testCatalog.terminology.addMapping": "Add mapping",
  "label.testCatalog.terminology.remove": "Remove mapping",
  "label.testCatalog.terminology.empty": "No terminology mappings yet.",
  "label.testCatalog.terminology.loadError": "Could not load terminology mappings.",
  "label.testCatalog.terminology.saved": "Terminology mappings saved.",
  "error.testCatalog.terminology.duplicate": "Duplicate {source} code {code} — this mapping already exists for this test.",
  "error.testCatalog.terminology.invalid": "The mappings could not be saved — check for a duplicate code, an unknown source, or an invalid relationship.",
  "label.testCatalog.terminology.rel.none": "— none —",
  "label.testCatalog.terminology.rel.SAME_AS": "Same as",
  "label.testCatalog.terminology.rel.BROADER_THAN": "Broader than",
  "label.testCatalog.terminology.rel.NARROWER_THAN": "Narrower than",
  "label.testCatalog.panels.intro": "Manage which panels this test belongs to, and its position within each.",
  "label.testCatalog.panels.addToPanel": "Add to panel",
  "label.testCatalog.panels.col.panel": "Panel",
  "label.testCatalog.panels.col.position": "Posisi",
  "label.testCatalog.panels.col.actions": "Aksi",
  "label.testCatalog.panels.position": "Posisi",
  "label.testCatalog.panels.remove": "Remove from panel",
  "label.testCatalog.panels.remove.confirm.heading": "Remove test from panel?",
  "label.testCatalog.panels.remove.confirm.body": "This test will be removed from {panel}. It stays in the catalog and any other panels. You can re-add it later.",
  "label.testCatalog.panels.moveUp": "Move earlier",
  "label.testCatalog.panels.moveDown": "Move later",
  "label.testCatalog.panels.viewOrder": "View this panel's test order",
  "label.testCatalog.panels.orderContext": "Tests in this panel (in order):",
  "label.testCatalog.panels.empty": "This test is not in any panel yet.",
  "label.testCatalog.panels.loadError": "Could not load panel memberships.",
  "label.testCatalog.panels.saved": "Panel memberships saved.",
  "label.testCatalog.panels.createPanel": "Create new panel",
  "label.testCatalog.panels.createPanelHint": "Enter a name to create a panel and add this test to it. Its sample type, ordering modules and other settings are configured later in Panel Management.",
  "notification.testCatalog.panels.created": "Panel '{name}' created and this test added. Configure it further in Panel Management.",
  "label.search": "Cari",
  "label.testCatalog.list": "Katalog Pemeriksaan",
  "label.testCatalog.list.search": "Search by test name",
  "label.testCatalog.list.col.status": "Status",
  "label.testCatalog.list.filter.allDomains": "All domains",
  "label.testCatalog.list.filter.allStatus": "All statuses",
  "label.testCatalog.list.filter.inactive": "Inaktif",
  "label.testCatalog.list.coverageIncomplete": "Coverage incomplete",
  "label.testCatalog.list.filter.amr": "AMR",
  "label.testCatalog.list.filter.anyAmr": "Apa saja",
  "label.testCatalog.list.filter.amrOnly": "AMR only",
  "label.testCatalog.list.filter.nonAmr": "Non-AMR",
  "label.testCatalog.list.filter.sampleType": "Jenis Sampel",
  "label.testCatalog.list.filter.allSampleTypes": "All sample types",
  "label.testCatalog.list.amrTag": "AMR",
  "label.testCatalog.list.noLoinc": "No LOINC",
  "label.testCatalog.list.filter.issuesOnly": "Only tests with issues",
  "label.testCatalog.list.health.banner": "{count} tests have configuration issues ({errors} errors · {warnings} warnings)",
  "label.testCatalog.list.health.show": "Show",
  "label.testCatalog.activation.incomplete.heading": "Test cannot be activated yet",
  "label.testCatalog.activation.incomplete.body": "Resolve the following before this test can be activated:",
  "label.testCatalog.list.col.sampleType": "Jenis Sampel",
  "button.testCatalog.newTest": "New test",
  "button.testCatalog.editRelated": "Edit related tests together",
  "button.testCatalog.editRelatedFromEditor": "Edit related tests…",
  "label.testCatalog.editor.noRelated": "No related tests share this test's name.",
  "label.testCatalog.editor.createSaveFirst.title": "Save the test first",
  "label.testCatalog.editor.createSaveFirst": "Complete Basic Info and save. This section becomes available once the test is created.",
  "label.testCatalog.editingNTests": "Editing {count} tests",
  "label.testCatalog.perTestIdentity": "Identity & LOINC (per test)",
  "state.testCatalog.differsAcrossTests": "Differs across tests",
  "button.testCatalog.setAllTo": "Set all to these values",
  "label.testCatalog.group.rangesSaved": "Reference ranges saved to {count} tests.",
  "label.testCatalog.group.storageIntro": "Edit storage & handling once; saving applies it to every selected test.",
  "button.testCatalog.removeFromSet": "Remove from this set",
  "label.testCatalog.group.rangesIntro": "Edit the reference ranges once; saving applies them to every selected test. Identity and LOINC stay per test.",
  "label.testCatalog.group.rangesDiffer": "The selected tests' current ranges are not identical. Saving will set all of them to the values below.",
  "label.testCatalog.ranges.table.sex": "Applies to",
  "label.testCatalog.ranges.table.age": "Rentang Umur",
  "label.testCatalog.ranges.table.normal": "Normal (low / high)",
  "label.testCatalog.list.filters": "Filter",
  "label.testCatalog.list.filters.count": "Filters ({count})",
  "label.testCatalog.list.error": "Couldn't load the test catalog. Adjust the filters or reload to try again.",
  "label.testCatalog.list.empty": "No tests match the current filters.",
  "sidenav.label.admin.testmgt.ManageMethod": "Pengelolaan Metode",
  "sidenav.label.admin.testmgt.reflex": "Pengelolaan Pemeriksaan Refleks",
  "sidenav.label.admin.testmgt.ViewtestCatalog": "Lihat Katalog Pemeriksaan",
  "sidenav.label.admin.usermgt": "Pengelolaan Pengguna",
  "sideNav.label.arvfollowup1": "ARV Tindak Lanjut Versi 1",
  "sideNav.label.arvfollowup2": "ARV TIndak Lanjut Versi 2",
  "sideNav.label.arvreports1": "ARV Awal Versi 1",
  "sideNav.label.arvreports2": "ARV Awal Versi 2",
  "sideNav.label.arvversion1": "ARV-Versi 1",
  "sideNav.label.associatedpatientreport": "Laporan Pasien Terkait",
  "sideNav.label.audittrail": "Jejak Audit",
  "sidenav.label.barcode": "kode QR",
  "sidenav.label.batchorder": "Entri Pemesanan Batch",
  "sideNav.label.bypaneltype": "Berdasarkan Jenis Panel",
  "sideNav.label.bytesttype": "Berdasarkan Jenis Pemeriksaan",
  "sideNav.label.byunit": "Berdasarkan Unit",
  "sideNav.label.collectedarvpatientreports": "Kumpulan Laporan Pasien ARV",
  "sidenav.label.cytology": "Sitologi",
  "sidenav.label.cytology.dashboard": "Dasbor",
  "sideNav.label.delayedvalidation": "Validasi Tertunda",
  "sidenav.label.editorder": "Edit Pemesanan",
  "sideNav.label.eidreports1": "EID Versi 1",
  "sideNav.label.eidreports2": "EID Versi 2",
  "sideNav.label.exportcsvfile": "Ekspor file CSV rutin",
  "sideNav.label.followuprequired": "Diperlukan Tindak Lanjut",
  "sideNav.label.generalreport": "Laporan Umum",
  "sideNav.label.hivtestsummary": "Ringkasan Pemeriksaan HIV",
  "sidenav.label.immunochem": "Imunohistokimia",
  "sidenav.label.immunochem.dashboard": "Dasbor",
  "sidenav.label.incomingorder": "Permintaan elektronik",
  "sideNav.label.intermediatebyservice": "Internediate berdasarkan Layanan",
  "sideNav.label.intermediatereport1": "Intermediate Versi 1",
  "sideNav.label.intermediatereport2": "Internediate Versi 2",
  "sidenav.label.inventory": "Inventaris",
  "sidenav.label.inventory.management": "Pengelolaan inventaris",
  "sidenav.label.inventory.management.tooltip": "Kelola barang inventaris, lot dan jumlah stok",
  "sidenav.label.inventory.tooltip": "Pengelolaan inventaris untuk reagen, kit dan pasokan",
  "sideNav.label.laporanHasil": "Compliance Report",
  "sideNav.label.noncomformitynotification": "Notifikasi Ketidaksesuaian",
  "sideNav.label.noncomformityreportsbydate": "Berdasarkan Tanggal",
  "sideNav.label.noncomformityreportsbylabno": "Berdasarkan No Lab",
  "sideNav.label.noncomformityreportsbyunit": "Berdasarkan Unit dan Alasan",
  "sidenav.label.notebook": "Notebook",
  "sidenav.label.add.order": "Tambah Pemesanan",
  "sidenav.label.clinical.order": "Tambah Pemesanan Klinis",
  "sidenav.label.environmental.compliance": "Compliance Dashboard",
  "sidenav.label.environmental.order": "Tambah Pemesanan Lingkungan",
  "sidenav.label.vector.order": "Tambah Pemesanan Vektor",
  "sidenav.label.order": "Pemesanan",
  "sidenav.label.order.collect": "Ambil Sampel",
  "sidenav.label.order.dashboard": "Dasbor",
  "sidenav.label.order.enter": "Masukkan Pemesanan",
  "sidenav.label.order.label": "Label & Simpan",
  "sidenav.label.order.qa": "Tinjauan QA",
  "sidenav.label.pathology": "Patologi",
  "sidenav.label.pathology.dashboard": "Dasbor",
  "sideNav.label.referredtestreport": "Laporan Pemeriksaan yang dirujuk ke luar",
  "sideNav.label.rejectionreport": "Laporan Penolakan",
  "sidenav.label.reports": "Laporan",
  "sidenav.label.reports.routine": "Rutin",
  "sidenav.label.reports.study": "Kajian",
  "sidenav.label.results": "Hasil",
  "sidenav.label.results.byrange": "Berdasarkan Rentang Nomor Registrasi",
  "sidenav.label.results.order": "Berdasarkan Permintaan",
  "sidenav.label.results.patient": "Berdasarkan Pasien",
  "sidenav.label.results.testdate": "Berdasarkan Tanggal Pemeriksaan",
  "sidenav.label.results.unit": "Berdasarkan Unit",
  "sideNav.label.sectionperformance": "Kinerja Bagian",
  "sideNav.label.specialrequest": "Permintaan Khusus",
  "sidenav.label.statisticsreport": "Laporan Statistik",
  "sidenav.label.statusreport": "Laporan Status Pasien",
  "sidenav.label.storage.coldstorage": "Pemantauan Penyimpanan Dingin",
  "sidenav.label.storage.coldstorage.tooltip": "Memantau suhu dan kelembaban freezer dan kulkas",
  "sidenav.label.storage.management": "Pengelolaan Penyimpanan",
  "sidenav.label.storage.management.tooltip": "Pengelolaan lokasi penyimpanan dan perangkat",
  "sidenav.label.testsummary": "Ringkasan Semua Pemeriksaan",
  "sidenav.label.validation": "Validasi",
  "sidenav.label.validation.order": "Cari Berdasarkan Permintaan",
  "sidenav.label.validation.routine": "Rutin",
  "sidenav.label.validation.study": "Kajian",
  "sidenav.label.validation.testdate": "Cari Berdasarkan Tanggal Pemeriksaan",
  "sideNav.label.viralloaddataexport": "Ekspor Data Viral Load",
  "sideNav.label.vlversionnational": "Versi VL Nasional",
  "sidenav.label.workplan": "Rencana Kerja",
  "sidenav.label.workplan.panel": "Berdasarkan Jenis Panel",
  "sidenav.label.workplan.priority": "Berdasarkan Prioritas",
  "sidenav.label.workplan.test": "Berdasarkan Jenis Pemeriksaan",
  "sidenav.label.workplan.unit": "Berdasarkan Unit",
  "sideNav.title.activityreport": "Laporan Kegiatan",
  "sidenav.title.aggregatereport": "Laporan Agregat",
  "sideNav.title.arvreports": "Laporan ARV",
  "sideNav.title.associatedpatientreport": "Laporan Terkait Pasien",
  "sideNav.title.audittrail": "Jejak Audit",
  "sideNav.title.collectedarvpatientreports": "Kumpulan Laporan pasien ARV",
  "sideNav.title.delayedvalidation": "Validasi Tertunda",
  "sideNav.title.eidreports": "Laporan EID",
  "sideNav.title.environmentalReports": "Environmental Reports",
  "sideNav.title.exportbydate": "Ekspor berdasarkan Tanggal",
  "sideNav.title.exportcsvfile": "Ekspor CSV file Rutin",
  "sideNav.title.indicator": "Indikator",
  "sideNav.title.intermediatereport": "Laporan Intermediate",
  "sideNav.title.noncomformityreports": "Laporan Ketidaksesuaian",
  "sideNav.title.referredtestreport": "Laporan Pemeriksaan yang dirujuk ke luar",
  "sideNav.title.rejectionreport": "Laporan Penolakan",
  "sideNav.title.specialrequest": "Permintaan Khusus",
  "sideNav.title.tatreport": "Waktu Penyelesaian",
  "sideNav.title.vectorIdentification": "Vector Identification",
  "sideNav.title.vlreport": "Laporan VL",
  "sideNav.label.audittrail.orderEvents": "Event Pemesanan",
  "sideNav.label.audittrail.systemEvents": "Event Sistem",
  "sidenav.label.addorder": "Tambah Permintaan",
  "sidenav.label.admin.sampleTypeManagement": "Sample Type Management",
  "sidenav.title.statusreport": "Laporan Status Pasien",
  "systemAudit.filter.startDate": "Tanggal Mulai",
  "systemAudit.filter.endDate": "Tanggal Selesai",
  "systemAudit.filter.entityType": "Jenis Entitas",
  "systemAudit.filter.action": "Aksi",
  "systemAudit.filter.search": "Cari",
  "systemAudit.filter.export": "Ekspor CSV",
  "systemAudit.table.heading.time": "Waktu",
  "systemAudit.table.heading.entityType": "Jenis Entitas",
  "systemAudit.table.heading.entityId": "ID Entitas",
  "systemAudit.table.heading.action": "Aksi",
  "systemAudit.table.heading.user": "Pengguna",
  "systemAudit.table.heading.changes": "Perubahan",
  "systemAudit.noResults": "Tidak ada event sistem ditemukan untuk filter ini.",
  "systemAudit.filter.all": "Semua",
  "systemAudit.filter.user": "Pengguna",
  "systemAudit.filter.searchText": "Cari",
  "systemAudit.filter.searchText.placeholder": "Cari berdasarkan ID entitas...",
  "systemAudit.filter.exportPdf": "Ekspor PDF",
  "systemAudit.filter.selectedPatient": "Pasien yang Dipilih",
  "systemAudit.filter.selectedPatient.none": "Tidak ada",
  "systemAudit.filter.selectPatient": "Pilih Pasien",
  "systemAudit.filter.selectAnotherPatient": "Pilih Pasien Lain",
  "systemAudit.action.insert": "Masukkan",
  "systemAudit.action.update": "Perbarui",
  "systemAudit.action.delete": "Hapus",
  "site.branding.cancel": "Batalkan",
  "site.branding.color.format.error": "Format warna tidak valid. Mohon gunakan warna CSS valid (misalnya, #0f62fe)",
  "site.branding.color.hex.label": "Kode Warna Hex",
  "site.branding.colorPicker.helperText": "Masukkan warna CSS (misalnya, #0f62fe, biru, rgb(15, 98, 254))",
  "site.branding.colorPicker.placeholder": "#0f62fe atau biru",
  "site.branding.confirm.remove": "Hapus Logo",
  "site.branding.confirm.remove.message": "Apakah Anda ingin menghapus logo ini dan mengembalikan ke logo OpenELIS default?",
  "site.branding.current.logo": "Logo saat ini",
  "site.branding.description": "Kostumisasi branding visual organisasi, seperti logo dan warna",
  "site.branding.error.remove": "Gagal menghapus file logo.",
  "site.branding.favicon": "Favicon",
  "site.branding.favicon.description": "Ikon yang tampil di browser tab dan bookmark",
  "site.branding.file.format.error": "Format file tidak didukung. Mohon gunakan PNG, SVG, atau JPG/JPEG",
  "site.branding.file.pending": "File dipilih - klik Simpan Perubahan untuk mengunggah",
  "site.branding.file.size.error": "Ukuran file melebihi batas 2MB",
  "site.branding.formats": "Format: PNG, SVG, JPG (maks 2MB)",
  "site.branding.header.color": "Warna header",
  "site.branding.header.color.description": "Warna latar belakang untuk header bar aplikasi",
  "site.branding.header.logo": "Logo Header",
  "site.branding.header.logo.description": "Logo header di kiri-atas",
  "site.branding.login.logo": "Logo Halaman Login",
  "site.branding.login.logo.description": "Logo yang tampil di halaman login",
  "site.branding.login.using.header.logo": "Menggunakan logo header untuk halaman login",
  "site.branding.logo.upload.success": "Logo berhasil diunggah",
  "site.branding.no.logo": "Tidak ada logo kostum (default)",
  "site.branding.preview": "Pratinjau",
  "site.branding.primary.color": "Warna primer",
  "site.branding.primary.color.description": "Warna untuk tombol primer, item menu aktif, dan tautan",
  "site.branding.remove.favicon": "Hapus Favicon",
  "site.branding.remove.header.logo": "Hapus Logo Header",
  "site.branding.remove.login.logo": "Hapus Logo Login",
  "site.branding.remove.logo": "Hapus Logo",
  "site.branding.reset.confirmation": "Apakah anda ingin mengatur ulang semua branding ke default OpenELIS? Aksi ini akan menghapus semua kostumisasi logo dan warna.",
  "site.branding.reset.error": "Gagal mengatur ulang branding ke default.",
  "site.branding.reset.success": "Atur ulang branding ke default berhasil dilakukan.",
  "site.branding.reset.to.defaults": "Atur Ulang ke Branding Awal (Default)",
  "site.branding.save": "Simpan Perubahan",
  "site.branding.save.error": "Gagal menyimpan konfigurasi branding",
  "site.branding.save.success": "Konfigurasi branding berhasil disimpan",
  "site.branding.secondary.color": "Warna Sekunder",
  "site.branding.secondary.color.description": "Warna untuk tombol sekunder, batas, dan status yang inaktif",
  "site.branding.section.colors": "Warna",
  "site.branding.section.logos": "Logo",
  "site.branding.title": "Branding Situs",
  "site.branding.unsaved.changes": "Anda memiliki perubahan yang belum disimpan. Apakah Anda ingin menyimpan, menghapus, atau membatalkan?",
  "site.branding.unsaved.changes.warning": "Perubahan belum disimpan. Klik Simpan untuk menerapkan perubahan.",
  "site.branding.upload.favicon": "Unggah Favicon",
  "site.branding.upload.header.logo": "Unggah Logo Header",
  "site.branding.upload.login.logo": "Unggah Logo Login",
  "site.branding.upload.logo": "Unggah Logo",
  "site.branding.use.header.logo.for.login": "Gunakan logo yang sama sebagai header",
  "siteInfo.description.default.barcode": "Tentukan jumlah default label kode QR yang harus dicetak pada setiap pemesanan dan spesimen.",
  "siteInfo.description.dimensions": "Tentukan dimensi yang harus dipatuhi saaat mencetak label kode QR.",
  "siteInfo.description.elements": "Centang kotak di samping, untuk elemen opsional yang harus muncul pada pemesanan dan label kode QR sampel.",
  "siteInfo.description.max.barcode": "Tentukan jumlah maksimum label kode QR yang dapat dicetak untuk setiap pemesanan atau spesimen. Setelah jumlah maksimum tercapai, pengguna tidak akan dapat mencetak label tambahan.",
  "siteInfo.elements.mandatory": "Elemen Wajib",
  "siteInfo.elements.optional": "Elemen Opsional",
  "siteInfo.section.altAccession": "Kode QR Nomor Registrasi Pracetak",
  "siteInfo.section.elements": "Elemen Label Kode QR",
  "siteInfo.section.number": "Label Nomor Kode QR ",
  "siteInfo.section.size": "Dimensi Label Kode QR",
  "siteInfo.title.default.barcode": "Label Kode QR Default",
  "siteInfo.title.default.barcode.block": "Blok",
  "siteInfo.title.default.barcode.height": "Tinggi",
  "siteInfo.title.default.barcode.order": "Pemesanan",
  "siteInfo.title.default.barcode.order.none": "Tidak ada",
  "siteInfo.title.default.barcode.slide": "Slide",
  "siteInfo.title.default.barcode.specimen": "Spesimen",
  "siteInfo.title.default.barcode.freezer": "Freezer",
  "siteInfo.title.default.barcode.width": "Lebar",
  "siteInfo.title.max.barcode": "Label Kode QR Maksimum",
  "started.date": "Tanggal Mulai",
  "status": "Status",
  "status.in.progress": "Dalam Pengerjaan",
  "status.unknown": "Tidak diketahui",
  "stillThere.message": "Sesi pengguna akan habis. Klik dimana saja untuk tetap login.",
  "stillThere.title": "Masih di tempat?",
  "stock.available": "Tersedia",
  "stock.level": "Level Stok",
  "stock.status": "Status Stok",
  "stock.status.expired": "Kedaluwarsa",
  "stock.status.expiring": "Segera Kedaluwarsa",
  "stock.status.inStock": "Stok Ada",
  "stock.status.lowStock": "Stok Sedikit",
  "stock.status.outOfStock": "Stok Habis",
  "storage.active": "Aktif",
  "storage.add.device": "Tambah Perangkat",
  "storage.add.location": "Lokasi",
  "storage.add.location.option": "Tambah Lokasi...",
  "storage.add.new.device": "Tambah perangkat baru",
  "storage.add.rack": "Tambah Laci",
  "storage.add.box": "Tambah Boks",
  "storage.add.room": "Tambah Ruangan",
  "storage.add.shelf": "Tambah Rak",
  "storage.allAssigned.title": "Semua Sample Ditugaskan",
  "storage.assign.button": "Tempatkan di Lokasi",
  "storage.assign.title": "Tugaskan Lokasi Penyimpanan",
  "storage.assigned": "Ditugaskan",
  "storage.assigned.by": "Ditempatkan Oleh",
  "storage.assigned.date": "Tanggal Penempatan",
  "storage.barcode.scan.placeholder": "Pindai Kode QR atau masukkan manual",
  "storage.bulk.move.auto.assigned": "Posisi ditetapkan otomatis (dapat diedit)",
  "storage.bulk.move.preview": "Pratinjau Pemindahan Jumlah Besar",
  "storage.cannotDelete.hasAssignments": "Tidak dapat menghapus {entityType} '{name}': yang mengandung {count} sampel yang ditempatkan",
  "storage.cannotDelete.hasChildren": "Tidak dapat menghapus {entityType} '{name}': yang mengandung {count} {childType}",
  "storage.capacity.calculated": "Dihitung",
  "storage.capacity.manual": "Batas Manual",
  "storage.capacity.undetermined.tooltip": "Kapasitas tidak dapat dihitung: beberapa lokasi turunan tidak memiliki kapasitas yang ditentukan",
  "storage.capacity.warning": "{location} is {percentage}% penuh. Pertimbangkan penyimpanan alternatif.",
  "storage.code.change.acknowledge": "Saya mengerti dan akan melanjutkan pengubahan kode",
  "storage.code.change.warning": "Peringatan",
  "storage.code.change.warning.message": "Mengubah kode akan membatalkan validasi label yang sudah dicetak untuk lokasi ini.",
  "storage.confirm.add.device": "Apakah Anda mau membuat perangkat baru '{name}'?",
  "storage.conditionNotes": "Catatan Kondisi",
  "storage.conditionNotes.placeholder": "Masukkan catatan tentang kondisi penyimpanan...",
  "storage.confirm.delete": "Konfirmasi Penghapusan",
  "storage.create.room.error": "Gagal membuat ruangan: {error}",
  "storage.create.room.success": "Ruangan \"{name}\" berhasil dibuat",
  "storage.current.location": "Lokasi Saat Ini",
  "storage.currentLocation": "Lokasi Saat Ini",
  "storage.delete.admin.only": "Hanya Administrator Global yang dapat menghapus lokasi",
  "storage.delete.are.you.sure": "Apakah Anda mau menghapus",
  "storage.delete.cannot.be.undone": "Aksi ini tidak dapat dibatalkan",
  "storage.delete.cascade.confirm": "Konfirmasi Penghapusan Bertingkat",
  "storage.delete.cascade.confirmation.checkbox": "Saya mengkonfirmasi akan menghapus lokasi dan turunannya. Semua sampel akan tidak ditempatkan lagi. Aksi ini tidak dapat dibatalkan.",
  "storage.delete.cascade.summary": "Ini akan menghapus {childCount} {childType} dan sampel yang belum ditempatkan {sampleCount}. Apakah Anda ingin lanjut?",
  "storage.delete.cascade.warning": "Peringatan Penghapusan Bertingkat",
  "storage.delete.checking": "Memeriksa batasan...",
  "storage.delete.confirmation.checkbox": "Saya mengkonfirmasi akan menghapus lokasi ini. Aksi ini tidak dapat dibatalkan.",
  "storage.delete.constraints.title": "Tidak Dapat Menghapus",
  "storage.delete.device": "Hapus Perangkat",
  "storage.delete.error": "Gagal menghapus lokasi",
  "storage.delete.location": "Hapus Lokasi",
  "storage.delete.rack": "Hapus Laci",
  "storage.delete.room": "Hapus Ruangan",
  "storage.delete.shelf": "Hapus Rak",
  "storage.device.code": "Kode",
  "storage.device.communicationProtocol": "Protokol Komunikasi",
  "storage.device.communicationProtocol.helper": "Protokol yang digunakan untuk komunikasi perangkat (misalnya, BACnet)",
  "storage.device.ipAddress": "Alamat IP",
  "storage.device.ipAddress.helper": "Alamat IPv4 atau IPv6 untuk alat terkoneksi ke jaringan",
  "storage.device.label": "Perangkat",
  "storage.device.name": "Nama",
  "storage.device.placeholder": "Pilih atau ketik untuk menambah perangkat...",
  "storage.device.port": "Portal",
  "storage.device.port.helper": "Nomor Portal (1-65535) untuk komunikasi",
  "storage.device.room": "Ruangan",
  "storage.device.type": "Jenis",
  "storage.edit.device": "Edit Perangkat",
  "storage.edit.error.loadLocation": "Gagal memuat lokasi",
  "storage.edit.error.saveFailed": "Penyimpanan gagal",
  "storage.edit.error.saveHttp": "Penyimpanan gagal (HTTP {status})",
  "storage.edit.rack": "Edit Laci",
  "storage.edit.room": "Edit Ruangan",
  "storage.edit.shelf": "Edit Rak",
  "storage.edit.selectParent": "Pilih {parent}",
  "storage.editbox.error.loadBox": "Gagal memuat boks",
  "storage.editbox.selectRack": "Pilih Laci",
  "storage.box.capacity": "Kapasitas",
  "storage.box.rows": "Baris",
  "storage.box.columns": "Kolom",
  "storage.box.preset": "Pengaturan awal dimensi",
  "storage.box.preset.select": "Pilih dimensi",
  "storage.error.location.inactive": "Tidak dapat menempatkan di lokasi yang inaktif",
  "storage.error.name.duplicate": "{entityType} dengan nama ini sudah ada di lokasi induk yang dipilih",
  "storage.error.position.occupied": "Posisi sudah diisi",
  "storage.expanded.capacityLimit": "Batas Kapasitas",
  "storage.expanded.createdBy": "Dibuat Oleh",
  "storage.expanded.createdDate": "Tanggal Dibuat",
  "storage.expanded.description": "Deskripsi",
  "storage.expanded.lastModifiedBy": "Dimodifikasi Terakhir Oleh",
  "storage.expanded.lastModifiedDate": "Tanggal Modifikasi Terakhir",
  "storage.expanded.notAvailable": "N/A",
  "storage.expanded.positionSchemaHint": "Petunjuk Skema Posisi",
  "storage.expanded.temperatureSetting": "Pengaturan Suhu",
  "storage.filter.by.locations": "Filter berdasarkan lokasi",
  "storage.filter.by.locations.placeholder": "Filter berdasarkan lokasi...",
  "storage.filter.device": "Filter berdasarkan Perangkat",
  "storage.filter.room": "Filter berdasarkan Ruangan",
  "storage.filter.status": "Filter berdasarkan Status",
  "storage.hierarchical.path": "Jalur Lokasi",
  "storage.inline.add.device": "Tambah Perangkat Baru",
  "storage.inline.add.rack": "Tambah Laci Baru",
  "storage.inline.add.room": "Tambah Ruangan Baru",
  "storage.inline.add.shelf": "Tambah Rak Baru",
  "storage.location": "Lokasi",
  "storage.location.active": "Aktif",
  "storage.location.add.button": "Tambah Lokasi",
  "storage.location.add.title": "Tambah Lokasi Penyimpanan",
  "storage.location.current": "Lokasi Penyimpanan",
  "storage.location.code": "Kode Lokasi",
  "storage.location.code.helper": "Maksimum 10 karakter, alfanumerik dengan hyphen/underscore",
  "storage.location.description": "Deskripsi",
  "storage.location.label": "Lokasi Penyimpanan",
  "storage.location.name": "Nama Lokasi",
  "storage.location.skipped": "Storage Skipped",
  "storage.location.tempMax": "Suhu Maksimum",
  "storage.location.tempMin": "Suhu Minimum",
  "storage.location.type": "Jenis Lokasi",
  "storage.location.unassigned": "Tidak ditugaskan",
  "storage.manageLocation.error.saveFailed": "Penyimpanan gagal",
  "storage.manageLocation.error.selectTarget": "Pilih perangkat, rak, laci, atau boks sebelum menyimpan",
  "storage.nav.device": "Perangkat",
  "storage.nav.room": "Ruangan",
  "storage.nav.shelf": "Rak",
  "storage.picker.backToSearch": "Kembali ke pencarian",
  "storage.picker.createNewLocation": "Buat lokasi baru",
  "storage.picker.currentLocation": "Lokasi saat ini",
  "storage.picker.heading.assignLocation": "Tugaskan Lokasi Penyimpanan",
  "storage.picker.heading.moveSample": "Pindahkan Sampel",
  "storage.picker.newLocation": "Lokasi baru",
  "storage.picker.notes": "Catatan",
  "storage.picker.position.optional": "Posisi (opsional)",
  "storage.picker.select": "Pilih {level}",
  "storage.picker.addNewLevel": "Tambah baru {level}",
  "storage.picker.inlineCreate.heading": "Buat baru {level}",
  "storage.picker.inlineCreate.error.title": "Tidak dapat membuat lokasi",
  "storage.picker.inlineCreate.error": "Gagal membuat lokasi",
  "storage.picker.sample.accession": "Nomor Registrasi",
  "storage.picker.sample.heading": "Sampel",
  "storage.picker.sample.status": "Status",
  "storage.picker.sample.type": "Jenis",
  "storage.picker.storageLocation": "Lokasi Penyimpanan",
  "storage.metrics.active": "Aktif",
  "storage.metrics.disposed": "Dimusnahkan",
  "storage.metrics.storage.locations": "Lokasi Penyimpanan",
  "storage.metrics.total.samples": "Total Item Sampel",
  "storage.mode.autocomplete": "Pencarian Ketik",
  "storage.mode.barcode": "Pindai Kode QR",
  "storage.mode.cascading": "Dropdown bertingkat",
  "storage.move.button": "Pindahkan Sampel",
  "storage.move.reason.label": "Alasan Pemindahan",
  "storage.nav.boxes": "Boks",
  "storage.nav.boxes.tooltip": "Kelola boks penyimpanan",
  "storage.nav.dashboard": "Dasbor penyimpanan",
  "storage.nav.devices": "Perangkat",
  "storage.nav.devices.tooltip": "Kelola perangkat penyimpanan",
  "storage.nav.locations": "Lokasi",
  "storage.nav.locations.tooltip": "Kelola lokasi penyimpanan",
  "storage.nav.racks": "Laci",
  "storage.nav.racks.tooltip": "Kelola laci penyimpanan",
  "storage.nav.rooms": "Ruangan",
  "storage.nav.rooms.tooltip": "Kelola ruangan penyimpanan",
  "storage.nav.sample.items": "Item Sampel",
  "storage.nav.sample.items.tooltip": "Lihat dan kelola sampel tersimpan",
  "storage.nav.samples": "Item Sampel",
  "storage.nav.samples.tooltip": "Lihat dan kelola sampel tersimpan",
  "storage.nav.shelves": "Rak",
  "storage.nav.shelves.tooltip": "Kelola rak penyimpanan",
  "storage.no.data": "Tidak ada data",
  "storage.occupancy": "Tingkat Keterisian",
  "storage.position.label": "Posisi",
  "storage.rack.device": "Perangkat",
  "storage.rack.dimensions": "Dimensi",
  "storage.rack.label": "Laci",
  "storage.rack.placeholder": "Pilih atau ketik untuk menambah laci...",
  "storage.rack.room": "Ruangan",
  "storage.rack.shelf": "Rak",
  "storage.room.code": "Kode",
  "storage.room.devices": "Perangkat",
  "storage.room.label": "Ruangan",
  "storage.room.name": "Nama",
  "storage.room.placeholder": "Pilih atau ketik untuk menambah ruangan...",
  "storage.room.samples": "Sampel",
  "storage.sampleitem.id": "ID Item Sampel",
  "storage.search.devices.placeholder": "Cari berdasarkan nama atau kode perangkat...",
  "storage.search.placeholder": "Cari berdasarkan ID sampel atau lokasi...",
  "storage.search.racks.placeholder": "Cari berdasarkan label laci...",
  "storage.search.rooms.placeholder": "Cari berdasarkan nama atau kode ruangan...",
  "storage.search.samples.placeholder": "Cari berdasarkan ID sampel atau lokasi...",
  "storage.search.shelves.placeholder": "Cari berdasarkan label rak...",
  "storage.select.location": "Pilih Lokasi",
  "storage.selectSample": "Pilih Sampel",
  "storage.shelf.device": "Perangkat",
  "storage.shelf.label": "Rak",
  "storage.shelf.placeholder": "Pilih atau ketik untuk menambah rak...",
  "storage.shelf.room": "Ruangan",
  "storage.status": "Status",
  "storage.status.disposed": "Dimusnahkan",
  "storage.success.assigned": "Penempatan sampel di lokasi penyimpanan berhasil",
  "storage.success.moved": "Pemindahan sampel ke lokasi baru berhasil",
  "storage.tab.devices": "Perangkat",
  "storage.tab.racks": "Laci",
  "storage.tab.rooms": "Ruangan",
  "storage.tab.samples": "Item Sampel",
  "storage.tab.shelves": "Rak",
  "storage.target.location": "Lokasi Target",
  "storage.unassigned.title": "Sampel tidak ditugaskan",
  "storage.skipAssignment": "Tidak diperlukan penyimpanan - sampel akan segera diproses",
  "success.add.edited.msg": "Berhasil Ditambah/Diedit",
  "success.delete.msg": "Berhasil DIhapus",
  "success.import.patient": "Pasien Berhasil Diimpor",
  "success.report.status": "Pembuatan Laporan Berhasil",
  "success.save.msg": "Penyimpanan berhasil",
  "success.save.patient": "Penyimpanan Pasien Berhasil",
  "systemuser.firstName": "Nama Depan Pengguna Sistem",
  "systemuser.isActive": "Adalah Aktif",
  "systemuser.lastName": "Nama Akhir Pengguna Sistem",
  "systemuser.loginName": "Nama Login Pengguna Sistem",
  "systemuser.role": "Peran",
  "systemuserrole.apply": "Terapkan",
  "systemuserrole.copypermissions": "Salin Izin dari Pengguna",
  "systemuserrole.copypermissions.placeholder": "Menyalin Izin Pengguna",
  "systemuserrole.instruction.1": "Terdapat dua jenis Peran. Peran Global untuk keseluruhan aplikasi dan Peran Unit Laboratorium untuk semua Unit Laboratorium atau Unit Laboratorium tertentu.",
  "systemuserrole.instruction.2": "Peran Global yang tersedia adalah: Administrator Global (Akses ke semua Fungsi Admin), Jejak Audit (Akses ke semua Jejak Audit), Administrator Akun Pengguna (memiliki akses ke semua fitur administrasi akun pengguna, tetapi tidak ke fungsi admin lainnya).",
  "systemuserrole.instruction.3": "Peran Unit Laboratorium adalah: Penerimaan (Akses ke Tab Pemesanan, Pasien, dan Ketidaksesuaian), Hasil (Akses ke Tab Rencana Kerja, Ketidaksesuaian, dan Hasil), Validasi (Akses ke Tab Validasi dan Ketidaksesuaian), Laporan (Akses ke Tab Laporan kecuali ekspor CSV hanya tersedia untuk Administrator Global).",
  "systemuserrole.instruction.4": "Untuk menetapkan Peran Unit Lab, pilih semua unit lab atau unit lab tertentu dari menu dropdown dan pilih peran apa yang ingin ditetapkan.",
  "systemuserrole.instruction.5": "Anda dapat menggunakan Fitur Salin Izin untuk menyalin izin pengguna yang sudah ada. Pastikan Anda telah mengisi semua informasi di atas dan masukkan nama pengguna yang izinnya ingin Anda salin ke dalam kotak, lalu klik terapkan.",
  "systemuserrole.newpermissions": "Tambah Izin Baru",
  "systemuserrole.rmpermissions": "Hapus Izin",
  "systemuserrole.roles.global": "Peran Global",
  "systemuserrole.roles.labunit": "Peran Unit Lab",
  "test.add.copy.name": "Salin dari Nama Pemeriksaan",
  "test.antimicrobialResistance": "Resistensi Antimikroba",
  "test.description.active": "Jika pemeriksaan sedang aktif, maka dapat dipesan melalui formulir pemesanan atau sebagai bagian algoritma pemeriksaan. Jika pemeriksaan tidak aktif, maka tidak dapat dipesan atau dijadikan bagian algoritma pemeriksaan.",
  "test.description.name": "Nama pemeriksaan akan muncul di dalam sistem, baik versi bahasa Inggris maupun Prancis.",
  "test.description.orderable": "Jika pemeriksaan aktif dan dapat dipesan, maka pemeriksaan dapat dipesan melalui formulir pemesanan. Jika pemeriksaan aktif tetapi tidak dapat dipesan, maka pemeriksaan hanya akan dilakukan sebagai refleks dari pemeriksaan lain.",
  "test.description.panel": "Jika pemeriksaan ini merupakan bagian dari panel pemeriksaan, maka panel tersebut dapat ditambahkan di sini. Kemungkinan pemeriksaan ada di lebih dari satu panel.",
  "test.description.reportName": "Nama pemeriksaan akan muncul di dalam sistem, baik versi bahasa Inggris maupun Prancis. Jika Nama dan nama pelapor sama, klik tombol untuk menyalin nama",
  "test.description.testSection": "Bagian tempat pemeriksaan dilakukan",
  "test.description.uom": "Satuan pengukuran pemeriksaan. Biasanya berlaku hanya untuk jenis hasil numerik atau alfanumerik.",
  "test.field.active": "Aktif",
  "test.field.orderable": "Dapat dipesan",
  "test.inLabOnly": "Hanya Di Lab",
  "test.modify.en": "en",
  "test.modify.fr": "fr",
  "test.modify.header.modify": "Pilih Pemeriksaan yang akan Dimodifikasi!",
  "test.modify.header.test": "Pemeriksaan",
  "test.name": "Nama Pemeriksaan",
  "test.notifyResults": "Kirim Notifikasi ke Pasien dengan Hasil",
  "test.section": "Bagian Pemeriksaan",
  "test.section.label": "Bagian Pemeriksaan",
  "test.show.guide": "Tampilkan Panduan",
  "testcalculation.label.calculation": "Penghitungan",
  "testcalculation.label.finalresult": "Hasil Akhir",
  "testcalculation.label.insertOperation": "Masukan Operasi",
  "testcalculation.label.integer": "Bilangan Bulat",
  "testcalculation.label.mathFucntion": "Fungsi Matematika",
  "testcalculation.label.name": "Nama Penghitungan",
  "testcalculation.label.patientAttribute": "Atribut Pasien",
  "testcalculation.label.searchNumericTest": "Cari Pemeriksaan Numerik",
  "testcalculation.label.selectDictionaryValue": "Pilih Nilai Kamus",
  "testcalculation.label.testResult": "Hasil Pemeriksaan",
  "testcalculation.label.textValue": "Nilai teks",
  "testCatalog.header.ageRange": "Rentang Umur",
  "testCatalog.header.criticalRange": "Rentang Kritis",
  "testCatalog.header.field": "Bidang",
  "testCatalog.header.gender": "Jenis Kelamin",
  "testCatalog.header.normalRange": "Rentang Normal",
  "testCatalog.header.reportingRange": "Rentang Pelaporan",
  "testCatalog.header.validRange": "Rentang Valid",
  "testCatalog.header.value": "Nilai",
  "admin.testCatalog.methods.title": "Metode",
  "admin.testCatalog.methods.column.name": "Nama Metode",
  "admin.testCatalog.methods.column.code": "Kode",
  "admin.testCatalog.methods.column.default": "Default",
  "admin.testCatalog.methods.column.effectiveDate": "Tanggal Efektif",
  "admin.testCatalog.methods.column.actions": "Aksi",
  "admin.testCatalog.methods.action.edit": "Edit",
  "admin.testCatalog.methods.action.remove": "Hapus",
  "admin.testCatalog.methods.btn.linkMethod": "+ Link Method",
  "admin.testCatalog.methods.btn.createMethod": "+ Create New Method",
  "admin.testCatalog.methods.btn.copyFromTest": "Copy from Test",
  "admin.testCatalog.methods.modal.link.title": "Link Method",
  "admin.testCatalog.methods.modal.link.selectPlaceholder": "Select a method to link",
  "admin.testCatalog.methods.modal.link.noAvailable": "All active methods are already linked",
  "admin.testCatalog.methods.inline.nameEnglish": "Method Name (English)",
  "admin.testCatalog.methods.inline.nameFrench": "Method Name (French)",
  "admin.testCatalog.methods.inline.code": "Shortcode",
  "admin.testCatalog.methods.inline.codeHint": "3–10 uppercase alphanumeric characters, no spaces",
  "admin.testCatalog.methods.inline.createAndLink": "Create & Link",
  "admin.testCatalog.methods.copyFromTest.label": "Copy methods from test",
  "admin.testCatalog.methods.copyFromTest.placeholder": "Select source test",
  "admin.testCatalog.methods.effectiveDate.label": "Tanggal Efektif",
  "admin.testCatalog.methods.default.label": "Set as default",
  "admin.testCatalog.methods.error.duplicateLink": "This method is already linked to the test",
  "admin.testCatalog.methods.error.codeFormat": "Code must be 3–10 uppercase alphanumeric characters with no spaces",
  "admin.testCatalog.methods.error.effectiveDateRequired": "Effective date is required",
  "admin.testCatalog.methods.empty": "No methods linked. Use '+ Link Method' or '+ Create New Method' to add one.",
  "testnotification.bcc": "BCC",
  "testnotification.instructionis.variables.body": "[testName] : Nama pemeriksaan",
  "testnotification.instructionis.variables.body.0": "[testResult] : Hasil pemeriksaan",
  "testnotification.instructionis.variables.body.1": "[patientFirstName] : Nama depan pasien ",
  "testnotification.instructionis.variables.body.2": "[patientLastNameInitial] : Inisial nama belakang pasien",
  "testnotification.instructionis.variables.header": "Daftar variabel:",
  "testnotification.instructions.body": "Saat notifikasi dibuat, sistem akan memeriksa dahulu apakah template pesan telah ditentukan untuk penerima/tipe pesan tersebut.",
  "testnotification.instructions.body.0": "Jika tidak ada, maka akan menggunakan pesan default pemeriksaan.",
  "testnotification.instructions.body.1": "Jika tidak ada, maka akan menggunakan pesan default sistem.",
  "testnotification.instructions.body.2": "Variabel akan digantikan oleh nilai yang sesuai di dalam isi pesan dan subjek.",
  "testnotification.instructions.body.3": "Variabel harus selalu menyertakan tanda kurung siku dan tidak boleh mengandung spasi.",
  "testnotification.instructions.header": "Petunjuk:",
  "testnotification.messagetemplate": "Pesan",
  "testnotification.options": "Pesan Pribadi",
  "testnotification.patient.email": "Email Pasien",
  "testnotification.patient.sms": "SMS Pasien",
  "testnotification.patiententry.header": "Pelaporan Hasil",
  "testnotification.patiententry.info": "Jika sistem tidak dapat terhubung ke penerima, maka hasilnya akan dimasukkan ke dalam antrian. Antrian yang banyak dan menumpuk adalah tanda bahwa perlu dilakukan pemecahan masalah, misalnya menghubungi pihak penerima.",
  "testnotification.provider.email": "Email Penyelenggara",
  "testnotification.provider.sms": "SMS Penyelenggara",
  "testnotification.subjecttemplate": "Subjek",
  "testnotification.systemdefault.template": "Pesan Default Sistem",
  "testnotification.testdefault.editIcon": "Edit Notifikasi Pemeriksaan",
  "testnotification.testdefault.template": "Pesan Default untuk Pemeriksaan",
  "testnotificationconfig.browse.title": "Konfigurasi Notifikasi Pemeriksaan",
  "tests.not.assigned": "Pemeriksaan tidak ditugaskan",
  "testsection.testSectionName": "Nama Bagian Pemeriksaan",
  "testUnit.existing": "Instalasi Lab Yang Ada",
  "testUnit.existing.inactive": "Instalasi Lab Inaktif. Tugaskan pemeriksaan untuk mengaktivasi.",
  "testUnit.new": "Pemeriksaan Unit Baru",
  "text.length.max": "Panjang teks tidak lebih dari 200",
  "title.notestfoundmatching": "Tidak ditemukan kecocokan pemeriksaan",
  "to.title": "Kepada",
  "tooltip.banner.menu.generic.sample.results": "Masukan hasil pemeriksaan untuk sampel generik",
  "total.quantity": "Kuantitas Total",
  "transaction.date": "Tanggal",
  "transaction.quantity": "Kuantitas",
  "transaction.type": "Jenis",
  "transaction.user": "Pengguna",
  "true.label": "True",
  "unifiedSystemUser.add.user": "Tambah Pengguna",
  "unifiedSystemUser.browser.button.add": "Tambah Pengguna Baru",
  "unifiedSystemUser.browser.search": "Cari Berdasarkan Nama Pengguna",
  "unifiedSystemUser.browser.search.placeholder": "Cari Berdasarkan Nama Pengguna...",
  "unifiedSystemUser.browser.title": "Pengelolaan Pengguna",
  "unifiedSystemUser.edit.user": "Modifikasi Pengguna",
  "unifiedSystemUser.select": "Pilih",
  "unknown.section": "Bagian Tidak Diketahui",
  "unknown.test": "Pemeriksaan Tidak Diketahui",
  "uom.browse.title": "Satuan Pengukuran",
  "uom.create.heading.confirmation": "Konfirmasi",
  "uom.existing": "Satuan Pengukuran Saat Ini",
  "uom.existing.inactive": "Satuan Pengukuran Inaktif. Tugaskan pemeriksaan pada Satuan Pengukuran untuk mengaktivasi.",
  "uom.new": "Buat Satuan Pengukuran baru",
  "uom.new.added": "Satuan Pengukuran Baru akan ditambahkan",
  "uom.notification.duplicate": "Satuan Pengukuran sudah ada",
  "uom.notification.save": "Satuan Pengukuran Baru akan disimpan.",
  "uom.uomName": "Nama Satuan Pengukuran",
  "training.installation.message": "Instalasi Pelatihan",
  "translation.edit.title": "Edit Terjemahan",
  "translation.export": "Ekspor CSV",
  "translation.export.success": "Terjemahan berhasil diekspor",
  "translation.fallback": "Alternatif (English)",
  "translation.management.description": "Lihat dan edit terjemahan untuk metadata.",
  "translation.management.title": "Pengelolaan Terjemahan",
  "translation.missing": "Hilang",
  "translation.search": "Cari terjemahan...",
  "translation.selectLocale": "Pilih Bahasa",
  "translation.showMissing": "Tampilkan Hanya yang Hilang ",
  "translation.stats.title": "Kemajuan Penterjemahan",
  "translation.stats.total": "Total entri: {count}",
  "translation.update.error": "Gagal memperbarui terjemahan",
  "translation.update.success": "Terjemahan berhasil diperbarui",
  "translation.value": "Terjemahan",
  "usage.analysisId": "Nomor Identitas Analisis",
  "usage.date": "Tanggal Digunakan",
  "usage.notes": "Catatan",
  "usage.notes.placeholder": "Tambah catatan untuk penggunaan ini",
  "usage.quantityUsed": "Kuantitas yang Digunakan",
  "usage.quantityUsed.helper": "Masukkan nomor unit yang habis",
  "usage.record.button": "Merekam Penggunaan",
  "usage.record.success": "Penggunaan berhasil terekam",
  "usage.record.title": "Merekam Penggunaan Inventaris",
  "usage.testResultId": "Nomor Identitas Hasil Pemeriksaan (Opsional)",
  "usage.testResultId.placeholder": "Terkati ke hasil pemeriksaan untuk penelusuran",
  "user.select.instruction": "Pilih Pengguna yang ingin Dimodifikasi atau Dinonaktifkan. Anda dapat mengatur Filter, Mencari pengguna, atau Menambahkan Pengguna dengan kendali di bagian atas.",
  "validation.accept.all": "Simpan Semua Hasil",
  "validation.accept.normal": "Simpan Semua Normal",
  "validation.field.required": "Bidang ini diperlukan",
  "validation.ignore.all": "Abaikan Semua Hasil",
  "validation.label.nonconform": "= Sampel atau Pemesanan yang tidak sesuai atau Pemeriksaan telah ditolak",
  "validation.password.match": "Kata kunci harus sama",
  "validation.password.minLength": "Kata Kunci harus lebih dari 7 karakter",
  "validation.password.notSameAsOld": "Kata kunci baru tidak boleh sama dengan kata kunci lama",
  "validation.password.specialChar": "Kata kunci harus mengandung setidaknya satu karakter khusus (*$#!) dan satu huruf besar",
  "validation.no.records.display": "Tidak ada rekaman untuk ditampilkan",
  "validation.reject.all": "Ulang Semua Pemeriksaan",
  "validation.save.error": "Validasi Hasil berhasil",
  "validation.save.success": "Validasi Hasil berhasil",
  "validation.search.noresult": "Hasil tidak ditemukan untuk divalidasi",
  "validation.search.noresult.analyser": "Hasil tidak ditemukan dari :",
  "vl.arvRegimen": "ARV Regimen",
  "vl.durationOnARV": "Durasi pemberian ARV (bulan)",
  "vl.durationOnARV.placeholder": "Masukkan bulan berjalan pengobatan",
  "vl.indication": "Indikasi untuk pemeriksaan VL",
  "vl.lastVLDate": "Tanggal Hasil VL Terakhir",
  "vl.lastVLResult": "Hasil VL Terakhir (copies/mL)",
  "vl.lastVLResult.placeholder": "mis., 150",
  "vl.pregnancyStatus": "Status Kehamilan / Menyusui",
  "workplan.page.title": "Rencana Kerja {0}",
  "workplan.panel.selection.error.msg": "Ini pesan error tidak valid.",
  "workplan.panel.title": "Rencana Kerja Berdasarkan Panel",
  "workplan.panel.types": "Jenis Panel",
  "workplan.print": "Cetak Rencana Kerja",
  "workplan.priority.list": "Prioritas",
  "workplan.priority.title": "Rencana Kerja Berdasarkan Prioritas",
  "workplan.run": "Ambil Rencana Kerja",
  "workplan.test.title": "Rencana Kerja Berdasarkan Pemeriksaan",
  "workplan.test.types": "Jenis Pemeriksaan",
  "workplan.title": "Rencana Kerja",
  "workplan.unit.title": "Rencana Kerja Berdasarkan Unit",
  "workplan.unit.types": "Jenis Unit",
  "yes.option": "Ya",
  "shipment.module.title": "Pengelolaan Pengiriman",
  "shipment.breadcrumb": "Pengiriman Sampel",
  "shipment.nav.dashboard": "Dasbor",
  "shipment.nav.createBox": "Buat Boks",
  "shipment.nav.receiveBox": "Terima Boks",
  "shipment.dashboard.title": "Dasbor Pengiriman",
  "shipment.dashboard.description": "Kelola boks pengiriman dan lacak sampel yang dirujuk",
  "shipment.dashboard.tabs.shipments": "Pengiriman",
  "shipment.dashboard.tabs.unassigned": "Pemeriksaan Tidak Ditugaskan",
  "shipment.tab.boxes": "Boks Pengiriman",
  "shipment.tab.unassignedSamples": "Sampel Tidak Ditugaskan",
  "shipment.label.boxId": "ID Boks",
  "shipment.label.createdDate": "Tanggal Dibuat",
  "shipment.label.daysUnassigned": "Hari Tidak Ditugaskan",
  "shipment.label.destination": "Tujuan",
  "shipment.label.priority": "Prioritas",
  "shipment.label.referralTest": "Pemeriksaan Rujukan",
  "shipment.label.sampleCount": "Jumlah Sample",
  "shipment.label.state": "Status",
  "shipment.label.tests": "Pemeriksaan",
  "shipment.filter.state": "Filter berdasarkan Status",
  "shipment.filter.facility": "Filter berdasarkan Lembaga",
  "shipment.action.addSelected": "Add selected",
  "shipment.action.addToBox": "Tambah ke Boks",
  "shipment.action.cancelReferral": "Batalkan Rujukan",
  "shipment.action.confirmRejection": "Konfirmasi Penolakan",
  "shipment.action.createBox": "Buat Boks Baru",
  "shipment.action.markAsLost": "Tandai sebagai Hilang",
  "shipment.action.printManifest": "Cetak Manifest",
  "shipment.action.rejectSample": "Tolak Sampel",
  "shipment.action.saveAndMarkReady": "Simpan & Tandai Siap Dikirim",
  "shipment.action.saveBox": "Simpan Boks",
  "shipment.action.saveDraft": "Simpan sebagai Draf",
  "shipment.action.scanSample": "Pindai Sampel",
  "shipment.box.addSample": "Tambah Sampel",
  "shipment.box.addSampleDescription": "Pilih sampel untuk ditambah ke boks pengiriman ini",
  "shipment.box.addSamples": "Tambah Sampel",
  "shipment.box.details": "Box Details",
  "shipment.box.autoGenerate": "Auto-generate",
  "shipment.box.capacity": "Kapasitas",
  "shipment.box.capacityValue": "{capacity} sampel",
  "shipment.box.create": "Buat Boks",
  "shipment.box.createDescription": "Buat boks pengiriman baru untuk sampel yang dirujuk",
  "shipment.box.created": "Tanggal Dibuat:",
  "shipment.box.createdBy": "Dibuat Oleh:",
  "shipment.box.createdDate": "Tanggal Dibuat",
  "shipment.box.destination": "Tujuan",
  "shipment.box.downloadLabel": "Unduh Label",
  "shipment.box.downloadManifest": "Unduh Manifest",
  "shipment.box.generateLabel": "Buat Label",
  "shipment.box.generateManifest": "Buat Manifest",
  "shipment.box.id": "ID Boks:",
  "shipment.box.labelDownloaded": "Label berhasil diunduh",
  "shipment.box.labelPrefix": "Prefiks Label",
  "shipment.box.labelPrefixHelper": "Dikonfigurasi oleh administrator di Pengaturan Situs",
  "shipment.box.manifest": "Manifest",
  "shipment.box.manifestDownloaded": "Manifest berhasil diunduh",
  "shipment.box.noSamples": "Boks ini belum memiliki sampel",
  "shipment.box.noUnassignedSamples": "Tidak ada sampel yang ditugaskan untuk lembaga ini",
  "shipment.box.notes": "Catatan",
  "shipment.box.notesPlaceholder": "Masukkan instruksi atau catatan penanganan khusus...",
  "shipment.box.number": "Nomor Boks",
  "shipment.box.readyConfirmation": "Apakah Anda yakin ingin menandai boks ini sebagai siap dikirim?",
  "shipment.box.readySampleCount": "Boks ini memiliki {count} sampel",
  "shipment.box.readyToSend": "Tandai Siap Dikirim",
  "shipment.box.reconcile": "Rekonsiliasi",
  "shipment.box.removeSample": "Hapus Sampel",
  "shipment.box.removeSampleConfirmation": "Apakah Anda yakin ingin menghapus sampel ini dari boks?",
  "shipment.box.resendManifest": "Kirim Ulang Manifest",
  "shipment.box.sampleCount": "Jumlah Sampel",
  "shipment.box.sampleProgress": "{added} / {capacity} ({remaining} sisa)",
  "shipment.box.samplesAdded": "Sampel Ditambah",
  "shipment.box.samplesSelected": "{count} sampel dipilih",
  "shipment.box.scanExisting": "Pindai yang ada",
  "shipment.box.scanExistingId": "Pindai atau masukkan ID Boks yang ada",
  "shipment.box.scanExistingIdPlaceholder": "Pindai kode QR atau ketik ID boks",
  "shipment.box.sendBox": "Kirim Boks",
  "shipment.box.sendConfirmation": "Apakah Anda yakin akan mengirim boks ini?",
  "shipment.box.sendSampleCount": "Boks ini memiliki {count} sampel yang akan ditandai sebagai terkirim",
  "shipment.box.state": "Status",
  "shipment.box.summary": "Ringkasan",
  "shipment.box.temperature": "Persyaratan Suhu",
  "shipment.box.title": "Boks {boxId}",
  "shipment.box.useExistingId": "Mode ID Boks",
  "shipment.dashboard.boxNotFound": "Tidak ada boks ditemukan dengan ID \"{boxId}\". Coba dengan memfilter daftar.",
  "shipment.dashboard.scanBoxPlaceholder": "Cari atau pindai ID Boks (tekan Enter untuk navigasi)",
  "shipment.error.addSample": "Gagal menambah sampel ke boks",
  "shipment.error.assignToBox": "Gagal menugaskan sampel ke boks",
  "shipment.error.boxFull": "Boks penuh. Tidak dapat menambah sampel.",
  "shipment.error.boxNotEmpty": "Boks harus memiliki setidaknya satu sampel",
  "shipment.error.boxNotFound": "Boks tidak ditemukan",
  "shipment.error.cancelReferral": "Gagal membatalkan rujukan",
  "shipment.error.confirmReception": "Gagal mengkonfirmasi penerimaan",
  "shipment.error.createBox": "Gagal membuat boks pengiriman",
  "shipment.error.exceedsCapacity": "Tidak dapat menambah {requested} sampel. Hanya {available} slot yang tersedia.",
  "shipment.error.fetchBox": "Gagal menarik informasi boks",
  "shipment.error.fetchBoxes": "Gagal menarik boks yang tersedia",
  "shipment.error.generateLabel": "Error membuat label pengiriman",
  "shipment.error.generateManifest": "Error membuat manifest",
  "shipment.error.invalidState": "Status boks invalid untuk operasional ini",
  "shipment.error.markAsLost": "Gagal menandai sampel sebagai hilang",
  "shipment.error.markReady": "Gagal menandai boks sebagai siap dikirim",
  "shipment.error.noDestinationFacility": "Tidak ada lembaga tujuan dicantumkan untuk sampel ini",
  "shipment.error.noReferralId": "Tidak ada ID rujukan tersedia untuk sampel ini",
  "shipment.error.noSampleSelected": "Mohon pilih setidaknya satu sampel",
  "shipment.error.partialReception": "Beberapa sampel statusnya gagal diperbarui. Mohon coba lagi.",
  "shipment.error.reasonRequired": "Masukkan alasan",
  "shipment.error.reconcile": "Error rekonsiliasi boks",
  "shipment.error.removeSample": "Gagal menghapus sampel dari boks",
  "shipment.error.sampleAlreadyAssigned": "Sampel ini siap ditugaskan ke boks",
  "shipment.error.sampleAlreadyInBox": "Sampel sudah di dalam boks",
  "shipment.error.sampleNotFound": "Sampel tidak ditemukan",
  "shipment.error.saveFailed": "Gagal menyimpan",
  "shipment.error.searchFailed": "Gagal mencari sampel. Mohon coba lagi.",
  "shipment.error.selectBox": "Mohon pilih boks",
  "shipment.error.sendBox": "Gagal mengirim boks",
  "shipment.filter.clear": "Hapus Filter",
  "shipment.filter.dateFrom": "Dari Tanggal",
  "shipment.filter.dateTo": "Sampai Tanggal",
  "shipment.filter.referenceLab": "Lab Rujukan",
  "shipment.label.addedDate": "Tanggal Ditambah",
  "shipment.label.position": "Posisi",
  "shipment.label.samples": "Sampel",
  "shipment.label.shippingLabel": "LABEL PENGIRIMAN",
  "shipment.manifest.generated": "Dibuat:",
  "shipment.manifest.number": "#",
  "shipment.manifest.recallExpired": "Penarikan manifest tidak tersedia lagi (sudah melebihi batas 7-hari sejak dikirim)",
  "shipment.manifest.regenerationExpired": "Pembuatan ulang manifest tidak tersedia lagi (sudah melebihi batas 24-jam sejak dikirim)",
  "shipment.manifest.serviceLocation": "Lokasi Layanan:",
  "shipment.manifest.specimenBarcodes": "Kode QR Spesimen",
  "shipment.manifest.title": "Manifest Pengiriman",
  "shipment.manifest.totalSamples": "Total Sampel",
  "shipment.modal.addToBox.existingBox": "Tambah ke boks yang ada",
  "shipment.modal.addToBox.mode": "Pilih opsi",
  "shipment.modal.addToBox.newBox": "Buat boks baru",
  "shipment.modal.addToBox.newBoxInfo.message": "Anda akan diarahkan ke pembuatan boks baru untuk sampel ini",
  "shipment.modal.addToBox.newBoxInfo.title": "Buat Boks Baru",
  "shipment.modal.addToBox.noDraftBoxes.message": "Tidak ada draf boks untuk tujuan ini. Boks baru akan dibuat.",
  "shipment.modal.addToBox.noDraftBoxes.title": "Tidak Ada Draf Boks Tersedia",
  "shipment.modal.addToBox.selectBox": "Pilih Boks",
  "shipment.modal.addToBox.title": "Tambah Sampel ke Boks",
  "shipment.modal.cancelReferral.reason": "Alasan Pembatalan",
  "shipment.modal.cancelReferral.reasonPlaceholder": "Mohon jelaskan mengapa perujukan ini dibatalkan...",
  "shipment.modal.cancelReferral.title": "Batalkan Rujukan",
  "shipment.modal.cancelReferral.warning.message": "Aksi ini akan membatalkan rujukan secara permanen dan tidak bisa dibatalkan.",
  "shipment.modal.cancelReferral.warning.title": "Peringatan",
  "shipment.modal.createBox.cancel": "Batal",
  "shipment.modal.createBox.submit": "Buat",
  "shipment.modal.createBox.title": "Buat Boks Baru",
  "shipment.modal.markAsLost.reason": "Alasan menandai sebagai hilang",
  "shipment.modal.markAsLost.reasonPlaceholder": "Jelaskan mengapa sampel ini ditandai sebagai hilang...",
  "shipment.modal.markAsLost.title": "Tandai Sampel sebagai Hilang",
  "shipment.modal.markAsLost.warning.message": "Aksi ini akan menandai sampel sebagai hilang secara permanen dan tidak bisa dibatalkan.",
  "shipment.modal.markAsLost.warning.title": "Peringatan",
  "shipment.modal.rejectSample": "Tolak Sampel",
  "shipment.modal.rejectSampleMessage": "Apakah Anda yakin ingin menolak sampel {accession}?",
  "shipment.nav.referenceLabResults": "Reference Lab Results",
  "shipment.nav.reports": "Laporan",
  "shipment.nav.settings": "Pengaturan",
  "shipment.notification.boxCreated": "Boks berhasil dibuat",
  "shipment.notification.boxReadyToSend": "Boks ditandai sebagai Siap Dikirim",
  "shipment.notification.boxReconciled": "Boks berhasil direkonsiliasi",
  "shipment.notification.boxSent": "Boks berhasil dikirim",
  "shipment.notification.error": "Terjadi error: {message}",
  "shipment.notification.partialSamplesAdded": "Hanya {added} dari {total} sampel ditambahkan. Boks sudah mencapai kapasitasnya ({notAdded} tidak ditambahkan).",
  "shipment.notification.receptionComplete": "Paket berhasil diterima",
  "shipment.notification.referralCancelled": "Perujukan berhasil dibatalkan",
  "shipment.notification.sampleAdded": "Sampel {accessionNumber} ditambah dengan {testCount, plural, one {# test} other {# tests}}",
  "shipment.notification.sampleAssignedToBox": "Sampel berhasil ditugaskan ke boks",
  "shipment.notification.sampleMarkedAsLost": "Sampel ditandai sebagai hilang",
  "shipment.notification.sampleRejected": "Sampel {accession} ditolak: {reason}",
  "shipment.notification.sampleRemoved": "Sampel dihapus dari boks",
  "shipment.notification.samplesAdded": "{count, plural, other {# sampel ditambah ke boks}}",
  "shipment.notification.samplesRemovedDueToCapacity": "{removed} sampel dihapus karena pengurangan kapasitas.",
  "shipment.reception.acceptSample": "Accept Sample",
  "shipment.reception.applyToAll": "Terapkan status ke semua...",
  "shipment.reception.awaitingAcceptance": "Awaiting acceptance",
  "shipment.reception.confirmMessage": "Konfirmasi penerimaan untuk {count} sampel?",
  "shipment.reception.confirmReception": "Konfirmasi Penerimaan",
  "shipment.reception.damaged": "Rusak",
  "shipment.reception.description": "Pindai kode QR boks untuk menerima dan memverifikasi sampel",
  "shipment.reception.enterBoxId": "SIlahkan masukan ID boks",
  "shipment.reception.generalNotes": "Catatan Umum",
  "shipment.reception.generalNotesPlaceholder": "Masukkan catatan umum penerimaan ",
  "shipment.reception.importError": "Error mengimpor pengiriman dari remote server",
  "shipment.reception.importFromFhir": "Impor dari FHIR",
  "shipment.reception.importResult": "{count, plural, =0 {No new shipments found} one {1 shipment imported} other {{count} shipments imported}}",
  "shipment.reception.incomingBoxes": "Incoming Shipments",
  "shipment.reception.leaked": "Bocor",
  "shipment.reception.markAllMissing": "Tandai Semua Hilang",
  "shipment.reception.markAllReceived": "Tandai Semua Diterima",
  "shipment.reception.missing": "Hilang",
  "shipment.reception.noIncomingBoxes": "No incoming shipments. Click 'Import from FHIR' to check for new shipments.",
  "shipment.reception.notes": "Catatan",
  "shipment.reception.notesPlaceholder": "Masukkan catatan bila diperlukan",
  "shipment.reception.notesRequired": "Catatan wajib ada untuk sampel yang diterima tidak dalam kondisi baik",
  "shipment.reception.notesRequiredPlaceholder": "Wajib: jelaskan masalah",
  "shipment.reception.openBox": "Buka",
  "shipment.reception.originFacility": "Dari",
  "shipment.reception.pending": "Tertunda",
  "shipment.reception.pendingAcceptance": "Specimens Awaiting Acceptance",
  "shipment.reception.received": "Diterima",
  "shipment.reception.referralOrder": "Referral Order",
  "shipment.reception.rejected": "Ditolak",
  "shipment.reception.sampleCountSummary": "{accepted} accepted / {expected} expected",
  "shipment.reception.sampleNotFound": "Sampel {accessionNumber} tidak ditemukan di boks ini",
  "shipment.reception.sampleScanned": "Sampel {accessionNumber} diperiksa saat diterima",
  "shipment.reception.sampleVerification": "Verifikasi Sampel",
  "shipment.reception.scanBox": "ID Boks / Kode QR",
  "shipment.reception.scanBoxPlaceholder": "Pindai atau masukkan kode QR boks",
  "shipment.reception.scanButton": "Pindai Boks",
  "shipment.reception.scanSample": "Pindai Sampel ID",
  "shipment.reception.scanSampleButton": "Sampel Check In",
  "shipment.reception.scanSamplePlaceholder": "Pindai atau ketik nomor registrasi sampel",
  "shipment.reception.shipped": "Sudah dikirim",
  "shipment.reception.specimen": "Spesimen",
  "shipment.reception.status": "Status Penerimaan",
  "shipment.reception.title": "Terima Paket",
  "shipment.reception.unresolved": "No matching order",
  "shipment.rejection.damaged": "Rusak",
  "shipment.rejection.expired": "Kedaluwarsa",
  "shipment.rejection.insufficientVolume": "Volume tidak cukup",
  "shipment.rejection.other": "Lainnya",
  "shipment.rejection.reason": "Alasan Penolakan",
  "shipment.rejection.wrongType": "Jenis Sampel Salah",
  "shipment.report.contents": "Isi",
  "shipment.report.description": "Buat dan ekspor laporan pengiriman berdasarkan boks, tanggal, tujuan, atau lab rujukan",
  "shipment.report.export.excel": "Ekspor Excel",
  "shipment.report.export.pdf": "Ekspor PDF",
  "shipment.report.generate": "Buat Laporan",
  "shipment.report.noResults": "Tidak ada rekaman pengiriman ditemukan dengan filter ini.",
  "shipment.report.receivedDate": "Tanggal Diterima",
  "shipment.report.receivedStatus": "Status Penerimaan",
  "shipment.report.receiver": "Penerima",
  "shipment.report.receivingUser": "Pengguna Yang Menerima",
  "shipment.report.sender": "Pengirim",
  "shipment.report.sentDate": "Tanggal Dikirim",
  "shipment.report.title": "Laporan Pengiriman",
  "shipment.report.totalBoxes": "Total Boks",
  "shipment.report.totalSamples": "Total Sampel",
  "shipment.sample.accessionNumber": "Nomor Registrasi",
  "shipment.sample.multipleMatches": "Multiple samples match — select which to add",
  "shipment.sample.remove": "Hapus",
  "shipment.sample.search": "Cari sampel berdasarkan nomor registrasi",
  "shipment.sample.searchPlaceholder": "Pindai atau masukkan nomor registrasi",
  "shipment.sample.status": "Status",
  "shipment.sample.type": "Jenis Sampel",
  "shipment.settings.administration": "Administrasi",
  "shipment.settings.boxLabelSection": "Konfigurasi Label Boks",
  "shipment.settings.description": "Konfigurasi pengaturan modul pengiriman",
  "shipment.settings.fhirConfig": "Opsi Pemetaan FHIR",
  "shipment.settings.fhirConfigDesc": "Konfigurasi pemetaan SupplyDelivery dan jenis wadah spesimen untuk interoperabilitas FHIR",
  "shipment.settings.fhirConfigNote": "Pemetaan FHIR dikonfigurasi melalui properti aplikasi. Kontak admin sistem untuk melakukan perubahan.",
  "shipment.settings.fhirConfigSaveError": "Gagal menyimpan konfigurasi pemetaan FHIR",
  "shipment.settings.fhirConfigSaved": "Konfigurasi pemetaan FHIR disimpan",
  "shipment.settings.fhirContainerType": "Jenis Wadah Spesimen (SNOMED CT)",
  "shipment.settings.fhirDisplayName": "Nama di Tampilan",
  "shipment.settings.fhirNonConformity": "Kode Ketidaksesuaian (SNOMED CT)",
  "shipment.settings.fhirSnomedCode": "Kode SNOMED CT",
  "shipment.settings.manageFacilities": "Kelola Registri Lembaga",
  "shipment.settings.manageFacilitiesDesc": "Tambah, edit, atau hapus tujuan laboratorium rujukan",
  "shipment.settings.manageUsers": "Kelola Pengguna",
  "shipment.settings.manageUsersDesc": "Konfigurasi akun dan peran pengguna untuk modul pengiriman",
  "shipment.settings.prefixHelperText": "Prefiks yang digunakan saat membuat ID boks baru (mis. BOX, SHIP, LAB)",
  "shipment.settings.prefixPlaceholder": "BOKS",
  "shipment.settings.prefixPreview": "Pratinjau: {preview}",
  "shipment.settings.prefixRequired": "Prefiks label boks wajib ada",
  "shipment.settings.prefixSaveError": "Error saat menyimpan prefiks label boks",
  "shipment.settings.prefixSaved": "Prefiks label boks berhasil disimpan",
  "shipment.settings.siteOrgDescription": "Pilih organisasi yang mewakili laboratorium ini. Hanya pengiriman dengan tujuan laboratorium ini yang akan diimpor ke server FHIR remote.",
  "shipment.settings.siteOrgLabel": "Laboratorium Ini",
  "shipment.settings.siteOrgSaveError": "Error menyimpan pengaturan tempat",
  "workflow.clinical": "Klinis",
  "workflow.environmental": "Lingkungan / Lainnya",
  "provider.name": "Nama Penyelenggara",
  "provider.name.placeholder": "Masukkan nama penyelenggara",
  "provider.phone": "Telepon Penyelenggara",
  "provider.search.helper": "Masukkan nama atau nomor telepon penyelenggara dan tekan Cari.",
  "site.search": "Cari Tempat",
  "site.name": "Nama Tempat",
  "site.name.placeholder": "Masukkan nama tempat",
  "site.location": "Lokasi",
  "site.type": "Jenis",
  "site.department": "Department / Ward / Unit",
  "site.department.selectFirst": "Pilih lembaga terlebih dahulu..",
  "site.department.none": "Tidak ada subunit tersedia",
  "sample.filterByLabUnit": "Filter berdasarkan Instalasi Lab",
  "sample.allLabUnits": "Semua Instalasi Lab",
  "sample.orderPanels": "Panel Pemesanan",
  "sample.orderTests": "Pemesanan Pemeriksaan",
  "sample.referToReferenceLab": "Rujuk pemeriksaan ke lab rujukan",
  "sample.optional.info": "Pemilihan sampel dan pemeriksaan opsional pada tahap ini. Jenis pemeriksaan dan sampel dapat dispesifikasi nanti saat pengambilan.",
  "panel.search.placeholder": "Pilih Panel yang Tersedia",
  "test.search.placeholder": "Pilih Pemeriksaan yang tersedia",
  "test.timeHolding": "SOP Max Holding Time (minutes)",
  "select.regimen": "Pilih Regimen...",
  "select": "Pilih...",
  "generating": "Membuat...",
  "label.order": "Label Pemesanan",
  "label.sample": "Label Sampel",
  "label.slide": "Label Slide",
  "label.block": "Label Blok",
  "label.freezer": "Label Freezer",
  "environmental.coming.soon": "Alur Kerja Lingkungan",
  "environmental.location.info": "Bidang hirarki lokasi (Kabupaten/Kecamatan/Kelurahan-Desa) dan tangkapan GPS akan tersedia disini.",
  "env.collectionConditions.title": "Kondisi Pengambilan Default",
  "env.collectionConditions.subtitle": "Default di aplikasikan ke semua sampel di batch ini",
  "env.collectionMethod": "Metode Pengambilan",
  "env.waterTemp": "Suhu Air (°C)",
  "env.ambientTemp": "Suhu Lingkungan (°C)",
  "env.weather": "Cuaca",
  "env.preservationMethod": "Metode Pengawetan",
  "env.preservationMethod.placeholder": "mis., asidifikasi HNO3, pendinginan 4°C",
  "env.fieldNotes": "Catatan Lapangan",
  "env.fieldNotes.placeholder": "Masukkan pengamatan lapangan...",
  "env.sample.manifest.title": "Manifes Pra-Pengambilan Sampel",
  "env.sample.manifest.subtitle": "satu baris = satu sampel fisik",
  "env.sample.container": "Wadah",
  "env.sample.gpsLat": "GPS Lat",
  "env.sample.gpsLat.placeholder": "mis. -6.2088",
  "env.sample.gpsLng": "GPS Lng",
  "env.sample.gpsLng.placeholder": "mis. 106.8456",
  "env.sample.locationDetails": "Rincian Lokasi",
  "env.sample.locationDetails.placeholder": "mis., Keran, Sungai...",
  "env.sample.collected": "Diambil",
  "env.sample.duplicate": "Duplikasi sampel",
  "env.sample.addRow": "+ Tambah baris sampel",
  "env.sample.total": "Total: {count} {count, plural, one {sample} other {samples}} di batch ini",
  "env.sample.testsAndPanels": "Pengujian & Panel",
  "env.sample.tests.required": "wajib",
  "env.complianceStandards.title": "Baku Mutu Tersedia",
  "env.complianceStandards.subtitle": "Pilih standar peraturan untuk pemesanan ini",
  "env.complianceStandards.label": "Baku Mutu",
  "env.complianceStandards.placeholder": "Pilih standar...",
  "env.complianceStandards.empty": "Tidak ada konfigurasi baku mutu aktif. Tambah baku mutu di Administrasi → Baku Mutu.",
  "order.dashboard.samplingSite": "Tempat Pengambilan Sampel",
  "order.search.placeholder.env": "Cari berdasarkan nama tempat atau nomor lab...",
  "order.filter.dateFrom": "Dari",
  "order.filter.dateTo": "Kepada",
  "program.placeholder": "Ketik untuk memfilter atau memilih dari daftar",
  "program.helper": "Ketik untuk memfilter atau memilih dari daftar. Memilih program akan menampilkan bidang Informasi Pesanan Tambahan khusus program tersebut di bawah ini.",
  "patient.externalSearch": "Pencarian Eksternal",
  "patient.results": "Hasil Pasien",
  "patient.id.helper": "Enter subject number, national ID, or ST number.",
  "patient.id.placeholder": "Masukkan Identitas Pasien",
  "patient.lastName.placeholder": "Masukkan Nama Belakang Pasien",
  "patient.firstName.placeholder": "Masukkan Nama Depan Pasien",
  "patient.natId": "Nomor Pengidentifikasi Kesehatan Unik",
  "patient.dataSource": "Sumber Data",
  "patient.noResults": "0-0 dari 0 item",
  "patient.new.info": "Masukkan informasi pasien di bawah ini. Pasien akan dibuat saat pemesanan disimpan.",
  "pagination.showing": "Menunjukkan {start}-{end} dari {total} pemeriksaan",
  "results.found.for": "hasil ditemukan untuk \"{term}\"",
  "selected": "Dipilih",
  "shipment.settings.siteOrgSaved": "Pengorganisasian situs disimpan (FHIR UUID: {uuid})",
  "shipment.settings.siteOrgSection": "Organisasi Situs (FHIR)",
  "shipment.settings.title": "Pengaturan Pengiriman",
  "shipment.state.cancelled": "Dibatalkan",
  "shipment.state.draft": "Draf",
  "shipment.state.inTransit": "Dalam Transit",
  "shipment.state.lostInTransit": "Hilang Dalam Transit",
  "shipment.state.partiallyReceived": "Parsial DIterima",
  "shipment.state.readyToSend": "Siap Dikirim",
  "shipment.state.received": "Diterima",
  "shipment.state.reconciled": "Direkonsiliasi",
  "shipment.state.sent": "Terkirim",
  "shipment.stats.delivered": "Sudah Diantar",
  "shipment.stats.inTransit": "Dalam Transit",
  "shipment.stats.reconciled": "Direkonsiliasi",
  "shipment.stats.totalSamples": "Total Sampel",
  "shipment.temperature.ambient": "Ambient (Suhu Ruangan)",
  "shipment.temperature.deepFrozen": "Deep Frozen (-80°C)",
  "shipment.temperature.dryIce": "Dry Ice",
  "shipment.temperature.frozen": "Frozen (-20°C)",
  "shipment.temperature.refrigerated": "Refrigerated (2-8°C)",
  "shipment.validation.addSample": "Tambah setidaknya satu sampel",
  "shipment.validation.selectDestination": "Pilih lembaga tujuan",
  "qc.dashboard.title": "Dasbor Kendali Mutu",
  "qc.dashboard.lastUpdate": "Pembaruan Terakhir",
  "qc.dashboard.complianceStatus": "Status Kepatuhan",
  "qc.dashboard.compliant": "Sesuai Kepatuhan",
  "qc.dashboard.warning": "Peringatan",
  "qc.dashboard.nonCompliant": "Tidak Sesuai Kepatuhan",
  "qc.dashboard.violationsCount": "{count} pelanggaran",
  "qc.dashboard.lastResult": "Hasil Terakhir",
  "qc.dashboard.noInstruments": "Tidak ada alat dikonfigurasi",
  "qc.dashboard.subtitle": "Monitor status dan peringatan QC alat",
  "qc.dashboard.loading": "Memuat data dasbor...",
  "qc.dashboard.refresh": "Refresh",
  "qc.dashboard.lastUpdated": "Pembaruan Terakhir",
  "qc.dashboard.error.title": "Error",
  "qc.dashboard.error.loadFailed": "Gagal memuat data dasbor. Silahkan coba lagi.",
  "qc.dashboard.tab.instruments": "Alat",
  "qc.dashboard.tab.alerts": "Peringatan",
  "qc.dashboard.summary.inControl": "Alat Dalam Kendali",
  "qc.dashboard.summary.warningStatus": "Status Peringatan",
  "qc.dashboard.summary.outOfControl": "Diluar Kendali",
  "qc.dashboard.summary.passRate": "QC Pass Rate Secara Umum",
  "qc.dashboard.summary.ofTotal": "{percentage}% total alat",
  "qc.dashboard.instruments.title": "Status Kendali Mutu Alat",
  "qc.dashboard.instruments.subtitle": "Monitor status kepatuhan dan kinerja QC di semua alat laboratorium",
  "qc.dashboard.instruments.search": "Cari alat...",
  "qc.dashboard.instruments.col.id": "ID Alat",
  "qc.dashboard.instruments.col.name": "Nama Alat",
  "qc.dashboard.instruments.col.type": "Tipe",
  "qc.dashboard.instruments.col.location": "Lokasi",
  "qc.dashboard.instruments.col.status": "Status",
  "qc.dashboard.instruments.col.analytes": "Analit",
  "qc.dashboard.instruments.col.violations": "Pelanggaran Terkini",
  "qc.dashboard.instruments.col.lastUpdate": "Pembaruan Terakhir",
  "qc.dashboard.instruments.col.actions": "Aksi",
  "qc.dashboard.instruments.view": "Lihat",
  "qc.dashboard.instruments.status.green": "Dalam Kendali",
  "qc.dashboard.instruments.status.yellow": "Peringatan",
  "qc.dashboard.instruments.status.red": "Diluar Kendali",
  "qc.dashboard.instruments.noViolations": "Tidak ada pelanggaran",
  "qc.dashboard.instruments.empty": "Tidak ada alat ditemukan",
  "qc.dashboard.alerts.title": "Pelanggaran & Peringatan QC",
  "qc.dashboard.alerts.subtitle": "Menunjukkan pelanggaran dari {period} terakhir",
  "qc.dashboard.alerts.timePeriod": "Periode Waktu",
  "qc.dashboard.alerts.timePeriod.24h": "24 jam terakhir",
  "qc.dashboard.alerts.timePeriod.72h": "72 jam terakhir",
  "qc.dashboard.alerts.timePeriod.7d": "7 hari terakhir",
  "qc.dashboard.alerts.timePeriod.30d": "30 hari terakhir",
  "qc.dashboard.alerts.timePeriod.all": "Semua Waktu",
  "qc.dashboard.alerts.active": "Pelanggaran QC Aktif",
  "qc.dashboard.alerts.active.count": "{count} pelanggaran tidak diketahui yang memerlukan perhatian",
  "qc.dashboard.alerts.active.empty": "Tidak ada pelanggaran aktif",
  "qc.dashboard.alerts.acknowledge": "Mengetahui",
  "qc.dashboard.alerts.acknowledged": "Pelanggaran yang Diketahui",
  "qc.dashboard.alerts.acknowledged.count": "{count} pelanggaran telah diketahui",
  "qc.dashboard.alerts.acknowledged.empty": "Tidak ada pelanggaran yang diketahui",
  "qc.dashboard.alerts.col.severity": "Keparahan",
  "qc.dashboard.alerts.col.time": "Waktu",
  "qc.dashboard.alerts.col.instrument": "Alat",
  "qc.dashboard.alerts.col.analyte": "Analit",
  "qc.dashboard.alerts.col.rule": "Aturan",
  "qc.dashboard.alerts.col.acknowledgedBy": "DIketahui Oleh",
  "qc.dashboard.alerts.col.acknowledgedDate": "Tanggal Diketahui",
  "qc.chart.axis.date": "Tanggal/Waktu",
  "qc.chart.axis.value": "Simpangan Baku (σ)",
  "qc.chart.legend.normal": "Normal",
  "qc.chart.legend.violation": "Pelanggaran",
  "qc.chart.mean": "Mean",
  "qc.chart.noData": "Tidak ada data QC tersedia",
  "qc.chart.tooltip.date": "Tanggal",
  "qc.chart.tooltip.value": "Nilai",
  "qc.chart.tooltip.violations": "Pelanggaran",
  "qc.chart.tooltip.zScore": "Z-Score",
  "qc.charts.title": "Control Charts",
  "qc.charts.leveyJennings": "Levey-Jennings Chart",
  "qc.charts.dateRange": "Rentang Tanggal",
  "qc.charts.controlLevel": "Level Kontrol",
  "qc.charts.export": "Ekspor grafik",
  "qc.charts.noData": "Tidak ada data QC tersedia",
  "qc.violations.title": "Pelanggaran QC",
  "qc.violations.severity": "Keparahan",
  "qc.violations.rule": "Aturan",
  "qc.violations.date": "Tanggal",
  "qc.violations.status": "Status",
  "qc.violations.unresolved": "Belum diatasi",
  "qc.violations.resolved": "Sudah diatasi",
  "qc.violations.acknowledged": "Sudah diketahui",
  "qc.correctiveActions.title": "Tindakan Perbaikan",
  "qc.correctiveActions.create": "Buat Tindakan Perbaikan",
  "qc.correctiveActions.type": "Jenis Tindakan",
  "qc.correctiveActions.description": "Deskripsi",
  "qc.correctiveActions.assignedTo": "Ditugaskan Ke",
  "qc.correctiveActions.status": "Status",
  "qc.correctiveActions.pending": "Tertunda",
  "qc.correctiveActions.inProgress": "Dalam Pengerjaan",
  "qc.correctiveActions.completed": "Selesai",
  "qc.correctiveActions.resolutionNotes": "Catatan Pemecahan Masalah",
  "qc.alerts.title": "Peringatan QC",
  "qc.alerts.markAsRead": "Tandai sebagai Sudah Dibaca",
  "qc.alerts.viewDetails": "Lihat Rincian",
  "qc.rules.title": "Konfigurasi Aturan Westgard",
  "qc.rules.enable": "Aktifkan",
  "qc.rules.disable": "Nonaktifkan",
  "qc.rules.preset": "Pengaturan Ulang Konfigurasi ",
  "qc.rules.basic": "Dasar",
  "qc.rules.standard": "Standar",
  "qc.rules.comprehensive": "Komprehensif",
  "qc.rules.1₂ₛ.description": "Satu kontrol melebihi ±2SD",
  "qc.rules.1₃ₛ.description": "Satu kontrol melebihi ±3SD",
  "qc.rules.2₂ₛ.description": "Dua kontrol berurutan melebihi ±2SD ke arah yang sama",
  "qc.rules.R₄ₛ.description": "Rentang antara dua kontrol melebihi 4SD",
  "qc.rules.4₁ₛ.description": "Empat kontrol berurutan melebihi ±1SD ke arah yang sama",
  "qc.rules.10ₓ.description": "Sepuluh kontrol berurutan berada di sisi mean yang sama",
  "qc.rules.3₁ₛ.description": "Tiga kontrol berurutan melebihi ±1SD ke arah yang sama",
  "qc.rules.7ₜ.description": "Tujuh kontrol berurutan cenderung ke arah yang sama",
  "qc.ruleConfig.title": "Konfigurasi Aturan",
  "qc.ruleConfig.subtitle": "Konfigurasi Westgard rule per kombinasi alat dan pemeriksaan",
  "qc.ruleConfig.field.analyzer": "Alat",
  "qc.ruleConfig.field.selectAnalyzer": "Pilih alat",
  "qc.ruleConfig.field.test": "Pemeriksaan",
  "qc.ruleConfig.field.selectTest": "Pilih pemeriksaan",
  "qc.ruleConfig.field.severity": "Keparahan",
  "qc.ruleConfig.severity.warning": "Peringatan",
  "qc.ruleConfig.severity.rejection": "Penolakan",
  "qc.ruleConfig.category.rejection": "Aturan Penolakan",
  "qc.ruleConfig.category.warning": "Aturan Peringatan",
  "qc.ruleConfig.action.reset": "Atur Ulang ke Default",
  "qc.ruleConfig.loading": "Memuat konfigurasi aturan...",
  "qc.ruleConfig.prompt.selectAnalyzerTest": "Pilih alat dan pemeriksaan untuk mengkonfigurasi Westgard rules.",
  "qc.ruleConfig.error.title": "Error",
  "qc.ruleConfig.error.selectAnalyzerTest": "Silahkan pilih alat maupun pemeriksaan.",
  "qc.ruleConfig.error.saveFailed": "Gagal menyimpan konfigurasi aturan",
  "qc.ruleConfig.success.title": "Berhasil",
  "qc.ruleConfig.success.saved": "Konfigurasi aturan berhasil disimpan.",
  "qc.ruleConfig.table.title": "Set Aturan yang Dikonfigurasi",
  "qc.ruleConfig.table.empty": "Konfigurasi aturan tidak ditemukan",
  "qc.ruleConfig.field.enabledRules": "Aktifkan Aturan",
  "qc.ruleConfig.unconfigured.title": "Pemetaan Kontrol yang Tidak Dikonfigurasi",
  "qc.ruleConfig.unconfigured.subtitle": "Lot kontrol tanpa konfigurasi aturan Westgard",
  "qc.ruleConfig.unconfigured.configure": "Konfigurasi",
  "qc.ruleConfig.unconfigured.activeLots": "Lot Aktif",
  "qc.ruleConfig.modal.title.edit": "Edit Konfigurasi Aturan",
  "qc.ruleConfig.modal.title.create": "Membuat Konfigurasi Aturan",
  "button.saving": "Menyimpan...",
  "qc.controlLots.title": "Lot Kontrol",
  "qc.controlLots.create": "Buat Lot Kontrol",
  "qc.controlLots.productName": "Nama Produk",
  "qc.controlLots.lotNumber": "Nomor Lot",
  "qc.controlLots.level": "Level Kontrol",
  "qc.controlLots.statisticsMethod": "Metode Kalkulasi Statistik",
  "qc.controlLots.initialRuns": "Putaran Awal",
  "qc.controlLots.rolling": "Jendela Bergerak",
  "qc.controlLots.manufacturerFixed": "Perbaikan Pabrik",
  "qc.controlLots.activationDate": "Tanggal Aktivasi",
  "qc.controlLots.expirationDate": "Tanggal Kedaluwarsa",
  "qc.controlLots.status.active": "Aktif",
  "qc.controlLots.status.establishment": "Percobaan",
  "qc.controlLots.status.expired": "Kedaluwarsa",
  "qc.controlLots.subtitle": "Kelola lot kontrol QC untuk evaluasi Westgard rule",
  "qc.controlLots.empty": "Tidak ada lot kontrol ditemukan",
  "qc.controlLot.filter.allStatuses": "Semua Status",
  "qc.controlLot.status.establishment": "Percobaan",
  "qc.controlLot.status.active": "Aktif",
  "qc.controlLot.status.expired": "Kedaluwarsa",
  "qc.controlLot.field.lotNumber": "Nomor Lot",
  "qc.controlLot.field.lotNumberPlaceholder": "Masukkan nomor lot",
  "qc.controlLot.field.material": "Bahan Kontrol",
  "qc.controlLot.field.materialPlaceholder": "Masukkan nama bahan",
  "qc.controlLot.field.manufacturer": "Produsen",
  "qc.controlLot.field.level": "Level Kontrol",
  "qc.controlLot.field.selectLevel": "Pilih level",
  "qc.controlLot.field.expiration": "Tanggal Kedaluwarsa",
  "qc.controlLot.field.analyzer": "Alat",
  "qc.controlLot.field.selectAnalyzer": "Pilih Alat",
  "qc.controlLot.field.test": "Pemeriksaan",
  "qc.controlLot.field.selectTest": "Pilih Pemeriksaan",
  "qc.controlLot.field.isActive": "Status",
  "qc.controlLot.field.inactive": "Inaktif",
  "qc.controlLot.field.active": "Aktif",
  "qc.controlLot.field.status": "Status",
  "qc.controlLot.loading": "Memuat...",
  "qc.controlLot.error.title": "Error",
  "qc.controlLot.error.saveFailed": "Gagal menyimpan lot kontrol",
  "qc.controlLot.new.title": "Lot Kontrol Baru",
  "qc.controlLot.new.subtitle": "Buat lot kontrol QC baru",
  "qc.controlLot.edit.title": "Edit Lot Kontrol",
  "qc.controlLot.edit.subtitle": "Perbarui konfigurasi lot kontrol",
  "qc.controlLot.validation.lotNumberRequired": "Nomor lot wajib ada",
  "qc.controlLot.validation.materialRequired": "Bahan wajib ada",
  "qc.controlLot.validation.levelRequired": "Level kontrol wajib ada",
  "qc.controlLot.validation.expirationRequired": "Tanggal kedaluwarsa wajib ada",
  "qc.controlLot.validation.analyzerRequired": "Alat wajib ada",
  "qc.controlLot.validation.testRequired": "Pemeriksaan wajib ada",
  "qc.controlLot.level.low": "Rendah",
  "qc.controlLot.level.normal": "Normal",
  "qc.controlLot.level.high": "Tinggi",
  "qc.controlLot.statistics.title": "Konfigurasi Statistik",
  "qc.controlLot.statistics.configure": "Konfigurasi",
  "qc.controlLot.statistics.method": "Metode Kalkulasi",
  "qc.controlLot.statistics.mean": "Mean",
  "qc.controlLot.statistics.sd": "Simpangan Baku",
  "qc.controlLot.statistics.config.title": "Konfigurasi Statistik",
  "qc.controlLot.statistics.config.label": "Konfigurasi metode statistik",
  "qc.controlLot.statistics.method.manufacturer_fixed": "Perbaikan Produsen",
  "qc.controlLot.statistics.method.manufacturer_fixed.description": "Gunakan nilai mean dan SD yang disediakan produsen",
  "qc.controlLot.statistics.method.rolling": "Jendela Bergerak",
  "qc.controlLot.statistics.method.rolling.description": "Hitung ulang dari hasil N terkini",
  "qc.controlLot.statistics.method.initial_runs": "Putaran Awal",
  "qc.controlLot.statistics.method.initial_runs.description": "Hitung sekali dari putaran N pertama",
  "qc.controlLot.statistics.manufacturerValues": "Nilai Produsen",
  "qc.controlLot.statistics.rollingConfig": "Konfigurasi Rolling",
  "qc.controlLot.statistics.windowSize": "Ukuran Jendela",
  "qc.controlLot.statistics.windowSize.helper": "Jumlah hasil terakhir untuk diikutkan ke kalkulasi",
  "qc.controlLot.statistics.initialRunsConfig": "Konfigurasi Run Awal",
  "qc.controlLot.statistics.initialRunsRequired": "Putaran yang Diperlukan",
  "qc.controlLot.statistics.initialRunsRequired.helper": "Jumlah putaran uji coba sebelum penghitungan statistik dilakukan",
  "qc.instrumentDetail.analytesMonitored": "Analit yang Dimonitor",
  "qc.instrumentDetail.analyte.cv": "CV: {value}%",
  "qc.instrumentDetail.analyte.violations": "{count, plural, other {# pelanggaran}}",
  "qc.instrumentDetail.tab.activityTimeline": "Timeline Kegiatan",
  "qc.instrumentDetail.tab.controlChart": "Control Charts",
  "qc.instrumentDetail.timeline.empty": "Tidak ada peringatan atau tindakan korektif direkam pada periode waktu yang dipilih",
  "qc.instrumentDetail.timeline.violation": "Pelanggaran",
  "qc.instrumentDetail.timeline.correctiveAction": "Tindakan Perbaikan",
  "qc.instrumentDetail.timeline.loading": "Memuat timeline kegiatan...",
  "qc.instrumentDetail.chart.selectAnalyte": "Pilih Analit",
  "qc.instrumentDetail.chart.loading": "Memuat control chart...",
  "qc.instrumentDetail.chart.noData": "Tidak ada data QC tersedia untuk analit ini.",
  "qc.instrumentDetail.chart.activeRules": "Aturan QC Aktif",
  "qc.instrumentDetail.chart.noRules": "Tidak ada aturan aktif yang dikonfigurasi",
  "qc.instrumentDetail.chart.stats.cv": "CV%",
  "qc.instrumentDetail.chart.stats.mean": "Mean (x̄)",
  "qc.instrumentDetail.chart.stats.n": "N",
  "qc.instrumentDetail.chart.stats.sd": "Std Dev (s)",
  "qc.instrumentDetail.error.loadFailed": "Gagal memuat rincian alat",
  "question.text.required": "Teks pertanyaan wajib ada",
  "compliance.legend.limitTypes": "JENIS BATAS:",
  "compliance.limitType.borderlineShort": "Garis Ambang ⚑",
  "compliance.limitType.descriptiveShort": "Kualitatif",
  "compliance.limitType.MAXIMUM": "Batas Atas ≤",
  "compliance.limitType.MINIMUM": "Batas Bawah ≥",
  "compliance.limitType.RANGE": "Rentang Normal",
  "compliance.limitType.BORDERLINE": "Garis Ambang 🚩",
  "compliance.limitType.DESCRIPTIVE": "Kualitatif",
  "compliance.limitType.EXACT": "Pasti",
  "compliance.limitType.SELECT_MAP": "Pemetaan Nilai",
  "compliance.status.ACTIVE": "Aktif",
  "compliance.status.DRAFT": "Draf",
  "compliance.status.SUPERSEDED": "Digantikan",
  "compliance.status.ARCHIVED": "Diarsipkan",
  "compliance.standard.placeholder.name": "mis., PP No. 22/2021 — Kualitas Air",
  "compliance.standard.placeholder.issuingBody": "mis., Pemerintah RI",
  "compliance.standard.placeholder.regulationNumber": "mis., PP 22/2021",
  "compliance.standard.placeholder.version": "mis., 2021",
  "compliance.standard.placeholder.countryRegion": "mis., Indonesia",
  "compliance.standard.placeholder.description": "Opsional. Deskripsi lengkap ruang lingkup standar",
  "compliance.standard.placeholder.date": "yyyy-mm-dd",
  "compliance.threshold.placeholder.lower": "Bawah / Min",
  "compliance.threshold.placeholder.upper": "Atas / Max",
  "compliance.threshold.placeholder.unit": "Unit",
  "compliance.standard.archive": "Arsip",
  "compliance.standard.archiveHeading": "Arsipkan Baku Mutu",
  "compliance.standard.archivePrompt": "Apakah standar ini mau diarsipkan? Hasil yang sudah dievaluasi akan tetap ada untuk audit, tapi standar akan disembunyikan dari daftar aktif. Aksi ini dapat di batalkan dengan mengedit status standar kembali ke Aktif.",
  "compliance.standard.archived": "Baku Mutu Diarsipkan",
  "compliance.standard.archiveError": "Tidak dapat mengarsipkan baku mutu ini.",
  "button.complianceStandard.copy": "Salin Standar",
  "compliance.standard.copied": "Baku Mutu disalin sebagai Draf baru.",
  "compliance.standard.copyError": "Tidak dapat menyalin standar ini",
  "compliance.standard.viewLinkedTests": "Lihat Pengujian Terkait",
  "compliance.testEditor.groupBy": "Digrupkan berdasar",
  "compliance.testEditor.section.configuration": "Konfigurasi",
  "compliance.testEditor.section.organization": "Organisasi",
  "compliance.testEditor.section.resources": "Sumber daya",
  "compliance.testEditor.section.automation": "Otomatisasi",
  "compliance.testEditor.section.compliance": "Kepatuhan",
  "compliance.testEditor.tab.compliance": "Kepatuhan",
  "compliance.testEditor.tabPlaceholder": "Segera datang dengan Editor Pengujian — saat ini dapat dikelola di halaman Modifikasi Pengujian.",
  "compliance.parameterGroup.editBtn": "Edit",
  "compliance.parameterGroup.moveUp": "Geser ke atas",
  "compliance.parameterGroup.moveDown": "Geser ke bawah",
  "compliance.parameterGroup.updateError": "Tidak dapat memperbarui grup parameter.",
  "compliance.testEditor.standardInactiveBanner": "Pengujian ini memiliki ambang batas terkait dengan {name} yang sekarang {status}. Hasil tidak lagi dievaluasi terhadap standar ini.",
  "compliance.standard.viewLinkedTests.heading": "Pengujian terkait — {name}",
  "compliance.standard.viewLinkedTests.empty": "Tidak ada pengujian yang terkait dengan standar ini.",
  "compliance.filter.status": "Status",
  "compliance.filter.region": "Daerah",
  "compliance.filter.allStatuses": "Semua Status",
  "compliance.filter.allRegions": "Semua Daerah",
  "compliance.filter.sampleType": "Jenis Sampel",
  "compliance.filter.allSampleTypes": "Semua Jenis Sampel",
  "compliance.sampleTypes.addLabel": "Tambah jenis sampel",
  "compliance.sampleTypes.noneConfigured": "Tidak ada konfigurasi",
  "compliance.sampleTypes.noneTitle": "Belum ada konfigurasi jenis sampel.",
  "compliance.sampleTypes.noneSubtitle": "Tambahkan satu jenis sampel sebelum mengaitkan pengujian.",
  "compliance.sampleTypes.counter": "{count, plural, other {# jenis sampel dikonfigurasi}}",
  "compliance.standard.default": "Default",
  "compliance.standard.groups": "Grup",
  "compliance.standard.tests": "Pengujian",
  "compliance.standard.expiryDate": "Tanggal Kedaluwarsa",
  "compliance.parameterGroups.heading": "Grup Parameter & Pengujian Terkait",
  "compliance.parameterGroups.requireSampleTypes": "Konfigurasi bidang standar dan jenis sampel, kemudian kaitkan pengujian.",
  "compliance.button.save": "Simpan",
  "compliance.button.saving": "Menyimpan...",
  "compliance.parameterGroup.createError": "Tidak dapat menambah grup parameter.",
  "compliance.parameterGroup.deleteHeading": "Hapus Grup Parameter",
  "compliance.parameterGroup.deletePrompt": "Hapus grup parameter {name} dan semua ambang batas? Hal ini tidak dapat dibatalkan.",
  "compliance.parameterGroup.deleteWarning": "{count, plural, other {# pengujian adalah}} currently linked. All linked thresholds will be removed.",
  "compliance.threshold.saveError": "Tidak dapat menyimpan baris ini.",
  "compliance.threshold.deleteError": "Tidak dapat menghapus baris ini.",
  "compliance.validation.required": "Bidang ini diperlukan.",
  "compliance.validation.expiryAfterEffective": "Tanggal kedaluwarsa harus pada atau setelah tanggal efektif.",
  "compliance.validation.missingUpper": "Batas atas wajib ada.",
  "compliance.validation.missingLower": "Batas bawah wajib ada.",
  "compliance.validation.missingBounds": "Baik batas bawah dan atas wajib ada.",
  "compliance.validation.lowerGtUpper": "Batas bawah harus kurang dari atau sama dengan batas atas",
  "compliance.validation.missingDescriptive": "Nilai kualitatif wajib ada.",
  "compliance.linkTest.selectNoOptions": "Pengujian ini select-list tapi tidak ada opsi yang dikonfigurasi di katalog uji. Tambah opsi hasil di kelola pengujian sebelum mengaitkan ke baku mutu.",
  "compliance.linkTest.resultTypeLegend": "Jenis hasil",
  "compliance.linkTest.resultType.numeric": "Numerik (gunakan nilai batas)",
  "compliance.linkTest.resultType.select": "Select list (petakan opsi ke status)",
  "compliance.linkTest.optionsHint": "Tambah opsi hasil untuk pengujian ini (mis., 'Absent', 'Present'). Anda dapat memetakannya di status kepatuhan baku mutu di tahap selanjutnya.",
  "compliance.linkTest.optionLabel": "Nilai opsi",
  "compliance.linkTest.optionPlaceholder": "mis., Absen",
  "compliance.linkTest.optionsRequired": "Masukkan setidaknya satu opsi di atas sebelum melakukan pemetaan status.",
  "compliance.admin.title": "Administrasi Baku Mutu",
  "compliance.admin.tile.explain": "Kelola baku mutu, grup parameter, dan ambang batas pengujian (mis., PP 22/2021, WHO Air Minum).",
  "compliance.tabs.standardsAdmin": "Daftar Baku Mutu",
  "compliance.tabs.testThresholds": "Tab Kepatuhan (Editor Pengujian)",
  "compliance.testEditor.back": "Kembali",
  "compliance.testEditor.editTest": "Edit Pengujian:",
  "compliance.testEditor.loinc": "LOINC:",
  "compliance.testEditor.sampleType": "Jenis Sampel:",
  "compliance.testEditor.resultType": "Jenis Hasil:",
  "compliance.testEditor.saveTest": "Simpan Pengujian",
  "compliance.testEditor.saveDisabledHint": "Tab editor teks lainnya belum diintegrasikan dalam iterasi ini.",
  "compliance.testEditor.thresholdsHeading": "Ambang Batas Kepatuhan untuk",
  "compliance.testEditor.addThreshold": "Tambah Ambang Batas",
  "compliance.testEditor.addThresholdHeading": "Kaitkan {name} ke baku mutu",
  "compliance.testEditor.pickStandard": "Baku Mutu",
  "compliance.testEditor.pickStandardPlaceholder": "-- Pilih standar --",
  "compliance.testEditor.pickGroup": "Grup parameter",
  "compliance.testEditor.pickGroupPlaceholder": "-- Pilih grup parameter --",
  "compliance.testEditor.pickGroupHint": "Pilih standar dan grup parameter di atas untuk mengkonfigurasi ambang batas.",
  "compliance.testEditor.unlink": "Tidak kaitkan",
  "compliance.testEditor.unlinkHeading": "Tidak kaitkan ambang batas",
  "compliance.testEditor.unlinkPrompt": "Hapus ambang batas ini dari {test}? Ambang batas akan tetap ada di grup parameter standar; tapi akan dihapus dari pengujian yang terkait.",
  "compliance.testEditor.linkedBanner": "Pengujian ini terkait ke {count, plural, one {# compliance standard} other {# compliance standards}}. Ambang batas akan dievaluasi pada saat validasi.",
  "compliance.testEditor.expandRow": "Perluas baris",
  "compliance.testEditor.col.standard": "Standar",
  "compliance.testEditor.col.parameterGroup": "Grup Parameter",
  "compliance.testEditor.col.limitType": "Jenis Batas",
  "compliance.testEditor.col.thresholdRange": "Ambang batas / Rentang",
  "compliance.testEditor.col.unit": "Unit",
  "compliance.testEditor.col.effective": "Efektif",
  "compliance.testEditor.col.status": "Status",
  "compliance.testThresholds.selectHint": "Pilih pemeriksaan untuk melihat ambang kepatuhan yang saling terkait dengan berbagai standar.",
  "compliance.testThresholds.overviewHeading": "Pengujian terkait ke baku mutu",
  "compliance.testThresholds.overviewCount": "{filtered} dari {total} pengujian {total, plural, one {} other {s}}",
  "compliance.testThresholds.overviewEmpty": "Belum ada pengujian terkait ke baku mutu.",
  "compliance.testThresholds.overviewEmptyHint": "Ambang batas berbasis CSV pada tingkat grup parameter muncul di Tab 1 (Administrasi Baku Mutu), bukan di sini. Cari di atas untuk memilih pengujian dari katalog dan tautkan ke standar.",
  "compliance.testThresholds.noLinkedMatches": "Tidak ada pengujian terkait yang cocok dengan \"{q}\".",
  "compliance.testThresholds.addSection": "Tambahkan pengujian ke baku mutu",
  "compliance.testThresholds.col.test": "Pengujian",
  "compliance.testThresholds.col.code": "Kode",
  "compliance.testThresholds.col.loinc": "LOINC",
  "compliance.testThresholds.col.sampleTypes": "Jenis Sampel",
  "compliance.testThresholds.col.thresholdCount": "# Ambang Batas",
  "compliance.testThresholds.col.standardCount": "# Standar",
  "compliance.testThresholds.openEditor": "Buka",
  "compliance.testThresholds.title": "Ambang Kepatuhan Pengujian",
  "compliance.testThresholds.tile.explain": "Lihat ambang batas kepatuhan terkait ke pengujian, berdasarkan grup standar dan parameter.",
  "compliance.testThresholds.searchLabel": "Cari pengujian",
  "compliance.testThresholds.searchPlaceholder": "Filter daftar pengujian...",
  "compliance.testThresholds.test": "Pengujian",
  "compliance.testThresholds.selectPlaceholder": "-- Pilih pengujian --",
  "compliance.testThresholds.empty": "Belum ada ambang batas kepatuhan terkait dengan pengujian ini. Kilk + Tambah Ambang Batas di atas untuk mengaitkan baku mutu dengan grup parameter.",
  "compliance.testThresholds.parameter": "Parameter",
  "compliance.testThresholds.type": "Jenis Batas",
  "compliance.testThresholds.value": "Nilai",
  "compliance.testThresholds.note": "Catatan",
  "compliance.testThresholds.unknownStandard": "Standar tidak diketahui",
  "compliance.button.openAdmin": "Buka Admin Baku Mutu",
  "compliance.button.addStandard": "Tambah Standar",
  "compliance.button.saveStandard": "Simpan Standar",
  "compliance.button.linkTest": "Kaitkan Pemeriksaan ke Grup",
  "compliance.button.saveLimits": "Simpan Batas",
  "compliance.button.saveMapping": "Simpan Pemetaan",
  "compliance.search": "Cari standar",
  "compliance.search.placeholder": "Cari berdasarkan nama, badan yang menerbitkan, peraturan, negara...",
  "compliance.list.empty": "Belum ada baku mutu.",
  "compliance.standard.name": "Nama Standar",
  "compliance.standard.issuingBody": "Badan yang menerbitkan",
  "compliance.standard.regulationNumber": "Nomor Peraturan",
  "compliance.standard.version": "Versi",
  "compliance.standard.countryRegion": "Negara / Regional",
  "compliance.standard.status": "Status",
  "compliance.standard.effectiveDate": "Tanggal Efektif",
  "compliance.standard.description": "Deskripsi",
  "compliance.standard.addNew": "Tambah Baku Mutu Baru",
  "compliance.standard.edit": "Edit Baku Mutu",
  "compliance.standard.preSeeded": "Pre-seeded",
  "compliance.standard.saved": "Baku mutu disimpan.",
  "compliance.standard.saveError": "Tidak dapat menyimpan standar.",
  "compliance.standard.saveBeforeGroups": "Simpan standar sebelum menambahkan grup parameter.",
  "compliance.standard.deleted": "Baku mutu dihapus.",
  "compliance.standard.deleteError": "Tidak dapat menghapus standar (mungkin sedang diisi atau terkait dengan ambang batas).",
  "compliance.standard.deleteHeading": "Hapus Baku Mutu",
  "compliance.standard.deletePrompt": "Apakah Anda yakin mau menghapus standar ini? Standar yang tengah diisi atau terkait dengan ambang batas tidak dapat dihapus.",
  "compliance.sampleTypes.heading": "Jenis Sampel yang Dapat Diterapkan",
  "compliance.sampleTypes.explicitHint": "Sebutkan kategori jenis sampel yang dapat menerapkan standar. Pilihan ini menentukan filter pengujian saat mengatikan pengujian.",
  "compliance.sampleTypes.empty": "Belum ada jenis sample disebutkan.",
  "compliance.sampleTypes.selectPlaceholder": "Pilih jenis sampel...",
  "compliance.sampleTypes.addBtn": "Tambah Jenis Sampel",
  "compliance.sampleTypes.remove": "Hapus",
  "compliance.parameterGroups": "Grup Parameter",
  "compliance.parameterGroups.empty": "Belum ada grup parameter didefinisikan.",
  "compliance.parameterGroups.add": "Tambah Grup Parameter",
  "compliance.parameterGroup.name": "Nama grup",
  "compliance.parameterGroup.description": "Deskripsi",
  "compliance.parameterGroup.deleteBtn": "Hapus",
  "compliance.label.tests": "pengujian",
  "compliance.linkedTest.name": "Pengujian",
  "compliance.linkedTest.sampleTypes": "Jenis Sampel",
  "compliance.linkedTest.limits": "Konfigurasi Batas",
  "compliance.linkedTest.editLimits": "Edit batas",
  "compliance.linkedTest.unlink": "Hapus dari grup",
  "compliance.linkedTest.unlinkHeading": "Hapus Pengujian dari Grup",
  "compliance.linkedTest.unlinkConfirm": "Hapus",
  "compliance.linkedTest.unlinkPrompt": "Hapus pengujian dari grup? Semua definisi ambang batas untuk pengujian ini di grup ini akan dihapus.",
  "compliance.group.noTests": "Belum ada pengujian terkait dengan grup ini. Kaitkan pengujian untuk mendefinisikan ambang batas kepatuhan untuk evaluasi.",
  "compliance.linkTest.heading": "Kaitkan Pemeriksaan ke Grup",
  "compliance.linkTest.step1": "Tahap 1 — Filter berdasar Jenis Sampel",
  "compliance.linkTest.step2": "Tahap 2 — Cari & Pilih Pengujian",
  "compliance.linkTest.step3Numeric": "Tahap 3 — Konfigurasi Batas",
  "compliance.linkTest.step3Select": "Tahap 3 — Pemetaan Nilai Kepatuhan",
  "compliance.linkTest.filterByST": "Filter berdasarkan jenis sampel:",
  "compliance.linkTest.searchTest": "Cari katalog pengujian",
  "compliance.linkTest.searchPlaceholder": "Ketik untuk mencari berdasarkan nama atau kode...",
  "compliance.linkTest.noResults": "Tidak ada pengujian yang cocok.",
  "compliance.linkTest.selectListBadge": "Select List",
  "compliance.linkTest.clearSelection": "Hapus pilihan",
  "compliance.multiLimit.editHeading": "Konfigurasi Batas",
  "compliance.multiLimit.hint": "Mungkinkan satu atau lebih jenis batas untuk pengujian ini. Setidaknya satu jenis batas harus ada.",
  "compliance.multiLimit.type": "Jenis Batas",
  "compliance.multiLimit.lower": "Bawah",
  "compliance.multiLimit.upper": "Atas",
  "compliance.multiLimit.unit": "Unit",
  "compliance.multiLimit.note": "Catatan / Saran",
  "compliance.multiLimit.descriptive.placeholder": "mis., Tidak berbau, Absen, Jernih",
  "compliance.multiLimit.note.placeholder": "Catatan Opsional",
  "compliance.limitType.high": "Batas Atas ≤",
  "compliance.limitType.high.hint": "Tidak sesuai kepatuhan bila hasil melebihi batas atas",
  "compliance.limitType.low": "Batas Bawah ≥",
  "compliance.limitType.low.hint": "Tidak sesuai kepatuhan bila hasil di bawah batas bawah",
  "compliance.limitType.range": "Rentang Normal",
  "compliance.limitType.range.hint": "Dalam rentang kepatuhan atas–bawah",
  "compliance.limitType.borderline": "Garis ambang (Saran)",
  "compliance.limitType.borderline.hint": "Zona Saran - akan mentriger flag untuk meninjau, tidak gagal",
  "compliance.limitType.descriptive": "Kualitatif / Deskriptif",
  "compliance.limitType.descriptive.hint": "Nilai teks dievaluasi oleh analis",
  "compliance.selectMap.editHeading": "Pemetaan Kepatuhan",
  "compliance.selectMap.hint": "Petakan semua opsi hasil terhadap status kepatuhan. Opsi diambil dari katalog pengujian.",
  "compliance.selectMap.option": "Opsi Hasil",
  "compliance.selectMap.status": "Status Kepatuhan",
  "compliance.selectMap.preview": "Pratinjau",
  "compliance.selectMap.badge": "Pemetaan Nilai",
  "compliance.selectMap.optionsLabel": "opsi dipetakan",
  "compliance.selectMap.statusForOption": "Status kepatuhan untuk {option}",
  "compliance.status.compliant": "Sesuai Kepatuhan",
  "compliance.status.borderline": "Garis ambang",
  "compliance.status.nonCompliant": "Tidak Sesuai Kepatuhan",
  "compliance.status.compliantWithIcon": "Sesuai Kepatuhan ✓",
  "compliance.status.borderlineWithIcon": "Garis Ambang ⚑",
  "compliance.status.nonCompliantWithIcon": "Tidak Sesuai Kepatuhan ✗",
  "compliance.linkedTest.noLimits": "Tidak ada konfigurasi batas",
  "compliance.threshold.savedThresholds": "Ambang batas kepatuhan terkait pada pengujian.",
  "compliance.threshold.savedValueMap": "Ambang batas pemetaan nilai berhasil disimpan.",
  "compliance.threshold.savedPartialError": "Ambang batas tidak dapat disimpan. Tinjau ulang baris yang ditandai.",
  "compliance.threshold.unlinked": "Ambang batas tidak terkait dari pengujian.",
  "compliance.threshold.unlinkError": "Tidak dapat membatalkan ambang terkait.",
  "notification.title.success": "Berhasil",
  "notification.title.error": "Error",
  "sidenav.label.admin.vectorSurveillance": "Surveilans Vektor",
  "vector.admin.title": "Pengaturan Surveilans Vektor",
  "vector.admin.groups": "Grup organisme",
  "vector.admin.group.code": "Kode",
  "vector.admin.group.label": "Label",
  "vector.admin.group.colorTag": "Tag Warna",
  "vector.admin.group.description": "Deskripsi",
  "vector.admin.active": "Aktif",
  "vector.admin.system": "Sistem",
  "vector.admin.trapTypes": "Jenis Perangkap",
  "vector.admin.trapType.name": "Nama",
  "vector.admin.trapType.description": "Deskripsi",
  "vector.admin.species": "Spesies",
  "vector.admin.selectGroup": "Pilih grup di kiri untuk mengelola perangkap berdasar jenis dan spesies.",
  "vector.admin.newGroup": "Grup baru (tidak disimpan)",
  "vector.admin.newTrapType": "Jenis perangkap baru",
  "vector.admin.newSpecies": "Spesies baru",
  "vector.admin.saveGroup": "Simpan grup",
  "vector.admin.saveTrap": "Simpan perangkap",
  "vector.admin.saveSpecies": "Simpan spesies",
  "vector.admin.addGroup": "+ Tambah group",
  "vector.admin.addTrapType": "+ Tambah jenis perangkap",
  "vector.admin.addSpecies": "+ Tambah spesies",
  "vector.admin.locked": "dikunci",
  "vector.admin.systemGroup": "Grup diproteksi sistem",
  "vector.admin.systemGroup.desc": "Kode ini dikunci karena grup di gunakan pada laporan inti dan data. Anda tetap dapat mengedit label, warna, dan deskripsi.",
  "vector.admin.usedBy": "Digunakan oleh",
  "vector.admin.status": "Status",
  "vector.admin.status.active": "Aktif",
  "vector.admin.status.inactive": "Inaktif",
  "vector.admin.group": "Grup organisme",
  "vector.admin.trapType.group": "Grup organisme target",
  "vector.admin.trapType.groups": "Grup organisme",
  "vector.admin.trapType.sampleTypes": "Jenis sampel",
  "vector.admin.sampleType": "Jenis sampel",
  "vector.admin.search.groups": "Cari berdasarkan kode dan label...",
  "vector.admin.search.traps": "Cari nama perangkap atau deskripsi...",
  "vector.admin.search.species": "Cari genus atau spesies...",
  "vector.admin.samplingSites": "Tempat Pengambilan Sampel",
  "vector.admin.samplingSite.newSite": "Tempat baru",
  "vector.admin.samplingSite.allSites": "Semua Tempat",
  "vector.admin.samplingSite.code": "Kode",
  "vector.admin.samplingSite.name": "Nama Tempat",
  "vector.admin.samplingSite.type": "Jenis Tempat",
  "vector.admin.samplingSite.region": "Regional",
  "vector.admin.samplingSite.district": "Kabupaten / Kota",
  "vector.admin.samplingSite.contactName": "Kontak Person",
  "vector.admin.samplingSite.contactPhone": "Telepon Kontak",
  "vector.admin.samplingSite.gpsLatitude": "Garis Lintang GPS",
  "vector.admin.samplingSite.gpsLongitude": "Garis bujur GPS",
  "vector.admin.samplingSite.environmentalZone": "Zona Lingkungan",
  "vector.admin.samplingSite.address": "Alamat",
  "vector.admin.samplingSite.description": "Deskripsi",
  "vector.admin.samplingSite.source": "Sumber",
  "vector.admin.samplingSite.source.local": "LOKAL",
  "vector.admin.samplingSite.source.hub": "HUB",
  "vector.admin.samplingSite.lastCollection": "Pengambilan Terakhir",
  "vector.admin.samplingSite.search": "Cari berdasarkan kode, nama, regional...",
  "vector.admin.samplingSite.saveSite": "Simpan tempat",
  "vector.admin.samplingSites.registry": "Registri Tempat Pengambilan Sampel",
  "vector.admin.samplingSite.deactivate": "Nonaktifkan",
  "vector.admin.samplingSite.activate": "Aktifkan",
  "vector.admin.samplingSite.location": "Lokasi",
  "vector.admin.samplingSite.allTypes": "Semua Jenis",
  "vector.admin.samplingSite.subtype": "Subtipe",
  "vector.admin.samplingSite.subtype.placeholder": "e.g. Sungai, Sumur, BG-Sentinel, Fixed Station",
  "vector.admin.samplingSite.city": "Kota",
  "vector.admin.samplingSite.addressLocation": "Lokasi Alamat",
  "vector.admin.samplingSite.addressSearch.placeholder": "Cari lokasi untuk auto-fill dropdown...",
  "vector.admin.samplingSite.gpsCoordinates": "Koordinat GPS",
  "vector.admin.samplingSite.lastModified": "Dimodifikasi Terakhir",
  "label.noResults": "Hasil tidak ditemukan",
  "vector.admin.addSite": "+ Tempat Baru",
  "vector.order.title": "Pemesanan Vektor Baru",
  "vector.order.subtitle": "Instalasi Lab: Lab Surveilans Vektor - Domain vektor aktif",
  "vector.order.samplingSite": "Tempat Pengambilan Sampel",
  "vector.order.site.code": "Kode Tempat",
  "vector.order.site.helper": "Only active surveillance sites appear in results. GPS coordinates are pre-filled from the site record.",
  "vector.order.site.name": "Nama Tempat",
  "vector.order.site.placeholder": "Cari berdasarkan nama tempat atau kode...",
  "vector.order.site.type": "Jenis Tempat",
  "vector.order.specimen": "Spesimen",
  "vector.order.organism": "Hewan / Organisme",
  "vector.order.organism.hint": "Nama umum — mis., Nyamuk, Caplak, Rodensia, Agas.",
  "vector.order.organism.placeholder": "Cari organisme atau spesies...",
  "vector.order.quantity": "Kuantitas",
  "vector.order.quantity.hint": "Jumlah organisme dalam pool ini.",
  "vector.order.requester.section": "Program yang Memohon / Memesan",
  "vector.order.requester": "Pemohon",
  "vector.order.requester.placeholder": "Cari organisasi berdasarkan nama atau kode...",
  "vector.order.panels": "Panel Pemesanan",
  "vector.order.panels.search": "Pilih panel tersedia",
  "vector.order.tests": "Pemesanan Pengujian",
  "vector.order.tests.search": "Pilih Pengujian yang tersedia",
  "vector.order.collectionContext": "Konteks Pengambilan (opsional — bionomics capture)",
  "vector.order.timeOfDay": "Waktu Hari Itu",
  "vector.order.timeOfDay.dawn": "Pagi",
  "vector.order.timeOfDay.day": "Siang",
  "vector.order.timeOfDay.dusk": "Sore",
  "vector.order.timeOfDay.night": "Malam",
  "vector.order.restingContext": "Konteks Resting",
  "vector.order.restingContext.outdoor": "Outdoor (exophilic)",
  "vector.order.restingContext.indoor": "Indoor (endophilic)",
  "vector.order.restingContext.peridomestic": "Peridomestic",
  "vector.order.humanBitingCatch": "Penangkapan saat menggigit manusia (Human-Biting)",
  "vector.order.humanBitingCatch.hint": "spesimen ditemukan pada manusia",
  "vector.order.collectionNotes": "Catatan Pengambilan",
  "vector.order.collectionNotes.placeholder": "Cuaca, kondisi perangkap, anomali...",
  "vector.admin.group.code.placeholder": "mis., AGAS",
  "vector.admin.group.label.placeholder": "mis., Agas",
  "vector.species.genus.placeholder": "mis., Mansonia",
  "vector.species.species.placeholder": "mis., uniformis",
  "vector.species.subspecies.placeholder": "mis., diardii",
  "vector.species.genus": "Genus",
  "vector.species.species": "Spesies",
  "vector.species.subspecies": "Subspesies",
  "vector.species.pathogensOfInterest": "Pathogens of Interest",
  "vector.species.lifecycleStages": "Tahap Siklus Hidup",
  "vector.species.pathogenCategory": "Kategori Patogen",
  "vector.species.lifecycleCategory": "Kategori Siklus Hidup",
  "workflow.vector": "Surveilans Vektor",
  "vector.sampleType": "Jenis Sampel",
  "vector.organismGroup": "Grup organisme",
  "vector.species": "Spesies",
  "vector.animalOrganism": "Hewan/Organisme",
  "vector.animalOrganism.add": "Tambah Hewan/Organisme",
  "vector.animalOrganism.remove": "Hapus Hewan/Organisme",
  "vector.collectedVolume": "Kuantitas dalam Pool",
  "vector.lifecycleStage": "Tahapan Siklus Hidup",
  "vector.trapCount": "Traps Deployed",
  "vector.trapNights": "Nights Deployed",
  "vector.trapType": "Jenis Perangkap",
  "vector.poolingMethod": "Metode Pooling",
  "vector.poolCount": "Jumlah Pool",
  "vector.samplesPerPool": "Spesimen per Pool",
  "vector.totalSpecimens": "Total Spesimen",
  "vector.pathogensOfInterest": "Pathogens of Interest",
  "vector.homogeneous": "Homogen",
  "vector.random": "Acak",
  "vector.collectionSite": "Tempat Pengambilan",
  "vector.collectionSiteName": "Nama Tempat Pengambilan",
  "vector.gpsLatitude": "Garis Lintang GPS",
  "vector.gpsLongitude": "Garis bujur GPS",
  "patient.search.merged.tag": "Menggabungkan",
  "patient.merged.banner.title": "Rekaman pasien ini telah digabungkan",
  "patient.merged.banner.subtitle": "Rekaman aktif disimpan pada Pasien {target}.",
  "patient.merged.banner.subtitle.noTarget": "Rekaman ini telah digabungkan ke pasien lain.",
  "admin.testCatalog.tabs.ariaLabel": "Test details tabs",
  "admin.testCatalog.tabs.details": "Details",
  "admin.testCatalog.tabs.labels": "Label",
  "admin.testCatalog.labels.masterOverride.label": "Allow Order Entry Override",
  "admin.testCatalog.labels.masterOverride.on": "Nyalakan",
  "admin.testCatalog.labels.masterOverride.off": "Matikan",
  "admin.testCatalog.labels.linkedPresets.title": "Linked Label Presets",
  "admin.testCatalog.labels.linkedPresets.empty": "No label presets linked. Use the dropdown below to add one.",
  "admin.testCatalog.labels.col.presetName": "Nama Pengaturan",
  "admin.testCatalog.labels.col.defaultQty": "Kuantitas Default",
  "admin.testCatalog.labels.col.maxQty": "Kuantitas Maks",
  "admin.testCatalog.labels.col.allowOverride": "Izinkan Override",
  "admin.testCatalog.labels.col.actions": "Aksi",
  "admin.testCatalog.labels.action.remove": "Remove preset link",
  "admin.testCatalog.labels.addPreset.label": "Tambah Jenis Label",
  "admin.testCatalog.labels.addPreset.placeholder": "Select a label preset",
  "admin.testCatalog.labels.preview.title": "Order Entry Preview",
  "admin.testCatalog.labels.preview.col.locked": "Terkunci",
  "admin.testCatalog.labels.preview.locked": "Terkunci",
  "admin.testCatalog.labels.preview.unlocked": "Editable",
  "admin.testCatalog.labels.save.success": "Label configuration saved.",
  "admin.testCatalog.labels.save.error": "Failed to save label configuration.",
  "orderEntry.labels.orderTable.title": "Order Labels",
  "orderEntry.labels.sampleTable.title": "Sample Labels",
  "orderEntry.labels.col.row": "Baris",
  "orderEntry.labels.col.sample": "Sampel",
  "orderEntry.labels.col.quantity": "Kuantitas",
  "orderEntry.labels.orderRow.header": "Pemesanan",
  "orderEntry.labels.sampleRow.header": "Sampel {number}",
  "orderEntry.labels.input.sample": "Sample {number} {column} quantity",
  "orderEntry.labels.source.test": "From test",
  "orderEntry.labels.source.presetDefault": "Preset default",
  "orderEntry.labels.locked.tooltipFor": "{label} is locked by the test configuration and cannot be changed.",
  "orderEntry.labels.total": "Total labels: {total}",
  "orderEntry.labels.heading": "LABELS",
  "label.patientHistory.filterByCategory": "Filter by test category",
  "label.patientHistory.testCategories": "Test categories",
  "label.patientHistory.tree": "Tree",
  "label.patientHistory.showTree": "Show tree",
  "label.patientHistory.resetTree": "Reset tree",
  "label.patientHistory.viewResults": "View {count} results",
  "label.patientHistory.emptyState": "There are no {displayText} to display for this patient",
  "label.patientHistory.record": "Record {displayText}",
  "label.patientHistory.dataLoadError": "Data Load Error",
  "label.patientHistory.errorCopy": "Sorry, there was a problem displaying this information. You can try to reload this page, or contact the site administrator and quote the error code above.",
  "label.patientHistory.backToTimeline": "Back to timeline",
  "label.patientHistory.returnToTimeline": "Return to timeline",
  "label.patientHistory.timeOfTest": "Time of Test",
  "label.patientHistory.observations": "observations",
  "label.patientHistory.range.oneDay": "1 day",
  "label.patientHistory.range.fiveDays": "5 days",
  "label.patientHistory.range.oneMonth": "1 month",
  "label.patientHistory.range.sixMonths": "6 months",
  "label.patientHistory.range.oneYear": "1 year",
  "label.patientHistory.range.fiveYears": "5 years",
  "label.patientHistory.range.all": "Semua",
  "label.patientHistory.date": "Tanggal",
  "address.search.no.results": "No addresses found for '{term}'",
  "address.search.placeholder": "Search for address (type at least 2 characters)...",
  "address.search.results.count": "{count} results found",
  "alert.error": "Error",
  "alert.warning": "Peringatan",
  "analyzer.copyMappings.warnings": "Peringatan",
  "analyzer.errorDetails.noLogsAvailable": "No logs available",
  "analyzer.fieldMapping.panel.testValidation.button": "Test Validation",
  "analyzer.fieldMapping.panel.testValue.analyzerIdMissing": "Analyzer ID not available",
  "analyzer.fieldMapping.panel.testValue.error": "Error validating value",
  "analyzer.fieldMapping.panel.testValue.invalid": "Value fails validation",
  "analyzer.fieldMapping.panel.testValue.invalid.title": "Validation Failed",
  "analyzer.fieldMapping.panel.testValue.label": "Test Value",
  "analyzer.fieldMapping.panel.testValue.placeholder": "Enter a value to test against validation rules",
  "analyzer.fieldMapping.panel.testValue.required": "Please enter a test value",
  "analyzer.fieldMapping.panel.testValue.valid": "Value passes validation",
  "analyzer.fieldMapping.panel.testValue.valid.title": "Validation Passed",
  "analyzer.fieldMapping.panel.validationRules.title": "Validation Rules",
  "analyzer.fieldSelector.placeholder": "Search and select field...",
  "analyzer.fieldSelector.title": "Select OpenELIS Field",
  "analyzer.form.columnMappings": "Column Mappings (JSON)",
  "analyzer.form.columnMappings.helperText": "Maps file column names to internal field names",
  "analyzer.form.delimiter": "Delimiter",
  "analyzer.form.fileFormat": "Format File",
  "analyzer.form.fileImport.title": "File Import Settings",
  "analyzer.form.filePattern": "Pola File",
  "analyzer.form.filePattern.helperText": "Glob pattern to match result files",
  "analyzer.form.hasHeader": "File has header row",
  "analyzer.form.importDirectory": "Direktori Impor",
  "analyzer.form.importDirectory.helperText": "Directory the bridge watches for incoming result files",
  "analyzer.form.validation.columnMappings.invalid": "Column mappings must be valid JSON",
  "analyzer.form.validation.importDirectory.required": "Import directory is required for file-based analyzers",
  "analyzer.form.validation.port.invalid": "Port must be a number between 1 and 65535",
  "analyzer.qc.batch.failure.subtitle": "QC controls in this batch have failures. Review QC results below before accepting patient results.",
  "analyzer.qc.batch.failure.title": "QC Controls Failed",
  "analyzer.qc.controls.hidden": "QC controls hidden from patient view",
  "analyzer.qc.controls.section.title": "QC Controls ({count})",
  "audittrail.table.heading": "Order Information",
  "barcode.label.info.labnumber": "Nomor Registrasi",
  "button.close": "Tutup",
  "button.collapse": "Collapse",
  "button.expand": "Expand",
  "button.home": "Beranda",
  "button.new.search": "New Search",
  "column.name.labNo": "Lab #",
  "customFieldType.action.add": "Add Custom Field Type",
  "customFieldType.action.delete": "Hapus",
  "customFieldType.action.edit": "Edit",
  "customFieldType.actions.ariaLabel": "Aksi",
  "customFieldType.error.deleteFailed": "Failed to delete custom field type",
  "customFieldType.error.displayNameRequired": "Display name is required",
  "customFieldType.error.invalidRegex": "Invalid regex pattern",
  "customFieldType.error.rangeInvalid": "Minimum cannot be greater than maximum",
  "customFieldType.error.saveFailed": "Failed to save custom field type",
  "customFieldType.error.typeNameRequired": "Type name is required",
  "customFieldType.form.allowedCharacters": "Allowed Characters",
  "customFieldType.form.allowedCharactersHelper": "Optional: Character set restriction",
  "customFieldType.form.allowedCharactersPlaceholder": "e.g., ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
  "customFieldType.form.displayName": "Nama di Tampilan",
  "customFieldType.form.displayNamePlaceholder": "e.g., Custom Numeric Field",
  "customFieldType.form.isActive": "Status Aktif",
  "customFieldType.form.typeName": "Type Name",
  "customFieldType.form.typeNamePlaceholder": "e.g., CUSTOM_NUMERIC",
  "customFieldType.form.validationPattern": "Validation Pattern (Regex)",
  "customFieldType.form.validationPatternHelper": "Optional: Regular expression pattern for validation",
  "customFieldType.form.validationPatternPlaceholder": "e.g., ^[0-9]+$",
  "customFieldType.form.valueRangeMax": "Value Range Max",
  "customFieldType.form.valueRangeMaxHelper": "Optional: Maximum value for numeric types",
  "customFieldType.form.valueRangeMin": "Value Range Min",
  "customFieldType.form.valueRangeMinHelper": "Optional: Minimum value for numeric types",
  "customFieldType.modal.addTitle": "Add Custom Field Type",
  "customFieldType.modal.cancel": "Batal",
  "customFieldType.modal.delete": "Hapus",
  "customFieldType.modal.deleteMessage": "Are you sure you want to delete {typeName}? This action cannot be undone.",
  "customFieldType.modal.deleteTitle": "Delete Custom Field Type",
  "customFieldType.modal.editTitle": "Edit Custom Field Type",
  "customFieldType.modal.save": "Simpan",
  "customFieldType.page.subtitle": "Manage custom field types for analyzer field mapping",
  "customFieldType.search.label": "Search custom field types",
  "customFieldType.search.placeholder": "Search by type name or display name...",
  "customFieldType.success.deleted": "Custom field type deleted successfully",
  "customFieldType.success.saved": "Custom field type saved successfully",
  "customFieldType.table.header.displayName": "Nama di Tampilan",
  "customFieldType.table.header.status": "Status",
  "customFieldType.table.header.typeName": "Type Name",
  "customFieldType.table.header.validationPattern": "Validation Pattern",
  "customFieldType.table.header.valueRange": "Value Range",
  "env.collectionConditions.helper": "Search for an existing sampling site or create a new one. Sites are reusable across orders — like patients in clinical workflows.",
  "env.collectionMethod.placeholder": "e.g., Grab sample, Composite 24h",
  "env.conditions": "Kondisi Lingkungan",
  "env.conditions.placeholder": "e.g., 20°C, clear weather, dry season",
  "env.regulatoryReference": "Regulatory Reference",
  "env.regulatoryReference.placeholder": "e.g., PP No. 22/2021 Batu Mutu Air",
  "env.samplingSite.title": "Subject — Sampling Site",
  "env.site.address": "Alamat",
  "env.site.addressSearch.placeholder": "Search for location to auto-fill dropdowns below...",
  "env.site.code": "Kode Tempat",
  "env.site.code.placeholder": "Auto-generated (or enter manually)",
  "env.site.contactPerson": "Kontak Person",
  "env.site.contactPerson.placeholder": "Name of site custodian or contact",
  "env.site.contactPhone": "Telepon Kontak",
  "env.site.description": "Site Description",
  "env.site.description.placeholder": "e.g., Downstream monitoring point near floodgate",
  "env.site.helperText": "Register a new sampling site. The site will be saved to the Site Registry and can be reused for future orders.",
  "env.site.name": "Nama Tempat",
  "env.site.name.placeholder": "e.g., Sungai Ciliwung — Manggarai",
  "env.site.newTab": "New Site",
  "env.site.saveAndSelect": "Save & Select Site",
  "env.site.searchLabel": "Nama Tempat",
  "env.site.searchPlaceholder": "e.g., Sungai Ciliwung - Manggarai",
  "env.site.searchTab": "Search for Site",
  "env.site.streetAddress": "Alamat",
  "env.site.streetAddress.placeholder": "Street address or location reference",
  "env.site.subtype": "Subtipe",
  "env.site.subtype.placeholder": "e.g., River, Well, BG-Sentinel, Fixed Station",
  "env.site.type": "Jenis Tempat",
  "env.site.type.select": "Select Type...",
  "env.site.zone": "Zona Lingkungan",
  "env.site.zone.select": "Select Zone...",
  "error.dateRange.start": "Please select Start and end date.",
  "error.loading.metrics": "Error loading metrics",
  "error.nonconform.report.data.found": "No data found",
  "error.report.csv.dateType": "Silahkan pilih jenis tanggal.",
  "error.required.fields": "Please fill in all required fields",
  "error.save.sample": "Error saving sample",
  "error.validation.failed": "Validation failed",
  "error.value": "Please select a value.",
  "esig.context.saveResults": "Save {count} result(s) for accession {accession}",
  "esig.context.saveResultsMulti": "Save {count} result(s) across {accessionCount} accessions",
  "esig.context.validateResults": "Validate {count} result(s) for accession {accession}",
  "esig.context.validateResultsMulti": "Validate {count} result(s) across {accessionCount} accessions",
  "fhir.questionnaire.title": "Informasi Tambahan",
  "freezer.alert.detail.acknowledge": "Mengetahui",
  "freezer.alert.detail.acknowledgedAt": "Acknowledged At",
  "freezer.alert.detail.acknowledgedBy": "DIketahui Oleh",
  "freezer.alert.detail.actions": "Actions Taken",
  "freezer.alert.detail.close": "Tutup",
  "freezer.alert.detail.correctiveAction": "Tindakan Perbaikan",
  "freezer.alert.detail.freezer": "Freezer",
  "freezer.alert.detail.id": "Alert ID",
  "freezer.alert.detail.message": "Pesan",
  "freezer.alert.detail.notes": "Catatan",
  "freezer.alert.detail.notesPlaceholder": "Add notes about this alert...",
  "freezer.alert.detail.notifications": "Notifications Sent",
  "freezer.alert.detail.overview": "Alert Overview",
  "freezer.alert.detail.resolutionNotes": "Catatan Pemecahan Masalah",
  "freezer.alert.detail.resolve": "Resolve",
  "freezer.alert.detail.resolvedAt": "Resolved At",
  "freezer.alert.detail.resolvedBy": "Resolved By",
  "freezer.alert.detail.severity": "Keparahan",
  "freezer.alert.detail.startTime": "Waktu Mulai",
  "freezer.alert.detail.status": "Status",
  "freezer.alert.detail.title": "Alert Details",
  "genericSample.default.fields.title": "Informasi Sampel",
  "genericSample.import.success": "Import successful",
  "genericSample.notebook.label": "Pilih Notebook",
  "genericSample.order.newOrder": "Create Another Sample",
  "genericSample.search.title": "Cari berdasarkan Nomor Registrasi",
  "http.success": "Success!",
  "label.button.assign": "Menugaskan",
  "label.button.create": "Buat",
  "label.button.saving": "Menyimpan...",
  "label.button.view": "Lihat Laporan",
  "label.code": "Kode",
  "label.editing": "Editing",
  "label.label": "Label",
  "label.name": "Nama",
  "label.panel": "Panel",
  "label.tests": "pengujian",
  "loading.label": "Memuat...",
  "loading.metrics": "Loading metrics...",
  "locale.save.error": "Failed to save language",
  "logging.management.tail.clear": "Kosongkan",
  "logging.management.tail.disconnected": "Stream disconnected. Toggle off and on to reconnect.",
  "logging.management.tail.label": "Live application log",
  "logging.management.tail.off": "Matikan",
  "logging.management.tail.on": "Nyalakan",
  "logging.management.tail.stream": "Live stream",
  "nationalID.title": "NIK",
  "nce.button.linkSelected": "Link Selected Samples",
  "nce.button.submit": "Submit NCE",
  "nce.error.numberGeneration": "Failed to generate NCE number. Please try again.",
  "nce.field.dateOfEvent": "Tanggal Kejadian",
  "nce.field.description": "Deskripsi",
  "nce.field.nceNumber": "Nomor Kejadian Ketidaksesuaian",
  "nce.field.proposedAction.helper": "Separate from CAPA actions assigned during corrective action workflow",
  "nce.field.proposedAction.placeholder": "Recommended next steps...",
  "nce.field.reporterName": "Reporter Name",
  "nce.field.reportingUnit": "Unit yang melapor",
  "nce.field.subcategory": "Subcategory",
  "nce.field.suspectedCauses.helper": "Initial assessment only - formal root cause determined during investigation",
  "nce.field.suspectedCauses.placeholder": "Reporter",
  "nce.form.subtitle": "Document a quality event and link to affected samples and results",
  "nce.form.title": "Lapor Kejadian Ketidaksesuaian",
  "nce.linkSamples.helper": "Search for orders above to link samples to this NCE. This step is optional.",
  "nce.section.attachments": "Lampiran",
  "nce.section.classification": "Classification",
  "nce.section.details": "Details",
  "nce.section.linkSamples": "Link to Samples / Results (Optional)",
  "nce.section.reporterContext": "Reporter & Event Context",
  "nce.select.subcategory": "Select subcategory...",
  "nce.severity.critical.desc": "Resiko keselamatan pasien, pelanggaran peraturan",
  "nce.severity.major.desc": "Dampat signifikan pada mutu atau operasional",
  "nce.severity.minor.desc": "Dampak terbatas, mudah diperbaiki",
  "nonconform.corrective.requiredFields": "Fill all corrective-action fields (action, person responsible, date completed, and at least one action type), or leave the row entirely empty.",
  "nonconform.view.requiredFields": "Lab component, NCE category, NCE type, severity consequence and recurrence are all required.",
  "notebook.sample.create": "Buat",
  "notebook.sample.create.title": "Create New Sample",
  "notebook.sample.edit": "Edit",
  "notebook.sample.edit.title": "Edit Sampel",
  "notebook.sample.import": "Impor",
  "notebook.sample.import.title": "Impor Sampel",
  "notebook.sample.order.info": "This sample will be associated with the current notebook.",
  "notification.success": "Berhasil",
  "notification.warning": "Peringatan",
  "order.entry.setup.batch": "Masukkan Pemesanan Batch",
  "order.legend.patient1": "Informasi Pasien",
  "pagination.next": "Halaman berikutnya",
  "pagination.previous": "Halaman sebelumnya",
  "patient.fetch.error": "Could not load patient. The id may be invalid or the server is unreachable.",
  "patient.firstName": "Nama Depan",
  "patient.lastName": "Nama Belakang",
  "print.barcode.all": "Print All Barcodes ({count})",
  "program.name.program": "Program",
  "sample.item.id": "Sample Item ID",
  "sample.label": "Sampel",
  "sample.noPanels": "No panels available for this sample type",
  "sample.noTests": "No tests available for this sample type",
  "sample.selectType.first": "Select a sample type above to see available panels and tests",
  "sample.testsCount": "{count} tests available",
  "sample.types": "Sampel",
  "save.error.msg": "Error saving",
  "saving.label": "Menyimpan...",
  "select.label.analyzer": "Pilih Alat",
  "site.code": "Kode",
  "steps.complete": "steps",
  "storage.audit.empty": "No movements recorded for this sample yet.",
  "storage.audit.empty.title": "No movements",
  "storage.audit.fetch.error": "Could not load audit trail.",
  "storage.audit.fetch.error.title": "Error",
  "storage.audit.from": "Dari",
  "storage.audit.movedBy": "Moved By",
  "storage.audit.movementDate": "Movement Date",
  "storage.audit.reason": "Reason",
  "storage.audit.to": "Kepada",
  "storage.box.code.helper": "Up to 10 characters",
  "storage.breadcrumb.sampleitems": "Item Sampel",
  "storage.breadcrumb.storage": "Penyimpanan",
  "storage.confirm.disposal": "Confirm Disposal",
  "storage.dashboard.title": "Penyimpanan",
  "storage.disposal.method": "Disposal Method",
  "storage.disposal.method.placeholder": "Select method...",
  "storage.disposal.notes": "Additional Notes (optional)",
  "storage.disposal.notes.placeholder": "Enter any additional notes...",
  "storage.disposal.reason": "Alasan Pemusnahan",
  "storage.disposal.reason.placeholder": "Select reason...",
  "storage.dispose.confirmation": "I confirm that I want to permanently dispose of this sample. This action cannot be undone.",
  "storage.dispose.instructions.subtitle": "Please ensure proper disposal procedures are followed according to laboratory safety protocols.",
  "storage.dispose.instructions.title": "Disposal Instructions",
  "storage.dispose.location.note": "Sample will be removed from this location upon disposal",
  "storage.dispose.sample": "Dispose Sample",
  "storage.dispose.sample.subtitle": "Permanently dispose of sample {sampleId}",
  "storage.dispose.warning.subtitle": "The sample will be marked as disposed and removed from storage.",
  "storage.dispose.warning.title": "This action cannot be undone",
  "storage.edit.heading": "Edit {type}",
  "storage.edit.title": "Edit",
  "storage.editbox.heading": "Edit Box",
  "storage.error": "Error",
  "storage.error.save": "Failed to save location",
  "storage.filter.select.location": "Select location...",
  "storage.filter.selected": "Selected:",
  "storage.location.assigned.error": "Failed to assign location",
  "storage.location.assigned.success": "Location assigned successfully",
  "storage.location.no.results": "No locations found",
  "storage.location.type.devices": "devices",
  "storage.location.type.racks": "racks",
  "storage.location.type.rooms": "rooms",
  "storage.location.type.shelves": "shelves",
  "storage.manage.location": "Manage Location",
  "storage.nav.rack": "Laci",
  "storage.sample.actions": "Sample actions",
  "storage.sampleitem.accession": "Aksesi Sampel",
  "storage.sampleitem.location": "Lokasi Penyimpanan",
  "storage.sampleitem.status": "Status",
  "storage.sampleitem.type": "Tipe",
  "storage.search.location.label": "Search for a storage location",
  "storage.search.location.placeholder": "Type 2+ characters to search…",
  "storage.skipRemaining": "Skip storage for unassigned samples ({count}) - will be processed immediately",
  "storage.view.audit": "View Audit",
  "storage.view.audit.subtitle": "Movement history for sample {sampleId}",
  "storage.view.audit.title": "Storage Audit Trail",
  "systemDefaultPayloadTemplate.messageTemplate": "Message template",
  "systemDefaultPayloadTemplate.subjectTemplate": "Subject template",
  "tests.count": "{count, plural, one {test} other {tests}}",
  "validation.invalid.ip": "Invalid IP address format (IPv4 or IPv6)",
  "validation.invalid.port": "Port must be between 1 and 65535",
  "validation.required": "Bidang ini diperlukan",
  "validationRule.action.addValue": "Tambah",
  "validationRule.action.cancel": "Batal",
  "validationRule.action.save": "Save Rule",
  "validationRule.error.enumValuesRequired": "At least one enum value is required",
  "validationRule.error.invalidPattern": "Invalid regex pattern",
  "validationRule.error.minGreaterThanMax": "Minimum cannot be greater than maximum",
  "validationRule.error.minLengthGreaterThanMax": "Minimum length cannot be greater than maximum length",
  "validationRule.error.patternRequired": "Regex pattern is required",
  "validationRule.error.ruleNameRequired": "Rule name is required",
  "validationRule.error.saveFailed": "Failed to save validation rule",
  "validationRule.form.enumInputPlaceholder": "Enter value and press Enter",
  "validationRule.form.enumValues": "Allowed Values",
  "validationRule.form.errorMessage": "Error Message (Optional)",
  "validationRule.form.errorMessagePlaceholder": "Custom error message to display when validation fails",
  "validationRule.form.lengthMax": "Maximum Length",
  "validationRule.form.lengthMin": "Minimum Length",
  "validationRule.form.rangeMax": "Maximum",
  "validationRule.form.rangeMin": "Minimum",
  "validationRule.form.regexPattern": "Regex Pattern",
  "validationRule.form.regexPatternPlaceholder": "e.g., ^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\\\\.[A-Za-z]",
  "validationRule.form.ruleName": "Nama Aturan",
  "validationRule.form.ruleNamePlaceholder": "e.g., Email Pattern",
  "validationRule.form.ruleType": "Jenis Aturan",
  "validationRule.success.saved": "Validation rule saved successfully",
  "validationRule.test.invalid": "Value fails validation",
  "validationRule.test.section": "Test Validation",
  "validationRule.test.testButton": "Test Rule",
  "validationRule.test.testValue": "Test Value",
  "validationRule.test.testValuePlaceholder": "Enter a value to test",
  "validationRule.test.valid": "Value passes validation",
  "validationRule.test.valueRequired": "Please enter a test value",
  "common.accept": "Terima",
  "common.accessionNumber": "Nomor Registrasi",
  "common.action": "Aksi",
  "common.actions": "Aksi",
  "common.active": "Aktif",
  "common.addTests": "Tambah Pemeriksaan",
  "common.aliquots": "alikuot",
  "common.all": "Semua",
  "common.allStatuses": "Semua Status",
  "common.analyzer": "Alat",
  "common.analyzers": "Alat",
  "common.auditTrail": "Jejak Audit",
  "common.back": "Kembali",
  "common.boxId": "ID Boks",
  "common.byUnit": "Berdasarkan Unit",
  "common.cancel": "Batal",
  "common.category": "Kategori",
  "common.clinical": "Klinis",
  "common.code": "Kode",
  "common.collected": "Diambil",
  "common.collectionDate": "Tanggal Pengambilan",
  "common.complete": "Selesai",
  "common.completed": "Selesai",
  "common.confirm": "Konfirmasi",
  "common.correctiveActions": "Tindakan Perbaikan",
  "common.createAliquot": "Buat Alikuot",
  "common.critical": "Kritis",
  "common.dashboard": "Dasbor",
  "common.date": "Tanggal",
  "common.dateRange": "Rentang Tanggal",
  "common.deactivate": "Nonaktifkan",
  "common.delete": "Hapus",
  "common.description": "Deskripsi",
  "common.draft": "Draf",
  "common.edit": "Edit",
  "common.editOrder": "Edit Sampel",
  "common.email": "Email",
  "common.enterResults": "Masukkan Hasil",
  "common.error": "Error",
  "common.expired": "Kedaluwarsa",
  "common.exportPdf": "Ekspor PDF",
  "common.failed": "Gagal",
  "common.filterByStatus": "Filter berdasarkan Status",
  "common.firstName": "Nama Depan",
  "common.from": "Dari",
  "common.generateReport": "Buat Laporan",
  "common.home": "Beranda",
  "common.inProgress": "Dalam Pengerjaan",
  "common.inactive": "Inaktif",
  "common.labNumber": "Nomor Registrasi",
  "common.lastName": "Nama Belakang",
  "common.loading": "Memuat...",
  "common.location": "Lokasi",
  "common.mean": "Mean",
  "common.name": "Nama",
  "common.nationalId": "NIK",
  "common.new": "New",
  "common.none": "Tidak ada",
  "common.normal": "Normal",
  "common.normalRange": "Rentang Normal",
  "common.notes": "Catatan",
  "common.order": "Pemesanan",
  "common.overdue": "Lewat tenggat",
  "common.panels": "Panel",
  "common.participants": "Peserta",
  "common.patient": "Pasien",
  "common.pending": "Tertunda",
  "common.position": "Posisi",
  "common.printLabel": "Cetak Label",
  "common.priority": "Prioritas",
  "common.program": "Program",
  "common.programName": "Nama Program",
  "common.provider": "Penyelenggara",
  "common.quantity": "Kuantitas",
  "common.received": "Diterima",
  "common.referenceLab": "Lab Rujukan",
  "common.reject": "Tolak",
  "common.remove": "Hapus",
  "common.reports": "Laporan",
  "common.requester": "Pemohon",
  "common.result": "Hasil",
  "common.results": "Hasil",
  "common.room": "Ruangan",
  "common.routine": "Rutin",
  "common.sample": "Sampel",
  "common.sampleId": "Nomor Identitas Sampel",
  "common.sampleManagement": "Pengelolaan Sampel",
  "common.sampleType": "Jenis Sampel",
  "common.samples": "Sampel",
  "common.samplingSite": "Tempat Pengambilan Sampel",
  "common.save": "Simpan",
  "common.saveFailed": "Penyimpanan gagal",
  "common.saving": "Menyimpan...",
  "common.search": "Cari",
  "common.select": "Pilih",
  "common.severity": "Keparahan",
  "common.siteName": "Nama Tempat",
  "common.species": "Spesies",
  "common.standard": "Standar",
  "common.status": "Status",
  "common.storageLocation": "Lokasi Penyimpanan",
  "common.study": "Kajian",
  "common.test": "Pemeriksaan",
  "common.testName": "Nama Pemeriksaan",
  "common.tests": "Pemeriksaan",
  "common.type": "Tipe",
  "common.unit": "Unit",
  "common.user": "Pengguna",
  "common.value": "Nilai",
  "common.view": "Lihat",
  "common.warning": "Peringatan",
  "label.testCatalog.alerts.field.component": "Result component",
  "label.testCatalog.alerts.field.componentHelp": "Which result this alert watches. Leave unset to watch every component of this test.",
  "label.testCatalog.alerts.field.sampleType": "Jenis sampel",
  "label.testCatalog.alerts.field.sampleTypeHelp": "Which specimen this alert watches. Leave unset to watch every sample type this test runs on.",
  "label.testCatalog.alerts.scope.anyComponent": "Any component",
  "label.testCatalog.alerts.scope.anySampleType": "Any sample type",
  "label.testCatalog.alerts.col.scope": "Applies to",
  "label.testCatalog.alerts.scope.wholeTest": "Whole test",
  "rulebuilder.label.selectComponent": "Select Component",
  "testcalculation.label.selectComponent": "Select Component",
  "testcalculation.label.finalComponent": "Result Component"
}
